/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 79:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3702),
    listCacheDelete = __webpack_require__(80),
    listCacheGet = __webpack_require__(4739),
    listCacheHas = __webpack_require__(8655),
    listCacheSet = __webpack_require__(1175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 80:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductDelete_ProductDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductDelete/ProductDelete.vue?vue&type=template&id=864fc5b0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"hidden":_vm.onHidden},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.' + (_vm.value?.is_group ? 'group' : 'product') + '.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductDelete/ProductDelete.ts?vue&type=script&lang=ts&external




var ProductDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductDelete, _super);
    function ProductDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    ProductDelete.prototype.watchValue = function (value) {
        this.showModal = value !== null;
    };
    Object.defineProperty(ProductDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/catalog/product/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    ProductDelete.prototype.onOk = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete(this.apiUrl)
                                .then(function () {
                                interface_vue_.emitter.emit('productDeleted', _this.value);
                                _this.$emit('deleted');
                                _this.onHidden();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductDelete.prototype.onHidden = function () {
        //
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ProductDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('hidden')
    ], ProductDelete.prototype, "onHidden", null);
    ProductDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], ProductDelete);
    return ProductDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductDeletevue_type_script_lang_ts_external = (ProductDelete);

;// ./src/components/ProductDelete/ProductDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductDelete_ProductDeletevue_type_script_lang_ts_external = (ProductDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductDelete/ProductDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductDelete_ProductDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductDelete_ProductDelete = (component.exports);

/***/ }),

/***/ 181:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 189:
/***/ (function(module) {

"use strict";
module.exports = require("froala-editor");

/***/ }),

/***/ 270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(7068),
    isObjectLike = __webpack_require__(346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(2555));
	else // removed by dead control flow
{}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_688__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_688__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_688__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_688__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_688__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_688__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_688__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_688__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_688__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_688__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_688__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_688__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_688__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_688__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_688__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_688__(__nested_webpack_require_688__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __nested_webpack_require_4164__) {

"use strict";

var LIBRARY = __nested_webpack_require_4164__("2d00");
var $export = __nested_webpack_require_4164__("5ca1");
var redefine = __nested_webpack_require_4164__("2aba");
var hide = __nested_webpack_require_4164__("32e9");
var Iterators = __nested_webpack_require_4164__("84f2");
var $iterCreate = __nested_webpack_require_4164__("41a0");
var setToStringTag = __nested_webpack_require_4164__("7f20");
var getPrototypeOf = __nested_webpack_require_4164__("38fd");
var ITERATOR = __nested_webpack_require_4164__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __nested_webpack_require_7070__) {

var toInteger = __nested_webpack_require_7070__("4588");
var defined = __nested_webpack_require_7070__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __nested_webpack_require_7783__) {

"use strict";

var at = __nested_webpack_require_7783__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __nested_webpack_require_8134__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __nested_webpack_require_8134__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __nested_webpack_require_8593__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __nested_webpack_require_8593__("ce10");
var enumBugKeys = __nested_webpack_require_8593__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __nested_webpack_require_8892__) {

var dP = __nested_webpack_require_8892__("86cc");
var anObject = __nested_webpack_require_8892__("cb7c");
var getKeys = __nested_webpack_require_8892__("0d58");

module.exports = __nested_webpack_require_8892__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __nested_webpack_require_9392__) {

"use strict";

__nested_webpack_require_9392__("b0c5");
var redefine = __nested_webpack_require_9392__("2aba");
var hide = __nested_webpack_require_9392__("32e9");
var fails = __nested_webpack_require_9392__("79e5");
var defined = __nested_webpack_require_9392__("be13");
var wks = __nested_webpack_require_9392__("2b4c");
var regexpExec = __nested_webpack_require_9392__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __nested_webpack_require_12849__) {

var isObject = __nested_webpack_require_12849__("d3f4");
var document = __nested_webpack_require_12849__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __nested_webpack_require_13233__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __nested_webpack_require_13233__("2d95");
var TAG = __nested_webpack_require_13233__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __nested_webpack_require_14160__) {

var global = __nested_webpack_require_14160__("7726");
var hide = __nested_webpack_require_14160__("32e9");
var has = __nested_webpack_require_14160__("69a8");
var SRC = __nested_webpack_require_14160__("ca5a")('src');
var $toString = __nested_webpack_require_14160__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__nested_webpack_require_14160__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __nested_webpack_require_15334__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __nested_webpack_require_15334__("cb7c");
var dPs = __nested_webpack_require_15334__("1495");
var enumBugKeys = __nested_webpack_require_15334__("e11e");
var IE_PROTO = __nested_webpack_require_15334__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __nested_webpack_require_15334__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __nested_webpack_require_15334__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __nested_webpack_require_16945__) {

var store = __nested_webpack_require_16945__("5537")('wks');
var uid = __nested_webpack_require_16945__("ca5a");
var Symbol = __nested_webpack_require_16945__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __nested_webpack_require_17667__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __nested_webpack_require_17667__("5ca1");
var context = __nested_webpack_require_17667__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __nested_webpack_require_17667__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __nested_webpack_require_18235__) {

var dP = __nested_webpack_require_18235__("86cc");
var createDesc = __nested_webpack_require_18235__("4630");
module.exports = __nested_webpack_require_18235__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __nested_webpack_require_18611__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __nested_webpack_require_18611__("69a8");
var toObject = __nested_webpack_require_18611__("4bf8");
var IE_PROTO = __nested_webpack_require_18611__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __nested_webpack_require_19205__) {

"use strict";

var create = __nested_webpack_require_19205__("2aeb");
var descriptor = __nested_webpack_require_19205__("4630");
var setToStringTag = __nested_webpack_require_19205__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__nested_webpack_require_19205__("32e9")(IteratorPrototype, __nested_webpack_require_19205__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __nested_webpack_require_19831__) {

// 19.1.2.14 Object.keys(O)
var toObject = __nested_webpack_require_19831__("4bf8");
var $keys = __nested_webpack_require_19831__("0d58");

__nested_webpack_require_19831__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __nested_webpack_require_20609__) {

// 7.1.13 ToObject(argument)
var defined = __nested_webpack_require_20609__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __nested_webpack_require_20831__) {

var MATCH = __nested_webpack_require_20831__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __nested_webpack_require_21176__) {

"use strict";


var regexpFlags = __nested_webpack_require_21176__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __nested_webpack_require_23109__) {

var core = __nested_webpack_require_23109__("8378");
var global = __nested_webpack_require_23109__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __nested_webpack_require_23109__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __nested_webpack_require_23642__) {

var global = __nested_webpack_require_23642__("7726");
var core = __nested_webpack_require_23642__("8378");
var hide = __nested_webpack_require_23642__("32e9");
var redefine = __nested_webpack_require_23642__("2aba");
var ctx = __nested_webpack_require_23642__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __nested_webpack_require_25367__) {

// most Object methods by ES6 should accept primitives
var $export = __nested_webpack_require_25367__("5ca1");
var core = __nested_webpack_require_25367__("8378");
var fails = __nested_webpack_require_25367__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __nested_webpack_require_25845__) {

"use strict";


var classof = __nested_webpack_require_25845__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __nested_webpack_require_26551__) {

var shared = __nested_webpack_require_26551__("5537")('keys');
var uid = __nested_webpack_require_26551__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __nested_webpack_require_26811__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __nested_webpack_require_26811__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __nested_webpack_require_27194__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __nested_webpack_require_27194__("5ca1");
var $includes = __nested_webpack_require_27194__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__nested_webpack_require_27194__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __nested_webpack_require_27659__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __nested_webpack_require_27659__("626a");
var defined = __nested_webpack_require_27659__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __nested_webpack_require_28155__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __nested_webpack_require_28155__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __nested_webpack_require_28898__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __nested_webpack_require_28898__("0d58");
var gOPS = __nested_webpack_require_28898__("2621");
var pIE = __nested_webpack_require_28898__("52a7");
var toObject = __nested_webpack_require_28898__("4bf8");
var IObject = __nested_webpack_require_28898__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __nested_webpack_require_28898__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __nested_webpack_require_30635__) {

var toInteger = __nested_webpack_require_30635__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __nested_webpack_require_31112__) {

var def = __nested_webpack_require_31112__("86cc").f;
var has = __nested_webpack_require_31112__("69a8");
var TAG = __nested_webpack_require_31112__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __nested_webpack_require_31751__) {

var anObject = __nested_webpack_require_31751__("cb7c");
var IE8_DOM_DEFINE = __nested_webpack_require_31751__("c69a");
var toPrimitive = __nested_webpack_require_31751__("6a99");
var dP = Object.defineProperty;

exports.f = __nested_webpack_require_31751__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __nested_webpack_require_32441__) {

// optional / simple context binding
var aFunction = __nested_webpack_require_32441__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __nested_webpack_require_33048__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __nested_webpack_require_33048__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __nested_webpack_require_33048__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __nested_webpack_require_33448__) {

// 7.1.15 ToLength
var toInteger = __nested_webpack_require_33448__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __nested_webpack_require_33750__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__nested_webpack_require_33750__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __nested_webpack_require_34139__) {

"use strict";


var anObject = __nested_webpack_require_34139__("cb7c");
var toObject = __nested_webpack_require_34139__("4bf8");
var toLength = __nested_webpack_require_34139__("9def");
var toInteger = __nested_webpack_require_34139__("4588");
var advanceStringIndex = __nested_webpack_require_34139__("0390");
var regExpExec = __nested_webpack_require_34139__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__nested_webpack_require_34139__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __nested_webpack_require_38885__) {

// 7.2.8 IsRegExp(argument)
var isObject = __nested_webpack_require_38885__("d3f4");
var cof = __nested_webpack_require_38885__("2d95");
var MATCH = __nested_webpack_require_38885__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __nested_webpack_require_39282__) {

var $iterators = __nested_webpack_require_39282__("cadf");
var getKeys = __nested_webpack_require_39282__("0d58");
var redefine = __nested_webpack_require_39282__("2aba");
var global = __nested_webpack_require_39282__("7726");
var hide = __nested_webpack_require_39282__("32e9");
var Iterators = __nested_webpack_require_39282__("84f2");
var wks = __nested_webpack_require_39282__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __nested_webpack_require_41209__) {

"use strict";

var regexpExec = __nested_webpack_require_41209__("520a");
__nested_webpack_require_41209__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __nested_webpack_require_41706__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __nested_webpack_require_41706__("6821");
var toLength = __nested_webpack_require_41706__("9def");
var toAbsoluteIndex = __nested_webpack_require_41706__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_42729__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_42729__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_42729__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_42729__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __nested_webpack_require_44512__) {

module.exports = !__nested_webpack_require_44512__("9e1e") && !__nested_webpack_require_44512__("79e5")(function () {
  return Object.defineProperty(__nested_webpack_require_44512__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __nested_webpack_require_45568__) {

"use strict";

var addToUnscopables = __nested_webpack_require_45568__("9c6c");
var step = __nested_webpack_require_45568__("d53b");
var Iterators = __nested_webpack_require_45568__("84f2");
var toIObject = __nested_webpack_require_45568__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __nested_webpack_require_45568__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __nested_webpack_require_46777__) {

var isObject = __nested_webpack_require_46777__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __nested_webpack_require_47019__) {

var has = __nested_webpack_require_47019__("69a8");
var toIObject = __nested_webpack_require_47019__("6821");
var arrayIndexOf = __nested_webpack_require_47019__("c366")(false);
var IE_PROTO = __nested_webpack_require_47019__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __nested_webpack_require_47655__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __nested_webpack_require_47655__("aae3");
var defined = __nested_webpack_require_47655__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __nested_webpack_require_48796__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __nested_webpack_require_48796__("5ca1");
var toLength = __nested_webpack_require_48796__("9def");
var context = __nested_webpack_require_48796__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __nested_webpack_require_48796__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __nested_webpack_require_50913__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __nested_webpack_require_50913__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __nested_webpack_require_50913__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __nested_webpack_require_51166__) {

module.exports = __nested_webpack_require_51166__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __nested_webpack_require_51344__) {

var document = __nested_webpack_require_51344__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_51548__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_51548__.r(__nested_webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __nested_webpack_require_51548__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __nested_webpack_require_51548__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __nested_webpack_require_51548__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __nested_webpack_require_51548__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __nested_webpack_require_51548__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __nested_webpack_require_51548__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __nested_webpack_require_51548__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __nested_webpack_require_51548__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __nested_webpack_require_51548__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __nested_webpack_require_51548__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__nested_webpack_require_51548__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __nested_webpack_require_51548__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __nested_webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ 459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ox: function() { return /* binding */ fetchService; },
/* harmony export */   R4: function() { return /* binding */ serviceRelations; },
/* harmony export */   cu: function() { return /* binding */ needFetchService; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var serviceRelations = [
    'sale_category', 'vat_rate', 'unit', 'technicians', 'products', 'default_picture', 'custom_quantity_prices',
    'custom_type_prices', 'custom_fields'
];
var needFetchService = function (service) {
    return !serviceRelations.every(function (relation) { return relation in service; });
};
var fetchService = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCatalog.axios.get('/catalog/service/' + id, {
                    params: {
                        include: serviceRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CatalogList_CatalogList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CatalogList/CatalogList.vue?vue&type=template&id=0550b054
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-tabs',{attrs:{"content-class":"pt-3"}},[(_vm.notHide('product'))?_c('b-tab',{attrs:{"title":_vm.$t('catalog.product.menu'),"static":""}},[(_vm.can('catalog-products', 2))?_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.newProduct.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}),_vm._v(" "+_vm._s(_vm.$t('catalog.product.addLabel'))+" ")],1):_vm._e(),_c('ProductList',{attrs:{"addAction":_vm.addProduct,"defaultFilters":_vm.filters,"relations":_vm.include && 'product' in _vm.include ? _vm.include.product : [],"inlineMode":"","stateKey":"modal-catalog-product-list","showGroup":false}})],1):_vm._e(),(_vm.notHide('service'))?_c('b-tab',{attrs:{"title":_vm.$t('catalog.service.menu'),"static":""}},[(_vm.can('catalog-services', 2))?_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openModal('catalog-service-form')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}),_vm._v(" "+_vm._s(_vm.$t('catalog.service.addLabel'))+" ")],1):_vm._e(),_c('ServiceList',{attrs:{"inlineMode":"","addAction":_vm.addService,"defaultFilters":_vm.filters,"relations":_vm.include && 'service' in _vm.include ? _vm.include.service : [],"stateKey":"modal-catalog-service-list"}})],1):_vm._e(),(_vm.hasModule('catalog-groups') && _vm.notHide('group'))?_c('b-tab',{attrs:{"title":_vm.$t('catalog.group.menu'),"static":""}},[(_vm.can('catalog-groups', 2))?_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openModal('catalog-group-form')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}),_vm._v(" "+_vm._s(_vm.$t('catalog.group.addLabel'))+" ")],1):_vm._e(),_c('ProductList',{attrs:{"inlineMode":"","addAction":_vm.addGroup,"defaultFilters":_vm.filters,"relations":_vm.include && _vm.include.group ? _vm.include.group : [],"showGroup":""}})],1):_vm._e()],1),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.add'),"cancel-title":_vm.$t('interface.cancel')},on:{"ok":function($event){return _vm.addElement(_vm.askType, _vm.askElement)}},model:{value:(_vm.askForAdding),callback:function ($$v) {_vm.askForAdding=$$v},expression:"askForAdding"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.catalogSearch.askAddElement'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: ./src/components/ProductList/ProductList.vue + 3 modules
var ProductList = __webpack_require__(7439);
// EXTERNAL MODULE: ./src/components/ServiceList/ServiceList.vue + 3 modules
var ServiceList = __webpack_require__(4958);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CatalogList/CatalogList.ts?vue&type=script&lang=ts&external









var CatalogList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogList, _super);
    function CatalogList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.askForAdding = false;
        _this.askType = null;
        _this.askElement = null;
        return _this;
    }
    CatalogList.prototype.newProduct = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var value, provider;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        value = {};
                        if (!this.filters) return [3 /*break*/, 2];
                        if (this.filters.with_stock) {
                            value.with_stock = true;
                        }
                        if (!(((_a = this.filters) === null || _a === void 0 ? void 0 : _a.providers) && !Array.isArray(this.filters.providers))) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0,customers_vue_.fetchCustomer)(this.filters.providers)];
                    case 1:
                        provider = _b.sent();
                        value.providers = [provider];
                        value.providers_references = [
                            {
                                customer: provider,
                                reference: '',
                                buy_price_ht: 0,
                                various_costs: 0,
                                total_costs: 0
                            }
                        ];
                        _b.label = 2;
                    case 2:
                        this.openModal({ key: 'catalog-product-form', value: value });
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogList.prototype.mounted = function () {
        interface_vue_.emitter.on('productCreated', this.productCreated);
        interface_vue_.emitter.on('productUpdated', this.productUpdated);
        interface_vue_.emitter.on('serviceCreated', this.serviceCreated);
        interface_vue_.emitter.on('serviceUpdated', this.serviceUpdated);
        interface_vue_.emitter.on('groupCreated', this.groupCreated);
        interface_vue_.emitter.on('groupUpdated', this.groupUpdated);
    };
    CatalogList.prototype.destroyed = function () {
        interface_vue_.emitter.off('productCreated', this.productCreated);
        interface_vue_.emitter.off('productUpdated', this.productUpdated);
        interface_vue_.emitter.off('serviceCreated', this.serviceCreated);
        interface_vue_.emitter.off('serviceUpdated', this.serviceUpdated);
        interface_vue_.emitter.off('groupCreated', this.groupCreated);
        interface_vue_.emitter.off('groupUpdated', this.groupUpdated);
    };
    CatalogList.prototype.addProduct = function (product) {
        this.addElement('product', product);
    };
    CatalogList.prototype.addService = function (service) {
        this.addElement('service', service);
    };
    CatalogList.prototype.addGroup = function (group) {
        this.addElement('group', group);
    };
    CatalogList.prototype.addElement = function (type, element) {
        return {
            type: type,
            data: element
        };
    };
    CatalogList.prototype.newElement = function (type) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var value, provider;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(type === 'product' && ((_a = this.filters) === null || _a === void 0 ? void 0 : _a.providers) && !Array.isArray(this.filters.providers))) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0,customers_vue_.fetchCustomer)(this.filters.providers)];
                    case 1:
                        provider = _b.sent();
                        value = {
                            providers: [provider],
                            providers_references: [
                                {
                                    customer: provider,
                                    reference: null,
                                    buy_price_ht: 0,
                                    various_costs: 0,
                                    total_costs: 0
                                }
                            ]
                        };
                        _b.label = 2;
                    case 2:
                        this.openModal({
                            key: 'catalog-' + type + '-form',
                            value: value
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogList.prototype.productCreated = function (product) {
        this.askForAddElement('product', product);
    };
    CatalogList.prototype.productUpdated = function (event) {
        this.askForAddElement('product', event.new);
    };
    CatalogList.prototype.serviceCreated = function (service) {
        this.askForAddElement('service', service);
    };
    CatalogList.prototype.serviceUpdated = function (event) {
        this.askForAddElement('service', event.new);
    };
    CatalogList.prototype.groupCreated = function (group) {
        this.askForAddElement('group', group);
    };
    CatalogList.prototype.groupUpdated = function (event) {
        this.askForAddElement('group', event.new);
    };
    CatalogList.prototype.askForAddElement = function (type, element) {
        this.askType = type;
        this.askElement = element;
        this.askForAdding = true;
    };
    CatalogList.prototype.notHide = function (type) {
        if (this.only === null) {
            return true;
        }
        else if (typeof this.only === 'string') {
            return this.only === type;
        }
        else {
            return this.only.includes(type);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogList.prototype, "only", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogList.prototype, "filters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogList.prototype, "include", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('selected')
    ], CatalogList.prototype, "addElement", null);
    CatalogList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                ProductList: ProductList/* default */.A,
                ServiceList: ServiceList/* default */.A,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal
            }
        })
    ], CatalogList);
    return CatalogList;
}(lib/* Vue */.lD));
/* harmony default export */ var CatalogListvue_type_script_lang_ts_external = (CatalogList);

;// ./src/components/CatalogList/CatalogList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CatalogList_CatalogListvue_type_script_lang_ts_external = (CatalogListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CatalogList/CatalogList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CatalogList_CatalogListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CatalogList_CatalogList = (component.exports);

/***/ }),

/***/ 583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(7237),
    basePropertyDeep = __webpack_require__(7255),
    isKey = __webpack_require__(8586),
    toKey = __webpack_require__(7797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LotDelete_LotDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotDelete/LotDelete.vue?vue&type=template&id=e6fc2564
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":function($event){return _vm.$emit('cancel')},"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.productLot.deleteMsg'))+" "),(_vm.value && (_vm.value.origin_type === 'providerCommandContent' || _vm.value.origin_type === 'stockManualContent'))?_c('b-alert',{staticClass:"mt-4",attrs:{"show":"","variant":"warning"}},[(_vm.value.origin_type === 'providerCommandContent')?[_vm._v(" "+_vm._s(_vm.$t('catalog.productLot.deleteMsgAlertCommand'))+" ")]:(_vm.value.origin_type === 'stockManualContent')?[_vm._v(" "+_vm._s(_vm.$t('catalog.productLot.deleteMsgAlertMovement'))+" ")]:_vm._e()],2):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotDelete/LotDelete.ts?vue&type=script&lang=ts&external




var LotDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotDelete, _super);
    function LotDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    LotDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    LotDelete.prototype.onOk = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.$emit('deleted');
                                interface_vue_.emitter.emit('productLotDeleted', _this.value);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LotDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/catalog/stock/lot/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LotDelete.prototype, "watchValue", null);
    LotDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay, BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], LotDelete);
    return LotDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var LotDeletevue_type_script_lang_ts_external = (LotDelete);

;// ./src/components/LotDelete/LotDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotDelete_LotDeletevue_type_script_lang_ts_external = (LotDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LotDelete/LotDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LotDelete_LotDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotDelete_LotDelete = (component.exports);

/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(8077),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandItem_CommandItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandItem/CommandItem.vue?vue&type=template&id=61a652bb
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"provider-command-item"},[_c('PageHeader',{staticClass:"border-0 mb-0",attrs:{"page-title":'Commande n°' + _vm.value.reference,"buttons":_vm.headerButtons}},[_c('b-col',{staticClass:"mt-2 mt-lg-0",attrs:{"cols":"12","md":"auto"}},[_c('ul',{staticClass:"command-status-bar"},_vm._l((_vm.commandStatus),function(status){return _c('li',{key:status.value,class:{
            selected: status.value === _vm.value.status
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0)])],1),_c('AppMessages'),(_vm.value.title)?_c('h2',[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e(),_c('div',[(_vm.value.status !== 3)?_c('b-button',{staticClass:"mb-1 mb-md-3 mr-2",attrs:{"variant":!_vm.commandHasLots ? 'secondary' : 'success',"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.commandReceipt = true}}},[_vm._v(" Réception de la commande ")]):_vm._e(),(_vm.value.status < 1)?_c('b-button',{staticClass:"mb-1 mb-md-3 mr-2",attrs:{"variant":"success","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.commandStatusDelivery = 2}}},[_vm._v(" Marquer comme en attente de livraison ")]):_vm._e(),(_vm.value.status !== 3 && !_vm.commandHasLots)?_c('b-button',{staticClass:"mb-1 mb-md-3 mr-2",attrs:{"variant":"success","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.commandStatusDelivery = 3}}},[_vm._v(" Marquer comme livrée ")]):_vm._e(),(_vm.hasModule('charges') && _vm.value.charge_status !== 2)?_c('CommandCharge',{staticClass:"mb-1 mb-md-3",attrs:{"command":_vm.value,"variant":_vm.value.status !== 3 ? 'primary' : 'success'}}):_vm._e()],1),_c('b-row',{staticClass:"command-datas",attrs:{"align-v":"stretch"}},[_c('b-col',{attrs:{"cols":"12","md":"4","xxl":"3"}},[_c('b-card',[(_vm.hasModule('charges'))?_vm._l((_vm.value.charges),function(charge,i){return _c('b-badge',{key:i,staticClass:"mb-1 mr-1 badge-md",attrs:{"variant":"light","to":{ name: 'charges-item', params: { id: charge.id } }}},[_vm._v(" Charge n°"+_vm._s(charge.reference)+" ")])}):_vm._e(),_c('b-form-group',{staticClass:"mt-2",attrs:{"label":"Date"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")]),(_vm.value.provider)?_c('b-form-group',{attrs:{"label":"Client"}},[_c('CustomerSpeedItem',{attrs:{"type":"provider"},model:{value:(_vm.value.provider),callback:function ($$v) {_vm.$set(_vm.value, "provider", $$v)},expression:"value.provider"}})],1):_vm._e(),(_vm.value.contact)?_c('b-form-group',{attrs:{"label":"Contact"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}})],1):_vm._e(),(_vm.hasModule('stock-locations') && _vm.value.stock_location)?_c('b-form-group',{attrs:{"label":"Lieu de stockage"}},[_vm._v(" "+_vm._s(_vm.value.stock_location.name)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Adresse livraison"}},[(_vm.value.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road1))]):_vm._e(),(_vm.value.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road2))]):_vm._e(),(_vm.value.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road3))]):_vm._e(),_vm._v(" "+_vm._s(_vm.value.postal_code)+" "+_vm._s(_vm.value.town)+" "),(_vm.value.country)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.country.name))]):_vm._e()]),(_vm.value.comments)?_c('b-form-group',{attrs:{"label":"Commentaires"}},[_c('TextareaView',{model:{value:(_vm.value.comments),callback:function ($$v) {_vm.$set(_vm.value, "comments", $$v)},expression:"value.comments"}})],1):_vm._e(),(_vm.value.payment_term)?_c('b-form-group',{attrs:{"label":"Conditions de paiement"}},[_vm._v(" "+_vm._s(_vm.value.payment_term.label)+" ")]):_vm._e(),(_vm.value.custom_fields.length > 0)?_c('CustomFieldsDisplay',{attrs:{"type":"provider_command","value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e()],2),_c('b-row',{staticClass:"text-center my-4 my-2 document-totals mx-0 font-weight-bold"},[_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('small',[_vm._v("Total HT")]),_c('br'),_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_ht))+" "+_vm._s(_vm.value.currency.symbol)+" ")]),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('small',[_vm._v("Total TVA")]),_c('br'),_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_tva))+" "+_vm._s(_vm.value.currency.symbol)+" ")]),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('small',[_vm._v("Total TTC")]),_c('br'),_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_ttc))+" "+_vm._s(_vm.value.currency.symbol)+" ")])],1)],1),_c('b-col',{attrs:{"cols":"12","md":"8","xxl":"9"}},[_c('b-tabs',{staticClass:"tabs-card command-tabs"},[_c('b-tab',{staticClass:"p-0",attrs:{"title":"PDF"}},[_c('PdfViewer',{ref:"pdfviewer",attrs:{"id":_vm.value.id,"pdfStatus":_vm.value.pdf_status},on:{"pdfLoaded":_vm.pdfLoaded}})],1),_c('b-tab',{attrs:{"title":"Éléments","lazy":""}},[_c('AgregateDatas',{attrs:{"type":"providerCommand","id":_vm.value.id,"modelTitle":_vm.value.reference,"model":_vm.value,"url":'/catalog/command/' + _vm.value.id + '/agregate-datas',"linkedElements":_vm.linkedElements(true),"attachments":[ _vm.value.pdf ]}})],1),(_vm.hasModule('stock-tracabilities'))?_c('b-tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Lots de produit "),_c('b-badge',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.countLots)+" ")])]},proxy:true}],null,false,1452956786)},[_c('LotList',{ref:"lots",attrs:{"linkedElement":{ type: 'providerCommand', id: _vm.value.id }},on:{"lotCreated":function($event){return _vm.$emit('reloadCommand')},"lotUpdated":function($event){return _vm.$emit('reloadCommand')},"lotDeleted":function($event){return _vm.$emit('reloadCommand')}}})],1):_vm._e(),(_vm.linkedSalesContents.length > 0)?_c('b-tab',{attrs:{"title":"Ventes liées","lazy":""}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Produit")]),_c('th',[_vm._v("Élément(s)")])])]),_c('tbody',_vm._l((_vm.linkedSalesContents),function(content,i){return _c('tr',{key:i},[_c('td',{attrs:{"rowspan":content.affair_contents.length}},[_vm._v(_vm._s(content.product?.reference))]),_c('td',{attrs:{"rowspan":content.affair_contents.length}},[_vm._v(_vm._s(content.product?.name))]),_c('td',[_vm._l((content.affair_contents),function(sales,j){return [_c('b-row',{key:j,class:{ 'border-top': j > 0, 'mx-0': true }},[_c('b-col',[(sales.quotation)?_c('router-link',{attrs:{"to":{ name: 'quotation-item', params: { id: sales.quotation.id} }}},[_vm._v(" "+_vm._s(sales.quotation?.reference))]):_vm._e(),(sales.quotation && sales.command)?_c('span',[_vm._v(", ")]):_vm._e(),(sales.command)?_c('router-link',{attrs:{"to":{ name: 'command-item', params: { id: sales.command.id} }}},[_vm._v(" "+_vm._s(sales.command?.reference))]):_vm._e(),((sales.quotation || sales.command) && sales.proforma)?_c('span',[_vm._v(", ")]):_vm._e(),(sales.proforma)?_c('router-link',{attrs:{"to":{ name: 'proforma-item', params: { id: sales.proforma.id} }}},[_vm._v(" "+_vm._s(sales.proforma?.reference)+" ")]):_vm._e()],1),_c('b-col',{attrs:{"cols":"12","xl":"auto"}},[_vm._v(" Qté : "+_vm._s(_vm.showNumber(sales.quantity))+" ")])],1)]})],2)])}),0)])])]):_vm._e()],1)],1)],1),_c('FormModal',{attrs:{"title":"Livraison de la commande fournisseur","size":"xxl"},model:{value:(_vm.commandReceipt),callback:function ($$v) {_vm.commandReceipt=$$v},expression:"commandReceipt"}},[_c('CommandReceipt',{on:{"delivered":command => _vm.$emit('input', command)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),(_vm.commandStatusDelivery !== null)?_c('b-modal',{attrs:{"visible":"","title":"","cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.continue'),"no-close-on-backdrop":_vm.commandStatusLoading,"hide-header-close":_vm.commandStatusLoading,"busy":_vm.commandStatusLoading},on:{"ok":_vm.updateCommandStatus,"hidden":function($event){_vm.commandStatusDelivery = null}}},[(_vm.commandStatusLoading)?_c('Spinner'):_c('div',[_vm._v(" Êtes-vous sûr de vouloir marquer cette commande comme "),(_vm.commandStatusDelivery === 2)?[_vm._v(" en attente de livraison ")]:[_vm._v(" livrée ")],_vm._v(" ? "),(_vm.teamConfigs.stock_real_entry === 1 && _vm.commandStatusDelivery === 3)?_c('b-alert',{staticClass:"p-2 mt-3 mb-0",attrs:{"show":"","variant":"warning"}},[_vm._v(" Tous les produits seront automatiquement ajoutés au stock ")]):_vm._e()],2)],1):_vm._e(),_c('CommandDelete',{on:{"deleted":function($event){return _vm.$router.push({ name: 'stock-commands' })}},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// external "@kwixeo/communication-vue"
var communication_vue_namespaceObject = require("@kwixeo/communication-vue");
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
;// external "@kwixeo/calendars-vue"
var calendars_vue_namespaceObject = require("@kwixeo/calendars-vue");
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/CommandDelete/CommandDelete.vue + 3 modules
var CommandDelete = __webpack_require__(8674);
// EXTERNAL MODULE: ./src/components/CommandReceipt/CommandReceipt.vue + 3 modules
var CommandReceipt = __webpack_require__(2600);
// EXTERNAL MODULE: ./src/components/LotList/LotList.vue + 3 modules
var LotList = __webpack_require__(7666);
// EXTERNAL MODULE: ./src/components/PdfViewer/PdfViewer.vue + 3 modules
var PdfViewer = __webpack_require__(7611);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandCharge/CommandCharge.vue?vue&type=template&id=579b41ea
var CommandChargevue_type_template_id_579b41ea_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" Créer une charge "),(_vm.modal)?_c('FormModal',{attrs:{"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"ok-only":_vm.errorMsg !== null,"visible":""},on:{"hidden":function($event){_vm.modal = false}}},[(_vm.errorMsg)?_c('b-alert',{staticClass:"mb-0",attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_c('k-form',{attrs:{"action":'/catalog/command/' + _vm.command.id + '/charge'},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('p',[_vm._v(" Êtes-vous sûr de vouloir créer une charge ? ")]),_c('b-form-group',{attrs:{"label":"Date de la charge"}},[_c('k-form-datepicker',{attrs:{"name":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('b-form-radio-group',{attrs:{"name":"only_delivered"},model:{value:(_vm.onlyDelivered),callback:function ($$v) {_vm.onlyDelivered=$$v},expression:"onlyDelivered"}},[_c('b-form-radio',{staticClass:"mb-2",attrs:{"value":false}},[_vm._v(" Prendre en compte toutes les lignes ")]),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" Ne prendre en compte que les produits livrés ")])],1),(_vm.command.charges?.length > 0)?_c('p',{staticClass:"mt-3 mb-0 font-weight-bold text-danger"},[_vm._v(" Les charges déjà créées seront automatiquement déduites. ")]):_vm._e(),_c('k-form-checkbox',{staticClass:"mt-4",attrs:{"name":"add_draft"},model:{value:(_vm.addDraft),callback:function ($$v) {_vm.addDraft=$$v},expression:"addDraft"}},[_vm._v(" Ajouter à une charge existante "),_c('p',{staticClass:"text-muted text-justify small mb-0"},[_vm._v(" Si une charge du même fournisseur existe au statut brouillon, alors les produits seront ajoutés à la charge au lieu de créer une nouvelle charge. ")])])],1)],1):_vm._e()],1)
}
var CommandChargevue_type_template_id_579b41ea_staticRenderFns = []


// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandCharge/CommandCharge.ts?vue&type=script&lang=ts&external







var CommandCharge = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandCharge, _super);
    function CommandCharge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.date = null;
        _this.onlyDelivered = false;
        _this.addDraft = false;
        _this.errorMsg = null;
        return _this;
    }
    CommandCharge.prototype.watchModal = function () {
        if (this.modal) {
            this.date = (0,interface_vue_.moment)().format('YYYY-MM-DD');
            this.errorMsg = null;
            this.onlyDelivered = this.teamConfigs.provider_command_charge_delivered;
            this.addDraft = this.teamConfigs.provider_command_charge_add_draft;
        }
    };
    CommandCharge.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'charges-item',
                            params: {
                                id: String(response.data.id)
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommandCharge.prototype.submitError = function (error) {
        var _a, _b, _c;
        this.errorMsg = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommandCharge.prototype, "command", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommandCharge.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommandCharge.prototype, "watchModal", null);
    CommandCharge = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox,
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], CommandCharge);
    return CommandCharge;
}((external_vue_default())));
/* harmony default export */ var CommandChargevue_type_script_lang_ts_external = (CommandCharge);

;// ./src/components/CommandCharge/CommandCharge.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandCharge_CommandChargevue_type_script_lang_ts_external = (CommandChargevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommandCharge/CommandCharge.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandCharge_CommandChargevue_type_script_lang_ts_external,
  CommandChargevue_type_template_id_579b41ea_render,
  CommandChargevue_type_template_id_579b41ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandCharge_CommandCharge = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandItem/CommandItem.ts?vue&type=script&lang=ts&external














var CommandItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandItem, _super);
    function CommandItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toDelete = null; // to delete modal marker
        _this.tabsLeftIndex = 0; // Marker for active tab
        _this.commandReceipt = false; // Marker for modal receipt mode
        _this.commandStatusDelivery = null; // Marker for delivery status modal
        _this.commandStatusLoading = false; // Marker for delivery status process
        return _this;
    }
    Object.defineProperty(CommandItem.prototype, "commandHasLots", {
        // Check the command content has products with stock tracabilities
        get: function () {
            return this.value.contents.filter(function (content) {
                return content.product && content.product.stock_tracking_mode !== 0 && content.quantity_to_deliver > 0;
            }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandItem.prototype, "headerButtons", {
        // Return header buttons
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('manage-stock', 1)) {
                buttons.push({
                    label: this.$t('interface.edit'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setPageParams(this.value);
                                    return [4 /*yield*/, this.$router.push({
                                            name: 'stock-command-form',
                                            params: {
                                                id: String(this.value.id)
                                            }
                                        })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.can('manage-stock', 1)) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Réception',
                        click: function () {
                            _this.commandReceipt = true;
                        }
                    },
                    {
                        label: 'Fichier',
                        click: function () {
                            interface_vue_.emitter.emit('selectFiles-providerCommand-' + _this.value.id);
                        }
                    }
                ]);
            }
            if (this.hasModule('task') && this.can('task', 1)) {
                buttons.push({
                    label: 'Tâche',
                    click: function () {
                        _this.openModal({
                            key: 'task-form',
                            value: {
                                elements: _this.linkedElements(true)
                            }
                        });
                    }
                });
            }
            var relations = [];
            if (this.can('send-mail', 1)) {
                relations.push({
                    component: communication_vue_namespaceObject.SendEmailButton,
                    attributes: {
                        customer: this.value.provider,
                        contact: this.value.contact,
                        element: 'dropdown',
                        linkedElements: this.linkedElements(),
                        attachments: [this.value.pdf]
                    }
                });
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_namespaceObject.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        customer: this.value.provider,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_namespaceObject.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        customer: this.value.provider,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_namespaceObject.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements(true)
                    }
                });
            }
            if (relations.length > 1) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-email', 1)) {
                buttons.push({
                    component: communication_vue_namespaceObject.SendEmailButton,
                    attributes: {
                        customer: this.value.provider,
                        contact: this.value.contact,
                        element: 'button',
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.can('manage-stock', 1)) {
                buttons.push({
                    label: 'Autres',
                    items: [
                        {
                            label: 'Cloner',
                            click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.setPageParams(this.value);
                                            return [4 /*yield*/, this.$router.push({ name: 'stock-command-form' })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        },
                        {
                            label: this.$t('interface.delete'),
                            click: function () {
                                _this.toDelete = _this.value.id;
                            }
                        }
                    ]
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandItem.prototype, "linkedElements", {
        get: function () {
            var _this = this;
            return function (withCustomer) {
                if (withCustomer === void 0) { withCustomer = false; }
                var elements = [{
                        title: _this.value.reference,
                        type: 'providerCommand',
                        id: _this.value.id,
                        data: _this.value
                    }];
                if (withCustomer) {
                    var provider = _this.value.provider;
                    if (provider) {
                        elements.push({
                            title: provider.name,
                            type: 'customer',
                            id: provider.id,
                            data: provider
                        });
                    }
                    var contact = _this.value.contact;
                    if (contact) {
                        elements.push({
                            title: contact.fullname,
                            type: 'contact',
                            id: contact.id,
                            data: contact
                        });
                    }
                }
                return elements;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandItem.prototype, "commandStatus", {
        // Return all status for status bar
        get: function () {
            var _this = this;
            return [
                { value: 0, label: 'Brouillon' },
                { value: 1, label: 'En attente de livraison' },
                { value: 2, label: 'Livrée partiellement' },
                { value: 3, label: 'Livrée' }
            ].filter(function (status) {
                return status.value !== 2 || (status.value === 2 && status.value === _this.value.status);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandItem.prototype, "countLots", {
        get: function () {
            var nb = 0;
            this.value.contents.forEach(function (content) {
                nb += content.lots ? content.lots.length : 0;
            });
            return nb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandItem.prototype, "linkedSalesContents", {
        get: function () {
            return this.value.contents.filter(function (content) { var _a, _b; return 'affair_contents' in content && ((_b = (_a = content.affair_contents) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; });
        },
        enumerable: false,
        configurable: true
    });
    CommandItem.prototype.watchContent = function () {
        if (!this.$refs.lots) {
            return;
        }
        var lots = this.$refs.lots;
        lots.refresh();
    };
    // Mark the command as delivered
    CommandItem.prototype.updateCommandStatus = function (evt) {
        var _this = this;
        evt.preventDefault();
        this.commandStatusLoading = true;
        this.$kwCatalog.axios.put('/catalog/command/' + this.value.id, {
            status: this.commandStatusDelivery
        })
            .then(function (response) {
            _this.$emit('input', response.data);
        })
            .catch(function (error) {
            throw new Error(error);
        })
            .finally(function () {
            _this.commandStatusDelivery = null;
            _this.commandStatusLoading = false;
        });
    };
    CommandItem.prototype.pdfLoaded = function (file) {
        var command = JSON.parse(JSON.stringify(this.value));
        command.pdf_status = 2;
        command.pdf = file;
        this.$emit('input', command);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommandItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value.content', { deep: true })
    ], CommandItem.prototype, "watchContent", null);
    CommandItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandDelete: CommandDelete/* default */.A, CommandReceipt: CommandReceipt/* default */.A, LotList: LotList/* default */.A, PdfViewer: PdfViewer/* default */.A,
                Spinner: interface_vue_.Spinner, PageHeader: interface_vue_.PageHeader, FormModal: interface_vue_.FormModal, TextareaView: interface_vue_.TextareaView, AppMessages: interface_vue_.AppMessages,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem, ContactSpeedItem: customers_vue_.ContactSpeedItem,
                AgregateDatas: communication_vue_namespaceObject.AgregateDatas,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BBadge: external_bootstrap_vue_.BBadge,
                CommandCharge: CommandCharge_CommandCharge
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
        })
    ], CommandItem);
    return CommandItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var CommandItemvue_type_script_lang_ts_external = (CommandItem);

;// ./src/components/CommandItem/CommandItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandItem_CommandItemvue_type_script_lang_ts_external = (CommandItemvue_type_script_lang_ts_external); 
;// ./src/components/CommandItem/CommandItem.vue





/* normalize component */
;
var CommandItem_component = (0,componentNormalizer/* default */.A)(
  CommandItem_CommandItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandItem_CommandItem = (CommandItem_component.exports);

/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Mj = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleCategoryForm_SaleCategoryForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleCategoryForm/SaleCategoryForm.vue?vue&type=template&id=0717dc64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.localCategory.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.saleCategory.form.name')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.localCategory.label),callback:function ($$v) {_vm.$set(_vm.localCategory, "label", $$v)},expression:"localCategory.label"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.saleCategory.form.parent')}},[_c('k-form-select',{attrs:{"name":"parent","ajax":_vm.ajaxUrl,"reduce":opt => opt.id},model:{value:(_vm.localCategory.parent),callback:function ($$v) {_vm.$set(_vm.localCategory, "parent", $$v)},expression:"localCategory.parent"}})],1),(!_vm.localCategory.account_by_vatrate)?_c('b-form-group',{attrs:{"label":_vm.$t('catalog.saleCategory.form.accountNumberLabel')}},[_c('k-form-input',{attrs:{"name":"account_number"},model:{value:(_vm.localCategory.account_number),callback:function ($$v) {_vm.$set(_vm.localCategory, "account_number", $$v)},expression:"localCategory.account_number"}})],1):_vm._e(),_c('b-form-group',[_c('k-form-checkbox',{attrs:{"name":"account_by_vatrate"},model:{value:(_vm.localCategory.account_by_vatrate),callback:function ($$v) {_vm.$set(_vm.localCategory, "account_by_vatrate", $$v)},expression:"localCategory.account_by_vatrate"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.saleCategory.form.accountByVatRate'))+" ")])],1),(_vm.localCategory.account_by_vatrate)?_c('div',[_c('table',{staticClass:"table table-sm w-100"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.saleCategory.form.vatRate')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.saleCategory.form.accountNumber')))])])]),_c('tbody',_vm._l((_vm.vatRates),function(rate,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(rate.rate)+" %")]),_c('td',[_c('k-form-input',{attrs:{"name":'vat_rates_accounts[' + i + '][value]',"value":_vm.getVatRateAccount(rate)}}),_c('input',{attrs:{"type":"hidden","name":'vat_rates_accounts[' + i + '][id]'},domProps:{"value":rate.id}})],1)])}),0)])]):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleCategoryForm/SaleCategoryForm.ts?vue&type=script&lang=ts&external







var SaleCategoryForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleCategoryForm, _super);
    function SaleCategoryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.localCategory = {};
        return _this;
    }
    SaleCategoryForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setLocalCategory(this.value);
                        return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SaleCategoryForm.prototype.watchCategory = function (category) {
        this.setLocalCategory(category);
    };
    Object.defineProperty(SaleCategoryForm.prototype, "apiUrl", {
        get: function () {
            return '/catalog/sale_category';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleCategoryForm.prototype, "formUrl", {
        get: function () {
            var url = this.apiUrl;
            if (this.localCategory.id) {
                url += '/' + this.localCategory.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaleCategoryForm.prototype, "ajaxUrl", {
        get: function () {
            var url = this.apiUrl + '?sort=label&filter[is_parent]=1';
            if (this.localCategory.id) {
                url += '&filter[exclude]=' + this.localCategory.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    SaleCategoryForm.prototype.setLocalCategory = function (category) {
        this.localCategory = category ? JSON.parse(JSON.stringify(category)) : {};
    };
    SaleCategoryForm.prototype.getVatRateAccount = function (rate) {
        var _a;
        var accounts = (_a = this.localCategory.accounts) !== null && _a !== void 0 ? _a : [];
        var account = accounts.find(function (account) { return account.vatrate.id === rate.id; });
        return account ? account.account_number : null;
    };
    SaleCategoryForm.prototype.formSubmitted = function (response) {
        return response;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SaleCategoryForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], SaleCategoryForm.prototype, "watchCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], SaleCategoryForm.prototype, "formSubmitted", null);
    SaleCategoryForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['vatRates'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], SaleCategoryForm);
    return SaleCategoryForm;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleCategoryFormvue_type_script_lang_ts_external = (SaleCategoryForm);

;// ./src/components/SaleCategoryForm/SaleCategoryForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleCategoryForm_SaleCategoryFormvue_type_script_lang_ts_external = (SaleCategoryFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/SaleCategoryForm/SaleCategoryForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleCategoryForm_SaleCategoryFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleCategoryForm_SaleCategoryForm = (component.exports);

/***/ }),

/***/ 756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(756),
    keys = __webpack_require__(5950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 867:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'expand-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f424';
var svgPathData = 'M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.vQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f067';
var svgPathData = 'M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223),
    MapCache = __webpack_require__(3661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CommandFormView_CommandFormView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandFormView/CommandFormView.vue?vue&type=template&id=fd48b270
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('CommandForm',{model:{value:(_vm.command),callback:function ($$v) {_vm.command=$$v},expression:"command"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommandForm/CommandForm.vue + 23 modules
var CommandForm = __webpack_require__(8131);
// EXTERNAL MODULE: ./src/mixins/LoadCommandMixin.ts
var LoadCommandMixin = __webpack_require__(4873);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/CommandFormView/CommandFormView.ts?vue&type=script&lang=ts&external




var CommandFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandFormView, _super);
    function CommandFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommandFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandForm: CommandForm/* default */.A
            }
        })
    ], CommandFormView);
    return CommandFormView;
}((0,lib/* Mixins */.Xe)(LoadCommandMixin/* default */.A)));
/* harmony default export */ var CommandFormViewvue_type_script_lang_ts_external = (CommandFormView);

;// ./src/views/CommandFormView/CommandFormView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandFormView_CommandFormViewvue_type_script_lang_ts_external = (CommandFormViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CommandFormView/CommandFormView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandFormView_CommandFormViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandFormView_CommandFormView = (component.exports);

/***/ }),

/***/ 999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(9302),
    isIterateeCall = __webpack_require__(6800);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 1033:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 1042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fetchDatas_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(459);
/* harmony import */ var _components_ServiceItem_ServiceItem_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4204);






var LoadServiceMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__extends */ .C6)(LoadServiceMixin, _super);
    function LoadServiceMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.service = null;
        return _this;
    }
    LoadServiceMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapState)('app', ['pageParams'])),
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.Spinner,
                ServiceItem: _components_ServiceItem_ServiceItem_vue__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var pageParams;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageParams = vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD.prototype.$kwCatalog.store.state.app.pageParams;
                                if (pageParams && !(0,_fetchDatas_service__WEBPACK_IMPORTED_MODULE_3__/* .needFetchService */ .cu)(pageParams)) {
                                    next(function (vm) {
                                        vm.service = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_service__WEBPACK_IMPORTED_MODULE_3__/* .fetchService */ .Ox)(to.params.id)
                                        .then(function (service) {
                                        next(function (vm) {
                                            vm.service = service;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var service;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    service = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,_fetchDatas_service__WEBPACK_IMPORTED_MODULE_3__/* .needFetchService */ .cu)(service)) {
                                        this.service = service;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                this.loading = true;
                                this.service = null;
                                return [4 /*yield*/, (0,_fetchDatas_service__WEBPACK_IMPORTED_MODULE_3__/* .fetchService */ .Ox)(to.params.id)
                                        .then(function (service) {
                                        _this.service = service;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], LoadServiceMixin);
    return LoadServiceMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (LoadServiceMixin);


/***/ }),

/***/ 1126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(5389),
    baseSum = __webpack_require__(7721);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),

/***/ 1175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 1227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ VariationValues_VariationValues; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VariationValues/VariationValues.vue?vue&type=template&id=731e001e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('catalog.productVariations.newValue'),"updateTitle":_vm.$t('catalog.productVariations.editValue'),"deleteMsg":_vm.$t('catalog.productVariations.deleteValueMsg'),"deleteAlertMessage":_vm.$t('catalog.productVariations.deleteValueAlertMessage'),"sort":"value"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/VariationValues/VariationValues.ts?vue&type=script&lang=ts&external



var VariationValues = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(VariationValues, _super);
    function VariationValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VariationValues.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('catalog.productVariations.labelValue'),
                    key: 'value'
                },
                {
                    label: this.$t('catalog.productVariations.nbVariationsValue'),
                    key: 'product_variations_count',
                    hideOnForm: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariationValues.prototype, "apiUrl", {
        get: function () {
            return '/catalog/variation/' + this.value.id + '/value';
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], VariationValues.prototype, "value", void 0);
    VariationValues = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], VariationValues);
    return VariationValues;
}(lib/* Vue */.lD));
/* harmony default export */ var VariationValuesvue_type_script_lang_ts_external = (VariationValues);

;// ./src/components/VariationValues/VariationValues.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var VariationValues_VariationValuesvue_type_script_lang_ts_external = (VariationValuesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/VariationValues/VariationValues.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  VariationValues_VariationValuesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VariationValues_VariationValues = (component.exports);

/***/ }),

/***/ 1256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'shopping-cart';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f07a';
var svgPathData = 'M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports._R = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    getPrototype = __webpack_require__(8879),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 1380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductVariationForm_ProductVariationForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductVariationForm/ProductVariationForm.vue?vue&type=template&id=f1a37a1e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle,"size":"lg"},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Référence"}},[_c('k-form-input',{attrs:{"required":"","name":"reference"},model:{value:(_vm.variation.reference),callback:function ($$v) {_vm.$set(_vm.variation, "reference", $$v)},expression:"variation.reference"}})],1)],1),(!_vm.hasModule('stock-locations'))?[_c('b-col',[(_vm.product.with_stock)?_c('b-form-group',{attrs:{"label":"Quantité réelle en stock"}},[_c('k-form-spinner',{attrs:{"name":"stock_quantity"},model:{value:(_vm.variation.stock_quantity),callback:function ($$v) {_vm.$set(_vm.variation, "stock_quantity", $$v)},expression:"variation.stock_quantity"}})],1):_vm._e()],1),_c('b-col',[(_vm.product.with_stock)?_c('b-form-group',{attrs:{"label":"Quantité théorique en stock"}},[_c('k-form-spinner',{attrs:{"name":"stock_theoretical_quantity"},model:{value:(_vm.variation.stock_theoretical_quantity),callback:function ($$v) {_vm.$set(_vm.variation, "stock_theoretical_quantity", $$v)},expression:"variation.stock_theoretical_quantity"}})],1):_vm._e()],1)]:_vm._e()],2),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Informations sur la variation ")]),(!_vm.variation.id)?_c('div',[_c('b-row',[(_vm.product.variation_level1)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level1.label ?? 'Niveau 1'}},[_c('input',{attrs:{"type":"hidden","name":"level1"},domProps:{"value":_vm.variationValue(_vm.variation?.level1)}}),_c('k-form-select',{attrs:{"ajax":_vm.variationValuesUrl(_vm.product.variation_level1.id),"label":"value","reduce":opt => typeof opt === 'string' ? opt : opt.value,"required":"","taggable":"","clearable":false},model:{value:(_vm.variation.level1),callback:function ($$v) {_vm.$set(_vm.variation, "level1", $$v)},expression:"variation.level1"}})],1)],1):_vm._e(),(_vm.product.variations_length > 1 && _vm.product.variation_level2)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level2.label ?? 'Niveau 2'}},[_c('input',{attrs:{"type":"hidden","name":"level2"},domProps:{"value":_vm.variationValue(_vm.variation?.level2)}}),_c('k-form-select',{attrs:{"ajax":_vm.variationValuesUrl(_vm.product.variation_level2.id),"label":"value","reduce":opt => typeof opt === 'string' ? opt : opt.value,"required":"","taggable":"","clearable":false},model:{value:(_vm.variation.level2),callback:function ($$v) {_vm.$set(_vm.variation, "level2", $$v)},expression:"variation.level2"}})],1)],1):_vm._e(),(_vm.product.variations_length > 2 && _vm.product.variation_level3)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level3.label ?? 'Niveau 3'}},[_c('input',{attrs:{"type":"hidden","name":"level3"},domProps:{"value":_vm.variationValue(_vm.variation?.level3)}}),_c('k-form-select',{attrs:{"ajax":_vm.variationValuesUrl(_vm.product.variation_level3.id),"label":"value","reduce":opt => typeof opt === 'string' ? opt : opt.value,"required":"","taggable":"","clearable":false},model:{value:(_vm.variation.level3),callback:function ($$v) {_vm.$set(_vm.variation, "level3", $$v)},expression:"variation.level3"}})],1)],1):_vm._e()],1),_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(" Si vous utilisez les mêmes valeurs pour tous les niveaux de variation qu'une autre variation, aucune variation ne sera créée, c'est la variation correspondante qui sera mise à jour. ")])],1):_c('b-form-row',[(_vm.product.variation_level1)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level1.label ?? 'Niveau 1'}},[_vm._v(" "+_vm._s(_vm.variation.level1.value)+" ")])],1):_vm._e(),(_vm.variation.level2 && _vm.product.variation_level2)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level2.label ?? 'Niveau 2'}},[_vm._v(" "+_vm._s(_vm.variation.level2.value)+" ")])],1):_vm._e(),(_vm.variation.level3 && _vm.product.variation_level3)?_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level3.label ?? 'Niveau 3'}},[_vm._v(" "+_vm._s(_vm.variation.level3.value)+" ")])],1):_vm._e()],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Prix de vente ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Prix U. HT"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ht"},on:{"input":function($event){return _vm.calculUnitPrices('ht')}},model:{value:(_vm.variation.unit_price_ht),callback:function ($$v) {_vm.$set(_vm.variation, "unit_price_ht", $$v)},expression:"variation.unit_price_ht"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":'TVA ' + this.showNumber(_vm.product.vat_rate ? _vm.product.vat_rate.rate : 0, 2) + ' %'}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"readonly":""},model:{value:(_vm.variation.unit_price_tva),callback:function ($$v) {_vm.$set(_vm.variation, "unit_price_tva", $$v)},expression:"variation.unit_price_tva"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Prix U. TTC"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ttc"},on:{"input":function($event){return _vm.calculUnitPrices('ttc')}},model:{value:(_vm.variation.unit_price_ttc),callback:function ($$v) {_vm.$set(_vm.variation, "unit_price_ttc", $$v)},expression:"variation.unit_price_ttc"}})],1)],1)],1)],1),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Référence fournisseur"}},[_c('k-form-input',{attrs:{"name":"provider_reference"},model:{value:(_vm.variation.provider_reference),callback:function ($$v) {_vm.$set(_vm.variation, "provider_reference", $$v)},expression:"variation.provider_reference"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Prix d'achat"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"buy_price_ht"},model:{value:(_vm.variation.buy_price_ht),callback:function ($$v) {_vm.$set(_vm.variation, "buy_price_ht", $$v)},expression:"variation.buy_price_ht"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Code ean"}},[_c('k-form-input',{attrs:{"name":"ean_code"},model:{value:(_vm.variation.ean_code),callback:function ($$v) {_vm.$set(_vm.variation, "ean_code", $$v)},expression:"variation.ean_code"}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductVariationForm/ProductVariationForm.ts?vue&type=script&lang=ts&external






var ProductVariationForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariationForm, _super);
    function ProductVariationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.variation = {};
        return _this;
    }
    Object.defineProperty(ProductVariationForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return ((_a = this.variation) === null || _a === void 0 ? void 0 : _a.id) ? 'Modification d\'une variation' : 'Ajout d\'une variation';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.variation) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/catalog/product/' + this.product.id + '/variation';
            if ((_a = this.variation) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.variation.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationForm.prototype, "variationValuesUrl", {
        get: function () {
            return function (id) { return '/catalog/variation/' + id + '/value'; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationForm.prototype, "vatRate", {
        get: function () {
            return this.product.vat_rate ? this.product.vat_rate.rate : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationForm.prototype, "variationValue", {
        get: function () {
            return function (value) {
                if (typeof value === 'string') {
                    return value;
                }
                else if (value === null || value === undefined) {
                    return null;
                }
                else {
                    return value.value;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    ProductVariationForm.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    ProductVariationForm.prototype.watchValue = function () {
        this.variation = this.value ? JSON.parse(JSON.stringify(this.value)) : {};
    };
    ProductVariationForm.prototype.calculUnitPrices = function (mode) {
        var _a, _b;
        var ttc = 0;
        var tva = 0;
        var ht = 0;
        if (mode === 'ttc') {
            ttc = this.number((_a = this.variation) === null || _a === void 0 ? void 0 : _a.unit_price_ttc);
            ht = this.roundNumber(ttc / (1 + (this.vatRate / 100)), 5);
            tva = ttc - ht;
        }
        else {
            ht = this.number((_b = this.variation) === null || _b === void 0 ? void 0 : _b.unit_price_ht);
            tva = this.roundNumber(ht * (this.vatRate / 100), 2);
            ttc = ht + tva;
        }
        if (this.variation) {
            this.variation.unit_price_ht = ht;
            this.variation.unit_price_tva = tva;
            this.variation.unit_price_ttc = ttc;
        }
    };
    ProductVariationForm.prototype.submitComplete = function (response) {
        this.$emit('submitComplete', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductVariationForm.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductVariationForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ProductVariationForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal')
    ], ProductVariationForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], ProductVariationForm.prototype, "watchValue", null);
    ProductVariationForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                BAlert: external_bootstrap_vue_.BAlert, BFormRow: external_bootstrap_vue_.BFormRow, BRow: external_bootstrap_vue_.BRow, BInputGroup: external_bootstrap_vue_.BInputGroup, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner, KFormNumber: form_vue_.KFormNumber
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], ProductVariationForm);
    return ProductVariationForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ProductVariationFormvue_type_script_lang_ts_external = (ProductVariationForm);

;// ./src/components/ProductVariationForm/ProductVariationForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductVariationForm_ProductVariationFormvue_type_script_lang_ts_external = (ProductVariationFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductVariationForm/ProductVariationForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductVariationForm_ProductVariationFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductVariationForm_ProductVariationForm = (component.exports);

/***/ }),

/***/ 1420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 1459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2032),
    hashDelete = __webpack_require__(3862),
    hashGet = __webpack_require__(6721),
    hashHas = __webpack_require__(2749),
    hashSet = __webpack_require__(5749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 1565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CommandListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandListView.vue?vue&type=template&id=a1fdf3ac
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommandList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommandList/CommandList.vue + 3 modules
var CommandList = __webpack_require__(4429);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandListView.vue?vue&type=script&lang=ts



var CommandListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandListView, _super);
    function CommandListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommandListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandList: CommandList/* default */.A
            }
        })
    ], CommandListView);
    return CommandListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CommandListViewvue_type_script_lang_ts = (CommandListView);

;// ./src/views/CommandListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CommandListViewvue_type_script_lang_ts = (CommandListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CommandListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CommandListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CommandListView = (component.exports);

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1658:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'trash';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1f8';
var svgPathData = 'M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_MouvementListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MouvementListView.vue?vue&type=template&id=33adf2e2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MovementList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/MovementList/MovementList.vue + 3 modules
var MovementList = __webpack_require__(5593);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MouvementListView.vue?vue&type=script&lang=ts



var MouvementListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MouvementListView, _super);
    function MouvementListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MouvementListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                MovementList: MovementList/* default */.A
            }
        })
    ], MouvementListView);
    return MouvementListView;
}(lib/* Vue */.lD));
/* harmony default export */ var MouvementListViewvue_type_script_lang_ts = (MouvementListView);

;// ./src/views/MouvementListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_MouvementListViewvue_type_script_lang_ts = (MouvementListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/MouvementListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_MouvementListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_MouvementListView = (component.exports);

/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isKey = __webpack_require__(8586),
    stringToPath = __webpack_require__(1802),
    toString = __webpack_require__(3222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 1774:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'list';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f03a';
var svgPathData = 'M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.IT = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1790:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'star';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f005';
var svgPathData = 'M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yy = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    baseAssignValue = __webpack_require__(3360);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 1798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LotItem_LotItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotItem/LotItem.vue?vue&type=template&id=ca028f16
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"title":"Détail du lot","visible":_vm.modalState,"size":"xl"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-form-row',{staticClass:"w-100"},[(_vm.lot !== null)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.$emit('toEdit'); close()}}},[_vm._v(" Modifier ")]),_c('b-button',{on:{"click":function($event){$event.preventDefault();_vm.$emit('toDelete'); close()}}},[_vm._v(" Supprimer ")])],1):_vm._e(),_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}])},[(_vm.lot === null)?_c('Spinner'):_c('div',[_c('b-form-row',[_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.productReference')}},[_vm._v(" "+_vm._s(_vm.lot.product.reference)+" ")])],1),_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.productName')}},[_vm._v(" "+_vm._s(_vm.lot.product.name)+" ")])],1),(_vm.hasModule('stock-locations') && _vm.lot.stock_location)?_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Lieu de stock"}},[_vm._v(" "+_vm._s(_vm.lot.stock_location.name)+" ")])],1):_vm._e()],1),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.expire' + _vm.lot.product.stock_tracking_mode)}},[_vm._v(" "+_vm._s(_vm.lot.expire_at ? _vm.date(_vm.lot.expire_at) : 'Non renseignée')+" ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.reference' + _vm.lot.product.stock_tracking_mode)}},[_vm._v(" "+_vm._s(_vm.lot.reference)+" ")])],1),(_vm.lot.product.stock_tracking_mode === 1)?[_c('b-col',{staticClass:"mx-md-4",attrs:{"cols":"6","md":"auto"}},[_c('b-form-group',{staticClass:"text-center",attrs:{"label":_vm.$t('catalog.productLot.form.quantity')}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.lot.quantity))+" ")])],1),_c('b-col',{attrs:{"cols":"6","md":"auto"}},[_c('b-form-group',{staticClass:"text-center",attrs:{"label":_vm.$t('catalog.productLot.form.stockQuantity')}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.lot.stock_quantity))+" ")])],1)]:[_c('b-col',{class:{
              'pt-4': true,
              'font-weight-bold': true,
              'text-danger': _vm.lot.stock_quantity === 0,
              'text-success': _vm.lot.stock_quantity > 0,
            },attrs:{"cols":"6","md":"auto"}},[_vm._v(" "+_vm._s(_vm.lot.stock_quantity ? 'En stock' : 'Stock épuisé')+" ")])]],2),_c('b-form-group',{attrs:{"label":"Origine du lot :"}},[(_vm.lot.origin_type === 'providerCommandContent')?_c('router-link',{attrs:{"to":{ name: 'stock-command-item', params: { id: String(_vm.lot.origin.id) }}}},[_vm._v(" "+_vm._s(_vm.originLabel)+" ")]):(_vm.lot.origin_type === 'stockManualContent')?_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.showManualMovement(_vm.lot.origin)}}},[_vm._v(" "+_vm._s(_vm.originLabel)+" ")]):[_vm._v(" "+_vm._s(_vm.originLabel)+" ")]],2),_c('b-form-group',{attrs:{"label":"Utilisation du lot :"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap"},[_c('thead',[_c('tr',[(_vm.withDate)?_c('th',[_vm._v("Date")]):_vm._e(),_c('th',[_vm._v("Element")]),_c('th',[_vm._v("Quantité")])])]),_c('tbody',[(_vm.lot.uses.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-3",attrs:{"colspan":_vm.withDate ? 3 : 2}},[_vm._v(" Aucune utilisation ")])]):_vm._l((_vm.lot.uses),function(use,i){return _c('tr',{key:i},[(use.element_type === 'affairContent')?[_c('td',{attrs:{"colspan":_vm.withDate ? 2 : 1}},[_vm._l((use.element),function(el,i){return [(i > 0)?_c('span',{key:'separator-' + i},[_vm._v(", ")]):_vm._e(),_c('router-link',{key:i,attrs:{"variant":"light","to":{
                          name: el.type + '-item',
                          params: {
                            id: String(el.id)
                          }
                        }}},[_vm._v(_vm._s(_vm.$t('sales.' + el.type + '.reference', { reference: el.reference })))])]})],2)]:[_c('td',[_vm._v(_vm._s(use.element ? _vm.date(use.element.date) : null))]),_c('td',[(use.element_type === 'providerCommandContent' || use.element_type === 'deliveryContent')?_c('router-link',{attrs:{"to":{ name: use.element_type === 'providerCommandContent' ? 'stock-command-item' : 'delivery-item', params: { id: String(use.element.id) }}}},[_vm._v(" "+_vm._s(_vm.useLabel(use))+" ")]):(use.element_type === 'stockManualContent')?_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.showManualMovement(use.element)}}},[_vm._v(" "+_vm._s(_vm.useLabel(use))+" ")]):[_vm._v(" "+_vm._s(_vm.useLabel(use))+" ")]],2)],_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(use.quantity))])],2)})],2)])])])],1)],1),(_vm.manualMovementItem !== null)?_c('ManualMovementItem',{attrs:{"modalState":_vm.manualMovementItem !== null},on:{"hidden":function($event){_vm.manualMovementItem = null}},model:{value:(_vm.manualMovementItem),callback:function ($$v) {_vm.manualMovementItem=$$v},expression:"manualMovementItem"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/fetchDatas/lot.ts
var lot = __webpack_require__(2443);
// EXTERNAL MODULE: ./src/components/ManualMovementItem/ManualMovementItem.vue + 3 modules
var ManualMovementItem = __webpack_require__(2685);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotItem/LotItem.ts?vue&type=script&lang=ts&external







var LotItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotItem, _super);
    function LotItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lot = null;
        _this.manualMovementItem = null;
        return _this;
    }
    Object.defineProperty(LotItem.prototype, "originLabel", {
        get: function () {
            if (!this.lot) {
                return null;
            }
            var content;
            switch (this.lot.origin_type) {
                case 'stockManualContent':
                    content = this.lot.origin;
                    return 'Mouvement de stock manuel n°' + content.reference;
                case 'providerCommandContent':
                    content = this.lot.origin;
                    return 'Commande fournisseur n°' + content.reference;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotItem.prototype, "useLabel", {
        get: function () {
            return function (use) {
                if (!use) {
                    return null;
                }
                switch (use.element_type) {
                    case 'stockManualContent':
                        return 'Mouvement de stock manuel n°' + use.element.reference;
                    case 'providerCommandContent':
                        return 'Commande fournisseur n°' + use.element.reference;
                    default:
                        return null;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotItem.prototype, "withDate", {
        get: function () {
            var _a, _b, _c;
            return ((_c = (_b = (_a = this.lot) === null || _a === void 0 ? void 0 : _a.uses) === null || _b === void 0 ? void 0 : _b.filter(function (use) { return use.element_type !== 'affairContent'; }).length) !== null && _c !== void 0 ? _c : 0) > 0;
        },
        enumerable: false,
        configurable: true
    });
    LotItem.prototype.watchValue = function (value) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) {
                            return [2 /*return*/];
                        }
                        if (!(0,lot/* needFetchLot */.cm)(value)) return [3 /*break*/, 2];
                        this.lot = null;
                        return [4 /*yield*/, (0,lot/* fetchLot */.wc)(value.id)];
                    case 1:
                        value = _a.sent();
                        _a.label = 2;
                    case 2:
                        this.lot = JSON.parse(JSON.stringify(value));
                        return [2 /*return*/];
                }
            });
        });
    };
    LotItem.prototype.showManualMovement = function (movement) {
        this.manualMovementItem = movement;
        var modal = this.$refs.modal;
        modal.hide();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotItem.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LotItem.prototype, "watchValue", null);
    LotItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ManualMovementItem: ManualMovementItem/* default */.A,
                BModal: external_bootstrap_vue_.BModal, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], LotItem);
    return LotItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var LotItemvue_type_script_lang_ts_external = (LotItem);

;// ./src/components/LotItem/LotItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotItem_LotItemvue_type_script_lang_ts_external = (LotItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LotItem/LotItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LotItem_LotItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotItem_LotItem = (component.exports);

/***/ }),

/***/ 1799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    baseIsEqual = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 1802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 1811:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBooks.js
var faBooks = __webpack_require__(3502);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBoxOpen.js
var faBoxOpen = __webpack_require__(9361);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlus.js
var faPlus = __webpack_require__(906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faStar.js
var faStar = __webpack_require__(1790);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(726);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faMousePointer.js
var faMousePointer = __webpack_require__(3858);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faDownload.js
var faDownload = __webpack_require__(6614);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTrash.js
var faTrash = __webpack_require__(1658);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPencil.js
var faPencil = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTimes.js
var faTimes = __webpack_require__(2986);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faExpandAlt.js
var faExpandAlt = __webpack_require__(867);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faSpinnerThird.js
var faSpinnerThird = __webpack_require__(5149);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faWindowAlt.js
var faWindowAlt = __webpack_require__(9328);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faArrowsAltV.js
var faArrowsAltV = __webpack_require__(7430);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faTimes.js
var pro_regular_svg_icons_faTimes = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faStar.js
var pro_light_svg_icons_faStar = __webpack_require__(9915);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faList.js
var faList = __webpack_require__(1774);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faShoppingCart.js
var faShoppingCart = __webpack_require__(1256);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTruckContainer.js
var faTruckContainer = __webpack_require__(5344);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faMinus.js
var faMinus = __webpack_require__(3712);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faClone.js
var faClone = __webpack_require__(6729);
;// ./src/fontawesome.ts






















fontawesome_svg_core_namespaceObject.library.add(faBooks/* faBooks */.GL, faBoxOpen/* faBoxOpen */.LJ, faPlus/* faPlus */.QL, faStar/* faStar */.yy, faSearch/* faSearch */.Mj, faMousePointer/* faMousePointer */.ii, faDownload/* faDownload */.cb, faTrash/* faTrash */.yL, faPencil/* faPencil */.zL, faTrash/* faTrash */.yL, faTimes/* faTimes */.GR, faExpandAlt/* faExpandAlt */.vQ, faSpinnerThird/* faSpinnerThird */.sq, faWindowAlt/* faWindowAlt */.jA, faArrowsAltV/* faArrowsAltV */.zh, pro_regular_svg_icons_faTimes/* faTimes */.GR, pro_light_svg_icons_faStar/* faStar */.yy, faList/* faList */.IT, faShoppingCart/* faShoppingCart */._R, faTruckContainer/* faTruckContainer */.OF, faMinus/* faMinus */.EZ, faClone/* faClone */.$3);


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 1986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    Uint8Array = __webpack_require__(7828),
    eq = __webpack_require__(5288),
    equalArrays = __webpack_require__(5911),
    mapToArray = __webpack_require__(317),
    setToArray = __webpack_require__(4247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 2032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 2193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(8984),
    getTag = __webpack_require__(5861),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLike = __webpack_require__(4894),
    isBuffer = __webpack_require__(3656),
    isPrototype = __webpack_require__(5527),
    isTypedArray = __webpack_require__(7167);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 2199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isArray = __webpack_require__(6449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 2224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 2349:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'times';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J2: function() { return /* binding */ lotRelations; },
/* harmony export */   cm: function() { return /* binding */ needFetchLot; },
/* harmony export */   wc: function() { return /* binding */ fetchLot; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var lotRelations = ['product', 'origin', 'uses', 'stock_location'];
var needFetchLot = function (lot) {
    return !lotRelations.every(function (relation) { return relation in lot; });
};
var fetchLot = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCatalog.axios.get('/catalog/stock/lot/' + id, {
                    params: {
                        include: lotRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 2480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CatalogReportView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CatalogReportView.vue?vue&type=template&id=aca9c87c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CatalogReport')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CatalogReport/CatalogReport.vue?vue&type=template&id=03ab5cfe
var CatalogReportvue_type_template_id_03ab5cfe_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"position-relative"},[_c('b-form-group',{attrs:{"label":"Type :","label-cols":"auto"}},[_c('k-form-select',{staticStyle:{"max-width":"200px"},attrs:{"options":_vm.types,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_c('k-table',{ref:"table",staticClass:"catalog-report-list",attrs:{"url":"/sales/catalog-report","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"stateKey":"sales-catalog-report","exportable":"catalogStatistics"}})],1)
}
var CatalogReportvue_type_template_id_03ab5cfe_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/CommandDelete/CommandDelete.vue + 3 modules
var CommandDelete = __webpack_require__(8674);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CatalogReport/CatalogReport.ts?vue&type=script&lang=ts&external








var CatalogReport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogReport, _super);
    function CatalogReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'product';
        _this.loading = false;
        _this.timeout = null;
        _this.storageKey = 'catalog-report';
        return _this;
    }
    CatalogReport.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loading = true;
                this.loadSaleCategories();
                this.fetchSearchParams();
                this.$nextTick(function () {
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(CatalogReport.prototype, "types", {
        get: function () {
            var types = [
                { label: 'Produit', value: 'product' },
                { label: 'Prestation', value: 'service' }
            ];
            if (this.hasModule('catalog-groups')) {
                types.push({ label: 'Groupe', value: 'group' });
            }
            return types;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogReport.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: ['sale_category'],
                filter: {
                    type: this.type,
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogReport.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'reference',
                    name: 'Référence',
                },
                {
                    data: 'name',
                    name: 'Nom',
                    sticky: true
                },
                {
                    data: 'quantity',
                    name: 'Quantités vendues',
                    render: 'number'
                },
                {
                    data: 'average_quantity',
                    name: 'Quantités moyennes vendues',
                    render: 'number'
                },
                {
                    data: 'average_ht',
                    name: 'Prix unitaire HT moyen',
                    render: 'currency'
                },
                {
                    data: 'average_tva',
                    name: 'Prix unitaire TVA moyen',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'average_ttc',
                    name: 'Prix unitaire TTC moyen',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'min_ht',
                    name: 'Prix minimum HT',
                    render: 'currency'
                },
                {
                    data: 'min_tva',
                    name: 'Prix minimum TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'min_ttc',
                    name: 'Prix minimum TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'max_ht',
                    name: 'Prix maximum HT',
                    render: 'currency'
                },
                {
                    data: 'max_tva',
                    name: 'Prix maximum TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'max_ttc',
                    name: 'Prix maximum TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: 'Total HT',
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: 'Total TVA',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: 'Total TTC',
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'sale_category.label',
                    name: 'Catégorie de vente',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogReport.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    label: 'Période',
                    type: 'period',
                    name: 'begin',
                    name2: 'end',
                    placeOnHeader: true
                },
                {
                    label: this.$t('catalog.filters.saleCategory'),
                    type: 'select',
                    name: 'sale_category',
                    options: this.saleCategories,
                    value: 'id',
                    optionLabel: 'label'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.provider'),
                    name: 'providers',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_provider]=1',
                    optionLabel: 'name',
                    value: 'id'
                }
            ];
            if (this.hasModule('stock')) {
                filters.push({
                    label: 'Gestion de stock',
                    type: 'select',
                    name: 'with_stock',
                    options: [
                        { value: true, label: 'Oui' },
                        { value: false, label: 'Non' }
                    ],
                    value: 'value',
                    optionLabel: 'label'
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    CatalogReport.prototype.rowLink = function (row) {
        return {
            name: 'catalog-' + this.type + '-item',
            params: {
                id: String(row.id)
            }
        };
    };
    CatalogReport.prototype.watchFilters = function () {
        if (this.loading) {
            return;
        }
        this.processSearch();
        this.saveSearchParams();
    };
    CatalogReport.prototype.processSearch = function () {
        var _this = this;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () {
            _this.$nextTick(function () {
                _this.$refs.table.refresh();
            });
        }, 800);
    };
    CatalogReport.prototype.saveSearchParams = function () {
        localStorage.setItem(this.storageKey, JSON.stringify({
            type: this.type
        }));
    };
    CatalogReport.prototype.fetchSearchParams = function () {
        var storage = localStorage.getItem(this.storageKey);
        if (!storage) {
            return;
        }
        var params = JSON.parse(storage);
        if (params.type) {
            this.type = params.type;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('type')
    ], CatalogReport.prototype, "watchFilters", null);
    CatalogReport = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandDelete: CommandDelete/* default */.A,
                KTable: table_vue_.KTable,
                KFormSelect: form_vue_.KFormSelect, KFormDatepicker: form_vue_.KFormDatepicker, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadSaleCategories'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('catalog', ['saleCategories'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], CatalogReport);
    return CatalogReport;
}(lib/* Vue */.lD));
/* harmony default export */ var CatalogReportvue_type_script_lang_ts_external = (CatalogReport);

;// ./src/components/CatalogReport/CatalogReport.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CatalogReport_CatalogReportvue_type_script_lang_ts_external = (CatalogReportvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CatalogReport/CatalogReport.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CatalogReport_CatalogReportvue_type_script_lang_ts_external,
  CatalogReportvue_type_template_id_03ab5cfe_render,
  CatalogReportvue_type_template_id_03ab5cfe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CatalogReport_CatalogReport = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CatalogReportView.vue?vue&type=script&lang=ts



var CatalogReportView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogReportView, _super);
    function CatalogReportView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogReportView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CatalogReport: CatalogReport_CatalogReport
            }
        })
    ], CatalogReportView);
    return CatalogReportView;
}(lib/* Vue */.lD));
/* harmony default export */ var CatalogReportViewvue_type_script_lang_ts = (CatalogReportView);

;// ./src/views/CatalogReportView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CatalogReportViewvue_type_script_lang_ts = (CatalogReportViewvue_type_script_lang_ts); 
;// ./src/views/CatalogReportView.vue





/* normalize component */
;
var CatalogReportView_component = (0,componentNormalizer/* default */.A)(
  views_CatalogReportViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CatalogReportView = (CatalogReportView_component.exports);

/***/ }),

/***/ 2523:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MultiDrag: function() { return /* binding */ MultiDragPlugin; },
/* harmony export */   Sortable: function() { return /* binding */ Sortable; },
/* harmony export */   Swap: function() { return /* binding */ SwapPlugin; }
/* harmony export */ });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ 2600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandReceipt_CommandReceipt; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandReceipt/CommandReceipt.vue?vue&type=template&id=192394ce
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loaded)?_c('k-form',{attrs:{"action":_vm.formUrl,"method":"put"},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[(_vm.hasModule('stock-locations') && _vm.value.stock_location)?_c('b-col',[_c('b-form-group',{attrs:{"label":"Lieu de stock :"}},[_vm._v(" "+_vm._s(_vm.value.stock_location.name)+" ")])],1):_vm._e(),_c('b-col',{staticClass:"text-right"},[(_vm.value.status !== 3)?_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.markAsDelivered.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.receipt.allDelivered'))+" ")]):_vm._e()],1)],1),_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"140px"}},[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.reference')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.designation')))]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.commandQty')))]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.deliveredQty')))]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.toDeliverQty')))]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.qty')))])])]),_c('tbody',[_vm._l((_vm.contents),function(content,i){return [_c('tr',{key:i},[_c('td',[_vm._v(_vm._s(content.reference))]),_c('td',{class:{ 'border-bottom-0': content.product && content.product.stock_tracking_mode !== 0 }},[(content.variation)?_c('ProductVariationView',{staticClass:"mb-3",attrs:{"value":content}}):_vm._e(),_c('FroalaView',{model:{value:(content.designation),callback:function ($$v) {_vm.$set(content, "designation", $$v)},expression:"content.designation"}}),(content.product && content.product.stock_tracking_mode !== 0 && content.deliver_quantity < 0)?_c('b-alert',{staticClass:"mt-2 mb-0",attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.receipt.lotExplain'))+" ")]):_vm._e()],1),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")]),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.delivered_quantity))+" ")]),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity_to_deliver))+" ")]),_c('td',{staticClass:"text-center"},[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i, 'id')},domProps:{"value":content.id}}),_c('k-form-spinner',{attrs:{"validationName":'contents.' + i + '.delivered_quantity',"name":_vm.getInputName(i, 'delivered_quantity'),"size":"sm","min":-content.delivered_quantity,"max":content.quantity_to_deliver,"maxDecimal":content.product && content.product.with_stock && content.product.stock_tracking_mode === 2 ? 0 : 5},on:{"input":function($event){return _vm.updateQuantity(i)}},model:{value:(_vm.contents[i].deliver_quantity),callback:function ($$v) {_vm.$set(_vm.contents[i], "deliver_quantity", $$v)},expression:"contents[i].deliver_quantity"}}),(content.product && content.product.with_stock)?_c('ProductStockIndicator',{staticClass:"mt-1",attrs:{"product":content.product,"location":_vm.value.stock_location}}):_vm._e()],1)]),(content.product && content.product.stock_tracking_mode !== 0 && content.deliver_quantity > 0)?_c('tr',{key:i + '-lot'},[_c('td'),_c('td',{staticClass:"border-top-0",attrs:{"colspan":"5"}},[(content.product.stock_tracking_mode === 1)?_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.lotNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.expirationDate')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.command.receipt.lotQty')))])])]),_c('tbody',_vm._l((content.lots),function(lot,index){return _c('tr',{key:index},[_c('td',[_c('k-form-input',{attrs:{"name":_vm.getInputName(i, 'reference', index),"required":""},model:{value:(_vm.contents[i].lots[index].reference),callback:function ($$v) {_vm.$set(_vm.contents[i].lots[index], "reference", $$v)},expression:"contents[i].lots[index].reference"}})],1),_c('td',[_c('k-form-datepicker',{attrs:{"name":_vm.getInputName(i, 'expire_at', index),"required":""},model:{value:(_vm.contents[i].lots[index].expire_at),callback:function ($$v) {_vm.$set(_vm.contents[i].lots[index], "expire_at", $$v)},expression:"contents[i].lots[index].expire_at"}})],1),_c('td',[_c('k-form-spinner',{attrs:{"name":_vm.getInputName(i, 'quantity', index),"min":0,"required":"","maxDecimal":5},on:{"change":function($event){return _vm.updateLotQuantity(content, index)}},model:{value:(_vm.contents[i].lots[index].quantity),callback:function ($$v) {_vm.$set(_vm.contents[i].lots[index], "quantity", $$v)},expression:"contents[i].lots[index].quantity"}})],1)])}),0)]):(content.product.stock_tracking_mode === 2)?_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.$t('catalog.command.receipt.serial'))+" "),(content.lots.length > 1 && _vm.canGenerateSerial(content))?_c('k-form-checkbox',{staticClass:"d-inline-block ml-5",attrs:{"size":"sm"},on:{"input":state => state && content.lots.length > 2 ? _vm.generateSerial(content) : null},model:{value:(_vm.contents[i].generate_serial),callback:function ($$v) {_vm.$set(_vm.contents[i], "generate_serial", $$v)},expression:"contents[i].generate_serial"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.receipt.automaticGeneration'))+" ")]):_vm._e()],1)])]),_c('tbody',_vm._l((content.lots),function(lot,index){return _c('tr',{key:index},[_c('td',[_c('k-form-input',{attrs:{"name":_vm.getInputName(i, 'reference', index),"required":"","size":"sm","readonly":content.generate_serial && index > 0 && _vm.canGenerateSerial(content)},on:{"change":function($event){content.generate_serial && index === 0 && _vm.canGenerateSerial(content) ? _vm.generateSerial(content) : null}},model:{value:(_vm.contents[i].lots[index].reference),callback:function ($$v) {_vm.$set(_vm.contents[i].lots[index], "reference", $$v)},expression:"contents[i].lots[index].reference"}})],1)])}),0)]):_vm._e()])]):_vm._e()]})],2)])],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/ProductVariationView/ProductVariationView.vue + 3 modules
var ProductVariationView = __webpack_require__(4456);
// EXTERNAL MODULE: ./src/components/ProductStockIndicator/ProductStockIndicator.vue + 3 modules
var ProductStockIndicator = __webpack_require__(4373);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandReceipt/CommandReceipt.ts?vue&type=script&lang=ts&external









var CommandReceipt = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandReceipt, _super);
    function CommandReceipt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.contents = [];
        return _this;
    }
    Object.defineProperty(CommandReceipt.prototype, "formUrl", {
        get: function () {
            return '/catalog/command/' + this.value.id + '/delivery';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandReceipt.prototype, "canGenerateSerial", {
        get: function () {
            return function (content) {
                var serial = content.lots && content.lots.length > 0 ? content.lots[0].reference : null;
                if (!serial) {
                    return true;
                }
                var regex = /[0-9]+$/;
                var test = regex.exec(serial);
                return test !== null;
            };
        },
        enumerable: false,
        configurable: true
    });
    CommandReceipt.prototype.mounted = function () {
        var _this = this;
        this.value.contents.forEach(function (content) {
            var deliver = JSON.parse(JSON.stringify(content));
            deliver.deliver_quantity = 0;
            deliver.generate_serial = true;
            deliver.lots = [];
            _this.contents.push(deliver);
        });
        this.loaded = true;
    };
    CommandReceipt.prototype.markAsDelivered = function () {
        var _this = this;
        this.contents.forEach(function (content, i) {
            _this.contents[i].deliver_quantity = content.quantity_to_deliver;
            _this.contents[i].generate_serial = true;
            _this.contents[i].lots = [];
        });
    };
    CommandReceipt.prototype.updateQuantity = function (index) {
        var _a;
        var content = this.contents[index];
        var stockMode = Number((_a = content.product) === null || _a === void 0 ? void 0 : _a.stock_tracking_mode);
        if (stockMode === 0) {
            return;
        }
        var lots = content.lots;
        var qty = content.deliver_quantity;
        if (stockMode === 2) {
            // If stock with serial
            if (qty > lots.length) {
                for (var i = lots.length; i < qty; i++) {
                    lots.push({
                        reference: null
                    });
                }
            }
            else if (lots.length > qty) {
                for (var i = lots.length; i > qty; i--) {
                    lots.splice(-1, 1);
                }
            }
        }
        else if (stockMode === 1) {
            // If stock with lot
            if (lots.length === 0) {
                // If have not some lots
                lots.push({
                    reference: null,
                    expire_at: null,
                    quantity: qty
                });
            }
            else {
                // If have already some lots
                var actualQty = sumBy_default()(lots, 'quantity');
                if (actualQty < qty) {
                    // If need to add quantity, add to the last lot
                    var lastLot = lots[lots.length - 1];
                    lastLot.quantity = Number(lastLot.quantity) + (qty - actualQty);
                }
                else if (actualQty > qty) {
                    // If have too many quantity
                    var lastLot = lots[lots.length - 1];
                    var newQty = Number(lastLot.quantity) - (actualQty - qty);
                    if (newQty > 0) {
                        lastLot.quantity = newQty;
                    }
                    else {
                        lots.splice(-1, 1);
                        if (newQty !== 0) {
                            this.updateQuantity(index);
                        }
                    }
                }
            }
        }
    };
    CommandReceipt.prototype.updateLotQuantity = function (content, index) {
        var lots = content.lots;
        var qty = content.deliver_quantity;
        var actualQty = sumBy_default()(lots, 'quantity');
        if (qty > actualQty) {
            if (index === (lots.length - 1)) {
                // If remove quantity from the last lot, add a new
                lots.push({
                    reference: null,
                    expire_at: null,
                    quantity: qty - actualQty
                });
            }
            else {
                // Add quantity to the last
                var lastLot = lots[lots.length - 1];
                var newQty = Number(lastLot.quantity) + (qty - actualQty);
                lastLot.quantity = newQty;
            }
        }
        else if (actualQty > qty) {
            var lastLot = lots[lots.length - 1];
            var newQty = Number(lastLot.quantity) - (actualQty - qty);
            if (newQty > 0) {
                lastLot.quantity = newQty;
            }
            else {
                lots.splice(-1, 1);
                if (newQty !== 0) {
                    this.updateLotQuantity(content, lots.length - 1);
                }
            }
        }
    };
    CommandReceipt.prototype.generateSerial = function (content) {
        var lots = content.lots;
        if (lots.length > 0 && lots[0].reference) {
            var prefix_1 = '';
            var number_1 = 0;
            lots.forEach(function (lot, i) {
                if (i === 0) {
                    // Take first serial and store datas
                    var reference = String(lot.reference);
                    var regex = /[0-9]+$/;
                    var test = regex.exec(reference);
                    if (test) {
                        prefix_1 = reference.substr(0, test.index);
                        number_1 = Number(test[0]);
                    }
                }
                else {
                    number_1++; // Increment serial
                    lot.reference = prefix_1 + number_1;
                }
            });
        }
    };
    CommandReceipt.prototype.getInputName = function (index, name, lot) {
        if (lot === void 0) { lot = null; }
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        var input = 'contents[' + index + ']';
        if (lot !== null) {
            input += '[lots][' + lot + ']';
        }
        input += '[' + name + ']';
        return input;
    };
    CommandReceipt.prototype.submitComplete = function (response) {
        this.$emit('delivered', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommandReceipt.prototype, "value", void 0);
    CommandReceipt = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProductVariationView: ProductVariationView/* default */.A,
                ProductStockIndicator: ProductStockIndicator/* default */.A,
                KForm: form_vue_.KForm, KFormSpinner: form_vue_.KFormSpinner, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormCheckbox: form_vue_.KFormCheckbox,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], CommandReceipt);
    return CommandReceipt;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CommandReceiptvue_type_script_lang_ts_external = (CommandReceipt);

;// ./src/components/CommandReceipt/CommandReceipt.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandReceipt_CommandReceiptvue_type_script_lang_ts_external = (CommandReceiptvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommandReceipt/CommandReceipt.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandReceipt_CommandReceiptvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandReceipt_CommandReceipt = (component.exports);

/***/ }),

/***/ 2651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(4218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ManualMovementItem_ManualMovementItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ManualMovementItem/ManualMovementItem.vue?vue&type=template&id=51d4e9b2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.modalTitle,"visible":_vm.modalState,"size":"xl"},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-form-row',{staticClass:"w-100"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.$emit('toEdit'); close()}}},[_vm._v(" Modifier ")]),_c('ManualMovementDelete',{staticClass:"d-inline-block",attrs:{"title":_vm.movement?.lots?.length > 0 ? 'Vous devez supprimer les lots avant de supprimer le mouvement de stock' : null,"disabled":_vm.movement?.lots?.length > 0},on:{"deleted":_vm.deleted},model:{value:(_vm.movement),callback:function ($$v) {_vm.movement=$$v},expression:"movement"}})],1),_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" Fermer ")])],1)],1)]}}])},[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-form-row',[_c('b-col',{attrs:{"cols":"12","md":_vm.hasModule('stock-locations') ? 3 : 4}},[_c('b-form-group',{attrs:{"label":"Référence :"}},[_vm._v(" "+_vm._s(_vm.movement.reference)+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":_vm.hasModule('stock-locations') ? 3 : 4}},[_c('b-form-group',{attrs:{"label":"Type de mouvement :"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.manualMovement.type.' + _vm.movement.type))+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":_vm.hasModule('stock-locations') ? 3 : 4}},[_c('b-form-group',{attrs:{"label":"Date :"}},[_vm._v(" "+_vm._s(_vm.date(_vm.movement.date))+" ")])],1),(_vm.hasModule('stock-locations') && _vm.movement?.type !== 3 && _vm.movement?.stock_location)?_c('b-col',{attrs:{"cols":"12","md":"3"}},[_c('b-form-group',{attrs:{"label":"Lieu de stock :"}},[_vm._v(" "+_vm._s(_vm.movement.stock_location?.name)+" ")])],1):_vm._e()],1),(_vm.hasModule('stock-locations') && _vm.movement?.type === 3)?_c('b-form-row',[_c('b-col',{attrs:{"cols":"12","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock de départ :"}},[_vm._v(" "+_vm._s(_vm.movement.from_stock_location?.name)+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock de destination :"}},[_vm._v(" "+_vm._s(_vm.movement.stock_location?.name)+" ")])],1)],1):_vm._e(),(_vm.movement.comments)?_c('b-form-group',{attrs:{"label":"Description"}},[_c('FroalaView',{model:{value:(_vm.movement.comments),callback:function ($$v) {_vm.$set(_vm.movement, "comments", $$v)},expression:"movement.comments"}})],1):_vm._e(),_c('b-tabs',[_c('b-tab',{staticClass:"pt-2",attrs:{"title":"Contenu"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap"},[_c('thead',{staticClass:"thead-dark small"},[_c('tr',[_c('th',[_vm._v("Produit")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Quantité")])])]),_c('tbody',[_vm._l((_vm.movement.contents),function(content,i){return [_c('tr',{key:i},[_c('td',[(content.product && content.product.variations_length > 0)?[(content.variation)?_c('ProductVariationView',{staticClass:"mb-2",attrs:{"value":content}}):_c('p',{staticClass:"small italic"},[_vm._v(" Variation supprimée ")])]:_vm._e(),(content.product)?[_vm._v(" "+_vm._s(content.product.name)+" ")]:_c('i',[_vm._v(" Produit supprimé ")])],2),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")])])]})],2)])])]),(_vm.hasModule('stock-tracabilities') && _vm.countLots > 0)?_c('b-tab',{staticClass:"pt-2",attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Lots de produit "),_c('b-badge',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.countLots)+" ")])]},proxy:true}],null,false,1452956786)},[(_vm.movement.type === 1)?_c('LotList',{attrs:{"linkedElement":{ type: 'stockManual', id: _vm.movement.id }},on:{"lotUpdated":_vm.lotUpdated,"lotDeleted":_vm.lotDeleted}}):_c('LotUsed',{attrs:{"value":_vm.movement.used_lots}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/ProductVariationView/ProductVariationView.vue + 3 modules
var ProductVariationView = __webpack_require__(4456);
// EXTERNAL MODULE: ./src/components/LotList/LotList.vue + 3 modules
var LotList = __webpack_require__(7666);
// EXTERNAL MODULE: ./src/components/LotUsed/LotUsed.vue + 4 modules
var LotUsed = __webpack_require__(8751);
// EXTERNAL MODULE: ./src/fetchDatas/manualMovement.ts
var manualMovement = __webpack_require__(4853);
// EXTERNAL MODULE: ./src/components/ManualMovementDelete/ManualMovementDelete.vue + 3 modules
var ManualMovementDelete = __webpack_require__(5365);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ManualMovementItem/ManualMovementItem.ts?vue&type=script&lang=ts&external












var ManualMovementItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ManualMovementItem, _super);
    function ManualMovementItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.movement = null;
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(ManualMovementItem.prototype, "modalTitle", {
        get: function () {
            if (!this.movement) {
                return '';
            }
            else if (this.movement.type === 1) {
                return 'Détail de l\'entrée de stock';
            }
            else {
                return 'Détail de la sortie de stock';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementItem.prototype, "countLots", {
        get: function () {
            var _this = this;
            var _a, _b, _c;
            if (((_a = this.movement) === null || _a === void 0 ? void 0 : _a.type) === 1) {
                return this.movement.lots ? sumBy_default()(this.movement.lots, function (lot) { return _this.number(lot.quantity); }) : 0;
            }
            return ((_b = this.movement) === null || _b === void 0 ? void 0 : _b.used_lots) ? sumBy_default()((_c = this.movement) === null || _c === void 0 ? void 0 : _c.used_lots, function (lot) { return _this.number(lot.quantity); }) : 0;
        },
        enumerable: false,
        configurable: true
    });
    ManualMovementItem.prototype.watchValue = function (value) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0,manualMovement/* needFetchManualMovement */.Y1)(value)) return [3 /*break*/, 2];
                        this.movement = null;
                        return [4 /*yield*/, (0,manualMovement/* fetchManualMovement */.AD)(value.id)];
                    case 1:
                        value = _a.sent();
                        _a.label = 2;
                    case 2:
                        this.movement = JSON.parse(JSON.stringify(value));
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Called when a lot is updated
    ManualMovementItem.prototype.lotUpdated = function (lot, old) {
        var _a, _b;
        if ((_a = this.movement) === null || _a === void 0 ? void 0 : _a.lots) {
            var index = (_b = this.movement.lots) === null || _b === void 0 ? void 0 : _b.findIndex(function (val) { return val.id === lot.id; });
            if (index >= 0) {
                lib/* Vue */.lD.set(this.movement.lots, index, lot);
            }
        }
        this.updateLotQuantity(lot, this.number(lot.quantity) - this.number(old.quantity));
    };
    // Called when a lot is deleted
    ManualMovementItem.prototype.lotDeleted = function (lot) {
        var _a, _b;
        if ((_a = this.movement) === null || _a === void 0 ? void 0 : _a.lots) {
            var index = (_b = this.movement.lots) === null || _b === void 0 ? void 0 : _b.findIndex(function (value) { return value.id === lot.id; });
            if (index >= 0) {
                lib/* Vue */.lD.delete(this.movement.lots, index);
            }
        }
        this.updateLotQuantity(lot, this.number(-lot.quantity), true);
    };
    // Apply a lot update or delete
    ManualMovementItem.prototype.updateLotQuantity = function (lot, quantity, toDelete) {
        if (toDelete === void 0) { toDelete = false; }
        var movement = JSON.parse(JSON.stringify(this.movement));
        var contentIndex = movement.contents.findIndex(function (content) { return content.product_id === lot.product_id; });
        if (contentIndex === -1) {
            return;
        }
        var content = movement.contents[contentIndex];
        if (!content.lots) {
            return;
        }
        content.quantity = this.number(content.quantity) + quantity;
        var lotIndex = content.lots.findIndex(function (val) { return val.id === lot.id; });
        if (lotIndex >= 0) {
            if (toDelete) {
                content.lots.splice(lotIndex, 1);
            }
            else {
                content.lots[lotIndex] = lot;
            }
        }
        movement.contents[contentIndex] = content;
        this.$emit('input', movement);
    };
    ManualMovementItem.prototype.deleted = function (movement) {
        var modal = this.$refs.modal;
        modal.hide();
        return movement;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ManualMovementItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ManualMovementItem.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ManualMovementItem.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('deleted')
    ], ManualMovementItem.prototype, "deleted", null);
    ManualMovementItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BBadge: external_bootstrap_vue_.BBadge,
                FroalaView: form_vue_.FroalaView,
                ProductVariationView: ProductVariationView/* default */.A,
                LotList: LotList/* default */.A, LotUsed: LotUsed/* default */.A, ManualMovementDelete: ManualMovementDelete/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], ManualMovementItem);
    return ManualMovementItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var ManualMovementItemvue_type_script_lang_ts_external = (ManualMovementItem);

;// ./src/components/ManualMovementItem/ManualMovementItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ManualMovementItem_ManualMovementItemvue_type_script_lang_ts_external = (ManualMovementItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ManualMovementItem/ManualMovementItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ManualMovementItem_ManualMovementItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ManualMovementItem_ManualMovementItem = (component.exports);

/***/ }),

/***/ 2711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fetchDatas_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5719);
/* harmony import */ var _components_ProductItem_ProductItem_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5663);






var LoadProductMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__extends */ .C6)(LoadProductMixin, _super);
    function LoadProductMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.product = null;
        return _this;
    }
    LoadProductMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapState)('app', ['pageParams'])),
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.Spinner,
                ProductItem: _components_ProductItem_ProductItem_vue__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var pageParams;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageParams = vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD.prototype.$kwCatalog.store.state.app.pageParams;
                                if (pageParams && !(0,_fetchDatas_product__WEBPACK_IMPORTED_MODULE_3__/* .needFetchProduct */ .U8)(pageParams)) {
                                    next(function (vm) {
                                        vm.product = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_product__WEBPACK_IMPORTED_MODULE_3__/* .fetchProduct */ .yj)(to.params.id)
                                        .then(function (product) {
                                        next(function (vm) {
                                            vm.product = product;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var product;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    product = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,_fetchDatas_product__WEBPACK_IMPORTED_MODULE_3__/* .needFetchProduct */ .U8)(product)) {
                                        this.product = product;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                this.loading = true;
                                this.product = null;
                                return [4 /*yield*/, (0,_fetchDatas_product__WEBPACK_IMPORTED_MODULE_3__/* .fetchProduct */ .yj)(to.params.id)
                                        .then(function (product) {
                                        _this.product = product;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], LoadProductMixin);
    return LoadProductMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (LoadProductMixin);


/***/ }),

/***/ 2713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_StockParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StockParamsView.vue?vue&type=template&id=190150fa
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StockParams')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/StockParams/StockParams.vue + 3 modules
var StockParams = __webpack_require__(3921);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StockParamsView.vue?vue&type=script&lang=ts



var StockParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockParamsView, _super);
    function StockParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StockParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                StockParams: StockParams/* default */.A
            }
        })
    ], StockParamsView);
    return StockParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var StockParamsViewvue_type_script_lang_ts = (StockParamsView);

;// ./src/views/StockParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_StockParamsViewvue_type_script_lang_ts = (StockParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/StockParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_StockParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_StockParamsView = (component.exports);

/***/ }),

/***/ 2724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockLocationList_StockLocationList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockLocationList/StockLocationList.vue?vue&type=template&id=6061d35e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":"Création d'un lieu de stock","updateTitle":"Modification d'un lieu de stock","deleteMsg":"Êtes-vous sûr de vouloir supprimer ce lieu de stock ?","deleteAlertMessage":"Attention, tous les stocks liés à ce lieu de stock seront supprimés","sort":"name","withDefault":"","customForm":_vm.components},on:{"submitted":_vm.setStockLocation,"deleted":_vm.deleteStockLocation}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/components/StockLocationForm/StockLocationForm.vue + 3 modules
var StockLocationForm = __webpack_require__(7284);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockLocationList/StockLocationList.ts?vue&type=script&lang=ts&external





var StockLocationList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockLocationList, _super);
    function StockLocationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.components = StockLocationForm/* default */.A;
        _this.columns = [
            {
                label: 'Nom du lieu',
                key: 'name',
            },
            {
                label: 'Code postal',
                key: 'postal_code'
            },
            {
                label: 'Ville',
                key: 'town',
            }
        ];
        return _this;
    }
    Object.defineProperty(StockLocationList.prototype, "apiUrl", {
        get: function () {
            return 'catalog/stock/location';
        },
        enumerable: false,
        configurable: true
    });
    StockLocationList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['setStockLocation', 'deleteStockLocation'])),
            components: {
                DynamicList: interface_vue_.DynamicList,
                Spinner: interface_vue_.Spinner
            }
        })
    ], StockLocationList);
    return StockLocationList;
}(lib/* Vue */.lD));
/* harmony default export */ var StockLocationListvue_type_script_lang_ts_external = (StockLocationList);

;// ./src/components/StockLocationList/StockLocationList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockLocationList_StockLocationListvue_type_script_lang_ts_external = (StockLocationListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockLocationList/StockLocationList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockLocationList_StockLocationListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockLocationList_StockLocationList = (component.exports);

/***/ }),

/***/ 2749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 2804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SaleCategoryList_SaleCategoryList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SaleCategoryList/SaleCategoryList.vue?vue&type=template&id=51b7ec97
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"formUrl":_vm.formUrl,"columns":_vm.columns,"createTitle":_vm.$t('catalog.saleCategory.new'),"updateTitle":_vm.$t('catalog.saleCategory.edit'),"deleteMsg":_vm.$t('catalog.saleCategory.deleteMsg'),"sort":"parent","sortFunction":_vm.sortElements,"customForm":_vm.formComponent,"customFormProperties":_vm.formProperties},on:{"submitted":_vm.submitted,"deleted":_vm.deleted}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/SaleCategoryForm/SaleCategoryForm.vue + 3 modules
var SaleCategoryForm = __webpack_require__(747);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SaleCategoryList/SaleCategoryList.ts?vue&type=script&lang=ts&external





var SaleCategoryList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleCategoryList, _super);
    function SaleCategoryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('catalog.saleCategory.label'),
                key: 'label',
                required: true
            },
            {
                label: _this.$t('catalog.saleCategory.parentLabel'),
                key: 'parent',
                keyShow: 'parent.label',
                class: 'd-none d-md-table-cell'
            },
            {
                label: _this.$t('catalog.saleCategory.accountLabel'),
                key: 'account_number',
                show: function (val, el) {
                    return el.account_by_vatrate ? _this.$t('catalog.saleCategory.accountLabel') : val;
                },
                class: 'd-none d-md-table-cell'
            }
        ];
        return _this;
    }
    Object.defineProperty(SaleCategoryList.prototype, "apiUrl", {
        get: function () {
            return this.formUrl + '?include=parent,accounts';
        },
        enumerable: false,
        configurable: true
    });
    SaleCategoryList.prototype.sortElements = function (elements) {
        var _this = this;
        var parents = Array.from(elements)
            .filter(function (el) { return !el.parent; })
            .map(function (el) {
            el.childs = [];
            return el;
        })
            .sort(this.sort);
        elements.filter(function (el) { return el.parent; })
            .forEach(function (el) {
            var parent = parents.find(function (p) { return p.id === el.parent.id; });
            if (parent) { // If parent is delete, don't add children
                el.parent.label = parent.label; // We take advantage of the sort function to rename the parent in case it has been renamed
                parent.childs.push(el);
            }
        });
        parents.map(function (parent) {
            parent.childs.sort(_this.sort);
            return parent;
        });
        var final = [];
        parents.forEach(function (parent) {
            var childs = parent.childs;
            lib/* Vue */.lD.delete(parent, 'childs');
            final.push(parent);
            final.push.apply(final, childs);
        });
        return final;
    };
    SaleCategoryList.prototype.sort = function (a, b) {
        var valA = a.label.toLowerCase();
        var valB = b.label.toLowerCase();
        return (valA < valB) ? -1 : (valA > valB) ? 1 : 0;
    };
    SaleCategoryList.prototype.submitted = function (category) {
        if (this.accountantMode === false) {
            this.setSaleCategory(category);
        }
    };
    SaleCategoryList.prototype.deleted = function (category) {
        if (this.accountantMode === false) {
            this.deleteSaleCategory(category);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SaleCategoryList.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/catalog/sale_category' })
    ], SaleCategoryList.prototype, "formUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return SaleCategoryForm/* default */.A; } })
    ], SaleCategoryList.prototype, "formComponent", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], SaleCategoryList.prototype, "formProperties", void 0);
    SaleCategoryList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['setSaleCategory', 'deleteSaleCategory'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], SaleCategoryList);
    return SaleCategoryList;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleCategoryListvue_type_script_lang_ts_external = (SaleCategoryList);

;// ./src/components/SaleCategoryList/SaleCategoryList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SaleCategoryList_SaleCategoryListvue_type_script_lang_ts_external = (SaleCategoryListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/SaleCategoryList/SaleCategoryList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SaleCategoryList_SaleCategoryListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SaleCategoryList_SaleCategoryList = (component.exports);

/***/ }),

/***/ 2824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(7805),
    cloneBuffer = __webpack_require__(3290),
    cloneTypedArray = __webpack_require__(1961),
    copyArray = __webpack_require__(3007),
    initCloneObject = __webpack_require__(5529),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLikeObject = __webpack_require__(3693),
    isBuffer = __webpack_require__(3656),
    isFunction = __webpack_require__(1882),
    isObject = __webpack_require__(3805),
    isPlainObject = __webpack_require__(1331),
    isTypedArray = __webpack_require__(7167),
    safeGet = __webpack_require__(4974),
    toPlainObject = __webpack_require__(9884);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 2865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(9570),
    shortOut = __webpack_require__(1811);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 2903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805),
    isPrototype = __webpack_require__(5527),
    nativeKeysIn = __webpack_require__(181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 2949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3007:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 3040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1549),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 3249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProductListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProductListView.vue?vue&type=template&id=6a584c16
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProductList/ProductList.vue + 3 modules
var ProductList = __webpack_require__(7439);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProductListView.vue?vue&type=script&lang=ts



var ProductListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductListView, _super);
    function ProductListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProductList: ProductList/* default */.A
            }
        })
    ], ProductListView);
    return ProductListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductListViewvue_type_script_lang_ts = (ProductListView);

;// ./src/views/ProductListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProductListViewvue_type_script_lang_ts = (ProductListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProductListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProductListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProductListView = (component.exports);

/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 3345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 3360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(3243);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 3375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(5765);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 3431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CatalogPictures_CatalogPictures; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CatalogPictures/CatalogPictures.vue?vue&type=template&id=41dd41e8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"catalog-pictures"},[(_vm.loading)?_c('Spinner'):_c('div',[(_vm.can('catalog-products', 3))?_c('k-form-file',{attrs:{"btnMode":"","btnLabel":_vm.$t('catalog.pictures.addLabel'),"btnSize":"sm","btnTheme":"primary","name":"file","accept":['image/png', 'image/jpeg'],"maxSize":5000000,"removeUploadedFile":"","multiple":"","url":_vm.apiUrl + '?with_file=1',"imageEdit":"","instantImageEdit":""},on:{"onUpload":_vm.uploaded}}):_vm._e(),_c('div',{staticClass:"list"},_vm._l((_vm.pictures),function(img,i){return _c('div',{key:img.id,staticClass:"item"},[_c('div',{staticClass:"img",style:({
            'background-image': 'url(data:image/' + img.extension + ';base64,' + img.thumbnail + ')',
            width: _vm.size + 'px',
            height: _vm.size + 'px',
          }),on:{"click":function($event){$event.preventDefault();_vm.withSelection === false ? _vm.preview = img : _vm.withSelection(img)}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.top",modifiers:{"top":true}}],staticClass:"mark-default",attrs:{"title":_vm.defaultPicture !== img.id ? _vm.$t('catalog.pictures.markDefault') : null}},[(_vm.updating === null || _vm.updating === img.id)?_c('font-awesome-icon',{attrs:{"icon":_vm.defaultIcon(img),"spin":_vm.updating === img.id},on:{"click":function($event){$event.stopPropagation();return _vm.changeDefault(img.id)}}}):_vm._e()],1),_c('div',{staticClass:"hover"},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.withSelection !== false ? 'mouse-pointer' : 'search']}})],1)]),_c('ul',{staticClass:"actions"},[_c('li',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"title":_vm.$t('interface.download')},on:{"click":function($event){return _vm.downloadPicture(img)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'download']}})],1),(_vm.can('catalog-products', 3))?_c('li',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"title":_vm.$t('interface.delete')},on:{"click":function($event){_vm.toDelete = i}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'trash']}})],1):_vm._e()])])}),0),(_vm.total > _vm.perPage)?_c('b-pagination',{staticClass:"mt-3",attrs:{"per-page":_vm.perPage,"total-rows":_vm.total,"align":"center","size":"sm"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],1),(_vm.preview)?_c('b-modal',{attrs:{"visible":_vm.preview !== null,"ok-only":"","ok-title":_vm.$t('interface.close'),"size":"xl","content-class":"text-center","scrollable":""},on:{"hidden":function($event){_vm.preview = null}}},[_c('img',{staticClass:"w-auto preview-catalog-image",attrs:{"src":'data:image/' + _vm.preview.extension + ';base64,' + _vm.preview.file,"alt":_vm.preview.filename}})]):_vm._e(),_c('b-modal',{attrs:{"visible":_vm.toDelete !== null,"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"title":_vm.$t('interface.deleteConfirmation'),"busy":_vm.deleting,"no-close-on-esc":_vm.deleting,"hide-header-close":_vm.deleting,"no-close-on-backdrop":_vm.deleting},on:{"ok":_vm.deletePicture,"hidden":function($event){_vm.toDelete = null}}},[(_vm.deleting)?_c('Spinner'):_c('span',[_vm._v(_vm._s(_vm.$t('catalog.pictures.deleteMsg')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CatalogPictures/CatalogPictures.ts?vue&type=script&lang=ts&external







var CatalogPictures = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogPictures, _super);
    function CatalogPictures() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pictures = [];
        _this.preview = null;
        _this.loading = false;
        _this.toDelete = null;
        _this.deleting = false;
        _this.updating = null;
        _this.perPage = 20;
        _this.page = 1;
        _this.total = 0;
        return _this;
    }
    Object.defineProperty(CatalogPictures.prototype, "apiUrl", {
        get: function () {
            return '/catalog/' + this.type + '/' + this.id + '/picture';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogPictures.prototype, "defaultIcon", {
        get: function () {
            var _this = this;
            return function (img) {
                if (_this.updating === img.id) {
                    return ['fad', 'spinner-third'];
                }
                else if (_this.defaultPicture === img.id) {
                    return ['fas', 'star'];
                }
                else {
                    return ['fal', 'star'];
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    CatalogPictures.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPictures()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogPictures.prototype.loadPictures = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.get(this.apiUrl, {
                                params: {
                                    per_page: this.perPage,
                                    page: this.page,
                                    with_file: true
                                }
                            })
                                .then(function (response) {
                                _this.pictures = response.data.data;
                                _this.total = response.data.meta.total;
                                _this.loading = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogPictures.prototype.watchPictures = function () {
        return this.total;
    };
    CatalogPictures.prototype.uploaded = function (response) {
        this.pictures.unshift(response);
        this.total++;
    };
    CatalogPictures.prototype.downloadPicture = function (img) {
        var a = document.createElement('a');
        a.href = 'data:image/png;base64,' + img.file;
        a.download = img.filename;
        a.click();
    };
    CatalogPictures.prototype.deletePicture = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var idx, img;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idx = this.toDelete;
                        if (idx === null) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        this.deleting = true;
                        img = this.pictures[idx];
                        return [4 /*yield*/, this.$kwCatalog.axios.delete(this.apiUrl + '/' + img.id, {
                                params: {
                                    with_file: true
                                }
                            })
                                .then(function () {
                                lib/* Vue */.lD.delete(_this.pictures, idx);
                                _this.total--;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.deleting = false;
                                _this.toDelete = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogPictures.prototype.changeDefault = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.updating !== null || !this.can('catalog-products', 3)) {
                            return [2 /*return*/];
                        }
                        this.updating = id;
                        return [4 /*yield*/, this.$kwCatalog.axios.put('/catalog/' + this.type + '/' + this.id, {
                                picture: id
                            })
                                .then(function (response) {
                                _this.$emit('defaultPicture', id);
                                _this.$emit('productUpdated', response.data);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.updating = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CatalogPictures.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CatalogPictures.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CatalogPictures.prototype, "defaultPicture", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 150 })
    ], CatalogPictures.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CatalogPictures.prototype, "withSelection", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('page')
    ], CatalogPictures.prototype, "loadPictures", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('total'),
        (0,lib/* Watch */.ox)('total')
    ], CatalogPictures.prototype, "watchPictures", null);
    CatalogPictures = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormFile: form_vue_.KFormFile,
                BModal: external_bootstrap_vue_.BModal,
                BPagination: external_bootstrap_vue_.BPagination
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CatalogPictures);
    return CatalogPictures;
}(lib/* Vue */.lD));
/* harmony default export */ var CatalogPicturesvue_type_script_lang_ts_external = (CatalogPictures);

;// ./src/components/CatalogPictures/CatalogPictures.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CatalogPictures_CatalogPicturesvue_type_script_lang_ts_external = (CatalogPicturesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CatalogPictures/CatalogPictures.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CatalogPictures_CatalogPicturesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CatalogPictures_CatalogPictures = (component.exports);

/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3502:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'books';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f5db';
var svgPathData = 'M575.11 443.25L461.51 19.06C458.2 6.7 445.61-3.18 430.15.96L414.7 5.1c-6.18 1.66-11.53 6.4-16.06 14.24-14.03 6.94-52.3 17.21-68 18.22-7.84-4.53-14.85-5.96-21.03-4.3l-15.46 4.14c-2.42.65-4.2 1.95-6.15 3.08V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v64h128l101.66 396.94c3.31 12.36 15.9 22.24 31.36 18.1l15.45-4.14c6.18-1.66 11.53-6.4 16.06-14.24 13.91-6.88 52.18-17.2 68-18.22 7.84 4.53 14.85 5.96 21.03 4.3l15.46-4.14c15.45-4.14 21.41-18.99 18.09-31.35zm-134.4-7.06L348.64 92.37l61.82-16.56 92.07 343.82-61.82 16.56zM0 384h128V128H0v256zM96 0H32C14.33 0 0 14.33 0 32v64h128V32c0-17.67-14.33-32-32-32zM0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H0v64zm160-96h128V128H160v256zm0 96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H160v64z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomPricesView_CustomPricesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomPricesView/CustomPricesView.vue?vue&type=template&id=33d75eb3
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-group',{staticClass:"form-text",attrs:{"label":_vm.$t('catalog.customPrices.types'),"label-cols":"auto"}},[(_vm.value.custom_price_mode === 'quantity')?[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.decreasingPrices'))+" ")]:(_vm.value.custom_price_mode === 'type')?[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCustomerType'))+" ")]:(_vm.value.custom_price_mode === 'customer')?[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCustomer'))+" ")]:(_vm.value.custom_price_mode === 'country')?[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCountry'))+" ")]:_vm._e()],2),(_vm.value.custom_price_mode === 'quantity')?_c('div',[_c('b-form-group',{staticClass:"form-text",attrs:{"label":_vm.$t('catalog.customPrices.decreasingPricesCondition'),"label-cols":"auto"}},[_vm._v(" "+_vm._s(_vm.customPriceQuantityLabel)+" ")]),_c('p',{staticClass:"font-weight-bold mt-4 mb-1"},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.decreasingPricesList')))]),_c('table',{staticClass:"table table-bordered table-sm mb-1 w-auto"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.qtyMin')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.qtyMax')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))])])]),_c('tbody',[(_vm.value.custom_quantity_prices.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))])])]):_vm._e(),_vm._l((_vm.value.custom_quantity_prices),function(price,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(price.minimum)+" ")]),_c('td',[_vm._v(" "+_vm._s(price.maximum)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(price.price, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])])})],2)])],1):(_vm.value.custom_price_mode === 'type')?_c('div',[_c('table',{staticClass:"table table-bordered table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.customer')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))])])]),_c('tbody',_vm._l((_vm.customPriceCustomerTypes),function(type,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(type.element.label)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(type.price, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])])}),0)])]):(_vm.value.custom_price_mode === 'customer')?_c('div',[_c('table',{staticClass:"table table-bordered table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.customer')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))])])]),_c('tbody',[(_vm.customPriceCustomers.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"2"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))])])]):_vm._e(),_vm._l((_vm.customPriceCustomers),function(price,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(price.element.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(price.price, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])])})],2)])]):(_vm.value.custom_price_mode === 'country')?_c('div',[_c('table',{staticClass:"table table-bordered table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.country')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))])])]),_c('tbody',[(_vm.customPriceCountries.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"2"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))])])]):_vm._e(),_vm._l((_vm.customPriceCountries),function(price,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(price.element.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(price.price, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])])})],2)])]):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomPricesView/CustomPricesView.ts?vue&type=script&lang=ts&external





var CustomPricesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomPricesView, _super);
    function CustomPricesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomPricesView.prototype, "customPriceQuantityLabel", {
        get: function () {
            switch (this.value.custom_price_quantity_mode) {
                case 1:
                    return this.$t('catalog.customPrices.qtyOnDocument');
                case 2:
                    return this.$t('catalog.customPrices.qtyCurrentYear');
                case 3:
                    return this.$t('catalog.customPrices.qtyPreviousYear');
                case 4:
                    return this.$tc('catalog.customPrices.qtyLastNbMonths', this.value.custom_price_quantity_month_length);
                case 5:
                    return this.$t('catalog.customPrices.qtyTotal');
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomPricesView.prototype, "customPriceCustomerTypes", {
        get: function () {
            return this.value.custom_type_prices.filter(function (price) { return price.type === 'customerType'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomPricesView.prototype, "customPriceCustomers", {
        get: function () {
            return this.value.custom_type_prices.filter(function (price) { return price.type === 'customer'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomPricesView.prototype, "customPriceCountries", {
        get: function () {
            return this.value.custom_type_prices.filter(function (price) { return price.type === 'country'; });
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], CustomPricesView.prototype, "value", void 0);
    CustomPricesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])),
            components: {
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BBadge: external_bootstrap_vue_.BBadge, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], CustomPricesView);
    return CustomPricesView;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CustomPricesViewvue_type_script_lang_ts_external = (CustomPricesView);

;// ./src/components/CustomPricesView/CustomPricesView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomPricesView_CustomPricesViewvue_type_script_lang_ts_external = (CustomPricesViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomPricesView/CustomPricesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomPricesView_CustomPricesViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomPricesView_CustomPricesView = (component.exports);

/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3040),
    mapCacheDelete = __webpack_require__(7670),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(2949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1799),
    getMatchData = __webpack_require__(776),
    matchesStrictComparable = __webpack_require__(7197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 3693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894),
    isObjectLike = __webpack_require__(346);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 3702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 3712:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'minus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f068';
var svgPathData = 'M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.EZ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3858:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'mouse-pointer';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f245';
var svgPathData = 'M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.ii = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_custom_fields_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4696);
/* harmony import */ var _kwixeo_custom_fields_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_custom_fields_vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3375);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_3__);





var CatalogListMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__extends */ .C6)(CatalogListMixin, _super);
    function CatalogListMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CatalogListMixin.prototype, "rowActions", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogListMixin.prototype, "include", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogListMixin.prototype, "computedInclude", {
        get: function () {
            return lodash_uniq__WEBPACK_IMPORTED_MODULE_2___default()((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__spreadArrays */ .aN)(this.include, this.relations));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogListMixin.prototype, "computedRowActions", {
        get: function () {
            var actions = this.rowActions;
            var addAction = this.addAction;
            if (addAction) {
                actions.unshift({
                    icon: 'add',
                    title: this.$t('interface.add'),
                    click: function (product) {
                        addAction(product);
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogListMixin.prototype, "actionsColumWidth", {
        get: function () {
            return this.addAction ? 120 : 80;
        },
        enumerable: false,
        configurable: true
    });
    CatalogListMixin.prototype.reload = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ default: false })
    ], CatalogListMixin.prototype, "inlineMode", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ default: null })
    ], CatalogListMixin.prototype, "addAction", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ default: null })
    ], CatalogListMixin.prototype, "defaultFilters", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Prop */ .kv)({ default: function () { return []; } })
    ], CatalogListMixin.prototype, "relations", void 0);
    CatalogListMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_3__.mapGetters)('subscriptions', ['hasModule']))
        })
    ], CatalogListMixin);
    return CatalogListMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_custom_fields_vue__WEBPACK_IMPORTED_MODULE_1__.CustomFieldsTableMixin)));
/* harmony default export */ __webpack_exports__.A = (CatalogListMixin);


/***/ }),

/***/ 3862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 3921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockParams_StockParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockParams/StockParams.vue?vue&type=template&id=25a19630
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":_vm.$t('catalog.stock.params.paramsTitle'),"lazy":""}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('div',{staticClass:"mb-4"},[_c('b-form-group',{staticClass:"mb-1",attrs:{"label":_vm.$t('catalog.stock.params.stockValueTitle')}},[_c('k-form-select',{attrs:{"name":"configs[stock_value_calculation]","options":_vm.stockValueOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_value_calculation),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_value_calculation", $$v)},expression:"localConfig.stock_value_calculation"}})],1),(_vm.localConfig.stock_value_calculation === 2)?_c('div',{staticClass:"text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.stockValueExplain1'))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.stockValueExplain2'))+" ")]):_vm._e()],1),_c('h4',{staticClass:"form-title"},[_vm._v("Commandes fournisseurs depuis les documents de ventes")]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.providerCommandStock')}},[_c('k-form-select',{attrs:{"name":"configs[sales_provider_command_stock]","options":_vm.providerCommandStockOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.sales_provider_command_stock),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_provider_command_stock", $$v)},expression:"localConfig.sales_provider_command_stock"}})],1),_c('input',{attrs:{"type":"hidden","name":"configs[sales_provider_command_stock_draft]"},domProps:{"value":_vm.localConfig.sales_provider_command_stock_draft ?? false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.sales_provider_command_stock_draft),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_provider_command_stock_draft", $$v)},expression:"localConfig.sales_provider_command_stock_draft"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.providerCommandStockDraft'))+" ")]),_c('h4',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.theoricaltitle')))]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.addToStock')}},[_c('k-form-select',{attrs:{"name":"configs[stock_theorical_entry]","options":_vm.inStockOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_theorical_entry),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_theorical_entry", $$v)},expression:"localConfig.stock_theorical_entry"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.removeFromStock')}},[_c('k-form-select',{attrs:{"name":"configs[stock_theorical_out]","options":_vm.outStockOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_theorical_out),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_theorical_out", $$v)},expression:"localConfig.stock_theorical_out"}}),(_vm.hasModule('stock-locations'))?_c('b-alert',{staticClass:"mt-2 py-1 px-2",attrs:{"variant":"danger","show":""}},[_vm._v(" Lorsque le module \"Stock multi-dépôts\" est activé, la sortie de stock ne peut être paramétrée que sur les bons de livraison. ")]):_vm._e()],1),_c('h4',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.realTitle')))]),_c('b-alert',{staticClass:"mt-2 text-justify",attrs:{"show":"","variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.realExplain1'))),_c('br'),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('catalog.stock.params.realExplain2')))]),_c('li',[_vm._v(_vm._s(_vm.$t('catalog.stock.params.realExplain3')))])])]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.addToStock')}},[_c('k-form-select',{attrs:{"name":"configs[stock_real_entry]","options":_vm.inStockOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_real_entry),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_real_entry", $$v)},expression:"localConfig.stock_real_entry"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.removeFromStock')}},[_c('k-form-select',{attrs:{"name":"configs[stock_real_out]","options":_vm.outStockOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_real_out),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_real_out", $$v)},expression:"localConfig.stock_real_out"}}),(_vm.hasModule('stock-locations'))?_c('b-alert',{staticClass:"mt-2 py-1 px-2",attrs:{"variant":"danger","show":""}},[_vm._v(" Lorsque le module \"Stock multi-dépôts\" est activé, la sortie de stock ne peut être paramétrée que sur les bons de livraison. ")]):_vm._e()],1),_c('h4',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.notificationTitle')))]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.notificationRecipients')}},[_vm._l((_vm.localConfig.stock_notifications_users),function(user,i){return _c('input',{key:i,attrs:{"type":"hidden","name":'configs[stock_notifications_users][' + i + ']'},domProps:{"value":user.id}})}),_c('k-form-select',{attrs:{"ajax":_vm.userApiUrl,"label":"fullname","multiple":""},model:{value:(_vm.localConfig.stock_notifications_users),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_users", $$v)},expression:"localConfig.stock_notifications_users"}})],2),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('h4',{staticClass:"form-title-alt mt-0 mb-1"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.theoricaltitle')))]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.receiveNotification')}},[_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_theorical_alert]"},domProps:{"value":_vm.localConfig.stock_notifications_theorical_alert}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stock_notifications_theorical_alert),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_theorical_alert", $$v)},expression:"localConfig.stock_notifications_theorical_alert"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productThreshold', { mode: _vm.$t('catalog.stock.params.theorical') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_theorical_min]"},domProps:{"value":_vm.localConfig.stock_notifications_theorical_min}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.stock_notifications_theorical_min),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_theorical_min", $$v)},expression:"localConfig.stock_notifications_theorical_min"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productMin', { mode: _vm.$t('catalog.stock.params.theorical') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_theorical_no]"},domProps:{"value":_vm.localConfig.stock_notifications_theorical_no}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.stock_notifications_theorical_no),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_theorical_no", $$v)},expression:"localConfig.stock_notifications_theorical_no"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productEmpty', { mode: _vm.$t('catalog.stock.params.theorical') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_theorical_max]"},domProps:{"value":_vm.localConfig.stock_notifications_theorical_max}}),_c('k-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.localConfig.stock_notifications_theorical_max),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_theorical_max", $$v)},expression:"localConfig.stock_notifications_theorical_max"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productMax', { mode: _vm.$t('catalog.stock.params.theorical') }))+" ")])],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('h4',{staticClass:"form-title-alt mt-0 mb-1"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.realTitle')))]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.receiveNotification')}},[_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_real_alert]"},domProps:{"value":_vm.localConfig.stock_notifications_real_alert}}),_c('k-form-checkbox',{attrs:{"name":"configs[stock_notifications_real_alert]"},model:{value:(_vm.localConfig.stock_notifications_real_alert),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_real_alert", $$v)},expression:"localConfig.stock_notifications_real_alert"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productThreshold', { mode: _vm.$t('catalog.stock.params.real') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_real_min]"},domProps:{"value":_vm.localConfig.stock_notifications_real_min}}),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"name":"configs[stock_notifications_real_min]"},model:{value:(_vm.localConfig.stock_notifications_real_min),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_real_min", $$v)},expression:"localConfig.stock_notifications_real_min"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productMin', { mode: _vm.$t('catalog.stock.params.real') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_real_no]"},domProps:{"value":_vm.localConfig.stock_notifications_real_no}}),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"name":"configs[stock_notifications_real_no]"},model:{value:(_vm.localConfig.stock_notifications_real_no),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_real_no", $$v)},expression:"localConfig.stock_notifications_real_no"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productEmpty', { mode: _vm.$t('catalog.stock.params.real') }))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_notifications_real_max]"},domProps:{"value":_vm.localConfig.stock_notifications_real_max}}),_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"name":"configs[stock_notifications_real_max]"},model:{value:(_vm.localConfig.stock_notifications_real_max),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_notifications_real_max", $$v)},expression:"localConfig.stock_notifications_real_max"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.productMax', { mode: _vm.$t('catalog.stock.params.real') }))+" ")])],1)],1)],1),_c('KFormStickyBar',{staticClass:"mt-4",attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1),_c('b-tab',{attrs:{"title":_vm.$t('catalog.stock.params.providerCommand'),"lazy":""}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('h3',{staticClass:"form-title mt-0"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.defaultParams')))]),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.pdfOptions'),"label-class":"mb-2"}},[_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_contact]"},domProps:{"value":_vm.localConfig.provider_command_contact ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.provider_command_contact),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_contact", $$v)},expression:"localConfig.provider_command_contact"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.showContact'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_reference_column]"},domProps:{"value":_vm.localConfig.provider_command_reference_column ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.provider_command_reference_column),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_reference_column", $$v)},expression:"localConfig.provider_command_reference_column"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.showReference'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_units]"},domProps:{"value":_vm.localConfig.provider_command_units ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.provider_command_units),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_units", $$v)},expression:"localConfig.provider_command_units"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.showUnit'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_not_show_price]"},domProps:{"value":_vm.localConfig.provider_command_not_show_price ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.provider_command_not_show_price),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_not_show_price", $$v)},expression:"localConfig.provider_command_not_show_price"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.notshowPrices'))+" ")])],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"5"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.defaultDeliveryAddress')}},[_c('small',[_vm._v(_vm._s(_vm.$t('catalog.stock.params.emptyDeliveryAddress')))]),_c('k-form-address',{attrs:{"size":"sm","countries-list":_vm.countries,"with-road3":true,"valuesMap":{ road: 'road1', city: 'town', postalCode: 'postal_code' },"road-name":"configs[provider_command_delivery_address_road1]","road2-name":"configs[provider_command_delivery_address_road2]","road3-name":"configs[provider_command_delivery_address_road3]","city-name":"configs[provider_command_delivery_address_town]","postal-code-name":"configs[provider_command_delivery_address_postal_code]","country-name":null},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_delivery_address_country]"},domProps:{"value":_vm.address.country ? _vm.address.country.id : null}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.stock.params.defaultStatus')}},[_c('b-form-radio-group',{attrs:{"name":"configs[provider_command_default_status]","stacked":""},model:{value:(_vm.localConfig.provider_command_default_status),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_default_status", $$v)},expression:"localConfig.provider_command_default_status"}},[_c('b-form-radio',{attrs:{"value":0}},[_vm._v(_vm._s(_vm.$t('catalog.command.status.draft')))]),_c('b-form-radio',{attrs:{"value":1}},[_vm._v(_vm._s(_vm.$t('catalog.command.status.waitDelivery')))]),_c('b-form-radio',{attrs:{"value":3}},[_vm._v(_vm._s(_vm.$t('catalog.command.status.delivered')))])],1),_c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.statusExplain'))+" ")])],1)],1)],1),_c('h3',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.formOptions')))]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_all_products]"},domProps:{"value":_vm.localConfig.provider_command_all_products ? 1 : 0}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.provider_command_all_products),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_all_products", $$v)},expression:"localConfig.provider_command_all_products"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.canSelectAllProduct'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_update_product_price]"},domProps:{"value":_vm.localConfig.provider_command_update_product_price ? 1 : 0}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.provider_command_update_product_price),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_update_product_price", $$v)},expression:"localConfig.provider_command_update_product_price"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.updateProductPrice'))+" ")]),(_vm.localConfig.provider_command_update_product_price)?[_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_update_product_costs]"},domProps:{"value":_vm.localConfig.provider_command_update_product_costs ? 1 : 0}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.provider_command_update_product_costs),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_update_product_costs", $$v)},expression:"localConfig.provider_command_update_product_costs"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.stock.params.calculateProductCosts'))+" ")])]:_vm._e(),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_charge_delivered]"},domProps:{"value":_vm.localConfig.provider_command_charge_delivered ?? false}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.provider_command_charge_delivered),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_charge_delivered", $$v)},expression:"localConfig.provider_command_charge_delivered"}},[_vm._v(" Lors de la création d'une charge, ne prendre en compte que les quantités déjà livrées ")]),_c('input',{attrs:{"type":"hidden","name":"configs[provider_command_charge_add_draft]"},domProps:{"value":_vm.localConfig.provider_command_charge_add_draft ?? false}}),_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.localConfig.provider_command_charge_add_draft),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_charge_add_draft", $$v)},expression:"localConfig.provider_command_charge_add_draft"}},[_vm._v(" Lors de la création d'une charge, par défaut, ajouter à une charge existante ")]),_c('h3',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.referenceTitle')))]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('catalog.references.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceTypeNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[provider_command_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.provider_command_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_reference_prefix", $$v)},expression:"localConfig.provider_command_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[provider_command_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.provider_command_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_reference_mode", $$v)},expression:"localConfig.provider_command_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[provider_command_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.provider_command_reference_mode !== 0},model:{value:(_vm.localConfig.provider_command_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_reference_number", $$v)},expression:"localConfig.provider_command_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[provider_command_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.provider_command_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_command_reference_length", $$v)},expression:"localConfig.provider_command_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.commandReferenceExample))])])])]),_c('KFormStickyBar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],2)],1),_c('b-tab',{attrs:{"title":_vm.$t('catalog.stock.params.manualMovement'),"lazy":""}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('h3',{staticClass:"form-title mt-0"},[_vm._v(_vm._s(_vm.$t('catalog.stock.params.manualMovementReferenceTitle')))]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('catalog.references.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceTypeNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[manual_movement_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.manual_movement_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "manual_movement_reference_prefix", $$v)},expression:"localConfig.manual_movement_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.manual_movement_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "manual_movement_reference_mode", $$v)},expression:"localConfig.manual_movement_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[manual_movement_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.manual_movement_reference_mode !== 0},model:{value:(_vm.localConfig.manual_movement_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "manual_movement_reference_number", $$v)},expression:"localConfig.manual_movement_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[manual_movement_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.manual_movement_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "manual_movement_reference_length", $$v)},expression:"localConfig.manual_movement_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.manualReferenceExample))])])])]),_c('KFormStickyBar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1),(_vm.hasModule('stock-tracabilities'))?_c('b-tab',{attrs:{"title":"Stock avec traçabilité"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Permettre de sélectionner les lots :"}},[_c('input',{attrs:{"type":"hidden","name":"configs[stock_tracabilities_allow_quotation]"},domProps:{"value":_vm.localConfig.stock_tracabilities_allow_quotation}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stock_tracabilities_allow_quotation),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_allow_quotation", $$v)},expression:"localConfig.stock_tracabilities_allow_quotation"}},[_vm._v(" Depuis un devis ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_tracabilities_allow_command]"},domProps:{"value":_vm.localConfig.stock_tracabilities_allow_command}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stock_tracabilities_allow_command),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_allow_command", $$v)},expression:"localConfig.stock_tracabilities_allow_command"}},[_vm._v(" Depuis un bon de commande ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_tracabilities_allow_proforma]"},domProps:{"value":_vm.localConfig.stock_tracabilities_allow_proforma}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stock_tracabilities_allow_proforma),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_allow_proforma", $$v)},expression:"localConfig.stock_tracabilities_allow_proforma"}},[_vm._v(" Depuis une facture proforma ")]),_c('input',{attrs:{"type":"hidden","name":"configs[stock_tracabilities_allow_invoice]"},domProps:{"value":_vm.localConfig.stock_tracabilities_allow_invoice}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.stock_tracabilities_allow_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_allow_invoice", $$v)},expression:"localConfig.stock_tracabilities_allow_invoice"}},[_vm._v(" Depuis une facture ")]),_c('k-form-checkbox',{attrs:{"checked":true,"disabled":""}},[_vm._v(" Depuis un bon de livraison ")])],1),_c('b-form-group',{attrs:{"label":"Sélection automatique des lots sur les documents de vente :"}},[_c('k-form-select',{attrs:{"options":_vm.autoSelectLotOptions,"name":"configs[stock_tracabilities_auto_select]","reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localConfig.stock_tracabilities_auto_select),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_auto_select", $$v)},expression:"localConfig.stock_tracabilities_auto_select"}})],1),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Traçabilité avec date de fin de garantie ")]),_c('b-form-group',{attrs:{"label":"Si la date de fin de garantie n'est pas renseignée, calculer la date de fin de garantie :"}},[_c('b-form-radio-group',{attrs:{"name":"configs[stock_tracabilities_warranty_auto]","stacked":""},model:{value:(_vm.localConfig.stock_tracabilities_warranty_auto),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_tracabilities_warranty_auto", $$v)},expression:"localConfig.stock_tracabilities_warranty_auto"}},[_c('b-form-radio',{attrs:{"value":1}},[_vm._v(" Lors de l'entrée du produit dans le stock ")]),_c('b-form-radio',{attrs:{"value":2}},[_vm._v(" Lors de la création du bon de livraison ")]),_c('b-form-radio',{attrs:{"value":3}},[_vm._v(" Lors de la création du bon de commande ")]),_c('b-form-radio',{attrs:{"value":4}},[_vm._v(" Lors de la création de la facture ")])],1)],1),_c('KFormStickyBar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1):_vm._e(),(_vm.hasModule('stock-locations'))?_c('b-tab',{attrs:{"lazy":"","title":"Lieux de stock"}},[_c('StockLocationLists')],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/StockLocationList/StockLocationList.vue + 3 modules
var StockLocationList = __webpack_require__(2724);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockParams/StockParams.ts?vue&type=script&lang=ts&external







var StockParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockParams, _super);
    function StockParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.numberTypes = [
            { id: 1, label: _this.$t('catalog.stock.params.referenceNormal') },
            { id: 2, label: _this.$t('catalog.stock.params.referenceMonth') },
            { id: 3, label: _this.$t('catalog.stock.params.referenceYear') }
        ];
        _this.address = {
            road1: null,
            road2: null,
            road3: null,
            postal_code: null,
            town: null,
            country: null
        };
        _this.stockValueOptions = [
            { value: 1, label: _this.$t('catalog.stock.params.stockValueOptions1') },
            { value: 2, label: _this.$t('catalog.stock.params.stockValueOptions2') }
        ];
        _this.inStockOptions = [
            { value: 1, label: _this.$t('catalog.stock.params.inStock1') },
            { value: 2, label: _this.$t('catalog.stock.params.inStock2') }
        ];
        _this.providerCommandStockOptions = [
            { value: 0, label: _this.$t('catalog.stock.params.providerCommandStockOption1') },
            { value: 1, label: _this.$t('catalog.stock.params.providerCommandStockOption2') }
        ];
        _this.autoSelectLotOptions = [
            { value: 0, label: 'Ne jamais sélectionner automatiquement les lots' },
            { value: 2, label: 'Uniquement lorsqu\'un lot seul lot est disponible' },
            { value: 1, label: 'Toujours sélectionner les lots' }
        ];
        return _this;
    }
    Object.defineProperty(StockParams.prototype, "outStockOptions", {
        get: function () {
            var location = this.hasModule('stock-locations');
            return [
                { value: 1, label: this.$t('catalog.stock.params.outStock1') },
                { value: 2, label: this.$t('catalog.stock.params.outStock2') },
                { value: 3, label: this.$t('catalog.stock.params.outStock3') },
                { value: 4, label: this.$t('catalog.stock.params.outStock4'), disabled: location },
                { value: 5, label: this.$t('catalog.stock.params.outStock5'), disabled: location },
                { value: 6, label: this.$t('catalog.stock.params.outStock6'), disabled: location },
                { value: 7, label: this.$t('catalog.stock.params.outStock7'), disabled: location }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockParams.prototype, "userApiUrl", {
        get: function () {
            return '/team/user?sort=fullname';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockParams.prototype, "commandReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.provider_command_reference_prefix, this.localConfig.provider_command_reference_number, this.localConfig.provider_command_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockParams.prototype, "manualReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.manual_movement_reference_prefix, this.localConfig.manual_movement_reference_number, this.localConfig.manual_movement_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    StockParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StockParams.prototype.setLocalTeamConfigs = function (config) {
        this.localConfig = JSON.parse(JSON.stringify(config));
        this.setLocalAddress(this.localConfig);
    };
    StockParams.prototype.setLocalAddress = function (config) {
        this.address = {
            road1: config.provider_command_delivery_address_road1,
            road2: config.provider_command_delivery_address_road2,
            road3: config.provider_command_delivery_address_road3,
            postal_code: config.provider_command_delivery_address_postal_code,
            town: config.provider_command_delivery_address_town,
            country: config.provider_command_delivery_address_country
        };
    };
    StockParams.prototype.pad = function (number, length) {
        if (!length) {
            return;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    StockParams.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('teamConfigs')
    ], StockParams.prototype, "setLocalTeamConfigs", null);
    StockParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            components: {
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KFormAddress: form_vue_.KFormAddress, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, KFormStickyBar: form_vue_.KFormStickyBar,
                BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BTableSimple: external_bootstrap_vue_.BTableSimple, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                StockLocationLists: StockLocationList/* default */.A
            }
        })
    ], StockParams);
    return StockParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var StockParamsvue_type_script_lang_ts_external = (StockParams);

;// ./src/components/StockParams/StockParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockParams_StockParamsvue_type_script_lang_ts_external = (StockParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockParams/StockParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockParams_StockParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockParams_StockParams = (component.exports);

/***/ }),

/***/ 3950:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 4042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CatalogSearch_CatalogSearch; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CatalogSearch/CatalogSearch.vue?vue&type=template&id=17d4b36a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"catalog-search"},[_c('b-input-group',{ref:"group"},[_c('k-form-input',{ref:"input",attrs:{"type":"search","placeholder":_vm.placeholder,"size":_vm.size,"disabled":_vm.disabled},on:{"input":_vm.onInput},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),(_vm.withModal)?_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"size":"sm","title":_vm.$t('catalog.catalogSearch.goToCatalog'),"disabled":_vm.disabled},on:{"click":function($event){_vm.showCatalogModal = !_vm.showCatalogModal}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'books']}})],1)],1):_vm._e()],1),_c('b-list-group',{ref:"list"},[(_vm.loading)?_c('b-list-group-item',{staticClass:"text-center loading"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):_vm._e(),(_vm.results)?[(_vm.results.total === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('catalog.catalogSearch.noResults'))+" ")]):_vm._e(),_vm._l((_vm.results.datas),function(result,i){return _c('b-list-group-item',{key:i,on:{"click":function($event){return _vm.selectEntry(result)}}},[_c('div',{staticClass:"type text-muted"},[_vm._v(" "+_vm._s(_vm.$t('catalog.' + result.type + '.label'))+" ")]),_c('div',{staticClass:"title"},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(result.data.reference)+" -")]),_vm._v(" "+_vm._s(result.data.name)+" ")]),_c('div',{staticClass:"price text-muted"},[_vm._v(" "+_vm._s(_vm.formattedNumber(result.data.unit_price_ht))+" "),(_vm.hasModule('stock') && result.data.with_stock)?_c('p',{staticClass:"mb-0 mt-1"},[_vm._v(" Stock : "+_vm._s(_vm.showNumber(result.data.stock_quantity))+" ")]):_vm._e()])])})]:_vm._e()],2),_c('b-modal',{attrs:{"dialog-class":"catalog-modal","content-class":"catalog-modal-content","size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close'),"scrollable":""},model:{value:(_vm.showCatalogModal),callback:function ($$v) {_vm.showCatalogModal=$$v},expression:"showCatalogModal"}},[_c('CatalogList',{attrs:{"only":_vm.only,"filters":_vm.computedFilters,"include":_vm.include},on:{"selected":_vm.selectedEntry}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/CatalogList/CatalogList.vue + 3 modules
var CatalogList = __webpack_require__(573);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CatalogSearch/CatalogSearch.ts?vue&type=script&lang=ts&external









var CatalogSearch = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogSearch, _super);
    function CatalogSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchTerm = null;
        _this.timeout = null;
        _this.results = null;
        _this.loading = false;
        _this.dropdownState = false;
        _this.popperInstance = null;
        _this.showCatalogModal = false;
        return _this;
    }
    Object.defineProperty(CatalogSearch.prototype, "computedFilters", {
        get: function () {
            var _a;
            var filters = (_a = this.filters) !== null && _a !== void 0 ? _a : {};
            filters.status = true;
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    CatalogSearch.prototype.watchDropdownState = function (state) {
        if (state) {
            this.initDropdown();
        }
        else if (this.popperInstance) {
            this.popperInstance.destroy();
            this.results = null;
        }
    };
    CatalogSearch.prototype.initDropdown = function () {
        var _this = this;
        var input = this.$refs.input;
        this.popperInstance = popper_createPopper(input.$el, this.$refs.list, {
            placement: 'bottom-start',
            modifiers: [
                {
                    name: 'setWidth',
                    enabled: true,
                    fn: function (_a) {
                        var state = _a.state, instance = _a.instance;
                        var group = _this.$refs.group;
                        if (!group) {
                            return;
                        }
                        var rawWidth = group.clientWidth;
                        var minWidth = rawWidth + 'px';
                        if (minWidth === state.styles.popper.minWidth) {
                            return;
                        }
                        state.styles.popper.minWidth = minWidth;
                        var maxWidth = window.innerWidth - group.getBoundingClientRect().x - 30;
                        if (maxWidth > (rawWidth + 300)) {
                            state.styles.popper.width = (maxWidth - 300) + 'px';
                        }
                        instance.update();
                    },
                    phase: 'beforeWrite'
                },
            ],
        });
    };
    CatalogSearch.prototype.onInput = function (val) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (!val) {
            this.dropdownState = false;
            this.loading = false;
            return;
        }
        this.results = null;
        this.dropdownState = true;
        this.loading = true;
        this.timeout = setTimeout(this.search, 400);
    };
    CatalogSearch.prototype.clearSearch = function () {
        this.results = null;
        this.dropdownState = false;
        this.loading = false;
        this.searchTerm = null;
    };
    CatalogSearch.prototype.search = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var params;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.searchTerm) {
                            this.timeout = null;
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        params = {
                            total: 10,
                            search: this.searchTerm,
                            filters: this.computedFilters
                        };
                        if (this.include) {
                            params.include = this.include;
                        }
                        if (this.only) {
                            params.elements = Array.isArray(this.only) ? this.only : [this.only];
                        }
                        return [4 /*yield*/, this.$kwCatalog.axios.get('/catalog/search', {
                                params: params
                            })
                                .then(function (response) {
                                _this.results = response.data;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.timeout = null;
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CatalogSearch.prototype.selectEntry = function (entry) {
        this.clearSearch();
        this.selectedEntry(JSON.parse(JSON.stringify(entry)));
    };
    CatalogSearch.prototype.selectedEntry = function (entry) {
        return entry;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogSearch.prototype, "only", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return this.$kwCatalog.i18n.t('catalog.catalogSearch.placeholder'); } })
    ], CatalogSearch.prototype, "placeholder", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogSearch.prototype, "include", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogSearch.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CatalogSearch.prototype, "withModal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogSearch.prototype, "filters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CatalogSearch.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('dropdownState')
    ], CatalogSearch.prototype, "watchDropdownState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('selected')
    ], CatalogSearch.prototype, "selectedEntry", null);
    CatalogSearch = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CatalogList: CatalogList/* default */.A,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormInput: form_vue_.KFormInput,
                BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem, BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], CatalogSearch);
    return CatalogSearch;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var CatalogSearchvue_type_script_lang_ts_external = (CatalogSearch);

;// ./src/components/CatalogSearch/CatalogSearch.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CatalogSearch_CatalogSearchvue_type_script_lang_ts_external = (CatalogSearchvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CatalogSearch/CatalogSearch.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CatalogSearch_CatalogSearchvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CatalogSearch_CatalogSearch = (component.exports);

/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ServiceItem_ServiceItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ServiceItem/ServiceItem.vue?vue&type=template&id=afc57232
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"service-item"},[_c('PageHeader',{staticClass:"border-0 mb-0",attrs:{"page-title":_vm.pageTitle,"buttons":_vm.headerButtons}}),_c('AppMessages'),(!_vm.value.status.active)?_c('p',{staticClass:"font-weight-bold text-danger"},[_vm._v(" Prestation désactivée ")]):_vm._e(),(_vm.value.designation)?_c('b-card',{staticClass:"p-2 mb-4",attrs:{"no-body":""}},[_c('p',{staticClass:"font-weight-bold text-underline"},[_vm._v(" "+_vm._s(_vm.value.name)+" ")]),_c('FroalaView',{model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),(_vm.value.custom_fields.length > 0 && !_vm.team.configs.custom_field_service_tab)?_c('CustomFieldsDisplay',{attrs:{"type":"service","value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e()],1):_vm._e(),_c('tabs',{staticClass:"tabs-card mb-4"},[_c('tab',{attrs:{"title":"Informations prestation"}},[_c('b-form-row',[_c('b-col',{staticClass:"py-3 px-4 border-right",attrs:{"cols":"12","md":"6","lg":"4"}},[(_vm.value.sale_category)?_c('b-form-group',{staticClass:"mb-4",attrs:{"label":"Catégorie de vente"}},[_vm._v(" "+_vm._s(_vm.value.sale_category.label)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Prix vente HT"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),(_vm.value.vat_rate)?_c('b-form-group',{attrs:{"label":'TVA ' + _vm.showNumber(_vm.value.vat_rate.rate) + ' %'}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_tva, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Prix vente TTC"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_ttc, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Qté par défaut"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.default_quantity))+" ")])],1),_c('b-col',[(_vm.value.unit)?_c('b-form-group',{attrs:{"label":"Unité"}},[_vm._v(" "+_vm._s(_vm.value.unit.label)+" ")]):_vm._e()],1)],1)],1),(_vm.can('sales-margin', 1) || _vm.can('catalog-services', 3))?_c('b-col',{staticClass:"py-3 px-4",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Coûts des produits"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.products_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Main d'oeuvre"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.workforce_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Coûts divers"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.various_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Coûts total"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Marge"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.gross_margin_amount ,2, 2))+" "+_vm._s(_vm.currency.symbol)+" / "+_vm._s(_vm.showNumber(_vm.value.gross_margin_rate))+" % ")]),_c('b-form-group',{attrs:{"label":"Taux de marque"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.markup_rate))+" % ")]),(_vm.value.cant_change_price)?_c('span',[_vm._v(" Prix de vente non modifiable lors l'édition des documents de vente ")]):_vm._e()],1):_vm._e(),(_vm.value.sale_category)?_c('b-col',{staticClass:"py-3 px-4 gray-part",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Nombre de personne nécessaire :"}},[_vm._v(" "+_vm._s(_vm.value.number_people_needed)+" ")]),_c('b-form-group',{attrs:{"label":"Durée de la prestation :"}},[_vm._v(" "+_vm._s(_vm.value.duration)+" "+_vm._s(_vm.value.duration_type)+" ")]),(_vm.value.hourly_person_cost)?_c('b-form-group',{attrs:{"label":"Coûts horaire d'une personne :"}},[_vm._v(" "+_vm._s(_vm.value.hourly_person_cost)+" "+_vm._s(_vm.currency.symbol)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Coûts total :"}},[_vm._v(" "+_vm._s(_vm.value.workforce_costs)+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Techniciens pouvant réaliser cette prestation :"}},[(_vm.value.allowed_all_technicians)?_c('span',[_vm._v(" Tous ")]):_vm._l((_vm.value.technicians),function(technician,i){return _c('span',{key:i},[(i > 0)?[_vm._v(", ")]:_vm._e(),_vm._v(_vm._s(technician.fullname))],2)})],2),(_vm.value.work_description)?_c('b-form-group',{attrs:{"label":"Description destinée aux personnes qui réaliseront la prestation :"}},[_vm._v(" "+_vm._s(_vm.value.work_description)+" ")]):_vm._e()],1):_vm._e()],1)],1),(_vm.value.products && _vm.value.products.length > 0)?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Produits "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.value.products.length))])]},proxy:true}],null,false,1238493694)},[_c('table',{staticClass:"table table-bordered table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom du produit")]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Prix achat HT")]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Quantité")]),_c('th',[_vm._v("Total HT")])])]),_c('tbody',_vm._l((_vm.value.products),function(product,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(product.product.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(product.product.reference)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(product.unit_price_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(product.quantity, 5))+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(product.total_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])])}),0)])]):_vm._e(),(_vm.nbCustomPrices > 0 && _vm.hasModule('catalog-custom-prices'))?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Prix personnalisé "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.nbCustomPrices))])]},proxy:true}],null,false,3112299060)},[_c('custom-prices-view',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e(),(_vm.value.custom_fields.length > 0 && _vm.team.configs.custom_field_product_tab)?_c('CustomFieldsDisplayTab',{attrs:{"type":"service","value":_vm.value.custom_fields,"formUrl":'/catalog/service/' + _vm.value.id,"canUpdate":_vm.can('catalog-services', 3)},on:{"input":service => _vm.$emit('input', service)}}):_vm._e(),_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Photos "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.totalPictures))])]},proxy:true}])},[_c('CatalogPictures',{attrs:{"id":_vm.value.id,"type":"service","default-picture":_vm.value.default_picture_id},on:{"total":total => _vm.totalPictures = total,"defaultPicture":_vm.updateDefaultPicture}})],1),_c('tab',{attrs:{"title":"Statistiques","lazy":""}},[_c('Statistics',{attrs:{"type":"service","id":_vm.value.id}})],1),(_vm.can('sales-quotation', 1))?_c('tab',{attrs:{"title":"Devis","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"quotation","type":"service","id":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-commands') && _vm.can('sales-command', 1))?_c('tab',{attrs:{"title":"Bons de commande","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"command","type":"service","id":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-deliveries') && _vm.can('sales-delivery', 1))?_c('tab',{attrs:{"title":"Bons de livraison","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"delivery","type":"service","id":_vm.value.id}})],1):_vm._e(),(_vm.can('sales-invoice', 1))?_c('tab',{attrs:{"title":"Factures","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"invoice","type":"service","id":_vm.value.id}})],1):_vm._e()],1),_c('ServiceDelete',{attrs:{"value":_vm.toDelete ? _vm.value : null},on:{"hidden":function($event){_vm.toDelete = false},"deleted":function($event){return _vm.$router.push({ name: 'catalog-services-list' })}}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/CustomPricesView/CustomPricesView.vue + 3 modules
var CustomPricesView = __webpack_require__(3613);
// EXTERNAL MODULE: ./src/components/CatalogPictures/CatalogPictures.vue + 3 modules
var CatalogPictures = __webpack_require__(3431);
// EXTERNAL MODULE: ./src/components/ServiceDelete/ServiceDelete.vue + 3 modules
var ServiceDelete = __webpack_require__(9478);
// EXTERNAL MODULE: ./src/components/ElementSalesList/ElementSalesList.vue + 3 modules
var ElementSalesList = __webpack_require__(7596);
// EXTERNAL MODULE: ./src/components/Statistics/Statistics.vue + 3 modules
var Statistics = __webpack_require__(7220);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ServiceItem/ServiceItem.ts?vue&type=script&lang=ts&external











var ServiceItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceItem, _super);
    function ServiceItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.totalPictures = 0;
        _this.toDelete = false;
        return _this;
    }
    Object.defineProperty(ServiceItem.prototype, "pageTitle", {
        get: function () {
            return this.$t('catalog.service.itemTitle') + ' - ' + this.value.reference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('catalog-services', 3)) {
                buttons.push({
                    label: 'Modifier',
                    click: function () {
                        _this.openModal({
                            key: 'catalog-service-form',
                            value: _this.value,
                            submitted: function (response) { return _this.$emit('input', response.data); }
                        });
                    }
                });
            }
            if (this.can('catalog-services', 4)) {
                buttons.push({
                    label: 'Supprimer',
                    click: function () {
                        _this.toDelete = true;
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceItem.prototype, "nbCustomPrices", {
        get: function () {
            return (this.value.custom_type_prices ? this.value.custom_type_prices.length : 0) + (this.value.custom_quantity_prices ? this.value.custom_quantity_prices.length : 0);
        },
        enumerable: false,
        configurable: true
    });
    ServiceItem.prototype.updateDefaultPicture = function (id) {
        var product = JSON.parse(JSON.stringify(this.value));
        product.default_picture_id = id;
        this.$emit('input', product);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ServiceItem.prototype, "value", void 0);
    ServiceItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'can', 'team'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                PageHeader: interface_vue_.PageHeader, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, AppMessages: interface_vue_.AppMessages,
                CustomPricesView: CustomPricesView/* default */.A,
                CatalogPictures: CatalogPictures/* default */.A,
                ServiceDelete: ServiceDelete/* default */.A,
                ElementSalesList: ElementSalesList/* default */.A,
                Statistics: Statistics/* default */.A,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                BCard: external_bootstrap_vue_.BCard, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BBadge: external_bootstrap_vue_.BBadge
            }
        })
    ], ServiceItem);
    return ServiceItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ServiceItemvue_type_script_lang_ts_external = (ServiceItem);

;// ./src/components/ServiceItem/ServiceItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ServiceItem_ServiceItemvue_type_script_lang_ts_external = (ServiceItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ServiceItem/ServiceItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ServiceItem_ServiceItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ServiceItem_ServiceItem = (component.exports);

/***/ }),

/***/ 4218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 4247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 4248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 4254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockByLocations_StockByLocations; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockByLocations/StockByLocations.vue?vue&type=template&id=5402b054
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[(_vm.can('catalog-products', 3) && !_vm.editMode)?_c('b-button',{staticClass:"mb-2",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.editMode = !_vm.editMode}}},[_vm._v(" Modifier ")]):_vm._e(),(_vm.variation)?_c('b-row',[(_vm.product.variation_level1)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level1.label ?? 'Niveau 1'}},[_vm._v(" "+_vm._s(_vm.variation.level1.value)+" ")])],1):_vm._e(),(_vm.variation.level2 && _vm.product.variation_level2)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level2.label ?? 'Niveau 2'}},[_vm._v(" "+_vm._s(_vm.variation.level2.value)+" ")])],1):_vm._e(),(_vm.variation.level3 && _vm.product.variation_level3)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level3.label ?? 'Niveau 3'}},[_vm._v(" "+_vm._s(_vm.variation.level3.value)+" ")])],1):_vm._e()],1):_vm._e(),_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered stock-locations-list text-nowrap align-middle"},[_c('thead',[_c('tr',{staticClass:"text-center"},[_c('th',{staticClass:"text-left"},[_vm._v("Lieu")]),_c('th',[_vm._v("Quantité")]),_c('th',[_vm._v("Montant HT")]),_c('th',[_vm._v("Quantité théorique")]),_c('th',[_vm._v("Montant HT théorique")])])]),_c('tbody',_vm._l((_vm.stocks),function(stockLocation,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(stockLocation.stock_location.name)+" "),_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][location]'},domProps:{"value":stockLocation.stock_location_id}})]),_c('td',{staticClass:"text-center"},[(_vm.editMode && _vm.product.stock_tracking_mode === 0)?_c('k-form-spinner',{attrs:{"size":"sm","maxDecimal":5,"name":'contents[' + i + '][stock_quantity]'},model:{value:(stockLocation.stock_quantity),callback:function ($$v) {_vm.$set(stockLocation, "stock_quantity", $$v)},expression:"stockLocation.stock_quantity"}}):_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(stockLocation.stock_quantity, 5))+" ")])],1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(stockLocation.stock_quantity * _vm.unitBuyPrice, 5))))]),_c('td',{staticClass:"text-center"},[(_vm.editMode)?_c('k-form-spinner',{attrs:{"size":"sm","maxDecimal":5,"name":'contents[' + i + '][stock_theoretical_quantity]'},model:{value:(stockLocation.stock_theoretical_quantity),callback:function ($$v) {_vm.$set(stockLocation, "stock_theoretical_quantity", $$v)},expression:"stockLocation.stock_theoretical_quantity"}}):_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(stockLocation.stock_theoretical_quantity, 5))+" ")])],1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(stockLocation.stock_theoretical_quantity * _vm.unitBuyPrice, 5))))])])}),0)])]),(_vm.editMode)?_c('div',{staticClass:"mb-2 text-center"},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.watchProduct(); _vm.editMode = false}}},[_vm._v(" Annuler ")]),_c('b-button',{staticClass:"ml-3",attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Enregistrer ")])],1):_vm._e()])]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockByLocations/StockByLocations.ts?vue&type=script&lang=ts&external






var StockByLocations = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockByLocations, _super);
    function StockByLocations() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.editMode = false;
        _this.stocks = [];
        return _this;
    }
    StockByLocations.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.watchProduct();
                        this.watchVariation();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StockByLocations.prototype, "formAction", {
        get: function () {
            if (this.variation) {
                return '/catalog/product/' + this.product.id + '/variation/' + this.variation.id + '/stock-location';
            }
            return '/catalog/product/' + this.product.id + '/stock-location';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockByLocations.prototype, "unitBuyPrice", {
        get: function () {
            return this.number(this.product.unit_buy_price_ht);
        },
        enumerable: false,
        configurable: true
    });
    StockByLocations.prototype.watchProduct = function () {
        var _this = this;
        if (this.variation) {
            return;
        }
        this.stocks = [];
        this.stockLocations.forEach(function (location) {
            var _a;
            var value = (_a = _this.product.stock_locations) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val.stock_location_id === location.id; });
            _this.stocks.push(value ? JSON.parse(JSON.stringify(value)) : {
                stock_location_id: location.id,
                stock_location: location,
                stock_theoretical_quantity: 0,
                stock_quantity: 0,
                total_stock_theoretical_ht: 0,
                total_stock_ht: 0
            });
        });
    };
    StockByLocations.prototype.watchVariation = function () {
        var _this = this;
        if (!this.variation) {
            return;
        }
        this.stocks = [];
        this.stockLocations.forEach(function (location) {
            var _a;
            var value = (_a = _this.variation.stock_locations) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val.stock_location_id === location.id; });
            _this.stocks.push(value ? JSON.parse(JSON.stringify(value)) : {
                stock_location_id: location.id,
                stock_location: location,
                stock_theoretical_quantity: 0,
                stock_quantity: 0,
                total_stock_theoretical_ht: 0,
                total_stock_ht: 0
            });
        });
    };
    StockByLocations.prototype.submitComplete = function (response) {
        this.$emit('input', response.data);
        this.editMode = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StockByLocations.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], StockByLocations.prototype, "variation", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('product', { deep: true })
    ], StockByLocations.prototype, "watchProduct", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('variation', { deep: true })
    ], StockByLocations.prototype, "watchVariation", null);
    StockByLocations = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            components: {
                BFormRow: external_bootstrap_vue_.BFormRow,
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KForm: form_vue_.KForm
            }
        })
    ], StockByLocations);
    return StockByLocations;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var StockByLocationsvue_type_script_lang_ts_external = (StockByLocations);

;// ./src/components/StockByLocations/StockByLocations.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockByLocations_StockByLocationsvue_type_script_lang_ts_external = (StockByLocationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockByLocations/StockByLocations.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockByLocations_StockByLocationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockByLocations_StockByLocations = (component.exports);

/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductStockIndicator_ProductStockIndicator; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductStockIndicator/ProductStockIndicator.vue?vue&type=template&id=5d9aa2a8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element)?_c('div',{staticClass:"small"},[(_vm.real !== false && _vm.theorical !== false)?_c('p',{staticClass:"mb-0 font-weight-bold"},[_vm._v(" Stock : ")]):_vm._e(),(_vm.real !== false)?_c('p',{staticClass:"mb-0"},[(_vm.theorical !== false)?_c('span',[_vm._v("Réel")]):_c('span',[_vm._v("Stock")]),_vm._v(" : "+_vm._s(_vm.showNumber(_vm.element.stock_quantity))+" ")]):_vm._e(),(_vm.theorical !== false)?_c('p',{staticClass:"mb-0"},[(_vm.real !== false)?_c('span',[_vm._v("Théorique")]):_c('span',[_vm._v("Stock théorique")]),_vm._v(" : "+_vm._s(_vm.showNumber(_vm.element.stock_theoretical_quantity))+" ")]):_vm._e(),(_vm.hasModule('stock-locations'))?[(_vm.location)?[_vm._v(" "+_vm._s(_vm.location.name)+" : "+_vm._s(_vm.showNumber(_vm.stockLocation.stock_quantity))+" ")]:_vm._e(),(_vm.location && _vm.location2)?_c('br'):_vm._e(),(_vm.location2)?[_vm._v(" "+_vm._s(_vm.location2.name)+" : "+_vm._s(_vm.showNumber(_vm.stockLocation2.stock_quantity))+" ")]:_vm._e(),(_vm.element.stock_locations?.length > 0)?_c('b-tooltip',{attrs:{"target":() => _vm.$el,"custom-class":"product-stock-indicator","boundary-padding":0,"placement":"left"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Lieu")]),(_vm.real !== false)?_c('th',[_vm._v("Stock")]):_vm._e(),(_vm.theorical !== false)?_c('th',[_vm._v("Théorique")]):_vm._e()])]),_vm._l((_vm.element.stock_locations),function(location,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(location.stock_location.name))]),(_vm.real !== false)?_c('td',[_vm._v(_vm._s(_vm.showNumber(location.stock_quantity)))]):_vm._e(),(_vm.theorical !== false)?_c('td',[_vm._v(_vm._s(_vm.showNumber(location.stock_theoretical_quantity)))]):_vm._e()])})],2)]):_vm._e()]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductStockIndicator/ProductStockIndicator.ts?vue&type=script&lang=ts&external





var ProductStockIndicator = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductStockIndicator, _super);
    function ProductStockIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProductStockIndicator.prototype, "element", {
        get: function () {
            if (this.product.variations_length > 0) {
                return this.variation;
            }
            return this.product;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductStockIndicator.prototype, "stockLocation", {
        get: function () {
            var _this = this;
            var _a, _b, _c;
            var value = (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.stock_locations) === null || _b === void 0 ? void 0 : _b.find(function (val) { var _a; return val.stock_location_id === ((_a = _this.location) === null || _a === void 0 ? void 0 : _a.id); });
            return value !== null && value !== void 0 ? value : {
                stock_location_id: (_c = this.location) === null || _c === void 0 ? void 0 : _c.id,
                stock_location: this.location,
                stock_theoretical_quantity: 0,
                stock_quantity: 0,
                total_stock_theoretical_ht: 0,
                total_stock_ht: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductStockIndicator.prototype, "stockLocation2", {
        get: function () {
            var _this = this;
            var _a, _b, _c;
            var value = (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.stock_locations) === null || _b === void 0 ? void 0 : _b.find(function (val) { var _a; return val.stock_location_id === ((_a = _this.location2) === null || _a === void 0 ? void 0 : _a.id); });
            return value !== null && value !== void 0 ? value : {
                stock_location_id: (_c = this.location2) === null || _c === void 0 ? void 0 : _c.id,
                stock_location: this.location2,
                stock_theoretical_quantity: 0,
                stock_quantity: 0,
                total_stock_theoretical_ht: 0,
                total_stock_ht: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductStockIndicator.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductStockIndicator.prototype, "variation", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductStockIndicator.prototype, "location", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductStockIndicator.prototype, "location2", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], ProductStockIndicator.prototype, "real", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ProductStockIndicator.prototype, "theorical", void 0);
    ProductStockIndicator = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTooltip: external_bootstrap_vue_.BTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], ProductStockIndicator);
    return ProductStockIndicator;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ProductStockIndicatorvue_type_script_lang_ts_external = (ProductStockIndicator);

;// ./src/components/ProductStockIndicator/ProductStockIndicator.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductStockIndicator_ProductStockIndicatorvue_type_script_lang_ts_external = (ProductStockIndicatorvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductStockIndicator/ProductStockIndicator.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductStockIndicator_ProductStockIndicatorvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductStockIndicator_ProductStockIndicator = (component.exports);

/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 4429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandList_CommandList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandList/CommandList.vue?vue&type=template&id=521e1001
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100 flex-table"},[(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/catalog/command","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":_vm.customStateKey ? _vm.customStateKey : 'stock-commands',"saveMainSearch":_vm.disableMainSearchSave === false}}),_c('div',{staticClass:"text-center"},[_c('b-card',{staticClass:"d-inline-block small mt-2 status-indicator-explain text-left",attrs:{"body-class":"px-3 py-2"}},[_c('b-row',{attrs:{"align-v":"center"}},_vm._l((_vm.statusIndicator),function(status,i){return _c('b-col',{key:i,attrs:{"cols":"auto"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{class:'pr-0 status-indicator ' + status.class,attrs:{"cols":"auto"}}),_c('b-col',{staticClass:"pl-2",attrs:{"cols":"auto"}},[_vm._v(_vm._s(status.label))])],1)],1)}),1)],1)],1),_c('CommandDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.deleteId),callback:function ($$v) {_vm.deleteId=$$v},expression:"deleteId"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/CommandDelete/CommandDelete.vue + 3 modules
var CommandDelete = __webpack_require__(8674);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandList/CommandList.ts?vue&type=script&lang=ts&external








var CommandList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandList, _super);
    function CommandList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deleteId = null;
        _this.deleteIndex = null;
        return _this;
    }
    CommandList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasModule('stock-locations')) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommandList.prototype, "include", {
        get: function () {
            var include = ['contact', 'country', 'customFields', 'stock_location'];
            if (this.provider === null) {
                include.push('provider');
            }
            return include;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-provider-command-0', label: 'Brouillon' },
                { class: 'status-provider-command-1', label: 'En attente de livraison' },
                { class: 'status-provider-command-2', label: 'Livrée partiellement' },
                { class: 'status-provider-command-3', label: 'Livrée' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    link: function (command) { return ({
                        name: 'stock-command-form',
                        params: {
                            id: String(command.id)
                        }
                    }); }
                },
                {
                    icon: 'delete',
                    click: function (command, index) {
                        _this.deleteId = command.id;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'reference',
                    name: this.$t('catalog.command.list.reference'),
                    sticky: true
                },
                {
                    data: 'date',
                    name: this.$t('catalog.command.list.date'),
                    render: 'date'
                },
                {
                    data: 'title',
                    name: this.$t('catalog.command.list.title')
                }
            ];
            if (this.provider === null) {
                columns.push({
                    data: 'provider.name',
                    name: this.$t('catalog.command.list.provider')
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'contact.fullname',
                    name: this.$t('catalog.command.list.contact'),
                    visible: false
                },
                {
                    data: 'road1',
                    name: this.$t('catalog.command.list.road1'),
                    visible: false
                },
                {
                    data: 'road2',
                    name: this.$t('catalog.command.list.road2'),
                    visible: false
                },
                {
                    data: 'road3',
                    name: this.$t('catalog.command.list.road3'),
                    visible: false
                },
                {
                    data: 'postal_code',
                    name: this.$t('catalog.command.list.postalCode'),
                    visible: false
                },
                {
                    data: 'town',
                    name: this.$t('catalog.command.list.town'),
                    visible: false
                },
                {
                    data: 'country.name',
                    name: this.$t('catalog.command.list.country'),
                    visible: false
                },
                {
                    data: 'comments',
                    name: this.$t('catalog.command.list.comments'),
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: this.$t('catalog.command.list.totalHt'),
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: this.$t('catalog.command.list.totalTva'),
                    render: 'currency'
                },
                {
                    data: 'total_ttc',
                    name: this.$t('catalog.command.list.totalTtc'),
                    render: 'currency'
                },
                {
                    data: 'status_label',
                    name: this.$t('catalog.command.list.status'),
                    cssClass: function (row) {
                        var cssClass = {
                            'status-indicator': true
                        };
                        cssClass['status-provider-command-' + row.status] = true;
                        return cssClass;
                    }
                }
            ]);
            if (this.hasModule('charges')) {
                columns.push({
                    data: 'charge_status',
                    name: 'Comptabilisé',
                    render: function (value) {
                        switch (value) {
                            case 2:
                                return 'Comptabilisée';
                            case 1:
                                return 'Comptabilisée partiellement';
                            default:
                                return 'Non comptabilisée';
                        }
                    }
                });
            }
            if (this.hasModule('stock-locations')) {
                columns.push({
                    data: 'stock_location.name',
                    name: 'Lieu de stock',
                    visible: false
                });
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime',
                    visible: false
                }
            ], this.customFieldTableColumns('provider_command')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'text',
                    label: 'Référence',
                    name: 'reference'
                },
                {
                    type: 'period',
                    label: this.$t('catalog.command.filter.period'),
                    name: 'date_since',
                    name2: 'date_until'
                }
            ];
            if (this.provider === null) {
                filters.push({
                    type: 'select',
                    label: this.$t('catalog.command.filter.provider'),
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_provider]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (this.hasModule('charges')) {
                filters.push({
                    type: 'select',
                    label: 'Comptabilisé',
                    name: 'accounted_status',
                    optionLabel: 'label',
                    value: 'id',
                    multiple: true,
                    options: [
                        { id: 2, label: 'Comptabilisée' },
                        { id: 1, label: 'Comptabilisée partiellement' },
                        { id: 0, label: 'Non comptabilisée' }
                    ]
                });
            }
            filters.push.apply(filters, [
                {
                    type: 'select',
                    label: this.$t('catalog.command.filter.status'),
                    name: 'status',
                    options: [
                        { id: 0, label: this.$t('catalog.command.status.draft') },
                        { id: 1, label: this.$t('catalog.command.status.waitDelivery') },
                        { id: 2, label: this.$t('catalog.command.status.partiallyDelivered') },
                        { id: 3, label: this.$t('catalog.command.status.delivered') }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                }
            ]);
            if (this.hasModule('stock-locations')) {
                filters.push({
                    type: 'select',
                    name: 'stock_location',
                    label: 'Lieu de stock',
                    options: this.stockLocations,
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true
                });
            }
            filters.push.apply(filters, this.customFieldTableFilters('provider_command'));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandList.prototype, "ajaxDatas", {
        get: function () {
            var data = {
                include: this.include.join(',')
            };
            if (this.provider === null) {
                data.filter = {
                    customer: this.provider
                };
            }
            return data;
        },
        enumerable: false,
        configurable: true
    });
    CommandList.prototype.rowLink = function (row) {
        return {
            name: 'stock-command-item',
            params: {
                id: String(row.id)
            }
        };
    };
    CommandList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteId = null;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommandList.prototype, "provider", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommandList.prototype, "customStateKey", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommandList.prototype, "disableMainSearchSave", void 0);
    CommandList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandDelete: CommandDelete/* default */.A,
                KTable: table_vue_.KTable,
                Spinner: interface_vue_.Spinner,
                BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations']))
        })
    ], CommandList);
    return CommandList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var CommandListvue_type_script_lang_ts_external = (CommandList);

;// ./src/components/CommandList/CommandList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandList_CommandListvue_type_script_lang_ts_external = (CommandListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommandList/CommandList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandList_CommandListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandList_CommandList = (component.exports);

/***/ }),

/***/ 4456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductVariationView_ProductVariationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductVariationView/ProductVariationView.vue?vue&type=template&id=51c2fc1a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"small"},[(_vm.value.product.variation_level1)?_c('b-col',{attrs:{"cols":"auto pr-5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.value.product.variation_level1.label}},[_vm._v(" "+_vm._s(_vm.value.variation.level1.value)+" ")])],1):_vm._e(),(_vm.value.variation.level2)?_c('b-col',{attrs:{"cols":"auto pr-5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.value.product.variation_level2.label}},[_vm._v(" "+_vm._s(_vm.value.variation.level2.value)+" ")])],1):_vm._e(),(_vm.value.variation.level3)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.value.product.variation_level3.label}},[_vm._v(" "+_vm._s(_vm.value.variation.level3.value)+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductVariationView/ProductVariationView.ts?vue&type=script&lang=ts&external




var ProductVariationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariationView, _super);
    function ProductVariationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductVariationView.prototype, "value", void 0);
    ProductVariationView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormSelect: form_vue_.KFormSelect,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], ProductVariationView);
    return ProductVariationView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductVariationViewvue_type_script_lang_ts_external = (ProductVariationView);

;// ./src/components/ProductVariationView/ProductVariationView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductVariationView_ProductVariationViewvue_type_script_lang_ts_external = (ProductVariationViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductVariationView/ProductVariationView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductVariationView_ProductVariationViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductVariationView_ProductVariationView = (component.exports);

/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(6545),
    noop = __webpack_require__(3950),
    setToArray = __webpack_require__(4247);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 4528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 4660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_GroupListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GroupListView.vue?vue&type=template&id=313fe7c6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductList',{attrs:{"showGroup":true}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProductList/ProductList.vue + 3 modules
var ProductList = __webpack_require__(7439);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/GroupListView.vue?vue&type=script&lang=ts



var GroupListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GroupListView, _super);
    function GroupListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProductList: ProductList/* default */.A
            }
        })
    ], GroupListView);
    return GroupListView;
}(lib/* Vue */.lD));
/* harmony default export */ var GroupListViewvue_type_script_lang_ts = (GroupListView);

;// ./src/views/GroupListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_GroupListViewvue_type_script_lang_ts = (GroupListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/GroupListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_GroupListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_GroupListView = (component.exports);

/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(9770),
    stubArray = __webpack_require__(3345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ServiceItemView_ServiceItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ServiceItemView/ServiceItemView.vue?vue&type=template&id=77eef7a0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ServiceItem',{model:{value:(_vm.service),callback:function ($$v) {_vm.service=$$v},expression:"service"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ServiceItem/ServiceItem.vue + 3 modules
var ServiceItem = __webpack_require__(4204);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/mixins/LoadServiceMixin.ts
var LoadServiceMixin = __webpack_require__(1055);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/ServiceItemView/ServiceItemView.ts?vue&type=script&lang=ts&external





var ServiceItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceItemView, _super);
    function ServiceItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ServiceItem: ServiceItem/* default */.A,
                Spinner: interface_vue_.Spinner
            }
        })
    ], ServiceItemView);
    return ServiceItemView;
}((0,lib/* Mixins */.Xe)(LoadServiceMixin/* default */.A)));
/* harmony default export */ var ServiceItemViewvue_type_script_lang_ts_external = (ServiceItemView);

;// ./src/views/ServiceItemView/ServiceItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ServiceItemView_ServiceItemViewvue_type_script_lang_ts_external = (ServiceItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ServiceItemView/ServiceItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ServiceItemView_ServiceItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ServiceItemView_ServiceItemView = (component.exports);

/***/ }),

/***/ 4696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 4739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'pencil';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f040';
var svgPathData = 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AD: function() { return /* binding */ fetchManualMovement; },
/* harmony export */   HW: function() { return /* binding */ manualMovementRelations; },
/* harmony export */   Y1: function() { return /* binding */ needFetchManualMovement; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var manualMovementRelations = ['lots', 'used_lots', 'contents', 'stock_location', 'from_stock_location'];
var needFetchManualMovement = function (movement) {
    return !manualMovementRelations.every(function (relation) { return relation in movement; });
};
var fetchManualMovement = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCatalog.axios.get('/catalog/stock/manual/' + id, {
                    params: {
                        include: manualMovementRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fetchDatas_command__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6589);
/* harmony import */ var _components_CommandItem_CommandItem_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(649);






var cleanCloneCommand = function (command) {
    delete command.id;
    delete command.reference;
    command.date = (0,_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.moment)().format('YYYY-MM-DD');
    command.contents.map(function (content) {
        delete content.id;
        content.lots = [];
        content.affair_contents = [];
    });
    return command;
};
var LoadCommandMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__extends */ .C6)(LoadCommandMixin, _super);
    function LoadCommandMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.command = null;
        return _this;
    }
    LoadCommandMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapState)('app', ['pageParams'])),
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.Spinner,
                CommandItem: _components_CommandItem_CommandItem_vue__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
            },
            beforeRouteEnter: function (to, from, next) {
                var _a;
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var pageParams, id;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                pageParams = vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD.prototype.$kwCatalog.store.state.app.pageParams;
                                if (pageParams && !(0,_fetchDatas_command__WEBPACK_IMPORTED_MODULE_3__/* .needFetchCommand */ .MZ)(pageParams)) {
                                    next(function (vm) {
                                        var command = JSON.parse(JSON.stringify(vm.pageParams));
                                        if (!to.params.id) {
                                            command = cleanCloneCommand(command);
                                        }
                                        vm.command = command;
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                id = (_a = to.params.id) !== null && _a !== void 0 ? _a : pageParams === null || pageParams === void 0 ? void 0 : pageParams.id;
                                if (!id) {
                                    next(function (vm) {
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,_fetchDatas_command__WEBPACK_IMPORTED_MODULE_3__/* .fetchCommand */ .GW)(id)
                                        .then(function (command) {
                                        next(function (vm) {
                                            if (!to.params.id) {
                                                command = cleanCloneCommand(command);
                                            }
                                            vm.command = command;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
                    var command;
                    var _this = this;
                    return (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__generator */ .YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    command = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,_fetchDatas_command__WEBPACK_IMPORTED_MODULE_3__/* .needFetchCommand */ .MZ)(command)) {
                                        this.command = command;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                if (!to.params.id) {
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                this.loading = true;
                                this.command = null;
                                return [4 /*yield*/, (0,_fetchDatas_command__WEBPACK_IMPORTED_MODULE_3__/* .fetchCommand */ .GW)(to.params.id)
                                        .then(function (command) {
                                        _this.command = command;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], LoadCommandMixin);
    return LoadCommandMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (LoadCommandMixin);


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 4958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ServiceList_ServiceList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ServiceList/ServiceList.vue?vue&type=template&id=5dfbc3df
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.serviceItem)?_c('k-table',{ref:"table",attrs:{"url":"/catalog/service","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.computedRowActions,"rowLink":_vm.inlineMode !== false ? null : _vm.rowLink,"rowClick":_vm.rowClick,"bordered":"","size":"sm","stateKey":_vm.stateKey,"colActionsWidth":_vm.actionsColumWidth,"exportable":"service","importable":"service","withTotals":false}}):_vm._e(),(_vm.serviceItem)?_c('ServiceItem',{model:{value:(_vm.serviceItem),callback:function ($$v) {_vm.serviceItem=$$v},expression:"serviceItem"}}):_vm._e(),_c('ServiceDelete',{on:{"hidden":function($event){_vm.serviceToDelete = null}},model:{value:(_vm.serviceToDelete),callback:function ($$v) {_vm.serviceToDelete=$$v},expression:"serviceToDelete"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/components/ServiceDelete/ServiceDelete.vue + 3 modules
var ServiceDelete = __webpack_require__(9478);
// EXTERNAL MODULE: ./src/components/ServiceItem/ServiceItem.vue + 3 modules
var ServiceItem = __webpack_require__(4204);
// EXTERNAL MODULE: ./src/mixins/CatalogListMixin.ts
var CatalogListMixin = __webpack_require__(3859);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ServiceList/ServiceList.ts?vue&type=script&lang=ts&external








var ServiceList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceList, _super);
    function ServiceList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serviceItem = null;
        _this.serviceToDelete = null;
        return _this;
    }
    Object.defineProperty(ServiceList.prototype, "include", {
        get: function () {
            return ['sale_category', 'vat_rate', 'unit', 'customFields'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('catalog-services', 3)) {
                actions.push({
                    icon: 'edit',
                    click: function (service) {
                        _this.openModal({
                            key: 'catalog-service-form',
                            attributes: {
                                id: service.id
                            },
                            value: service
                        });
                    }
                });
            }
            if (this.can('catalog-services', 3)) {
                actions.push({
                    icon: 'delete',
                    click: function (service) {
                        _this.serviceToDelete = service;
                    }
                });
            }
            if (this.can('catalog-services', 2)) {
                actions.push({
                    icon: ['fas', 'clone'],
                    title: this.$t('catalog.service.clone'),
                    click: function (service) {
                        var clone = JSON.parse(JSON.stringify(service));
                        delete clone.id;
                        _this.openModal({
                            key: 'catalog-service-form',
                            value: clone
                        });
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceList.prototype, "columns", {
        get: function () {
            return (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'reference',
                    name: this.$t('catalog.list.reference')
                },
                {
                    data: 'name',
                    name: this.$t('catalog.list.name')
                },
                {
                    data: 'unit_price_ht',
                    name: this.$t('catalog.list.unitPriceHt'),
                    render: 'currency'
                },
                {
                    data: 'unit_price_tva',
                    name: this.$t('catalog.list.unitPriceTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'unit_price_ttc',
                    name: this.$t('catalog.list.unitPriceTtc'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'default_quantity',
                    name: this.$t('catalog.list.defaultQuantity'),
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: this.$t('catalog.list.totalHt'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_tva',
                    name: this.$t('catalog.list.totalTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: this.$t('catalog.list.totalTtc'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'various_costs',
                    name: this.$t('catalog.list.variousCosts'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_costs',
                    name: this.$t('catalog.list.totalCosts'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'gross_margin_amount',
                    name: this.$t('catalog.list.grossMarginAmount'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'gross_margin_rate',
                    name: this.$t('catalog.list.grossMarginRate'),
                    render: 'pourcent',
                    visible: false
                },
                {
                    data: 'markup_rate',
                    name: this.$t('catalog.list.markupRate'),
                    render: 'pourcent',
                    visible: false
                },
                {
                    data: 'sale_category.label',
                    name: this.$t('catalog.list.saleCategory'),
                    visible: false
                },
                {
                    data: 'vat_rate.rate',
                    name: this.$t('catalog.list.vatRate'),
                    render: 'pourcent'
                },
                {
                    data: 'unit.label',
                    name: this.$t('catalog.list.unit'),
                    visible: false
                },
                {
                    data: 'hourly_person_cost',
                    name: this.$t('catalog.list.hourlyPersonCost'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'products_costs',
                    name: this.$t('catalog.list.productsCosts'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'workforce_costs',
                    name: this.$t('catalog.list.workforceCosts'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'duration_mn',
                    name: this.$t('catalog.list.durationMn'),
                    render: 'integer',
                    visible: false,
                    sortable: false
                },
                {
                    data: 'duration_hour',
                    name: this.$t('catalog.list.durationHour'),
                    render: 'amount',
                    visible: false,
                    sortable: false
                },
                {
                    data: 'number_people_needed',
                    name: this.$t('catalog.list.numberPeopleNeeded'),
                    render: 'integer',
                    visible: false
                },
                {
                    data: 'status.name',
                    name: this.$t('interface.activeStatus.label'),
                    visible: false
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                }
            ], this.customFieldTableColumns('service'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceList.prototype, "filters", {
        get: function () {
            return (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'text',
                    label: this.$t('catalog.filters.reference'),
                    name: 'reference'
                },
                {
                    type: 'text',
                    label: this.$t('catalog.filters.name'),
                    name: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.saleCategory'),
                    name: 'sale_category',
                    multiple: true,
                    ajax: '/catalog/sale_category?sort=label',
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.status'),
                    name: 'status',
                    options: [
                        { value: true, label: this.$t('interface.activeStatus.on') },
                        { value: false, label: this.$t('interface.activeStatus.off') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                }
            ], this.customFieldTableFilters('service'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: this.computedInclude.join(',')
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceList.prototype, "rowClick", {
        get: function () {
            var _this = this;
            if (this.addAction) {
                return this.addAction;
            }
            else if (this.inlineMode !== false) {
                return null;
            }
            else {
                return function (service) { return _this.serviceItem = service; };
            }
        },
        enumerable: false,
        configurable: true
    });
    ServiceList.prototype.rowLink = function (service) {
        return {
            name: 'catalog-service-item',
            params: {
                id: String(service.id)
            }
        };
    };
    ServiceList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                interface_vue_.emitter.on('serviceCreated', this.serviceCreated);
                interface_vue_.emitter.on('serviceUpdated', this.serviceUpdated);
                interface_vue_.emitter.on('serviceDeleted', this.serviceDeleted);
                return [2 /*return*/];
            });
        });
    };
    ServiceList.prototype.destroyed = function () {
        interface_vue_.emitter.off('serviceCreated', this.serviceCreated);
        interface_vue_.emitter.off('serviceUpdated', this.serviceUpdated);
        interface_vue_.emitter.off('serviceDeleted', this.serviceDeleted);
    };
    ServiceList.prototype.serviceCreated = function (service) {
        var table = this.$refs.table;
        table.addRow(service);
    };
    ServiceList.prototype.serviceUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    ServiceList.prototype.serviceDeleted = function (service) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === service.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'catalog-services' })
    ], ServiceList.prototype, "stateKey", void 0);
    ServiceList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                ServiceItem: ServiceItem/* default */.A,
                ServiceDelete: ServiceDelete/* default */.A,
                KTable: table_vue_.KTable
            }
        })
    ], ServiceList);
    return ServiceList;
}((0,lib/* Mixins */.Xe)(CatalogListMixin/* default */.A)));
/* harmony default export */ var ServiceListvue_type_script_lang_ts_external = (ServiceList);

;// ./src/components/ServiceList/ServiceList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ServiceList_ServiceListvue_type_script_lang_ts_external = (ServiceListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ServiceList/ServiceList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ServiceList_ServiceListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ServiceList_ServiceList = (component.exports);

/***/ }),

/***/ 4974:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 5083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(7296),
    isObject = __webpack_require__(3805),
    toSource = __webpack_require__(7473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 5149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'spinner-third';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f3f4';
var svgPathData = ['M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z', 'M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.sq = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    assignMergeValue = __webpack_require__(7805),
    baseFor = __webpack_require__(6649),
    baseMergeDeep = __webpack_require__(2824),
    isObject = __webpack_require__(3805),
    keysIn = __webpack_require__(7241),
    safeGet = __webpack_require__(4974);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 5288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 5321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CommandItemView_CommandItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommandItemView/CommandItemView.vue?vue&type=template&id=0e161c66
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('CommandItem',{on:{"reloadCommand":_vm.reloadCommand},model:{value:(_vm.command),callback:function ($$v) {_vm.command=$$v},expression:"command"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommandItem/CommandItem.vue + 9 modules
var CommandItem = __webpack_require__(649);
// EXTERNAL MODULE: ./src/mixins/LoadCommandMixin.ts
var LoadCommandMixin = __webpack_require__(4873);
// EXTERNAL MODULE: ./src/fetchDatas/command.ts
var command = __webpack_require__(6589);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/CommandItemView/CommandItemView.ts?vue&type=script&lang=ts&external





var CommandItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandItemView, _super);
    function CommandItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommandItemView.prototype.reloadCommand = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var id;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = (_a = this.command) === null || _a === void 0 ? void 0 : _a.id;
                        return [4 /*yield*/, (0,command/* fetchCommand */.GW)(id)
                                .then(function (command) {
                                _this.command = command;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommandItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommandItem: CommandItem/* default */.A
            }
        })
    ], CommandItemView);
    return CommandItemView;
}((0,lib/* Mixins */.Xe)(LoadCommandMixin/* default */.A)));
/* harmony default export */ var CommandItemViewvue_type_script_lang_ts_external = (CommandItemView);

;// ./src/views/CommandItemView/CommandItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandItemView_CommandItemViewvue_type_script_lang_ts_external = (CommandItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CommandItemView/CommandItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandItemView_CommandItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandItemView_CommandItemView = (component.exports);

/***/ }),

/***/ 5325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(6131);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 5344:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'truck-container';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f4dc';
var svgPathData = 'M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H464c-17.7 0-32 14.3-32 32v144H32c-17.7 0-32 14.3-32 32v27.8c0 40.8 28.7 78.1 69.1 83.5 30.7 4.1 58.3-9.5 74.9-31.7 18.4 24.7 50.4 38.7 85.3 29.7 25.2-6.5 46.1-26.2 54.4-50.8 4.9-14.8 5.4-29.2 2.8-42.4h163.2c-2.7 13.2-2.2 27.6 2.8 42.4 8.4 25.1 29.9 44.9 55.6 51.1 52.8 12.8 100-26.9 100-77.6 0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17.1-6.7-33.3-18.7-45.3zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm-48-176v-48h37.5c4.2 0 8.3 1.7 11.3 4.7l43.3 43.3H480zM32 304h336c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v208c0 17.7 14.3 32 32 32zM304 80h32v176h-32V80zm-80 0h32v176h-32V80zm-80 0h32v176h-32V80zm-80 0h32v176H64V80z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OF = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    createAssigner = __webpack_require__(999);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 5365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ManualMovementDelete_ManualMovementDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ManualMovementDelete/ManualMovementDelete.vue?vue&type=template&id=36151d82
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.title }),expression:"{ title: title }"}]},[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.manualMovement.deleteMsg')))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ManualMovementDelete/ManualMovementDelete.ts?vue&type=script&lang=ts&external




var ManualMovementDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ManualMovementDelete, _super);
    function ManualMovementDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ManualMovementDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    ManualMovementDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ManualMovementDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ManualMovementDelete.prototype.process = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete('/catalog/stock/manual/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualMovementDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    ManualMovementDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ManualMovementDelete.prototype.deleted = function () {
        this.$emit('deleted', this.value);
        this.closeModal();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ManualMovementDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ManualMovementDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ManualMovementDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ManualMovementDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ManualMovementDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ManualMovementDelete.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ManualMovementDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ManualMovementDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ManualMovementDelete.prototype, "watchModalState", null);
    ManualMovementDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ManualMovementDelete);
    return ManualMovementDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ManualMovementDeletevue_type_script_lang_ts_external = (ManualMovementDelete);

;// ./src/components/ManualMovementDelete/ManualMovementDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ManualMovementDelete_ManualMovementDeletevue_type_script_lang_ts_external = (ManualMovementDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ManualMovementDelete/ManualMovementDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ManualMovementDelete_ManualMovementDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ManualMovementDelete_ManualMovementDelete = (component.exports);

/***/ }),

/***/ 5389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3663),
    baseMatchesProperty = __webpack_require__(7978),
    identity = __webpack_require__(3488),
    isArray = __webpack_require__(6449),
    property = __webpack_require__(583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 5463:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 5481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(9344),
    getPrototype = __webpack_require__(8879),
    isPrototype = __webpack_require__(5527);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 5593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MovementList_MovementList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MovementList/MovementList.vue?vue&type=template&id=42752bfe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/catalog/stock/movement","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowClick":_vm.rowClick,"rowLink":_vm.rowLink,"stateKey":_vm.stateKey,"dataKey":() => Math.floor(Math.random() * 100)}}),(_vm.manualMovementItem !== null)?_c('ManualMovementItem',{attrs:{"modalState":_vm.manualMovementItem !== null},on:{"hidden":function($event){_vm.manualMovementItem = null},"toEdit":function($event){return _vm.editManualMovement(_vm.manualMovementItem)}},model:{value:(_vm.manualMovementItem),callback:function ($$v) {_vm.manualMovementItem=$$v},expression:"manualMovementItem"}}):_vm._e(),(_vm.lotItem !== null)?_c('LotItem',{attrs:{"modalState":_vm.lotItem !== null},on:{"hidden":function($event){_vm.lotItem = null}},model:{value:(_vm.lotItem),callback:function ($$v) {_vm.lotItem=$$v},expression:"lotItem"}}):_vm._e()]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/ManualMovementItem/ManualMovementItem.vue + 3 modules
var ManualMovementItem = __webpack_require__(2685);
// EXTERNAL MODULE: ./src/components/LotItem/LotItem.vue + 3 modules
var LotItem = __webpack_require__(1798);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MovementList/MovementList.ts?vue&type=script&lang=ts&external







var MovementList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MovementList, _super);
    function MovementList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.manualMovementItem = null;
        _this.lotItem = null;
        return _this;
    }
    MovementList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasModule('stock-locations')) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2:
                        interface_vue_.emitter.on('productCreated', this.productCreated);
                        interface_vue_.emitter.on('productUpdated', this.productUpdated);
                        return [2 /*return*/];
                }
            });
        });
    };
    MovementList.prototype.destroyed = function () {
        interface_vue_.emitter.off('productCreated', this.productCreated);
        interface_vue_.emitter.off('productUpdated', this.productUpdated);
    };
    Object.defineProperty(MovementList.prototype, "stateKey", {
        get: function () {
            return this.productId ? 'stock-movements-product' : 'stock-movements';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MovementList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {};
            if (this.productId) {
                filter.product = this.productId;
            }
            return {
                filter: filter,
                include: 'element,product,variation,stock_location'
            };
        },
        enumerable: false,
        configurable: true
    });
    MovementList.prototype.rowClick = function (row) {
        if (!row.element) {
            return null;
        }
        switch (row.element_type) {
            case 'stockManualContent':
                this.manualMovementItem = row.element;
                break;
            case 'productLot':
                this.lotItem = row.element;
                break;
            default:
                return null;
        }
    };
    MovementList.prototype.rowLink = function (row) {
        if (['product', 'productLot'].includes(row.element_type) || !row.element) {
            return null;
        }
        switch (row.element_type) {
            case 'providerCommandContent':
                return { name: 'stock-command-item', params: { id: String(row.element.id) } };
            case 'quotationContent':
                return { name: 'quotation-item', params: { id: String(row.element.id) } };
            case 'commandContent':
                return { name: 'command-item', params: { id: String(row.element.id) } };
            case 'deliveryContent':
                return { name: 'delivery-item', params: { id: String(row.element.id) } };
            case 'invoiceContent':
                return { name: 'invoice-item', params: { id: String(row.element.id) } };
            case 'creditContent':
                return { name: 'credit-item', params: { id: String(row.element.id) } };
            default:
                return null;
        }
    };
    Object.defineProperty(MovementList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: 'created_at',
                    name: 'Date / heure',
                    render: 'datetime'
                },
                {
                    data: 'product.reference',
                    name: 'Référence produit',
                    visible: this.productId === null
                },
                {
                    data: 'product.name',
                    name: 'Nom produit',
                    visible: this.productId === null
                },
                {
                    data: 'variation.reference',
                    name: 'Référence variation',
                    visible: false
                },
                {
                    data: 'quantity',
                    name: 'Quantité',
                    render: function (val) { return _this.showNumber(val); }
                },
                {
                    data: 'element_type',
                    name: 'Origine du mouvement',
                    sortable: false,
                    isHtml: true,
                    render: function (element_type, movement) {
                        var _a;
                        var element = movement.element;
                        switch (element_type) {
                            case 'stockManualContent':
                                if (!element) {
                                    return '<i>' + _this.$t('catalog.stock.types.stockManualContentDelete') + '</i>';
                                }
                                else if ('type' in element && element.type === 1) {
                                    return _this.$t('catalog.stock.types.stockManualContentEntry', { reference: element.reference });
                                }
                                else {
                                    return _this.$t('catalog.stock.types.stockManualContentOuput', { reference: element.reference });
                                }
                            case 'providerCommandContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.providerCommand', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.providerCommandDelete') + '</i>';
                            case 'product':
                            case 'productStock':
                                return _this.$t('catalog.stock.types.' + (((_a = movement.product) === null || _a === void 0 ? void 0 : _a.is_group) ? 'group' : 'product'));
                            case 'productVariation':
                                return _this.$t('catalog.stock.types.productVariation');
                            case 'productLot':
                                return _this.$t('catalog.stock.types.productLot');
                            case 'quotationContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.quotation', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.quotationDelete') + '</i>';
                            case 'commandContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.command', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.commandDelete') + '</i>';
                            case 'proformaContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.proforma', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.proformaDelete') + '</i>';
                            case 'deliveryContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.delivery', { reference: element.reference });
                                }
                                return '<i>Bon de livraison supprimé</i>';
                            case 'invoiceContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.invoice', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.invoiceDelete') + '</i>';
                            case 'creditContent':
                                if (element && 'reference' in element) {
                                    return _this.$t('catalog.stock.types.credit', { reference: element.reference });
                                }
                                return '<i>' + _this.$t('catalog.stock.types.creditDelete') + '</i>';
                            default:
                                return null;
                        }
                    }
                }
            ];
            if (this.hasModule('stock-locations')) {
                columns.push({
                    data: 'stock_location.name',
                    name: 'Lieu de stock'
                });
            }
            columns.push({
                data: 'element_type',
                name: 'Commentaires',
                isHtml: true,
                sortable: false,
                visible: false,
                render: function (element_type, movement) {
                    var element = movement.element;
                    if (element && 'title' in element) {
                        return element.title;
                    }
                    else if (element && 'comments' in element) {
                        return element.comments;
                    }
                    else {
                        return null;
                    }
                }
            });
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MovementList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'select',
                    name: 'theoretical',
                    label: 'Type de mouvement',
                    defaultValue: { label: 'Réel', value: false },
                    options: [
                        { label: 'Réel', value: false },
                        { label: 'Théorique', value: true }
                    ],
                    optionLabel: 'label',
                    value: 'value',
                    params: {
                        clearable: false
                    }
                },
                {
                    type: 'period',
                    label: 'Date du mouvement',
                    name: 'created_since',
                    name2: 'created_until'
                },
                {
                    type: 'select',
                    label: 'Produit',
                    name: 'product',
                    multiple: true,
                    ajax: '/catalog/product',
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: 'Type de mouvement',
                    name: 'type',
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id',
                    options: [
                        { id: 'creditContent', label: 'Avoir' },
                        { id: 'commandContent', label: 'Bon de commande' },
                        { id: 'deliveryContent', label: 'Bon de livraison' },
                        { id: 'providerCommandContent', label: 'Commande fournisseur' },
                        { id: 'quotationContent', label: 'Devis' },
                        { id: 'invoiceContent', label: 'Facture' },
                        { id: 'productLot', label: 'Lot' },
                        { id: 'stockManualContent', label: 'Mouvement de stock manuel' },
                        { id: 'product', label: 'Produit' },
                        { id: 'productVariation', label: 'Variation de produit' },
                    ]
                }
            ];
            if (this.hasModule('stock-locations')) {
                filters.push({
                    type: 'select',
                    name: 'stock_location',
                    label: 'Lieu de stock',
                    options: this.stockLocations,
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    MovementList.prototype.refresh = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    MovementList.prototype.productCreated = function (product) {
        if (product.with_stock) {
            this.refresh();
        }
    };
    MovementList.prototype.productUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            this.refresh();
        }
    };
    MovementList.prototype.editManualMovement = function (movement) {
        this.openModal({
            key: 'stock-manual-form',
            value: movement
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], MovementList.prototype, "productId", void 0);
    MovementList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            components: {
                KTable: table_vue_.KTable,
                ManualMovementItem: ManualMovementItem/* default */.A,
                LotItem: LotItem/* default */.A,
                Spinner: interface_vue_.Spinner
            }
        })
    ], MovementList);
    return MovementList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var MovementListvue_type_script_lang_ts_external = (MovementList);

;// ./src/components/MovementList/MovementList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MovementList_MovementListvue_type_script_lang_ts_external = (MovementListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MovementList/MovementList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MovementList_MovementListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MovementList_MovementList = (component.exports);

/***/ }),

/***/ 5663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductItem_ProductItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductItem/ProductItem.vue?vue&type=template&id=223eae34
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-item"},[_c('PageHeader',{staticClass:"border-0 mb-0",attrs:{"page-title":_vm.pageTitle,"buttons":_vm.headerButtons}}),_c('AppMessages'),(!_vm.value.status.active)?_c('p',{staticClass:"font-weight-bold text-danger"},[_vm._v(" "+_vm._s((this.value.is_group ? 'Groupe' : 'Produit'))+" désactivé ")]):(_vm.value.not_for_sale)?_c('p',{staticClass:"font-weight-bold text-danger"},[_vm._v(" Produit non destiné à la vente ")]):_vm._e(),(_vm.value.designation)?_c('b-card',{staticClass:"p-2 mb-4",attrs:{"no-body":""}},[_c('p',{staticClass:"font-weight-bold text-underline"},[_vm._v(" "+_vm._s(_vm.value.name)+" ")]),_c('FroalaView',{model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),(_vm.value.custom_fields.length > 0 && !_vm.team.configs.custom_field_product_tab)?_c('CustomFieldsDisplay',{attrs:{"type":"product","value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e()],1):_vm._e(),_c('tabs',{staticClass:"tabs-card mb-4"},[_c('tab',{attrs:{"title":'Informations ' + (this.value.is_group ? 'groupe' : 'produit')}},[_c('b-form-row',[_c('b-col',{staticClass:"py-3 px-4 border-right",attrs:{"cols":"12","md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Prix vente HT"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),(_vm.value.vat_rate)?_c('b-form-group',{attrs:{"label":'TVA ' + _vm.showNumber(_vm.value.vat_rate.rate) + ' %'}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_tva, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Prix vente TTC"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_price_ttc, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Qté par défaut"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.default_quantity))+" ")])],1),_c('b-col',[(_vm.value.unit)?_c('b-form-group',{attrs:{"label":"Unité"}},[_vm._v(" "+_vm._s(_vm.value.unit.label)+" ")]):_vm._e()],1)],1),(!_vm.value.is_group && _vm.value.providers?.length > 0)?_c('b-form-group',{attrs:{"label":"Fournisseurs"}},_vm._l((_vm.value.providers),function(provider,i){return _c('span',{key:provider.id},[_vm._v(_vm._s(i > 0 ? ', ': '')+_vm._s(provider.name))])}),0):_vm._e(),(_vm.value.eco_tax_ht > 0)?_c('b-form-group',{attrs:{"label":"Donc éco participation :"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"form-text",attrs:{"label":"HT","label-cols":"auto"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.eco_tax_ht, 2, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"form-text",attrs:{"label":"TTC","label-cols":"auto"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.eco_tax_ttc, 2, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])],1)],1)],1):_vm._e()],1),_c('b-col',{staticClass:"py-3 px-4",attrs:{"cols":"12","md":"6","lg":"3"}},[(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?[_c('b-form-group',{attrs:{"label":(this.value.is_group ? 'Coûts' : 'Prix d\'achat') + ' U. HT'}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_buy_price_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Coûts divers"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.various_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Coûts total"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.total_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('b-form-group',{attrs:{"label":"Marge par produit"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.gross_margin_amount ,2, 2))+" "+_vm._s(_vm.currency.symbol)+" / "+_vm._s(_vm.showNumber(_vm.value.gross_margin_rate))+" % ")]),_c('b-form-group',{attrs:{"label":"Taux de marque"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.markup_rate))+" % ")])]:_vm._e(),(_vm.value.cant_change_price)?_c('span',[_vm._v(" Prix de vente non modifiable lors l'édition des documents de vente ")]):_vm._e()],2),(_vm.value.sale_category || _vm.value.charge_category || _vm.value.ean_code || _vm.value.unit_weight || _vm.value.size_width || _vm.value.size_length || _vm.value.size_height)?_c('b-col',{staticClass:"py-3 px-4 gray-part",attrs:{"cols":"12","md":"6","lg":"3"}},[(_vm.value.sale_category)?_c('b-form-group',{attrs:{"label":"Catégorie de vente"}},[_vm._v(" "+_vm._s(_vm.value.sale_category.label)+" ")]):_vm._e(),(_vm.value.charge_category)?_c('b-form-group',{attrs:{"label":"Catégorie de charge"}},[_vm._v(" "+_vm._s(_vm.value.charge_category.label)+" ")]):_vm._e(),(_vm.value.ean_code)?_c('b-form-group',{attrs:{"label":"Code EAN"}},[_vm._v(" "+_vm._s(_vm.value.ean_code)+" ")]):_vm._e(),(_vm.value.unit_weight)?_c('b-form-group',{attrs:{"label":"Poids"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.unit_weight))+" kg ")]):_vm._e(),(_vm.value.size_length || _vm.value.size_width || _vm.value.size_height)?_c('b-form-group',{attrs:{"label":"Dimensions (L x l x h)"}},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.size_length))+" m x "+_vm._s(_vm.showNumber(_vm.value.size_width))+" m x "+_vm._s(_vm.showNumber(_vm.value.size_height))+" m ")]):_vm._e()],1):_vm._e(),(_vm.value.with_stock && _vm.hasModule('stock'))?_c('b-col',{staticClass:"py-3 px-4"},[_c('p',[_c('span',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Gestion de stock activée ")]),(_vm.tracabilityLabel && _vm.hasModule('stock-tracabilities'))?_c('span',[_c('br'),_vm._v(" "+_vm._s(_vm.tracabilityLabel)+" ")]):_vm._e()]),(_vm.value.with_stock && _vm.hasModule('stock-tracabilities') && _vm.value.stock_tracking_mode === 2)?_c('b-form-group',{attrs:{"label":"Durée de la garantie"}},[_vm._v(" "+_vm._s(_vm.value.warranty_duration)+" mois ")]):_vm._e(),(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?_c('b-form-group',{attrs:{"label":"Coût unitaire pondéré"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.average_buy_price))+" ")]):_vm._e(),(!_vm.hasVariations)?[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Stock réel"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.stock_quantity, 5))+" ")])])],1),(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?_c('b-col',[_c('b-form-group',{attrs:{"label":"Valeur HT"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_stock_ht))+" ")])],1):_vm._e()],1),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Stock théorique"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.value.stock_theoretical_quantity, 5))+" ")])])],1),(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?_c('b-col',[_c('b-form-group',{attrs:{"label":"Valeur HT"}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.total_stock_theoretical_ht))+" ")])],1):_vm._e()],1)]:_vm._e(),(_vm.value.stock_minimum)?_c('b-form-group',{attrs:{"label":"Alerte(s) de stock"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Mini")]),_c('th',[_vm._v("Maxi")]),_c('th',[_vm._v("Seuil alerte")])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.showNumber(_vm.value.stock_minimum)))]),_c('td',[_vm._v(_vm._s(_vm.showNumber(_vm.value.stock_maximum)))]),_c('td',[_vm._v(_vm._s(_vm.showNumber(_vm.value.stock_alert)))])])])]):_vm._e()],2):_vm._e()],1)],1),(_vm.value.is_group)?_c('tab',{attrs:{"title":"Contenu du groupe"}},[(_vm.value.group_stock_management)?_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Déduire automatiquement les produits du stock ")]):_vm._e(),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Type")]),_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom")]),(_vm.can('sales-margin', 1))?_c('th',{staticClass:"text-center"},[_vm._v("Coûts U.")]):_vm._e(),_c('th',{staticClass:"text-center"},[_vm._v("Quantité")]),(_vm.can('sales-margin', 1))?_c('th',{staticClass:"text-center"},[_vm._v("Coûts total")]):_vm._e()])]),_c('tbody',[(_vm.value.group_contents.length === 0)?_c('tr',[_c('td',{staticClass:"p-4 text-center",attrs:{"colspan":_vm.can('sales-margin', 1) ? 6 : 4}},[_vm._v(" Aucun produit ")])]):_vm._e(),_vm._l((_vm.value.group_contents),function(element,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.$t('catalog.' + element.catalog?.type + '.label')))]),_c('td',[_vm._v(_vm._s(element.catalog?.element?.reference))]),_c('td',[_vm._v(_vm._s(element.catalog?.element?.name))]),(_vm.can('sales-margin', 1))?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(element.catalog?.element?.total_costs)))]):_vm._e(),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(element.quantity)))]),(_vm.can('sales-margin', 1))?_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.roundNumber(_vm.number(element.catalog?.element?.total_costs) * _vm.number(element.quantity), 2))))]):_vm._e()])})],2)])]):_vm._e(),(!_vm.value.is_group && _vm.value.providers_references && _vm.value.providers_references.length > 0 && !_vm.hasVariations)?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Références fournisseurs "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.value.providers_references.length))])]},proxy:true}],null,false,540322209)},[_c('table',{staticClass:"table table-bordered table-sm mb-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Fournisseur")]),_c('th',[_vm._v("Référence")]),(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?[_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Coûts divers")]),_c('th',[_vm._v("Coûts total")])]:_vm._e()],2)]),_c('tbody',_vm._l((_vm.value.providers_references),function(reference,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(reference.customer?.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(reference.reference)+" ")]),(_vm.can('sales-margin', 1) || _vm.can('catalog-products', 3))?[_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(reference.buy_price_ht, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(reference.various_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.showNumber(reference.total_costs, 5, 2))+" "+_vm._s(_vm.currency.symbol)+" ")])]:_vm._e()],2)}),0)])]):_vm._e(),(!_vm.value.is_group && _vm.hasVariations)?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Variations "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.value.variations ? _vm.value.variations.length : 0))])]},proxy:true}],null,false,3067240582)},[_c('ProductVariations',{on:{"productUpdated":data => _vm.$emit('input', data),"reloadProduct":function($event){return _vm.$emit('reloadProduct')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e(),(!_vm.hasVariations && _vm.hasModule('catalog-custom-prices') && _vm.nbCustomPrices > 0)?_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Prix personnalisé "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.nbCustomPrices))])]},proxy:true}],null,false,3112299060)},[_c('custom-prices-view',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e(),(_vm.value.custom_fields.length > 0 && _vm.team.configs.custom_field_product_tab)?_c('CustomFieldsDisplayTab',{attrs:{"type":"product","value":_vm.value.custom_fields,"formUrl":'/catalog/product/' + _vm.value.id,"canUpdate":_vm.can('catalog-products', 3)},on:{"input":product => _vm.$emit('input', product)}}):_vm._e(),_c('tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Photos "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.totalPictures))])]},proxy:true}])},[_c('CatalogPictures',{attrs:{"id":_vm.value.id,"type":"product","default-picture":_vm.value.default_picture_id},on:{"total":total => _vm.totalPictures = total,"defaultPicture":_vm.updateDefaultPicture}})],1),_c('tab',{attrs:{"title":"Statistiques","lazy":""}},[_c('Statistics',{attrs:{"type":"product","id":_vm.value.id}})],1),(_vm.can('sales-quotation', 1))?_c('tab',{attrs:{"title":"Devis","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"quotation","type":"product","id":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-commands') && _vm.can('sales-command', 1))?_c('tab',{attrs:{"title":"Bons de commande","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"command","type":"product","id":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-deliveries') && _vm.can('sales-delivery', 1))?_c('tab',{attrs:{"title":"Bons de livraison","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"delivery","type":"product","id":_vm.value.id}})],1):_vm._e(),(_vm.can('sales-invoice', 1))?_c('tab',{attrs:{"title":"Factures","group":"Ventes","lazy":""}},[_c('ElementSalesList',{attrs:{"document-type":"invoice","type":"product","id":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('stock-locations') && _vm.can('see-stock', 1) && _vm.value.variations_length === 0)?_c('tab',{attrs:{"title":"Lieu de stock"}},[_c('StockByLocations',{attrs:{"product":_vm.value},on:{"input":data => _vm.$emit('input', data)}})],1):_vm._e(),(_vm.hasModule('stock') && _vm.can('see-stock', 1))?_c('tab',{attrs:{"title":"Mouvements de stock","lazy":""}},[_c('MovementList',{ref:"movements",attrs:{"productId":_vm.value.id}})],1):_vm._e(),(!_vm.value.is_group && _vm.value.stock_tracking_mode > 0 && _vm.hasModule('stock-tracabilities') && _vm.can('see-stock', 1))?_c('tab',{attrs:{"title":"Lots","lazy":""}},[_c('LotList',{attrs:{"productId":_vm.value.id}})],1):_vm._e()],1),_c('ProductDelete',{attrs:{"value":_vm.toDelete ? _vm.value : null},on:{"hidden":function($event){_vm.toDelete = false},"deleted":function($event){return _vm.$router.push({ name: 'catalog-products-list' })}}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/CustomPricesView/CustomPricesView.vue + 3 modules
var CustomPricesView = __webpack_require__(3613);
// EXTERNAL MODULE: ./src/components/ProductVariations/ProductVariations.vue + 3 modules
var ProductVariations = __webpack_require__(7007);
// EXTERNAL MODULE: ./src/components/CatalogPictures/CatalogPictures.vue + 3 modules
var CatalogPictures = __webpack_require__(3431);
// EXTERNAL MODULE: ./src/components/ProductDelete/ProductDelete.vue + 3 modules
var ProductDelete = __webpack_require__(160);
// EXTERNAL MODULE: ./src/components/MovementList/MovementList.vue + 3 modules
var MovementList = __webpack_require__(5593);
// EXTERNAL MODULE: ./src/components/ElementSalesList/ElementSalesList.vue + 3 modules
var ElementSalesList = __webpack_require__(7596);
// EXTERNAL MODULE: ./src/components/Statistics/Statistics.vue + 3 modules
var Statistics = __webpack_require__(7220);
// EXTERNAL MODULE: ./src/components/LotList/LotList.vue + 3 modules
var LotList = __webpack_require__(7666);
// EXTERNAL MODULE: ./src/components/StockByLocations/StockByLocations.vue + 3 modules
var StockByLocations = __webpack_require__(4254);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductItem/ProductItem.ts?vue&type=script&lang=ts&external
















var ProductItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductItem, _super);
    function ProductItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toDelete = false;
        _this.totalPictures = 0;
        return _this;
    }
    Object.defineProperty(ProductItem.prototype, "pageTitle", {
        get: function () {
            return this.$t('catalog.' + (this.value.is_group ? 'group' : 'product') + '.itemTitle') + ' - ' + this.value.reference;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItem.prototype, "nbCustomPrices", {
        get: function () {
            return (this.value.custom_type_prices ? this.value.custom_type_prices.length : 0) + (this.value.custom_quantity_prices ? this.value.custom_quantity_prices.length : 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItem.prototype, "hasVariations", {
        get: function () {
            return this.number(this.value.variations_length) > 0 && this.hasModule('catalog-variations');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItem.prototype, "tracabilityLabel", {
        get: function () {
            switch (this.value.stock_tracking_mode) {
                case 1:
                    return this.$t('catalog.form.traceabilities.lot');
                case 2:
                    return this.$t('catalog.form.traceabilities.serial');
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('catalog-products', 3)) {
                buttons.push({
                    label: 'Modifier',
                    click: function () {
                        _this.openModal({
                            key: 'catalog-' + (_this.value.is_group ? 'group' : 'product') + '-form',
                            value: _this.value,
                            submitted: function (response) { return _this.$emit('input', response.data); }
                        });
                    }
                });
            }
            if (this.can('catalog-products', 4)) {
                buttons.push({
                    label: 'Supprimer',
                    click: function () {
                        _this.toDelete = true;
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    ProductItem.prototype.watchValue = function () {
        var table = this.$refs.movements;
        if (table) {
            table.refresh();
        }
    };
    ProductItem.prototype.updateDefaultPicture = function (id) {
        var product = JSON.parse(JSON.stringify(this.value));
        product.default_picture_id = id;
        this.$emit('input', product);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { deep: true })
    ], ProductItem.prototype, "watchValue", null);
    ProductItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'can', 'team'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            components: {
                PageHeader: interface_vue_.PageHeader, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, AppMessages: interface_vue_.AppMessages,
                CustomPricesView: CustomPricesView/* default */.A,
                ProductVariations: ProductVariations/* default */.A,
                MovementList: MovementList/* default */.A,
                CatalogPictures: CatalogPictures/* default */.A,
                ProductDelete: ProductDelete/* default */.A,
                ElementSalesList: ElementSalesList/* default */.A,
                Statistics: Statistics/* default */.A,
                LotList: LotList/* default */.A,
                StockByLocations: StockByLocations/* default */.A,
                FroalaView: form_vue_.FroalaView,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                BCard: external_bootstrap_vue_.BCard, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BBadge: external_bootstrap_vue_.BBadge
            }
        })
    ], ProductItem);
    return ProductItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ProductItemvue_type_script_lang_ts_external = (ProductItem);

;// ./src/components/ProductItem/ProductItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductItem_ProductItemvue_type_script_lang_ts_external = (ProductItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductItem/ProductItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductItem_ProductItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductItem_ProductItem = (component.exports);

/***/ }),

/***/ 5719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F2: function() { return /* binding */ productRelations; },
/* harmony export */   U8: function() { return /* binding */ needFetchProduct; },
/* harmony export */   yj: function() { return /* binding */ fetchProduct; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var productRelations = [
    'sale_category', 'vat_rate', 'unit', 'charge_category', 'providers_references', 'custom_quantity_prices',
    'custom_type_prices', 'variation_levels', 'variations', 'custom_fields', 'group_contents', 'stockLocations'
];
var needFetchProduct = function (product) {
    return !productRelations.every(function (relation) { return relation in product; });
};
var fetchProduct = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCatalog.axios.get('/catalog/product/' + id, {
                    params: {
                        include: productRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 5749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arrayIncludes = __webpack_require__(5325),
    arrayIncludesWith = __webpack_require__(9905),
    cacheHas = __webpack_require__(9219),
    createSet = __webpack_require__(4517),
    setToArray = __webpack_require__(4247);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 5798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProviderReferenceList_ProviderReferenceList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProviderReferenceList/ProviderReferenceList.vue?vue&type=template&id=cc46aaf4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{ref:"table",attrs:{"url":"/catalog/providers-references","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"stateKey":"catalog-provider-references","exportable":"providerReference","importable":"providerReference","withTotals":false}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProviderReferenceList/ProviderReferenceList.ts?vue&type=script&lang=ts&external



var ProviderReferenceList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProviderReferenceList, _super);
    function ProviderReferenceList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.include = ['product', 'customer'];
        return _this;
    }
    Object.defineProperty(ProviderReferenceList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'product.reference',
                    name: this.$t('catalog.list.reference')
                },
                {
                    data: 'product.name',
                    name: this.$t('catalog.list.name')
                },
                {
                    data: 'product.ean_code',
                    name: this.$t('catalog.list.ean'),
                    visible: false
                },
                {
                    data: 'customer.company_name',
                    name: this.$t('catalog.list.providerName')
                },
                {
                    data: 'reference',
                    name: this.$t('catalog.list.providerReference')
                },
                {
                    data: 'buy_price_ht',
                    name: this.$t('catalog.list.unitBuyPriceHt'),
                    render: 'currency'
                },
                {
                    data: 'various_costs',
                    name: this.$t('catalog.list.variousCosts'),
                    render: 'currency'
                },
                {
                    data: 'total_costs',
                    name: this.$t('catalog.list.totalCosts'),
                    render: 'currency'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProviderReferenceList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'text',
                    label: this.$t('catalog.filters.reference'),
                    name: 'reference'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.product'),
                    name: 'products',
                    multiple: true,
                    ajax: '/catalog/product?sort=name',
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.provider'),
                    name: 'providers',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_provider]=1',
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'text',
                    label: this.$t('catalog.filters.ean'),
                    name: 'ean'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProviderReferenceList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: this.include.join(',')
            };
        },
        enumerable: false,
        configurable: true
    });
    ProviderReferenceList.prototype.rowLink = function (row) {
        return {
            name: 'catalog-product-item',
            params: {
                id: String(row.product.id)
            }
        };
    };
    ProviderReferenceList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            }
        })
    ], ProviderReferenceList);
    return ProviderReferenceList;
}(lib/* Vue */.lD));
/* harmony default export */ var ProviderReferenceListvue_type_script_lang_ts_external = (ProviderReferenceList);

;// ./src/components/ProviderReferenceList/ProviderReferenceList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProviderReferenceList_ProviderReferenceListvue_type_script_lang_ts_external = (ProviderReferenceListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProviderReferenceList/ProviderReferenceList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProviderReferenceList_ProviderReferenceListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProviderReferenceList_ProviderReferenceList = (component.exports);

/***/ }),

/***/ 5858:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/customers-vue");

/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(5580),
    Map = __webpack_require__(8223),
    Promise = __webpack_require__(2804),
    Set = __webpack_require__(6545),
    WeakMap = __webpack_require__(8303),
    baseGetTag = __webpack_require__(2552),
    toSource = __webpack_require__(7473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 5911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arraySome = __webpack_require__(4248),
    cacheHas = __webpack_require__(9219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 5999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomersSales_CustomersSales; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersSales/CustomersSales.vue?vue&type=template&id=79d3ebef
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{attrs:{"stateKey":"catalog-customers-sales","url":_vm.ajaxUrl,"columns":_vm.columns,"filters":_vm.filters,"lengthMenu":[10, 25, 50],"onlyTopFilters":"","searchable":false,"dataKey":"customer_id"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersSales/CustomersSales.ts?vue&type=script&lang=ts&external




var CustomersSales = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersSales, _super);
    function CustomersSales() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomersSales.prototype, "ajaxUrl", {
        get: function () {
            return '/catalog/' + this.type + '/' + this.id + '/customers';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersSales.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'customer',
                    name: this.$t('catalog.statistics.tables.customer')
                },
                {
                    data: 'quantity',
                    name: this.$t('catalog.statistics.tables.quantity'),
                    render: 'amount'
                },
                {
                    data: 'total_ht',
                    name: this.$t('catalog.statistics.tables.totalHt'),
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: this.$t('catalog.statistics.tables.totalTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: this.$t('catalog.statistics.tables.totalTtc'),
                    render: 'currency',
                    visible: false
                }
            ];
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_catalog_costs',
                        name: this.$t('catalog.statistics.tables.buyPrice'),
                        render: 'currency',
                        visible: this.type === 'product'
                    },
                    {
                        data: 'total_various_costs',
                        name: this.$t('catalog.statistics.tables.variousCosts'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs',
                        name: this.$t('catalog.statistics.tables.totalCosts'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            if (this.type === 'service') {
                columns.push.apply(columns, [
                    {
                        data: 'total_duration_hour',
                        name: this.$t('catalog.statistics.tables.duration'),
                        render: 'amount'
                    },
                    {
                        data: 'total_workforce',
                        name: this.$t('catalog.statistics.tables.workforce'),
                        render: 'amount'
                    },
                    {
                        data: 'total_charge',
                        name: this.$t('catalog.statistics.tables.charge'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            if (this.can('sales-margin', 1)) {
                columns.push({
                    data: 'gross_margin_amount',
                    name: this.$t('catalog.statistics.tables.grossMargin'),
                    render: 'currency'
                });
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersSales.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: this.$t('catalog.statistics.tables.period'),
                    name: 'since',
                    name2: 'until'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomersSales.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomersSales.prototype, "id", void 0);
    CustomersSales = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CustomersSales);
    return CustomersSales;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomersSalesvue_type_script_lang_ts_external = (CustomersSales);

;// ./src/components/CustomersSales/CustomersSales.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersSales_CustomersSalesvue_type_script_lang_ts_external = (CustomersSalesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomersSales/CustomersSales.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersSales_CustomersSalesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersSales_CustomersSales = (component.exports);

/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 6110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(5083),
    getValue = __webpack_require__(392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 6131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2523),
    baseIsNaN = __webpack_require__(5463),
    strictIndexOf = __webpack_require__(6959);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 6225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockLocationSelect_StockLocationSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockLocationSelect/StockLocationSelect.vue?vue&type=template&id=70c11ffa
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.stockLocations,"label":"name"}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockLocationSelect/StockLocationSelect.ts?vue&type=script&lang=ts&external




var StockLocationSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockLocationSelect, _super);
    function StockLocationSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StockLocationSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.defaultLocation) {
                            this.$emit('input', this.defaultLocation);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StockLocationSelect.prototype, "defaultLocation", {
        get: function () {
            return this.stockLocations.find(function (location) { return location.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockLocationSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], StockLocationSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], StockLocationSelect.prototype, "value", void 0);
    StockLocationSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], StockLocationSelect);
    return StockLocationSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var StockLocationSelectvue_type_script_lang_ts_external = (StockLocationSelect);

;// ./src/components/StockLocationSelect/StockLocationSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockLocationSelect_StockLocationSelectvue_type_script_lang_ts_external = (StockLocationSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockLocationSelect/StockLocationSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockLocationSelect_StockLocationSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockLocationSelect_StockLocationSelect = (component.exports);

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 6547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 6589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GW: function() { return /* binding */ fetchCommand; },
/* harmony export */   MZ: function() { return /* binding */ needFetchCommand; },
/* harmony export */   l1: function() { return /* binding */ commandRelations; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var commandRelations = [
    'provider', 'contact', 'country', 'pdf_model', 'currency', 'vatrates', 'contents', 'charges', 'linked_sales',
    'custom_fields', 'payment_term', 'stock_location'
];
var needFetchCommand = function (command) {
    return !commandRelations.every(function (relation) { return relation in command; });
};
var fetchCommand = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCatalog.axios.get('/catalog/command/' + id, {
                    params: {
                        include: commandRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 6614:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'download';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f019';
var svgPathData = 'M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.cb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 6729:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clone';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f24d';
var svgPathData = 'M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$3 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(1033);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 6777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ManualMovementList_ManualMovementList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ManualMovementList/ManualMovementList.vue?vue&type=template&id=46c1d8e5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/catalog/stock/manual","ajaxDatas":{ include: ['stock_location'] },"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowClick":_vm.rowClick,"stateKey":"stock-manual-movements","onlyTopFilters":""}}),(_vm.showMovement)?_c('ManualMovementItem',{attrs:{"modalState":_vm.showMovement !== null},on:{"hidden":function($event){_vm.showMovement = null},"toEdit":function($event){return _vm.toEdit(_vm.showMovement)},"toDelete":function($event){return _vm.toDelete(_vm.showMovement)},"deleted":_vm.deleted,"input":movement => _vm.movementUpdated({ old: movement, new: movement})},model:{value:(_vm.showMovement),callback:function ($$v) {_vm.showMovement=$$v},expression:"showMovement"}}):_vm._e(),_c('ManualMovementDelete',{attrs:{"modal":_vm.deleteMovement !== null,"element":"modal"},on:{"closed":function($event){_vm.deleteMovement = null},"deleted":_vm.deleted},model:{value:(_vm.deleteMovement),callback:function ($$v) {_vm.deleteMovement=$$v},expression:"deleteMovement"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/ManualMovementDelete/ManualMovementDelete.vue + 3 modules
var ManualMovementDelete = __webpack_require__(5365);
// EXTERNAL MODULE: ./src/components/ManualMovementItem/ManualMovementItem.vue + 3 modules
var ManualMovementItem = __webpack_require__(2685);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ManualMovementList/ManualMovementList.ts?vue&type=script&lang=ts&external







var ManualMovementList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ManualMovementList, _super);
    function ManualMovementList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showMovement = null;
        _this.deleteMovement = null;
        return _this;
    }
    ManualMovementList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasModule('stock-locations')) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2:
                        interface_vue_.emitter.on('stockManuaMovementCreated', this.movementCreated);
                        interface_vue_.emitter.on('stockManuaMovementUpdated', this.movementUpdated);
                        interface_vue_.emitter.on('stockManuaMovementDeleted', this.movementDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualMovementList.prototype.destroyed = function () {
        interface_vue_.emitter.off('stockManuaMovementCreated', this.movementCreated);
        interface_vue_.emitter.off('stockManuaMovementUpdated', this.movementUpdated);
        interface_vue_.emitter.off('stockManuaMovementDeleted', this.movementDeleted);
    };
    Object.defineProperty(ManualMovementList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'reference',
                    name: 'Référence'
                },
                {
                    data: 'type_label',
                    name: 'Type'
                },
                {
                    data: 'date',
                    name: 'Date',
                    render: 'date'
                },
                {
                    data: 'comments',
                    name: 'Commentaires',
                    isHtml: true
                }
            ];
            if (this.hasModule('stock-locations')) {
                columns.push({
                    data: 'stock_location.name',
                    name: 'Lieu de stock'
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: 'Dernière mise à jour',
                    render: 'datetime',
                    visible: false
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'select',
                    name: 'type',
                    label: 'Type',
                    options: [
                        { value: 1, label: 'Entrée' },
                        { value: 2, label: 'Sortie' },
                        { value: 3, label: 'Transfert' }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'period',
                    label: 'Date',
                    name: 'date_since',
                    name2: 'date_until'
                }
            ];
            if (this.hasModule('stock-locations')) {
                filters.push({
                    type: 'select',
                    name: 'stock_location',
                    label: 'Lieu de stock',
                    options: this.stockLocations,
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementList.prototype, "rowActions", {
        get: function () {
            return [
                {
                    icon: 'edit',
                    click: this.toEdit
                },
                {
                    icon: 'delete',
                    click: this.toDelete
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ManualMovementList.prototype.rowClick = function (row) {
        this.showMovement = row;
    };
    ManualMovementList.prototype.toEdit = function (movement) {
        this.openModal({
            key: 'stock-manual-form',
            value: movement
        });
    };
    ManualMovementList.prototype.toDelete = function (movement) {
        this.deleteMovement = movement;
    };
    ManualMovementList.prototype.deleted = function (movement) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (val) { return val.id === movement.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
        this.deleteMovement = null;
    };
    ManualMovementList.prototype.movementCreated = function (movement) {
        var table = this.$refs.table;
        table.addRow(movement);
    };
    ManualMovementList.prototype.movementUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    ManualMovementList.prototype.movementDeleted = function (movement) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === movement.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    ManualMovementList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            components: {
                ManualMovementItem: ManualMovementItem/* default */.A,
                ManualMovementDelete: ManualMovementDelete/* default */.A,
                KTable: table_vue_.KTable,
                Spinner: interface_vue_.Spinner
            }
        })
    ], ManualMovementList);
    return ManualMovementList;
}(lib/* Vue */.lD));
/* harmony default export */ var ManualMovementListvue_type_script_lang_ts_external = (ManualMovementList);

;// ./src/components/ManualMovementList/ManualMovementList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ManualMovementList_ManualMovementListvue_type_script_lang_ts_external = (ManualMovementListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ManualMovementList/ManualMovementList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ManualMovementList_ManualMovementListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ManualMovementList_ManualMovementList = (component.exports);

/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288),
    isArrayLike = __webpack_require__(4894),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(3805);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 6834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_StockStateView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StockStateView.vue?vue&type=template&id=f7bfe840
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StockState')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/StockState/StockState.vue + 3 modules
var StockState = __webpack_require__(8980);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/StockStateView.vue?vue&type=script&lang=ts



var StockStateView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockStateView, _super);
    function StockStateView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StockStateView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                StockState: StockState/* default */.A
            }
        })
    ], StockStateView);
    return StockStateView;
}(lib/* Vue */.lD));
/* harmony default export */ var StockStateViewvue_type_script_lang_ts = (StockStateView);

;// ./src/views/StockStateView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_StockStateViewvue_type_script_lang_ts = (StockStateViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/StockStateView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_StockStateViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_StockStateView = (component.exports);

/***/ }),

/***/ 6959:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 7007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductVariations_ProductVariations; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductVariations/ProductVariations.vue?vue&type=template&id=06e184f7
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('div',[(_vm.can('catalog-products', 2))?_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.variation = {}}}},[_vm._v(" Ajouter une variation ")]):_vm._e(),_c('k-table',{ref:"table",attrs:{"url":'/catalog/product/' + _vm.value.id + '/variation',"ajaxDatas":{ include: ['level1', 'level2', 'level3', 'stockLocations']},"columns":_vm.columns,"rowActions":_vm.rowActions,"stateKey":"stock-product-variations","exportable":"productVariations","export-parent-id":_vm.value.id,"importable":"productVariations","isTotals":['quantity']},on:{"importCompleted":function($event){return _vm.$emit('reloadProduct')}}}),_c('ProductVariationForm',{attrs:{"modal":_vm.variation !== null,"product":_vm.value},on:{"submitComplete":_vm.submitComplete,"hidden":function($event){_vm.variation = null}},model:{value:(_vm.variation),callback:function ($$v) {_vm.variation=$$v},expression:"variation"}}),_c('b-modal',{attrs:{"title":"Confirmation de suppression","visible":_vm.deleteIndex !== null,"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.deleteLoading,"hide-header-close":_vm.deleteLoading,"no-close-on-esc":_vm.deleteLoading,"no-close-on-backdrop":_vm.deleteLoading},on:{"ok":_vm.deleteVariation,"hidden":_vm.resetDeleting}},[(_vm.deleteLoading)?_c('Spinner'):_c('span',[_vm._v(" Étes-vous sûr de vouloir supprimer cette variation ? ")])],1),_c('b-modal',{attrs:{"visible":_vm.showStock !== null,"ok-title":_vm.$t('interface.close'),"ok-only":"","size":"lg"},on:{"hidden":function($event){_vm.showStock = null}}},[_c('StockByLocations',{attrs:{"product":_vm.value,"variation":_vm.showStock},on:{"input":_vm.submitComplete}})],1)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/ProductVariationForm/ProductVariationForm.vue + 3 modules
var ProductVariationForm = __webpack_require__(1411);
// EXTERNAL MODULE: ./src/components/StockByLocations/StockByLocations.vue + 3 modules
var StockByLocations = __webpack_require__(4254);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductVariations/ProductVariations.ts?vue&type=script&lang=ts&external









var ProductVariations = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariations, _super);
    function ProductVariations() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.variation = null;
        _this.showStock = null;
        _this.toDelete = null;
        _this.deleteIndex = null;
        _this.deleteLoading = false;
        return _this;
    }
    Object.defineProperty(ProductVariations.prototype, "columns", {
        get: function () {
            var _a, _b, _c;
            var product = this.value;
            var columns = [
                {
                    data: 'level1.value',
                    name: (_a = product.variation_level1) === null || _a === void 0 ? void 0 : _a.label
                }
            ];
            if (product.variations_length > 1) {
                columns.push({
                    data: 'level2.value',
                    name: (_b = product.variation_level2) === null || _b === void 0 ? void 0 : _b.label
                });
            }
            if (product.variations_length > 2) {
                columns.push({
                    data: 'level3.value',
                    name: (_c = product.variation_level3) === null || _c === void 0 ? void 0 : _c.label
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'reference',
                    name: 'Référence'
                },
                {
                    data: 'ean_code',
                    name: 'Code EAN',
                    visible: false
                },
                {
                    data: 'provider_reference',
                    name: 'Référence fournisseur',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1) || this.can('catalog-products', 3)) {
                columns.push.apply(columns, [
                    {
                        data: 'buy_price',
                        name: 'Prix achat HT',
                        visible: false,
                        render: 'currency'
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'unit_price_ht',
                    name: 'Prix U. HT',
                    render: 'currency'
                },
                {
                    data: 'unit_price_tva',
                    name: 'Prix U. TVA',
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'unit_price_ttc',
                    name: 'Prix U. TTC',
                    visible: false,
                    render: 'currency'
                }
            ]);
            if (this.value.with_stock && this.hasModule('stock')) {
                columns.push.apply(columns, [
                    {
                        data: 'stock_quantity',
                        name: 'Quantité réelle en stock',
                        render: 'quantity'
                    },
                    {
                        data: 'stock_theoretical_quantity',
                        name: 'Quantité théorique en stock',
                        render: 'quantity',
                        visible: false
                    },
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'created_at',
                    name: 'Date de création',
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: 'Dernière modification',
                    visible: false,
                    render: 'datetime'
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariations.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('see-stock', 1) && this.hasModule('stock-locations')) {
                actions.push({
                    label: 'Stock',
                    variant: 'danger',
                    click: function (variation) {
                        _this.showStock = variation;
                    }
                });
            }
            if (this.can('catalog-products', 3)) {
                actions.push({
                    icon: 'edit',
                    click: function (variation) {
                        _this.variation = variation;
                    }
                });
            }
            if (this.can('catalog-products', 4)) {
                actions.push({
                    icon: 'delete',
                    click: function (variation, index) {
                        _this.toDelete = variation;
                        _this.deleteIndex = index;
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    ProductVariations.prototype.deleteVariation = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.deleteLoading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete('/catalog/product/' + this.value.id + '/variation/' + ((_a = this.toDelete) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                var table = _this.$refs.table;
                                var index = table.getDatas().findIndex(function (data) { var _a; return data.id === ((_a = _this.toDelete) === null || _a === void 0 ? void 0 : _a.id); });
                                if (index >= 0) {
                                    table.deleteRow(index);
                                }
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(this.resetDeleting)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductVariations.prototype.resetDeleting = function () {
        this.toDelete = null;
        this.deleteIndex = null;
        this.deleteLoading = false;
    };
    ProductVariations.prototype.submitComplete = function (variation) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === variation.id; });
        if (index >= 0) {
            table.updateRow(index, variation);
        }
        else {
            table.addRow(variation);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductVariations.prototype, "value", void 0);
    ProductVariations = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'can'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                FormModal: interface_vue_.FormModal,
                Spinner: interface_vue_.Spinner,
                KTable: table_vue_.KTable,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSpinner: form_vue_.KFormSpinner, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BFormRow: external_bootstrap_vue_.BFormRow, BInputGroup: external_bootstrap_vue_.BInputGroup, BModal: external_bootstrap_vue_.BModal,
                ProductVariationForm: ProductVariationForm/* default */.A,
                StockByLocations: StockByLocations/* default */.A
            }
        })
    ], ProductVariations);
    return ProductVariations;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ProductVariationsvue_type_script_lang_ts_external = (ProductVariations);

;// ./src/components/ProductVariations/ProductVariations.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductVariations_ProductVariationsvue_type_script_lang_ts_external = (ProductVariationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductVariations/ProductVariations.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductVariations_ProductVariationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductVariations_ProductVariations = (component.exports);

/***/ }),

/***/ 7068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    equalArrays = __webpack_require__(5911),
    equalByTag = __webpack_require__(1986),
    equalObjects = __webpack_require__(689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(7167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 7081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductVariationSelect_ProductVariationSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductVariationSelect/ProductVariationSelect.vue?vue&type=template&id=9d2151c8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-row',[_c('b-col',{staticClass:"variation-level-select"},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level1.label,"label-size":_vm.size}},[_c('k-form-select',{attrs:{"size":_vm.size,"ajax":_vm.variationLevel1Ajax,"label":"value","required":"","validationName":_vm.product.variations_length === 1 ? _vm.validationName : null},on:{"input":_vm.level1Change},model:{value:(_vm.variationLevel1),callback:function ($$v) {_vm.variationLevel1=$$v},expression:"variationLevel1"}})],1)],1),(_vm.product.variations_length >= 2)?_c('b-col',{staticClass:"variation-level-select"},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level2.label,"label-size":_vm.size}},[_c('k-form-select',{attrs:{"size":_vm.size,"disabled":_vm.variationLevel1 === null,"ajax":_vm.variationLevel2Ajax,"label":"value","required":"","validationName":_vm.product.variations_length === 2 ? _vm.validationName : null},on:{"input":_vm.level2Change},model:{value:(_vm.variationLevel2),callback:function ($$v) {_vm.variationLevel2=$$v},expression:"variationLevel2"}})],1)],1):_vm._e(),(_vm.product.variations_length >= 3)?_c('b-col',{staticClass:"variation-level-select"},[_c('b-form-group',{attrs:{"label":_vm.product.variation_level3.label,"label-size":_vm.size}},[_c('k-form-select',{attrs:{"size":_vm.size,"disabled":_vm.variationLevel2 === null,"ajax":_vm.variationLevel3Ajax,"label":"value","required":"","validationName":_vm.product.variations_length === 3 ? _vm.validationName : null},on:{"input":_vm.level3Change},model:{value:(_vm.variationLevel3),callback:function ($$v) {_vm.variationLevel3=$$v},expression:"variationLevel3"}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductVariationSelect/ProductVariationSelect.ts?vue&type=script&lang=ts&external




var ProductVariationSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariationSelect, _super);
    function ProductVariationSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.variationLevel1 = null;
        _this.variationLevel2 = null;
        _this.variationLevel3 = null;
        return _this;
    }
    Object.defineProperty(ProductVariationSelect.prototype, "variationLevel1Ajax", {
        // Return url to get values for level 1
        get: function () {
            return '/catalog/product/' + this.product.id + '/levels';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationSelect.prototype, "variationLevel2Ajax", {
        // Return url to get values for level 2
        get: function () {
            var _a;
            return '/catalog/product/' + this.product.id +
                '/levels?level1=' + ((_a = this.variationLevel1) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationSelect.prototype, "variationLevel3Ajax", {
        // Return url to get values for level 3
        get: function () {
            var _a, _b;
            return '/catalog/product/' + this.product.id +
                '/levels?level1=' + ((_a = this.variationLevel1) === null || _a === void 0 ? void 0 : _a.id) + '&level2=' + ((_b = this.variationLevel2) === null || _b === void 0 ? void 0 : _b.id);
        },
        enumerable: false,
        configurable: true
    });
    // Actions when level1 is changed
    ProductVariationSelect.prototype.level1Change = function () {
        this.variationLevel2 = null;
        this.variationLevel3 = null;
        this.selectVariation(this.product.variations_length === 1);
    };
    // Actions when level2 is changed
    ProductVariationSelect.prototype.level2Change = function () {
        this.variationLevel3 = null;
        this.selectVariation(this.product.variations_length === 2);
    };
    // Actions when level3 is changed
    ProductVariationSelect.prototype.level3Change = function () {
        this.selectVariation(true);
    };
    // Function call when a variation is selected
    ProductVariationSelect.prototype.selectVariation = function (select) {
        var _this = this;
        var _a, _b, _c;
        var variation = null;
        if (select) {
            var level = void 0;
            switch (this.product.variations_length) {
                case 1:
                    level = this.variationLevel1;
                    variation = (_a = level.variations) === null || _a === void 0 ? void 0 : _a.find(function (variation) {
                        var _a;
                        return variation.level1_id === ((_a = _this.variationLevel1) === null || _a === void 0 ? void 0 : _a.id);
                    });
                    break;
                case 2:
                    level = this.variationLevel2;
                    variation = (_b = level.variations) === null || _b === void 0 ? void 0 : _b.find(function (variation) {
                        var _a, _b;
                        return variation.level1_id === ((_a = _this.variationLevel1) === null || _a === void 0 ? void 0 : _a.id)
                            && variation.level2_id === ((_b = _this.variationLevel2) === null || _b === void 0 ? void 0 : _b.id);
                    });
                    break;
                case 3:
                    level = this.variationLevel3;
                    variation = (_c = level.variations) === null || _c === void 0 ? void 0 : _c.find(function (variation) {
                        var _a, _b, _c;
                        return variation.level1_id === ((_a = _this.variationLevel1) === null || _a === void 0 ? void 0 : _a.id)
                            && variation.level2_id === ((_b = _this.variationLevel2) === null || _b === void 0 ? void 0 : _b.id)
                            && variation.level3_id === ((_c = _this.variationLevel3) === null || _c === void 0 ? void 0 : _c.id);
                    });
                    break;
            }
        }
        this.$emit('input', variation);
        if (!variation) {
            return;
        }
        this.$emit('selected', variation);
    };
    // Watch the product variation to attribute local variation levels
    ProductVariationSelect.prototype.watchProduct = function (value) {
        if (!value) {
            return;
        }
        this.variationLevel1 = value.level1;
        this.variationLevel2 = value.level2;
        this.variationLevel3 = value.level3;
    };
    // Watch if level1 is changed
    ProductVariationSelect.prototype.watchLevel1 = function (variation) {
        if (!variation && this.product.variations_length === 1) {
            this.$emit('unselected');
        }
    };
    // Watch if level2 is changed
    ProductVariationSelect.prototype.watchLevel2 = function (variation) {
        if (!variation && this.product.variations_length === 2) {
            this.$emit('unselected');
        }
    };
    // Watch if level3 is changed
    ProductVariationSelect.prototype.watchLevel3 = function (variation) {
        if (!variation && this.product.variations_length === 3) {
            this.$emit('unselected');
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductVariationSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ProductVariationSelect.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'sm' })
    ], ProductVariationSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductVariationSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ProductVariationSelect.prototype, "watchProduct", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('variationLevel1')
    ], ProductVariationSelect.prototype, "watchLevel1", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('variationLevel2')
    ], ProductVariationSelect.prototype, "watchLevel2", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('variationLevel3')
    ], ProductVariationSelect.prototype, "watchLevel3", null);
    ProductVariationSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormSelect: form_vue_.KFormSelect,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], ProductVariationSelect);
    return ProductVariationSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductVariationSelectvue_type_script_lang_ts_external = (ProductVariationSelect);

;// ./src/components/ProductVariationSelect/ProductVariationSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductVariationSelect_ProductVariationSelectvue_type_script_lang_ts_external = (ProductVariationSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductVariationSelect/ProductVariationSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductVariationSelect_ProductVariationSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductVariationSelect_ProductVariationSelect = (component.exports);

/***/ }),

/***/ 7159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomersWithoutSales_CustomersWithoutSales; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersWithoutSales/CustomersWithoutSales.vue?vue&type=template&id=e39c3ca2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{attrs:{"stateKey":"catalog-customers-without-sales","url":_vm.ajaxUrl,"columns":_vm.columns,"filters":_vm.filters,"onlyTopFilters":"","searchable":false}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersWithoutSales/CustomersWithoutSales.ts?vue&type=script&lang=ts&external



var CustomersWithoutSales = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersWithoutSales, _super);
    function CustomersWithoutSales() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomersWithoutSales.prototype, "ajaxUrl", {
        get: function () {
            return '/catalog/' + this.type + '/' + this.id + '/customers-without-sales';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersWithoutSales.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'reference',
                    name: this.$t('catalog.statistics.tables.reference'),
                    width: 300,
                    render: function (references) {
                        var _a;
                        return (_a = references.customer) !== null && _a !== void 0 ? _a : references.prospect;
                    }
                },
                {
                    data: 'name',
                    sortableName: 'customer.name',
                    name: this.$t('catalog.statistics.tables.name')
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersWithoutSales.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: this.$t('catalog.statistics.tables.period'),
                    name: 'since',
                    name2: 'until'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomersWithoutSales.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomersWithoutSales.prototype, "id", void 0);
    CustomersWithoutSales = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            }
        })
    ], CustomersWithoutSales);
    return CustomersWithoutSales;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomersWithoutSalesvue_type_script_lang_ts_external = (CustomersWithoutSales);

;// ./src/components/CustomersWithoutSales/CustomersWithoutSales.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersWithoutSales_CustomersWithoutSalesvue_type_script_lang_ts_external = (CustomersWithoutSalesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomersWithoutSales/CustomersWithoutSales.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersWithoutSales_CustomersWithoutSalesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersWithoutSales_CustomersWithoutSales = (component.exports);

/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 7217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(1420),
    stackDelete = __webpack_require__(938),
    stackGet = __webpack_require__(3605),
    stackHas = __webpack_require__(9817),
    stackSet = __webpack_require__(945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 7220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Statistics_Statistics; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Statistics/Statistics.vue?vue&type=template&id=13580e0a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.statistics.since'),"label-size":"sm"}},[_c('k-form-datepicker',{attrs:{"size":"sm","maxDate":_vm.until},on:{"input":_vm.loadDatas},model:{value:(_vm.since),callback:function ($$v) {_vm.since=$$v},expression:"since"}})],1)],1),_c('b-col',{attrs:{"cols":"12","sm":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.statistics.until'),"label-size":"sm"}},[_c('k-form-datepicker',{attrs:{"size":"sm","minDate":_vm.since},on:{"input":_vm.loadDatas},model:{value:(_vm.until),callback:function ($$v) {_vm.until=$$v},expression:"until"}})],1)],1),_c('b-col',{staticStyle:{"min-width":"200px"},attrs:{"cols":"12","sm":"auto"}},[_c('CustomerSelect',{attrs:{"labelSize":"sm","size":"sm","withForm":false},on:{"input":_vm.loadDatas},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)],1),(_vm.loading || _vm.datas === null)?_c('Spinner'):[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.ca')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.total_ht)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.salesQuantities')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.total_quantity, false)))])]),(_vm.can('sales-margin', 1))?[_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.totalCosts')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.total_costs)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.totalGrossMargin')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.total_gross_margin)))])])]:_vm._e()],2)]),_c('b-col',{attrs:{"cols":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.averageUnitPrice')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.average_unit_price)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.averageQuantities')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.average_quantity, false)))])]),(_vm.can('sales-margin', 1))?[_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.averageCosts')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.average_costs)))])]),_c('tr',[_c('td',{staticClass:"font-weight-bold pr-3"},[_vm._v(_vm._s(_vm.$t('catalog.statistics.averageGrossMargin')))]),_c('td',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.datas.average_gross_margin)))])])]:_vm._e()],2)])],1)],_c('p',{staticClass:"font-weight-bold mb-1 mt-2"},[_vm._v(" "+_vm._s(_vm.$t('catalog.statistics.other'))+" ")]),_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.customerSalesModal = true}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.statistics.salesPerCustomers'))+" ")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.customerWithoutSalesModal = true}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.statistics.customersWithoutSales'))+" ")]),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"title":_vm.$t('catalog.statistics.salesPerCustomers'),"size":"xxl","lazy":""},model:{value:(_vm.customerSalesModal),callback:function ($$v) {_vm.customerSalesModal=$$v},expression:"customerSalesModal"}},[_c('CustomersSales',{attrs:{"type":_vm.type,"id":_vm.id}})],1),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"title":_vm.$t('catalog.statistics.customersWithoutSales'),"size":"xxl","lazy":""},model:{value:(_vm.customerWithoutSalesModal),callback:function ($$v) {_vm.customerWithoutSalesModal=$$v},expression:"customerWithoutSalesModal"}},[_c('CustomersWithoutSales',{attrs:{"type":_vm.type,"id":_vm.id}})],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/CustomersSales/CustomersSales.vue + 3 modules
var CustomersSales = __webpack_require__(5999);
// EXTERNAL MODULE: ./src/components/CustomersWithoutSales/CustomersWithoutSales.vue + 3 modules
var CustomersWithoutSales = __webpack_require__(7159);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Statistics/Statistics.ts?vue&type=script&lang=ts&external









var Statistics = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Statistics, _super);
    function Statistics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.customer = null;
        _this.since = null;
        _this.until = null;
        _this.datas = null;
        _this.customerSalesModal = false;
        _this.customerWithoutSalesModal = false;
        return _this;
    }
    Statistics.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Statistics.prototype.loadDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.get('/catalog/' + this.type + '/' + this.id + '/statistics', {
                                params: {
                                    since: this.since,
                                    until: this.until,
                                    customer: this.customer ? this.customer.id : null
                                }
                            })
                                .then(function (response) {
                                _this.datas = response.data;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Statistics.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Statistics.prototype, "id", void 0);
    Statistics = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomersSales: CustomersSales/* default */.A,
                CustomersWithoutSales: CustomersWithoutSales/* default */.A,
                KFormDatepicker: form_vue_.KFormDatepicker,
                CustomerSelect: customers_vue_.CustomerSelect,
                Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], Statistics);
    return Statistics;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var Statisticsvue_type_script_lang_ts_external = (Statistics);

;// ./src/components/Statistics/Statistics.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Statistics_Statisticsvue_type_script_lang_ts_external = (Statisticsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Statistics/Statistics.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Statistics_Statisticsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Statistics_Statistics = (component.exports);

/***/ }),

/***/ 7237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 7241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeysIn = __webpack_require__(2903),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 7255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 7269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ChargesCategoryListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ChargesCategoryListView.vue?vue&type=template&id=b7c9b336
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChargeCategoryList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ChargeCategoryList/ChargeCategoryList.vue + 3 modules
var ChargeCategoryList = __webpack_require__(9992);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ChargesCategoryListView.vue?vue&type=script&lang=ts



var ChargesCategoryListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ChargesCategoryListView, _super);
    function ChargesCategoryListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChargesCategoryListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ChargeCategoryList: ChargeCategoryList/* default */.A
            }
        })
    ], ChargesCategoryListView);
    return ChargesCategoryListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ChargesCategoryListViewvue_type_script_lang_ts = (ChargesCategoryListView);

;// ./src/views/ChargesCategoryListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ChargesCategoryListViewvue_type_script_lang_ts = (ChargesCategoryListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ChargesCategoryListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ChargesCategoryListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ChargesCategoryListView = (component.exports);

/***/ }),

/***/ 7284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockLocationForm_StockLocationForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockLocationForm/StockLocationForm.vue?vue&type=template&id=96a54eb4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.stockLocation.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Nom"}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.stockLocation.name),callback:function ($$v) {_vm.$set(_vm.stockLocation, "name", $$v)},expression:"stockLocation.name"}})],1),_c('b-form-group',[_c('input',{attrs:{"type":"hidden","name":"use_default"},domProps:{"value":_vm.stockLocation.use_default}}),_c('k-form-checkbox',{attrs:{"validationName":"use_default"},model:{value:(_vm.stockLocation.use_default),callback:function ($$v) {_vm.$set(_vm.stockLocation, "use_default", $$v)},expression:"stockLocation.use_default"}},[_vm._v(" Utiliser par défaut ")])],1),_c('b-form-group',{attrs:{"label":"Adresse"}},[_c('k-form-address',{attrs:{"valuesMap":{ road: 'road1', city: 'town', postalCode: 'postal_code' },"countries-list":_vm.countries},model:{value:(_vm.stockLocation),callback:function ($$v) {_vm.stockLocation=$$v},expression:"stockLocation"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockLocationForm/StockLocationForm.ts?vue&type=script&lang=ts&external






var StockLocationForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockLocationForm, _super);
    function StockLocationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.stockLocation = {
            use_default: false
        };
        return _this;
    }
    StockLocationForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StockLocationForm.prototype.watchValue = function (location) {
        this.stockLocation = location ? JSON.parse(JSON.stringify(location)) : {
            use_default: false,
            country: this.country
        };
    };
    Object.defineProperty(StockLocationForm.prototype, "formUrl", {
        get: function () {
            var url = '/catalog/stock/location';
            if (this.stockLocation.id) {
                url += '/' + this.stockLocation.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    StockLocationForm.prototype.formSubmitted = function (response) {
        return response;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], StockLocationForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], StockLocationForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], StockLocationForm.prototype, "formSubmitted", null);
    StockLocationForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['country'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner,
            }
        })
    ], StockLocationForm);
    return StockLocationForm;
}(lib/* Vue */.lD));
/* harmony default export */ var StockLocationFormvue_type_script_lang_ts_external = (StockLocationForm);

;// ./src/components/StockLocationForm/StockLocationForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockLocationForm_StockLocationFormvue_type_script_lang_ts_external = (StockLocationFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockLocationForm/StockLocationForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockLocationForm_StockLocationFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockLocationForm_StockLocationForm = (component.exports);

/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7334:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 7430:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrows-alt-v';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f338';
var svgPathData = 'M227.03 388.97H156V123.03h71.03c10.691 0 16.045-12.926 8.485-20.485l-99.029-99.03c-4.686-4.686-12.284-4.686-16.971 0l-99.029 99.03c-7.56 7.56-2.206 20.485 8.485 20.485H100v265.94H28.97c-10.691 0-16.045 12.926-8.485 20.485l99.029 99.03c4.686 4.686 12.284 4.686 16.971 0l99.029-99.03c7.56-7.559 2.206-20.485-8.484-20.485z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zh = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductList_ProductList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductList/ProductList.vue?vue&type=template&id=71ffb107
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.productItem)?_c('k-table',{ref:"table",attrs:{"url":"/catalog/product","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.computedRowActions,"rowLink":_vm.inlineMode !== false ? null : _vm.rowLink,"rowClick":_vm.rowClick,"stateKey":_vm.computedStateKey,"bordered":"","size":"sm","colActionsWidth":_vm.actionsColumWidth,"exportable":_vm.showGroup !== false ? 'productGroup' : 'product',"importable":!_vm.provider && !_vm.showGroup !== false ? 'product' : null,"withTotals":false,"saveMainSearch":_vm.disableMainSearchSave === false}}):_vm._e(),(_vm.productItem)?_c('ProductItem',{model:{value:(_vm.productItem),callback:function ($$v) {_vm.productItem=$$v},expression:"productItem"}}):_vm._e(),_c('ProductDelete',{on:{"hidden":function($event){_vm.productToDelete = null}},model:{value:(_vm.productToDelete),callback:function ($$v) {_vm.productToDelete=$$v},expression:"productToDelete"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: ./src/mixins/CatalogListMixin.ts
var CatalogListMixin = __webpack_require__(3859);
// EXTERNAL MODULE: ./src/components/ProductDelete/ProductDelete.vue + 3 modules
var ProductDelete = __webpack_require__(160);
// EXTERNAL MODULE: ./src/components/ProductItem/ProductItem.vue + 3 modules
var ProductItem = __webpack_require__(5663);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductList/ProductList.ts?vue&type=script&lang=ts&external








var ProductList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductList, _super);
    function ProductList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productItem = null;
        _this.productToDelete = null;
        return _this;
    }
    Object.defineProperty(ProductList.prototype, "include", {
        get: function () {
            var include = ['sale_category', 'vat_rate', 'unit', 'charge_category', 'customFields', 'providers_references'];
            if (this.showGroup !== false) {
                include.push('group_contents');
            }
            return include;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "computedStateKey", {
        get: function () {
            var key = this.stateKey;
            if (this.showGroup !== false) {
                key = key.replace('product', 'group');
            }
            return key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "rowClick", {
        get: function () {
            var _this = this;
            if (this.addAction) {
                return this.addAction;
            }
            else if (this.inlineMode !== false) {
                return null;
            }
            else {
                return function (product) { return _this.productItem = product; };
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('catalog-products', 3)) {
                actions.push({
                    icon: 'edit',
                    click: function (product) {
                        _this.openModal({
                            key: 'catalog-' + (_this.showGroup !== false ? 'group' : 'product') + '-form',
                            attributes: {
                                id: product.id,
                                isGroup: _this.showGroup !== false
                            },
                            value: product
                        });
                    }
                });
            }
            if (this.can('catalog-products', 4)) {
                actions.push({
                    icon: 'delete',
                    click: function (product) {
                        _this.productToDelete = product;
                    }
                });
            }
            if (this.can('catalog-products', 2)) {
                actions.push({
                    icon: ['fas', 'clone'],
                    title: this.$t('catalog.' + (this.showGroup !== false ? 'group' : 'product') + '.clone'),
                    click: function (product) {
                        var clone = JSON.parse(JSON.stringify(product));
                        delete clone.id;
                        _this.openModal({
                            key: 'catalog-' + (_this.showGroup !== false ? 'group' : 'product') + '-form',
                            value: clone
                        });
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: 'reference',
                    name: this.$t('catalog.list.reference')
                },
                {
                    data: 'name',
                    name: this.$t('catalog.list.name')
                },
                {
                    data: 'designation',
                    name: this.$t('catalog.list.designation'),
                    visible: false,
                    isHtml: true
                },
                {
                    data: 'cant_change_price',
                    name: this.$t('catalog.list.cantChangePrice'),
                    visible: false
                },
                {
                    data: 'unit_price_ht',
                    name: this.$t('catalog.list.unitPriceHt'),
                    render: 'currency'
                },
                {
                    data: 'unit_price_tva',
                    name: this.$t('catalog.list.unitPriceTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'unit_price_ttc',
                    name: this.$t('catalog.list.unitPriceTtc'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'default_quantity',
                    name: this.$t('catalog.list.defaultQuantity'),
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: this.$t('catalog.list.totalHt'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_tva',
                    name: this.$t('catalog.list.totalTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: this.$t('catalog.list.totalTtc'),
                    render: 'currency',
                    visible: false
                }
            ];
            if (this.can('sales-margin', 1) || this.can('catalog-products', 3)) {
                columns.push.apply(columns, [
                    {
                        data: 'various_costs',
                        name: this.$t('catalog.list.variousCosts'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs',
                        name: this.$t('catalog.list.totalCosts'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_amount',
                        name: this.$t('catalog.list.grossMarginAmount'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_rate',
                        name: this.$t('catalog.list.grossMarginRate'),
                        render: 'pourcent',
                        visible: false
                    },
                    {
                        data: 'markup_rate',
                        name: this.$t('catalog.list.markupRate'),
                        render: 'pourcent',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'sale_category.label',
                    name: this.$t('catalog.list.saleCategory'),
                    visible: false
                },
                {
                    data: 'vat_rate.rate',
                    name: this.$t('catalog.list.vatRate'),
                    render: 'pourcent'
                },
                {
                    data: 'unit.label',
                    name: this.$t('catalog.list.unit'),
                    visible: false
                },
                {
                    data: 'status.name',
                    name: this.$t('interface.activeStatus.label'),
                    visible: false
                }
            ]);
            if (!this.showGroup !== false) {
                columns.push.apply(columns, [
                    {
                        data: 'not_for_sale',
                        name: this.$t('catalog.list.notForSale'),
                        visible: false,
                        render: function (val) { return _this.$t('interface.' + (val ? 'yes' : 'no')); }
                    },
                    {
                        data: 'charge_category.label',
                        name: this.$t('catalog.list.chargeCategory'),
                        visible: false
                    },
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'ean_code',
                    name: this.$t('catalog.list.ean'),
                    visible: false
                },
                {
                    data: 'unit_weight',
                    name: this.$t('catalog.list.unitWeight'),
                    visible: false
                }
            ]);
            if (!this.showGroup !== false) {
                columns.push.apply(columns, [
                    {
                        data: 'size_length',
                        name: this.$t('catalog.list.sizeLength'),
                        visible: false
                    },
                    {
                        data: 'size_width',
                        name: this.$t('catalog.list.sizeWidth'),
                        visible: false
                    },
                    {
                        data: 'size_height',
                        name: this.$t('catalog.list.sizeHeight'),
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'eco_tax_ht',
                    name: this.$t('catalog.list.ecoTaxHt'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'eco_tax_tva',
                    name: this.$t('catalog.list.ecoTaxTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'eco_tax_ttc',
                    name: this.$t('catalog.list.ecoTaxTtc'),
                    render: 'currency',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1) || this.can('catalog-products', 3)) {
                columns.push.apply(columns, [
                    {
                        data: 'unit_buy_price_ht',
                        name: this.$t('catalog.list.unitBuyPriceHt'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            if (this.hasModule('stock')) {
                columns.push.apply(columns, [
                    {
                        data: 'with_stock',
                        name: this.$t('catalog.list.withStock'),
                        render: function (val) { return _this.$t('interface.' + (val ? 'yes' : 'no')); },
                        visible: false
                    },
                    {
                        data: 'average_buy_price',
                        name: this.$t('catalog.list.averageBuyPrice'),
                        visible: false,
                        render: function (val) {
                            if (val === null) {
                                return null;
                            }
                            return _this.showNumber(val);
                        }
                    },
                    {
                        data: 'stock_quantity',
                        name: this.$t('catalog.list.stockQuantity'),
                        visible: false,
                        render: function (val) {
                            if (val === null) {
                                return null;
                            }
                            return _this.showNumber(val);
                        }
                    },
                    {
                        data: 'total_stock_ht',
                        name: this.$t('catalog.list.stockTotal'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'stock_theoretical_quantity',
                        name: this.$t('catalog.list.stockTheoreticalQuantity'),
                        visible: false,
                        render: function (val) {
                            if (val === null) {
                                return null;
                            }
                            return _this.showNumber(val);
                        }
                    },
                    {
                        data: 'total_stock_theoretical_ht',
                        name: this.$t('catalog.list.stockTheoreticalTotal'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'stock_minimum',
                        name: this.$t('catalog.list.stockMinimum'),
                        visible: false,
                        render: function (val) {
                            return val === null ? null : _this.showNumber(val);
                        }
                    },
                    {
                        data: 'stock_maximum',
                        name: this.$t('catalog.list.stockMaximum'),
                        visible: false,
                        render: function (val) {
                            return val === null ? null : _this.showNumber(val);
                        }
                    },
                    {
                        data: 'stock_alert',
                        name: this.$t('catalog.list.stockAlert'),
                        visible: false,
                        render: function (val) {
                            return val === null ? null : _this.showNumber(val);
                        }
                    },
                    {
                        data: 'stock_tracking_mode',
                        name: this.$t('catalog.list.stockTrackingMode'),
                        visible: false,
                        render: function (val) {
                            switch (val) {
                                case 1:
                                    return _this.$t('catalog.form.traceabilities.lot');
                                case 2:
                                    return _this.$t('catalog.form.traceabilities.serial');
                                default:
                                    return _this.$t('catalog.form.traceabilities.no');
                            }
                        }
                    }
                ]);
            }
            if (!this.showGroup !== false && this.hasModule('catalog-variations')) {
                columns.push.apply(columns, [
                    {
                        data: 'variations_length',
                        name: this.$t('catalog.list.variationsLength'),
                        render: function (val) { return _this.$t('interface.' + (val > 0 ? 'yes' : 'no')); },
                        visible: false
                    },
                    {
                        data: 'variation_level1.label',
                        name: this.$t('catalog.list.variationsLevel1'),
                        visible: false
                    },
                    {
                        data: 'variation_level2.label',
                        name: this.$t('catalog.list.variationsLevel2'),
                        visible: false
                    },
                    {
                        data: 'variation_level3.label',
                        name: this.$t('catalog.list.variationsLevel3'),
                        visible: false
                    }
                ]);
            }
            if (!this.showGroup !== false) {
                columns.push.apply(columns, [
                    {
                        data: 'providers',
                        name: this.$t('catalog.list.providers'),
                        render: function (data, row) {
                            if (row.variations_length > 0) {
                                return data ? data.map(function (customer) { return customer.name; }).join(', ') : null;
                            }
                            else {
                                return row.providers_references ? row.providers_references.map(function (reference) { var _a; return (_a = reference.customer) === null || _a === void 0 ? void 0 : _a.name; }).join(', ') : null;
                            }
                        },
                        visible: false
                    },
                    {
                        data: 'providers_references',
                        name: this.$t('catalog.list.providersReferences'),
                        render: function (data) {
                            if (!data) {
                                return null;
                            }
                            return data.map(function (ref) { return ref.reference; }).join(', ');
                        },
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                }
            ], this.customFieldTableColumns('product')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {
                is_group: this.showGroup !== false
            };
            if (this.defaultFilters) {
                filter = Object.assign({}, this.defaultFilters, filter);
            }
            if (this.provider) {
                filter.providers = this.provider;
            }
            return {
                include: this.computedInclude,
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductList.prototype, "filters", {
        get: function () {
            var _this = this;
            var filters = [
                {
                    type: 'text',
                    label: this.$t('catalog.filters.reference'),
                    name: 'reference'
                },
                {
                    type: 'text',
                    label: this.$t('catalog.filters.name'),
                    name: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.saleCategory'),
                    name: 'sale_category',
                    multiple: true,
                    ajax: '/catalog/sale_category?sort=label',
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.chargeCategory'),
                    name: 'charge_category',
                    multiple: true,
                    ajax: '/catalog/charge_category?sort=label',
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.status'),
                    name: 'status',
                    options: [
                        { value: true, label: this.$t('interface.activeStatus.on') },
                        { value: false, label: this.$t('interface.activeStatus.off') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.notForSale'),
                    name: 'not_for_sale',
                    options: [
                        { value: true, label: this.$t('interface.yes') },
                        { value: false, label: this.$t('interface.no') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                }
            ];
            if (this.hasModule('stock')) {
                filters.push({
                    type: 'select',
                    label: this.$t('catalog.filters.withStock'),
                    name: 'with_stock',
                    options: [
                        { value: true, label: this.$t('interface.yes') },
                        { value: false, label: this.$t('interface.no') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                });
            }
            if (this.hasModule('catalog-variations')) {
                filters.push({
                    type: 'select',
                    label: this.$t('catalog.filters.withVariations'),
                    name: 'has_variations',
                    options: [
                        { value: true, label: this.$t('interface.yes') },
                        { value: false, label: this.$t('interface.no') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                });
            }
            if (!this.provider) {
                filters.push({
                    type: 'select',
                    label: this.$t('catalog.filters.provider'),
                    name: 'providers',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_provider]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'text',
                    label: this.$t('catalog.filters.ean'),
                    name: 'ean'
                }
            ], this.customFieldTableFilters('product')));
            return filters.filter(function (filter) {
                return !_this.defaultFilters || _this.defaultFilters[filter.name] === undefined;
            });
        },
        enumerable: false,
        configurable: true
    });
    ProductList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                interface_vue_.emitter.on('productCreated', this.productCreated);
                interface_vue_.emitter.on('productUpdated', this.productUpdated);
                interface_vue_.emitter.on('productDeleted', this.productDeleted);
                return [2 /*return*/];
            });
        });
    };
    ProductList.prototype.destroyed = function () {
        interface_vue_.emitter.off('productCreated', this.productCreated);
        interface_vue_.emitter.off('productUpdated', this.productUpdated);
        interface_vue_.emitter.off('productDeleted', this.productDeleted);
    };
    ProductList.prototype.rowLink = function (product) {
        return {
            name: 'catalog-' + (this.showGroup !== false ? 'group' : 'product') + '-item',
            params: {
                id: String(product.id)
            }
        };
    };
    ProductList.prototype.toDelete = function (product) {
        this.productToDelete = product;
    };
    ProductList.prototype.productCreated = function (product) {
        if (product.is_group !== this.showGroup !== false) {
            return;
        }
        var table = this.$refs.table;
        table.addRow(product);
    };
    ProductList.prototype.productUpdated = function (event) {
        if (event.new.is_group !== this.showGroup !== false) {
            return;
        }
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    ProductList.prototype.productDeleted = function (product) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === product.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductList.prototype, "provider", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'catalog-products' })
    ], ProductList.prototype, "stateKey", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ProductList.prototype, "disableMainSearchSave", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ProductList.prototype, "showGroup", void 0);
    ProductList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                ProductItem: ProductItem/* default */.A,
                ProductDelete: ProductDelete/* default */.A,
                KTable: table_vue_.KTable
            }
        })
    ], ProductList);
    return ProductList;
}((0,lib/* Mixins */.Xe)(CatalogListMixin/* default */.A, interface_vue_.NumberMixin)));
/* harmony default export */ var ProductListvue_type_script_lang_ts_external = (ProductList);

;// ./src/components/ProductList/ProductList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductList_ProductListvue_type_script_lang_ts_external = (ProductListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductList/ProductList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductList_ProductListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductList_ProductList = (component.exports);

/***/ }),

/***/ 7473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ElementSalesList_ElementSalesList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ElementSalesList/ElementSalesList.vue?vue&type=template&id=751ccfde
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{ref:"table",attrs:{"url":_vm.ajaxUrl,"ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowClick":_vm.rowClick,"stateKey":'catalog-sales-' + _vm.documentType,"onlyTopFilters":"","searchable":false,"dataKey":_vm.getDataKey,"exportable":_vm.type + '-' + _vm.documentType,"exportParentId":_vm.id,"exportCanSelectColumn":false}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ElementSalesList/ElementSalesList.ts?vue&type=script&lang=ts&external




var ElementSalesList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ElementSalesList, _super);
    function ElementSalesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ElementSalesList.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: ['vat_rate', this.documentType, this.documentType + '.customer', this.documentType + '.contact']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementSalesList.prototype, "ajaxUrl", {
        get: function () {
            return '/catalog/' + this.type + '/' + this.id + '/' + this.documentType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementSalesList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: this.documentType + '.reference',
                    name: this.$t('catalog.sales.list.documentReference')
                },
                {
                    data: this.documentType + '.date',
                    name: this.$t('catalog.sales.list.date'),
                    render: 'date',
                },
                {
                    data: this.documentType + '.customer.name',
                    name: this.$t('catalog.sales.list.customer'),
                    visible: false
                },
                {
                    data: this.documentType + '.contact.fullname',
                    name: this.$t('catalog.sales.list.contact'),
                    visible: false
                },
                {
                    data: 'unit_price_ht',
                    name: this.$t('catalog.sales.list.unitPriceHt'),
                    render: 'currency'
                },
                {
                    data: 'unit_price_tva',
                    name: this.$t('catalog.sales.list.unitPriceTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'unit_price_ttc',
                    name: this.$t('catalog.sales.list.unitPriceTtc'),
                    render: 'currency',
                    visible: false
                }
            ];
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'catalog_costs_u',
                        name: this.$t('catalog.sales.list.catalogCostU'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'various_costs_u',
                        name: this.$t('catalog.sales.list.variousCostU'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs_u',
                        name: this.$t('catalog.sales.list.totalCostU'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'hourly_person_cost',
                        name: this.$t('catalog.sales.list.hourlyPersonCost'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'number_people_needed',
                    name: this.$t('catalog.sales.list.numberPeopleNeeded'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'duration',
                    name: this.$t('catalog.sales.list.duration'),
                    visible: false,
                    render: function (data, row) { return data + ' ' + _this.$tc('interface.duration.' + row.duration_type, data); }
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'workforce_costs_u',
                        name: this.$t('catalog.sales.list.workforceCostsU'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_charge_u',
                        name: this.$t('catalog.sales.list.totalChargeU'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_amount_u',
                        name: this.$t('catalog.sales.list.grossMarginAmountU'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'quantity',
                    name: this.$t('catalog.sales.list.quantity'),
                    render: 'amount'
                },
                {
                    data: 'secondary_quantity',
                    name: this.$t('catalog.sales.list.secondaryQuantity'),
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'total_quantity',
                    name: this.$t('catalog.sales.list.totalQuantity'),
                    render: 'amount',
                    visible: false
                },
                {
                    data: 'vat_rate.rate',
                    name: this.$t('catalog.sales.list.vatRate'),
                    visible: false
                },
                {
                    data: 'total_ht',
                    name: this.$t('catalog.sales.list.totalHt'),
                    render: 'currency'
                },
                {
                    data: 'total_tva',
                    name: this.$t('catalog.sales.list.totalTva'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'total_ttc',
                    name: this.$t('catalog.sales.list.totalTtc'),
                    render: 'currency',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_catalog_costs',
                        name: this.$t('catalog.sales.list.totalCatalogCosts'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_various_costs',
                        name: this.$t('catalog.sales.list.totalVariousCosts'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_costs',
                        name: this.$t('catalog.sales.list.totalCosts'),
                        render: 'currency',
                        visible: false
                    }
                ]);
            }
            columns.push.apply(columns, [
                {
                    data: 'total_duration_hour',
                    name: this.$t('catalog.sales.list.totalDurationHour'),
                    render: 'currency',
                    visible: false
                }
            ]);
            if (this.can('sales-margin', 1)) {
                columns.push.apply(columns, [
                    {
                        data: 'total_workforce',
                        name: this.$t('catalog.sales.list.totalWorkforce'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'total_charge',
                        name: this.$t('catalog.sales.list.totalCharge'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_amount',
                        name: this.$t('catalog.sales.list.grossMarginAmount'),
                        render: 'currency',
                        visible: false
                    },
                    {
                        data: 'gross_margin_rate',
                        name: this.$t('catalog.sales.list.grossMarginRate'),
                        render: 'pourcentage',
                        visible: false
                    },
                    {
                        data: 'markup_rate',
                        name: this.$t('catalog.sales.list.markupRate'),
                        render: 'pourcentage',
                        visible: false
                    }
                ]);
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementSalesList.prototype, "filters", {
        get: function () {
            return [
                {
                    type: 'period',
                    label: this.$t('catalog.sales.filter.period'),
                    name: 'date_since',
                    name2: 'date_until'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.sales.filter.customer'),
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ElementSalesList.prototype.getDataKey = function (data) {
        return data[this.documentType].id;
    };
    ElementSalesList.prototype.rowClick = function (data) {
        this.$router.push({ name: this.documentType + '-item', params: { id: data[this.documentType].id } });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ElementSalesList.prototype, "documentType", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ElementSalesList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ElementSalesList.prototype, "id", void 0);
    ElementSalesList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], ElementSalesList);
    return ElementSalesList;
}(lib/* Vue */.lD));
/* harmony default export */ var ElementSalesListvue_type_script_lang_ts_external = (ElementSalesList);

;// ./src/components/ElementSalesList/ElementSalesList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ElementSalesList_ElementSalesListvue_type_script_lang_ts_external = (ElementSalesListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ElementSalesList/ElementSalesList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ElementSalesList_ElementSalesListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ElementSalesList_ElementSalesList = (component.exports);

/***/ }),

/***/ 7611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PdfViewer_PdfViewer; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfViewer/PdfViewer.vue?vue&type=template&id=41b8a080
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):(_vm.error)?_c('div',{staticClass:"text-center font-weight-bold text-danger p-4"},[_vm._v(" Erreur lors de la génération du PDF ")]):_c('Viewer',{ref:"viewer",attrs:{"width":"100%","src":_vm.pdfFile,"filename":_vm.filename}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external



var PdfViewer = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfViewer, _super);
    function PdfViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.file = null;
        _this.filename = null;
        _this.timeout = null;
        _this.timeoutLimit = 0;
        _this.error = false;
        return _this;
    }
    PdfViewer.prototype.mounted = function () {
        interface_vue_.emitter.on('PdfGenerated', this.pdfGenerated);
    };
    PdfViewer.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('PdfGenerated', this.pdfGenerated);
        this.clearTimeout();
    };
    Object.defineProperty(PdfViewer.prototype, "url", {
        get: function () {
            return '/catalog/command/' + this.id + '/pdf';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfViewer.prototype, "pdfFile", {
        get: function () {
            return 'data:application/pdf;base64,' + this.file;
        },
        enumerable: false,
        configurable: true
    });
    PdfViewer.prototype.pdfGenerated = function (datas) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(datas.type === 'providerCommand' && datas.id === this.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadPdf()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.watchId = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.file = null;
                        this.error = false;
                        return [4 /*yield*/, this.processStatus(this.pdfStatus)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.processStatus = function (status) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = status;
                        switch (_a) {
                            case 3: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 2];
                    case 1:
                        this.loading = false;
                        this.error = true;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.loadPdf()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.loadPdf = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearTimeout();
                        return [4 /*yield*/, this.$kwCatalog.axios.get(this.url)
                                .then(function (response) {
                                var data = response.data;
                                if (data.status !== undefined) {
                                    if (data.status >= 0 && data.status <= 2) {
                                        _this.setTimeout();
                                    }
                                    else {
                                        _this.error = true;
                                    }
                                }
                                else {
                                    _this.file = data.file;
                                    _this.filename = data.filename;
                                    _this.loading = false;
                                    _this.$emit('pdfLoaded', data);
                                }
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.download = function () {
        var viewer = this.$refs.viewer;
        viewer.download();
    };
    PdfViewer.prototype.setTimeout = function () {
        this.clearTimeout();
        if (this.timeoutLimit > 10) {
            this.loading = false;
            this.error = true;
            return;
        }
        this.timeout = setTimeout(this.loadPdf, 1500);
        this.timeoutLimit++;
    };
    PdfViewer.prototype.clearTimeout = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "pdfStatus", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('id', { immediate: true })
    ], PdfViewer.prototype, "watchId", null);
    PdfViewer = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Viewer: interface_vue_.PdfViewer,
                Spinner: interface_vue_.Spinner
            }
        })
    ], PdfViewer);
    return PdfViewer;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfViewervue_type_script_lang_ts_external = (PdfViewer);

;// ./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfViewer_PdfViewervue_type_script_lang_ts_external = (PdfViewervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PdfViewer/PdfViewer.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PdfViewer_PdfViewervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfViewer_PdfViewer = (component.exports);

/***/ }),

/***/ 7666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LotList_LotList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotList/LotList.vue?vue&type=template&id=6dc8671d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/catalog/stock/lot","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowClick":_vm.rowClick,"stateKey":_vm.stateKey,"exportable":"productLot"}}),_c('LotDelete',{attrs:{"value":_vm.deleteLot},on:{"hidden":function($event){_vm.deleteLot = null}}}),_c('LotItem',{attrs:{"modalState":_vm.showLot !== null},on:{"hidden":function($event){_vm.showLot = null},"toEdit":function($event){return _vm.toEdit(_vm.showLot)},"toDelete":function($event){return _vm.toDelete(_vm.showLot)}},model:{value:(_vm.showLot),callback:function ($$v) {_vm.showLot=$$v},expression:"showLot"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/LotDelete/LotDelete.vue + 3 modules
var LotDelete = __webpack_require__(607);
// EXTERNAL MODULE: ./src/components/LotItem/LotItem.vue + 3 modules
var LotItem = __webpack_require__(1798);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotList/LotList.ts?vue&type=script&lang=ts&external







var LotList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotList, _super);
    function LotList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showLot = null;
        _this.deleteLot = null;
        return _this;
    }
    LotList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasModule('stock-locations')) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2:
                        interface_vue_.emitter.on('productLotUpdated', this.lotUpdated);
                        interface_vue_.emitter.on('productLotDeleted', this.lotDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    LotList.prototype.destroyed = function () {
        interface_vue_.emitter.off('productLotUpdated', this.lotUpdated);
        interface_vue_.emitter.off('productLotDeleted', this.lotDeleted);
    };
    Object.defineProperty(LotList.prototype, "stateKey", {
        get: function () {
            return 'stock-lots' + (this.productId ? '-product' : '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotList.prototype, "rowActions", {
        get: function () {
            return [
                {
                    icon: 'edit',
                    click: this.toEdit
                },
                {
                    icon: 'delete',
                    click: this.toDelete
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [];
            if (!this.productId) {
                columns.push.apply(columns, [
                    {
                        data: 'product.reference',
                        name: this.$t('catalog.productLot.list.productReference')
                    },
                    {
                        data: 'product.name',
                        name: this.$t('catalog.productLot.list.productName')
                    }
                ]);
            }
            if (this.hasModule('stock-locations')) {
                columns.push({
                    data: 'stock_location.name',
                    name: 'Lieu de stock'
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'reference',
                    name: this.$t('catalog.productLot.list.reference')
                },
                {
                    data: 'expire_at',
                    name: this.$t('catalog.productLot.list.expire'),
                    render: 'date'
                },
                {
                    data: 'quantity',
                    name: this.$t('catalog.productLot.list.quantity'),
                    render: function (val) { return _this.showNumber(val); },
                    cssClass: 'kw-table-render-number'
                },
                {
                    data: 'stock_quantity',
                    name: this.$t('catalog.productLot.list.stockQuantity'),
                    render: function (val) { return _this.showNumber(val); },
                    cssClass: 'kw-table-render-number'
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                }
            ]);
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {};
            if (this.linkedElement) {
                filter.element = this.linkedElement;
            }
            if (this.productId) {
                filter.where_product = this.productId;
            }
            return {
                include: ['product', 'stock_location'],
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotList.prototype, "filters", {
        get: function () {
            var filters = [];
            if (!this.productId) {
                filters.push({
                    type: 'text',
                    label: this.$t('catalog.productLot.filter.productReference'),
                    name: 'product_reference'
                });
            }
            if (this.hasModule('stock-locations')) {
                filters.push({
                    type: 'select',
                    name: 'stock_location',
                    label: 'Lieu de stock',
                    options: this.stockLocations,
                    optionLabel: 'name',
                    value: 'id',
                    multiple: true
                });
            }
            filters.push.apply(filters, [
                {
                    type: 'text',
                    label: this.$t('catalog.productLot.filter.reference'),
                    name: 'reference'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.productLot.filter.inStock'),
                    name: 'only_in_stock',
                    options: [
                        { value: true, label: 'Oui' },
                        { value: false, label: 'Non' }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'period',
                    label: this.$t('catalog.productLot.filter.expire'),
                    name: 'expire_since',
                    name2: 'expire_until'
                }
            ]);
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    LotList.prototype.rowClick = function (row) {
        this.showLot = row;
    };
    LotList.prototype.toEdit = function (lot) {
        this.openModal({
            key: 'catalog-product-lot',
            value: lot
        });
    };
    LotList.prototype.lotUpdated = function (lot) {
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (row) { return row.id === lot.id; });
        if (index >= 0) {
            var old = datas[index];
            table.updateRow(index, lot);
            this.$emit('lotUpdated', lot, old);
        }
        else {
            table.addRow(lot);
            this.$emit('lotCreated', lot);
        }
    };
    LotList.prototype.toDelete = function (lot) {
        this.deleteLot = lot;
    };
    LotList.prototype.lotDeleted = function (lot) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (row) { return row.id === lot.id; });
        if (index >= 0) {
            table.deleteRow(index);
            this.$emit('lotDeleted', lot);
        }
    };
    LotList.prototype.refresh = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotList.prototype, "linkedElement", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotList.prototype, "productId", void 0);
    LotList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            components: {
                KTable: table_vue_.KTable,
                LotItem: LotItem/* default */.A,
                LotDelete: LotDelete/* default */.A,
                Spinner: interface_vue_.Spinner
            }
        })
    ], LotList);
    return LotList;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var LotListvue_type_script_lang_ts_external = (LotList);

;// ./src/components/LotList/LotList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotList_LotListvue_type_script_lang_ts_external = (LotListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LotList/LotList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LotList_LotListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotList_LotList = (component.exports);

/***/ }),

/***/ 7670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 7721:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 7797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 7828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 7978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270),
    get = __webpack_require__(8156),
    hasIn = __webpack_require__(631),
    isKey = __webpack_require__(8586),
    isStrictComparable = __webpack_require__(756),
    matchesStrictComparable = __webpack_require__(7197),
    toKey = __webpack_require__(7797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandForm_CommandForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandForm/CommandForm.vue?vue&type=template&id=ddfe18c0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('k-form',{ref:"form",staticClass:"sales-form",attrs:{"action":_vm.formUrl,"method":_vm.formMethod,"parent":"#page"},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"5"}},[_c('b-card',{staticClass:"h-100"},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('input',{attrs:{"name":"customer","type":"hidden"},domProps:{"value":_vm.command.provider ? _vm.command.provider.id : null}}),_c('CustomerSelect',{attrs:{"label":_vm.$t('catalog.command.form.provider'),"type":"provider","validationName":"customer","include":['configurations']},on:{"input":_vm.onProviderChange},model:{value:(_vm.command.provider),callback:function ($$v) {_vm.$set(_vm.command, "provider", $$v)},expression:"command.provider"}})],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.command.contact ? _vm.command.contact.id : null}}),_c('ContactSelect',{attrs:{"disabled":!_vm.command.provider,"validationName":"contact","customer":_vm.command.provider},model:{value:(_vm.command.contact),callback:function ($$v) {_vm.$set(_vm.command, "contact", $$v)},expression:"command.contact"}})],1)],1),(_vm.hasModule('stock-locations'))?_c('b-form-group',{attrs:{"label":"Lieu de stockage"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.command.stock_location?.id}}),_c('StockLocationSelect',{attrs:{"selectDefault":"","required":""},model:{value:(_vm.command.stock_location),callback:function ($$v) {_vm.$set(_vm.command, "stock_location", $$v)},expression:"command.stock_location"}})],1):_vm._e(),_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('catalog.command.form.deliveryAddress')}},[_c('k-form-address',{attrs:{"countries-list":_vm.countries,"road-placeholder":_vm.$t('catalog.command.form.road'),"withRoad3":true,"valuesMap":{ road: 'road1', city: 'town', postalCode: 'postal_code' },"size":"sm"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1)],1)],1),_c('b-col',[_c('b-card',{staticClass:"pb-1 h-100",attrs:{"body-class":"pb-2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.title')}},[_c('k-form-input',{attrs:{"name":"title"},model:{value:(_vm.command.title),callback:function ($$v) {_vm.$set(_vm.command, "title", $$v)},expression:"command.title"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.date')}},[_c('k-form-datepicker',{attrs:{"name":"date","required":""},model:{value:(_vm.command.date),callback:function ($$v) {_vm.$set(_vm.command, "date", $$v)},expression:"command.date"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.currency')}},[_c('input',{attrs:{"type":"hidden","name":"currency"},domProps:{"value":_vm.command.currency ? _vm.command.currency.id : null}}),_c('CurrencySelect',{attrs:{"validationName":"currency","selectDefault":""},model:{value:(_vm.command.currency),callback:function ($$v) {_vm.$set(_vm.command, "currency", $$v)},expression:"command.currency"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.pdfModel')}},[_c('input',{attrs:{"type":"hidden","name":"pdf_model"},domProps:{"value":_vm.command.pdf_model ? _vm.command.pdf_model.id : null}}),_c('PdfModelSelect',{attrs:{"validationName":"pdf_model","required":""},model:{value:(_vm.command.pdf_model),callback:function ($$v) {_vm.$set(_vm.command, "pdf_model", $$v)},expression:"command.pdf_model"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.comments')}},[_c('k-form-textarea',{attrs:{"name":"comments","rows":"3"},model:{value:(_vm.command.comments),callback:function ($$v) {_vm.$set(_vm.command, "comments", $$v)},expression:"command.comments"}})],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.command.form.pdfOptions')}},[_c('b-form-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"options[contact]"},domProps:{"value":_vm.command.options.contact ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.command.options.contact),callback:function ($$v) {_vm.$set(_vm.command.options, "contact", $$v)},expression:"command.options.contact"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.pdfShowContact'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"options[reference_column]"},domProps:{"value":_vm.command.options.reference_column ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.command.options.reference_column),callback:function ($$v) {_vm.$set(_vm.command.options, "reference_column", $$v)},expression:"command.options.reference_column"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.pdfShowReference'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"options[units]"},domProps:{"value":_vm.command.options.units ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.command.options.units),callback:function ($$v) {_vm.$set(_vm.command.options, "units", $$v)},expression:"command.options.units"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.pdfShowUnit'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"options[not_show_price]"},domProps:{"value":_vm.command.options.not_show_price ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.command.options.not_show_price),callback:function ($$v) {_vm.$set(_vm.command.options, "not_show_price", $$v)},expression:"command.options.not_show_price"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.pdfDontShowPrices'))+" ")])],1)],1)],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[(!_vm.command.id)?_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Créer au statut :"}},[_c('b-form-radio-group',{staticClass:"mt-1",attrs:{"size":"sm","name":"status"},model:{value:(_vm.command.status),callback:function ($$v) {_vm.$set(_vm.command, "status", $$v)},expression:"command.status"}},[_c('b-form-radio',{attrs:{"value":0}},[_vm._v(_vm._s(_vm.$t('catalog.command.status.draft')))]),_c('b-form-radio',{attrs:{"value":1}},[_vm._v(_vm._s(_vm.$t('catalog.command.status.waitDelivery')))]),_c('b-form-radio',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
                      title: _vm.hasProductWithTracability ? _vm.$t('catalog.command.form.needManualReceipt') : null
                    }),expression:"{\n                      title: hasProductWithTracability ? $t('catalog.command.form.needManualReceipt') : null\n                    }"}],attrs:{"disabled":_vm.hasProductWithTracability,"value":3}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.status.delivered'))+" ")])],1)],1):_vm._e()],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sales.form.paymentTerm')}},[_c('input',{attrs:{"type":"hidden","name":"payment_term"},domProps:{"value":_vm.command.payment_term ? _vm.command.payment_term.id : null}}),_c('PaymentTermSelect',{attrs:{"validateName":"payment_term"},model:{value:(_vm.command.payment_term),callback:function ($$v) {_vm.$set(_vm.command, "payment_term", $$v)},expression:"command.payment_term"}})],1)],1),(_vm.teamConfigs.provider_command_update_product_price && _vm.teamConfigs.provider_command_update_product_costs)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Coûts divers"}},[_c('b-input-group',{attrs:{"append":"€","size":"sm"}},[_c('k-form-number',{attrs:{"name":"various_costs","noDefaultValue":"","min":0,"size":"sm"},on:{"change":_vm.applyGlobalCosts},model:{value:(_vm.command.various_costs),callback:function ($$v) {_vm.$set(_vm.command, "various_costs", $$v)},expression:"command.various_costs"}})],1)],1)],1):_vm._e()],1),_c('CustomFieldsForm',{attrs:{"title-class":"form-title-alt mt-4","type":"provider_command"},model:{value:(_vm.command.custom_fields),callback:function ($$v) {_vm.$set(_vm.command, "custom_fields", $$v)},expression:"command.custom_fields"}})],1)],1)],1),_c('h3',{staticClass:"form-title pb-1 mb-0"},[_vm._v(_vm._s(_vm.$t('catalog.command.form.content')))]),_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('CatalogSearch',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.command.provider === null ? _vm.$t('catalog.command.form.needSelectProvider') : null }),expression:"{ title: command.provider === null ? $t('catalog.command.form.needSelectProvider') : null }"}],staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","placeholder":_vm.$t('catalog.command.form.productSearch'),"only":_vm.catalogSearchOnly,"include":_vm.catalogSearchInclude,"disabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"filters":_vm.catalogSearchFilters},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.emptyLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addCommentLine()}}},[_vm._v(" Commentaires ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addPageBreakLine()}}},[_vm._v(" Saut de page ")])],1)],1)],1),_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"table-responsive-lg"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 table-command-content text-nowrap"},[_c('thead',{staticClass:"thead-dark small text-center"},[_c('tr',[_c('th',{staticStyle:{"width":"18px"}}),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.reference'))+" ")]),_c('th',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.designation'))+" ")]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.unitPriceHt'))+" ")]),_c('th',{staticStyle:{"width":"76px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.vatRate'))+" ")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.quantity'))+" ")]),_c('th',{staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.totalHt'))+" ")]),_c('th',{staticStyle:{"width":"21px"}})])]),(_vm.command.contents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"8"}},[_c('input',{attrs:{"type":"hidden","name":"contents"}}),_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.emptyCommand'))+" ")])])]):_vm._e(),(_vm.command.contents.length > 0)?_c('draggable',{ref:"draggable",attrs:{"list":_vm.command.contents,"handle":".draggable-handle","tag":"tbody"},on:{"start":_vm.startDragging,"end":_vm.stopDragging}},[_vm._l((_vm.command.contents),function(content,i){return [(content.is_pagebreak)?_c('PageBreak',{key:i,ref:'content' + i,refInFor:true,attrs:{"command":_vm.command,"index":i,"catalogOnly":_vm.catalogSearchOnly,"catalogInclude":_vm.catalogSearchInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogSearchFilters},on:{"addSubLine":event => _vm.addSubLine(i, event),"deleteLine":function($event){return _vm.deleteLine(i)}},model:{value:(_vm.command.contents[i]),callback:function ($$v) {_vm.$set(_vm.command.contents, i, $$v)},expression:"command.contents[i]"}}):(content.is_comments)?_c('Comment',{key:i,ref:'content' + i,refInFor:true,attrs:{"command":_vm.command,"index":i,"catalogOnly":_vm.catalogSearchOnly,"catalogInclude":_vm.catalogSearchInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogSearchFilters},on:{"addSubLine":event => _vm.addSubLine(i, event),"deleteLine":function($event){return _vm.deleteLine(i)}},model:{value:(_vm.command.contents[i]),callback:function ($$v) {_vm.$set(_vm.command.contents, i, $$v)},expression:"command.contents[i]"}}):_c('Content',{key:i,ref:'content' + i,refInFor:true,attrs:{"command":_vm.command,"index":i,"catalogOnly":_vm.catalogSearchOnly,"catalogInclude":_vm.catalogSearchInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogSearchFilters},on:{"addSubLine":event => _vm.addSubLine(i, event),"deleteLine":function($event){return _vm.deleteLine(i)}},model:{value:(_vm.command.contents[i]),callback:function ($$v) {_vm.$set(_vm.command.contents, i, $$v)},expression:"command.contents[i]"}})]})],2):_vm._e()],1)])]),(_vm.command.contents.length > 4)?_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('CatalogSearch',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.command.provider === null ? _vm.$t('catalog.command.form.needSelectProvider') : null }),expression:"{ title: command.provider === null ? $t('catalog.command.form.needSelectProvider') : null }"}],staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","placeholder":_vm.$t('catalog.command.form.productSearch'),"only":_vm.catalogSearchOnly,"include":_vm.catalogSearchInclude,"disabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"filters":_vm.catalogSearchFilters},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.emptyLine'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addCommentLine()}}},[_vm._v(" Commentaires ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addPageBreakLine()}}},[_vm._v(" Saut de page ")])],1)],1)],1):_vm._e(),_c('p',{staticClass:"pb-5"},[_c('br')]),_c('div',{staticClass:"p-2",attrs:{"id":"command-form-sidebar"}},[_c('b-row',{staticClass:"text-center icon-menu mb-3"},[(_vm.rightSidebar)?_c('b-col'):_vm._e(),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('catalog.command.form.sidebar.sidebarPosition')},on:{"click":function($event){$event.preventDefault();return _vm.changeSidebarMode.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'window-alt']}})],1)],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('catalog.command.form.sidebar.fullscreen')},on:{"click":function($event){$event.preventDefault();return _vm.setFullscreenMode(!_vm.fullscreenMode)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'expand-alt']}})],1)],1),(_vm.rightSidebar)?_c('b-col'):_vm._e()],1),_c('table',{staticClass:"table-totals"},[_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.sidebar.totalHt'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.command.total_ht))+" ")])]),_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.sidebar.totalTva'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.command.total_tva))+" ")])]),_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.form.sidebar.totalTtc'))+" ")]),_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.command.total_ttc))+" ")])])]),_c('div',{class:{ submit: true, 'text-center': _vm.rightSidebar }},[_c('b-button',{staticClass:"my-3 ml-3",attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.command.id ? 'Modifier la commande' : 'Créer la commande')+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__(432);
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// external "@kwixeo/sales-vue"
var sales_vue_namespaceObject = require("@kwixeo/sales-vue");
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/CatalogSearch/CatalogSearch.vue + 57 modules
var CatalogSearch = __webpack_require__(4042);
// EXTERNAL MODULE: ./src/components/ProductVariationSelect/ProductVariationSelect.vue + 3 modules
var ProductVariationSelect = __webpack_require__(7081);
// EXTERNAL MODULE: ./src/components/StockLocationSelect/StockLocationSelect.vue + 3 modules
var StockLocationSelect = __webpack_require__(6225);
// EXTERNAL MODULE: ./src/components/ProductStockIndicator/ProductStockIndicator.vue + 3 modules
var ProductStockIndicator = __webpack_require__(4373);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandForm/LineMenu/LineMenu.vue?vue&type=template&id=77c30424
var LineMenuvue_type_template_id_77c30424_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{ref:"main",staticClass:"sales-line-dropdown-menu d-block",attrs:{"size":"sm","variant":"icon","toggle-class":"p-0","right":"","menu-class":"py-0"},on:{"hide":_vm.hideMain}},[_c('b-dropdown',{attrs:{"size":"sm","text":"Ajouter une ligne au dessus","dropleft":"","block":"","menu-class":"py-0"},on:{"show":_vm.showSub,"hide":_vm.hideSub}},[_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm","disabled":_vm.catalogDisabled},on:{"click":function($event){$event.preventDefault();return _vm.showCatalog('top')}}},[_vm._v(" Catalogue produit ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('empty', 'top')}}},[_vm._v(" Ligne vide ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('comments', 'top')}}},[_vm._v(" Commentaires ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('pagebreak', 'top')}}},[_vm._v(" Saut de page ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('clone', 'top')}}},[_vm._v(" Cloner la ligne ")])],1),_c('b-dropdown',{attrs:{"size":"sm","text":"Ajouter une ligne en dessous","dropleft":"","block":"","menu-class":"py-0"},on:{"show":_vm.showSub,"hide":_vm.hideSub}},[_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm","disabled":_vm.catalogDisabled},on:{"click":function($event){$event.preventDefault();return _vm.showCatalog('bottom')}}},[_vm._v(" Catalogue produit ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('empty', 'bottom')}}},[_vm._v(" Ligne vide ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('comments', 'bottom')}}},[_vm._v(" Commentaires ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('pagebreak', 'bottom')}}},[_vm._v(" Saut de page ")]),_c('b-dropdown-item-button',{attrs:{"button-class":"btn-sm"},on:{"click":function($event){$event.preventDefault();return _vm.event('clone', 'bottom')}}},[_vm._v(" Cloner la ligne ")])],1),_c('b-modal',{staticClass:"catalog-modal",attrs:{"content-class":"catalog-modal-content","size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close'),"scrollable":""},model:{value:(_vm.showCatalogModal),callback:function ($$v) {_vm.showCatalogModal=$$v},expression:"showCatalogModal"}},[_c('CatalogList',{attrs:{"only":_vm.catalogOnly,"include":_vm.catalogInclude,"filters":_vm.catalogFilters},on:{"selected":_vm.selectCatalog}})],1)],1)
}
var LineMenuvue_type_template_id_77c30424_staticRenderFns = []


;// external "@kwixeo/catalog-vue"
var catalog_vue_namespaceObject = require("@kwixeo/catalog-vue");
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandForm/LineMenu/LineMenu.ts?vue&type=script&lang=ts&external






var LineMenu = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LineMenu, _super);
    function LineMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDropdownTopVisible = false;
        _this.isSubDropdownVisible = false;
        _this.showCatalogModal = false;
        _this.position = null;
        return _this;
    }
    LineMenu.prototype.productCreated = function (product) {
        this.$emit('setCatalog', {
            id: product.id,
            type: 'product',
            element: JSON.parse(JSON.stringify(product))
        });
    };
    LineMenu.prototype.serviceCreated = function (service) {
        this.$emit('setCatalog', {
            id: service.id,
            type: 'service',
            element: JSON.parse(JSON.stringify(service))
        });
    };
    LineMenu.prototype.hideMain = function (bvEvent) {
        if (this.isDropdownTopVisible) {
            bvEvent.preventDefault();
        }
    };
    LineMenu.prototype.hideSub = function (bvEvent) {
        if (this.isSubDropdownVisible) {
            bvEvent.preventDefault();
        }
    };
    LineMenu.prototype.showSub = function () {
        var _this = this;
        this.isDropdownTopVisible = true;
        this.$nextTick(function () {
            _this.isDropdownTopVisible = false;
        });
    };
    LineMenu.prototype.event = function (type, position, catalog) {
        var _this = this;
        //(this.$refs.main as BDropdown).hide()
        this.$emit('add', {
            type: type,
            position: position,
            catalog: catalog
        });
        this.isDropdownTopVisible = false;
        this.isSubDropdownVisible = true;
        this.$nextTick(function () {
            _this.isSubDropdownVisible = false;
        });
    };
    LineMenu.prototype.showCatalog = function (position) {
        this.showCatalogModal = true;
        this.position = position;
    };
    LineMenu.prototype.selectCatalog = function (entry) {
        this.event('catalog', this.position, entry);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LineMenu.prototype, "line", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LineMenu.prototype, "catalogOnly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LineMenu.prototype, "catalogInclude", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LineMenu.prototype, "catalogDisabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LineMenu.prototype, "catalogFilters", void 0);
    LineMenu = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                BDropdown: external_bootstrap_vue_.BDropdown,
                BDropdownDivider: external_bootstrap_vue_.BDropdownDivider,
                BDropdownItemButton: external_bootstrap_vue_.BDropdownItemButton,
                BModal: external_bootstrap_vue_.BModal,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                CatalogList: catalog_vue_namespaceObject.CatalogList
            }
        })
    ], LineMenu);
    return LineMenu;
}(lib/* Vue */.lD));
/* harmony default export */ var LineMenuvue_type_script_lang_ts_external = (LineMenu);

;// ./src/components/CommandForm/LineMenu/LineMenu.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LineMenu_LineMenuvue_type_script_lang_ts_external = (LineMenuvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommandForm/LineMenu/LineMenu.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LineMenu_LineMenuvue_type_script_lang_ts_external,
  LineMenuvue_type_template_id_77c30424_render,
  LineMenuvue_type_template_id_77c30424_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LineMenu_LineMenu = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandForm/Content/Content.vue?vue&type=template&id=2e2db81c
var Contentvue_type_template_id_2e2db81c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[(_vm.command.contents.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),(!_vm.value.is_comments && !_vm.value.is_pagebreak)?_c('td',[_c('k-form-input',{attrs:{"name":_vm.getInputName('reference'),"size":"sm","disabled":_vm.contentIsDisabled},model:{value:(_vm.value.reference),callback:function ($$v) {_vm.$set(_vm.value, "reference", $$v)},expression:"value.reference"}})],1):_vm._e(),_c('td',{class:{
      'text-center p-3': _vm.value.is_pagebreak,
      'text-wrap': true
    },attrs:{"colspan":!_vm.value.is_comments && !_vm.value.is_pagebreak ? 1 : 6}},[(_vm.value.product && _vm.value.product.variations_length > 0)?_c('ProductVariationSelect',{attrs:{"product":_vm.value.product},on:{"selected":variation => _vm.variationSelected(variation),"unselected":function($event){return _vm.variationUnselected()}},model:{value:(_vm.value.variation),callback:function ($$v) {_vm.$set(_vm.value, "variation", $$v)},expression:"value.variation"}}):_vm._e(),(_vm.value.is_pagebreak)?[_vm._v(" Saut de page ")]:_c('k-form-editor',{attrs:{"name":_vm.getInputName('designation'),"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}}),(_vm.value.product && _vm.teamConfigs.provider_command_update_product_price && _vm.teamConfigs.provider_command_update_product_costs)?_c('b-row',{staticClass:"my-1"},[_c('b-col'),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Coûts divers unitaire","label-class":"small","size":"sm"}},[_c('b-input-group',{attrs:{"append":"€","size":"sm"}},[_c('k-form-number',{attrs:{"name":_vm.getInputName('various_costs'),"noDefaultValue":"","min":0,"maxDecimal":5,"size":"sm"},on:{"input":function($event){return _vm.variousCostsUpdated()}},model:{value:(_vm.value.various_costs),callback:function ($$v) {_vm.$set(_vm.value, "various_costs", $$v)},expression:"value.various_costs"}})],1)],1)],1)],1):_vm._e(),(_vm.value.product && _vm.value.product.stock_tracking_mode !== 0 && _vm.value.lots?.length > 0)?[(_vm.value.product.stock_tracking_mode === 1)?_c('table',{staticClass:"table table-sm table-bordered mb-1 mt-3"},[_vm._m(0),_c('tbody',_vm._l((_vm.value.lots),function(lot,index){return _c('tr',{key:'old-' + index},[_c('td',[_vm._v(_vm._s(lot.reference))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.expire_at)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(lot.quantity)))])])}),0)]):(_vm.value.product.stock_tracking_mode === 2)?_c('table',{staticClass:"table table-sm table-bordered mb-1 mt-3"},[_vm._m(1),_c('tbody',_vm._l((_vm.value.lots),function(lot,index){return _c('tr',{key:'old-' + index},[_c('td',[_vm._v(" "+_vm._s(lot.reference)+" ")])])}),0)]):_vm._e()]:_vm._e()],2),(!_vm.value.is_comments && !_vm.value.is_pagebreak)?_c('td',[_c('b-input-group',{attrs:{"append":"€","size":"sm"}},[_c('k-form-number',{attrs:{"name":_vm.getInputName('unit_price_ht'),"size":"sm","max-decimal":5,"disabled":_vm.contentIsDisabled},on:{"change":function($event){return _vm.calculLinePrices()}},model:{value:(_vm.value.unit_price_ht),callback:function ($$v) {_vm.$set(_vm.value, "unit_price_ht", $$v)},expression:"value.unit_price_ht"}})],1)],1):_vm._e(),(!_vm.value.is_comments && !_vm.value.is_pagebreak)?_c('td',[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('vat_rate')},domProps:{"value":_vm.value.vat_rate ? _vm.value.vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"size":"sm","selectDefault":""},on:{"input":function($event){return _vm.calculLinePrices()}},model:{value:(_vm.value.vat_rate),callback:function ($$v) {_vm.$set(_vm.value, "vat_rate", $$v)},expression:"value.vat_rate"}})],1):_vm._e(),(!_vm.value.is_comments && !_vm.value.is_pagebreak)?_c('td',{staticClass:"text-center"},[_c('k-form-spinner',{attrs:{"name":_vm.getInputName('quantity'),"size":"sm","max-decimal":5,"min":_vm.usedLotQuantities},on:{"input":function($event){return _vm.calculLinePrices()}},model:{value:(_vm.value.quantity),callback:function ($$v) {_vm.$set(_vm.value, "quantity", $$v)},expression:"value.quantity"}}),(_vm.command.options.units)?_c('UnitSelect',{staticClass:"mt-2",attrs:{"name":_vm.getInputName('unit'),"reduce":opt => opt.label,"size":"sm"},model:{value:(_vm.value.unit),callback:function ($$v) {_vm.$set(_vm.value, "unit", $$v)},expression:"value.unit"}}):_vm._e(),(_vm.value.product && _vm.value.product.with_stock)?_c('ProductStockIndicator',{staticClass:"mt-1",attrs:{"product":_vm.value.product,"variation":_vm.value.variation,"location":_vm.command.stock_location}}):_vm._e()],1):_vm._e(),(!_vm.value.is_comments && !_vm.value.is_pagebreak)?_c('td',[_c('b-input-group',{attrs:{"append":"€","size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","disabled":_vm.contentIsDisabled},on:{"change":function($event){return _vm.calculLineTotals()}},model:{value:(_vm.value.total_ht),callback:function ($$v) {_vm.$set(_vm.value, "total_ht", $$v)},expression:"value.total_ht"}})],1)],1):_vm._e(),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.value.id && _vm.value.lots && _vm.value.lots.length > 0 ? _vm.$t('catalog.command.form.cantDeleteLine') : null }),expression:"{ title: value.id && value.lots && value.lots.length > 0 ? $t('catalog.command.form.cantDeleteLine') : null }"}]},[(_vm.value.id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('id')},domProps:{"value":_vm.value.id}}):_vm._e(),(_vm.value.product)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('product')},domProps:{"value":_vm.value.product.id}}):_vm._e(),(_vm.value.variation)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('variation')},domProps:{"value":_vm.value.variation.id}}):_vm._e(),(_vm.value.is_comments)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_comments')},domProps:{"value":true}}):_vm._e(),(_vm.value.is_pagebreak)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_pagebreak')},domProps:{"value":true}}):_vm._e(),_c('b-button',{staticClass:"p-0 text-danger",attrs:{"variant":"icon","disabled":_vm.value.id && _vm.value.lots && _vm.value.lots.length > 0},on:{"click":_vm.deleteLine}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1),_c('LineMenu',{attrs:{"line":_vm.value,"catalogOnly":_vm.catalogOnly,"catalogInclude":_vm.catalogInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogFilters},on:{"add":event => _vm.$emit('addSubLine', event)}})],1)])
}
var Contentvue_type_template_id_2e2db81c_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("N° de lot")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"180px"}},[_vm._v("Date d'expiration")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"180px"}},[_vm._v("Quantité dans le lot")])])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v(" N° de série ")])])])
}]


;// ./src/components/CommandForm/Content/Content.vue?vue&type=template&id=2e2db81c

// EXTERNAL MODULE: external "froala-editor"
var external_froala_editor_ = __webpack_require__(189);
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_);
;// ./src/components/CommandForm/editorConfig.ts

var buttons = [
    'bold',
    'italic',
    'underline',
    '|',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    '|',
    'fontSize',
    '|',
    'textColor',
    'backgroundColor',
    '|',
    'formatUL',
    'formatOL'
];
var moreMisc = {
    buttons: ['undo', 'redo', 'html'],
    align: 'right',
    buttonsVisible: 0
};
var config = {
    enter: (external_froala_editor_default()).ENTER_BR,
    fontSizeUnit: 'pt',
    listAdvancedTypes: false,
    quickInsertEnabled: false,
    wordCounterCount: false,
    pasteDeniedAttrs: ['class', 'id'],
    pastePlain: false,
    htmlAllowedStyleProps: ['font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color'],
    htmlRemoveTags: ['script', 'style'],
    toolbarButtonsXS: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 0,
        }
    },
    toolbarButtonsSM: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 4,
        }
    },
    toolbarButtonsMD: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 5,
        }
    },
    toolbarButtons: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 12
        },
        moreMisc: moreMisc
    },
    events: {
        'paste.afterCleanup': function (content) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var tbody = this.$el.closest('tbody');
            if (tbody.length > 0 && tbody[0].classList.contains('dragging')) {
                return '';
            }
            return content;
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandForm/Content/Content.ts?vue&type=script&lang=ts&external












var Content = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Content, _super);
    function Content() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig;
        return _this;
    }
    Object.defineProperty(Content.prototype, "contentIsDisabled", {
        // Check if the content has a product with variation & if the variation is selected
        get: function () {
            if (!this.value.product) {
                return false;
            }
            return this.value.product.variations_length > 0 && (this.value.variation === undefined || this.value.variation === null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Content.prototype, "usedLotQuantities", {
        get: function () {
            var _a;
            var content = this.value;
            if (!content.product || content.product.stock_tracking_mode === 0 || !content.lots || ((_a = content.lots) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return null;
            }
            return sumBy_default()(content.lots, function (lot) { return lot.quantity; });
        },
        enumerable: false,
        configurable: true
    });
    Content.prototype.getInputName = function (name) {
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        return 'contents[' + this.index + '][' + name + ']';
    };
    Content.prototype.variationSelected = function (variation) {
        var _a;
        var content = this.value;
        content.reference = (_a = variation.provider_reference) !== null && _a !== void 0 ? _a : variation.reference;
        content.unit_price_ht = variation.buy_price_ht;
        this.calculLinePrices();
    };
    Content.prototype.variationUnselected = function () {
        var content = this.value;
        content.reference = null;
        content.unit_price_ht = 0;
        this.calculLinePrices();
    };
    Content.prototype.calculLinePrices = function () {
        var _a, _b;
        var content = this.value;
        content.total_ht = this.roundNumber(this.number(content.unit_price_ht) * this.number(content.quantity), 2);
        content.total_tva = this.roundNumber(content.total_ht * ((_b = (_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : 0) / 100, 2);
        content.total_ttc = this.roundNumber(content.total_ht + content.total_tva, 2);
        this.variousCostsUpdated();
    };
    Content.prototype.calculLineTotals = function () {
        var content = this.value;
        content.unit_price_ht = this.roundNumber(this.number(content.total_ht) / this.number(content.quantity), 5);
    };
    Content.prototype.variousCostsUpdated = function () {
        var _this = this;
        var content = this.value;
        if (content.product && this.teamConfigs.provider_command_update_product_price && this.teamConfigs.provider_command_update_product_costs) {
            content.total_various_costs = this.roundNumber(this.number(content.various_costs) * this.number(content.quantity), 5);
            this.command.various_costs = sumBy_default()(this.command.contents, function (content) { return _this.number(content.total_various_costs); });
        }
    };
    Content.prototype.deleteLine = function () {
        this.$emit('deleteLine');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], Content.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], Content.prototype, "command", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Content.prototype, "index", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Content.prototype, "catalogOnly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Content.prototype, "catalogInclude", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Content.prototype, "catalogDisabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Content.prototype, "catalogFilters", void 0);
    Content = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton,
                KFormSpinner: form_vue_.KFormSpinner, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                ProductVariationSelect: ProductVariationSelect/* default */.A,
                ProductStockIndicator: ProductStockIndicator/* default */.A,
                LineMenu: LineMenu_LineMenu,
                VatRateSelect: interface_vue_.VatRateSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], Content);
    return Content;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var Contentvue_type_script_lang_ts_external = (Content);

;// ./src/components/CommandForm/Content/Content.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Content_Contentvue_type_script_lang_ts_external = (Contentvue_type_script_lang_ts_external); 
;// ./src/components/CommandForm/Content/Content.vue





/* normalize component */
;
var Content_component = (0,componentNormalizer/* default */.A)(
  Content_Contentvue_type_script_lang_ts_external,
  Contentvue_type_template_id_2e2db81c_render,
  Contentvue_type_template_id_2e2db81c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Content_Content = (Content_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandForm/Comment/Comment.vue?vue&type=template&id=11b7c17b
var Commentvue_type_template_id_11b7c17b_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[(_vm.command.contents.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',{class:{
      'text-center p-3': _vm.value.is_pagebreak,
      'text-wrap': true
    },attrs:{"colspan":"6"}},[_c('k-form-editor',{attrs:{"name":_vm.getInputName('designation'),"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.value.designation),callback:function ($$v) {_vm.$set(_vm.value, "designation", $$v)},expression:"value.designation"}})],1),_c('td',[(_vm.value.id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('id')},domProps:{"value":_vm.value.id}}):_vm._e(),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_comments')},domProps:{"value":true}}),_c('b-button',{staticClass:"p-0 text-danger",attrs:{"variant":"icon","disabled":_vm.value.id && _vm.value.lots && _vm.value.lots.length > 0},on:{"click":_vm.deleteLine}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1),_c('LineMenu',{attrs:{"line":_vm.value,"catalogOnly":_vm.catalogOnly,"catalogInclude":_vm.catalogInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogFilters},on:{"add":event => _vm.$emit('addSubLine', event)}})],1)])
}
var Commentvue_type_template_id_11b7c17b_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandForm/Comment/Comment.ts?vue&type=script&lang=ts&external








var Comment = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig;
        return _this;
    }
    Comment.prototype.getInputName = function (name) {
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        return 'contents[' + this.index + '][' + name + ']';
    };
    Comment.prototype.deleteLine = function () {
        this.$emit('deleteLine');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], Comment.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], Comment.prototype, "command", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Comment.prototype, "index", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Comment.prototype, "catalogOnly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Comment.prototype, "catalogInclude", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Comment.prototype, "catalogDisabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Comment.prototype, "catalogFilters", void 0);
    Comment = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                LineMenu: LineMenu_LineMenu,
                KFormEditor: form_vue_.KFormEditor
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], Comment);
    return Comment;
}(lib/* Vue */.lD));
/* harmony default export */ var Commentvue_type_script_lang_ts_external = (Comment);

;// ./src/components/CommandForm/Comment/Comment.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Comment_Commentvue_type_script_lang_ts_external = (Commentvue_type_script_lang_ts_external); 
;// ./src/components/CommandForm/Comment/Comment.vue





/* normalize component */
;
var Comment_component = (0,componentNormalizer/* default */.A)(
  Comment_Commentvue_type_script_lang_ts_external,
  Commentvue_type_template_id_11b7c17b_render,
  Commentvue_type_template_id_11b7c17b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Comment_Comment = (Comment_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandForm/PageBreak/PageBreak.vue?vue&type=template&id=fdd6ac1a
var PageBreakvue_type_template_id_fdd6ac1a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[(_vm.command.contents.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e()],1),_c('td',{staticClass:"text-center p-3 text-wrap",attrs:{"colspan":"6"}},[_vm._v(" Saut de page ")]),_c('td',[(_vm.value.id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('id')},domProps:{"value":_vm.value.id}}):_vm._e(),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName('is_pagebreak')},domProps:{"value":true}}),_c('b-button',{staticClass:"p-0 text-danger",attrs:{"variant":"icon","disabled":_vm.value.id && _vm.value.lots && _vm.value.lots.length > 0},on:{"click":_vm.deleteLine}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1),_c('LineMenu',{attrs:{"line":_vm.value,"catalogOnly":_vm.catalogOnly,"catalogInclude":_vm.catalogInclude,"catalogDisabled":!_vm.teamConfigs.provider_command_all_products && _vm.command.provider === null,"catalogFilters":_vm.catalogFilters},on:{"add":event => _vm.$emit('addSubLine', event)}})],1)])
}
var PageBreakvue_type_template_id_fdd6ac1a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandForm/PageBreak/PageBreak.ts?vue&type=script&lang=ts&external






var PageBreak = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PageBreak, _super);
    function PageBreak() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageBreak.prototype.getInputName = function (name) {
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        return 'contents[' + this.index + '][' + name + ']';
    };
    PageBreak.prototype.deleteLine = function () {
        this.$emit('deleteLine');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], PageBreak.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return ({}); } })
    ], PageBreak.prototype, "command", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PageBreak.prototype, "index", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageBreak.prototype, "catalogOnly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageBreak.prototype, "catalogInclude", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PageBreak.prototype, "catalogDisabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageBreak.prototype, "catalogFilters", void 0);
    PageBreak = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                LineMenu: LineMenu_LineMenu
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], PageBreak);
    return PageBreak;
}(lib/* Vue */.lD));
/* harmony default export */ var PageBreakvue_type_script_lang_ts_external = (PageBreak);

;// ./src/components/CommandForm/PageBreak/PageBreak.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PageBreak_PageBreakvue_type_script_lang_ts_external = (PageBreakvue_type_script_lang_ts_external); 
;// ./src/components/CommandForm/PageBreak/PageBreak.vue





/* normalize component */
;
var PageBreak_component = (0,componentNormalizer/* default */.A)(
  PageBreak_PageBreakvue_type_script_lang_ts_external,
  PageBreakvue_type_template_id_fdd6ac1a_render,
  PageBreakvue_type_template_id_fdd6ac1a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PageBreak_PageBreak = (PageBreak_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandForm/CommandForm.ts?vue&type=script&lang=ts&external




















var CommandForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandForm, _super);
    function CommandForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rightSidebar = true;
        _this.loading = false;
        _this.command = {
            provider: null,
            contact: null,
            contents: [],
            options: {},
            status: 0,
            stock_location: null,
            payment_term: null
        };
        _this.address = {
            road1: null,
            road2: null,
            road3: null,
            postal_code: null,
            town: null,
            country: null
        };
        return _this;
    }
    CommandForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.rightSidebar = !(localStorage.getItem('sales-form-right-sidebar') !== 'true');
                        this.setSidebarMode();
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadPdfModels()];
                    case 2:
                        _a.sent();
                        this.watchValue(this.value);
                        this.watchStockLocation();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CommandForm.prototype.beforeDestroy = function () {
        this.setDynamicAppClass(null);
    };
    Object.defineProperty(CommandForm.prototype, "catalogSearchFilters", {
        get: function () {
            var _a, _b;
            var filters = {};
            if (!this.teamConfigs.provider_command_all_products) {
                filters.providers = (_b = (_a = this.command.provider) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "catalogSearchInclude", {
        get: function () {
            var include = {
                product: ['unit', 'vat_rate', 'variation_levels', 'providers_references', 'stockLocations']
            };
            if (this.hasModule('catalog-groups') && this.teamConfigs.provider_command_all_products) {
                include.group = ['unit', 'vat_rate'];
            }
            return include;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "catalogSearchOnly", {
        get: function () {
            var only = ['product'];
            if (this.hasModule('catalog-groups') && this.teamConfigs.provider_command_all_products) {
                only.push('group');
            }
            return only;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "pageTitle", {
        // Return page title
        get: function () {
            return this.$t('catalog.command.' + (this.command.id ? 'edit' : 'add') + 'Title');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "formUrl", {
        // Return form url
        get: function () {
            return '/catalog/command' + (this.command.id ? '/' + this.command.id : '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "formMethod", {
        // Return form method
        get: function () {
            return this.command.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "pdfModelApiUrl", {
        // Return url to get pdf models list
        get: function () {
            return '/sales/pdf_model?sort=label';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "hasProductWithTracability", {
        // Check if the command has a product with stock management & tracability
        get: function () {
            return this.command.contents.find(function (content) { return content.product && content.product.stock_tracking_mode !== 0; }) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "contentIsDisabled", {
        // Check if the content has a product with variation & if the variation is selected
        get: function () {
            return function (content) {
                if (!content.product) {
                    return false;
                }
                return content.product.variations_length > 0 && (content.variation === undefined || content.variation === null);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommandForm.prototype, "usedLotQuantities", {
        get: function () {
            return function (content) {
                var _a;
                if (!content.product || content.product.stock_tracking_mode === 0 || !content.lots || ((_a = content.lots) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    return null;
                }
                return sumBy_default()(content.lots, function (lot) { return lot.quantity; });
            };
        },
        enumerable: false,
        configurable: true
    });
    CommandForm.prototype.watchValue = function (value) {
        if (value) {
            this.command = JSON.parse(JSON.stringify(value));
            this.setAddress(this.command);
        }
        else {
            this.setDefaultValue();
        }
    };
    CommandForm.prototype.watchStockLocation = function () {
        var location = this.command.stock_location;
        if (location && (location.postal_code || location.town)) {
            this.address = location;
        }
    };
    CommandForm.prototype.changeSidebarMode = function () {
        this.rightSidebar = !this.rightSidebar;
        this.setSidebarMode();
    };
    CommandForm.prototype.setSidebarMode = function () {
        localStorage.setItem('command-form-right-sidebar', String(this.rightSidebar));
        this.setDynamicAppClass({
            'command-form-sidebar': this.rightSidebar,
            'command-form-bottombar': !this.rightSidebar
        });
    };
    CommandForm.prototype.setDefaultValue = function () {
        var config = this.teamConfigs;
        this.command = {
            date: new Date(),
            provider: null,
            contact: null,
            contents: [],
            total_ht: 0,
            total_tva: 0,
            total_ttc: 0,
            status: config.provider_command_default_status,
            pdf_model: this.defaultPdfModel('provider_command'),
            options: {
                not_show_price: config.provider_command_not_show_price,
                contact: config.provider_command_contact,
                reference_column: config.provider_command_reference_column,
                units: config.provider_command_units
            }
        };
        if (config.provider_command_delivery_address_road1 || config.provider_command_delivery_address_road2 ||
            config.provider_command_delivery_address_road3 || config.provider_command_delivery_address_postal_code ||
            config.provider_command_delivery_address_town) {
            this.address = {
                road1: config.provider_command_delivery_address_road1,
                road2: config.provider_command_delivery_address_road2,
                road3: config.provider_command_delivery_address_road3,
                postal_code: config.provider_command_delivery_address_postal_code,
                town: config.provider_command_delivery_address_town,
                country: config.provider_command_delivery_address_country
            };
        }
        else {
            this.setAddress(this.team);
        }
    };
    CommandForm.prototype.setAddress = function (element) {
        this.address = {
            road1: element.road1,
            road2: element.road2,
            road3: element.road3,
            postal_code: element.postal_code,
            town: element.town,
            country: element.country
        };
    };
    CommandForm.prototype.onProviderChange = function () {
        var _a;
        this.command.contact = null;
        if (!this.teamConfigs.provider_command_all_products) {
            this.command.contents = this.command.contents.filter(function (content) {
                return content.product === null || content.product === undefined;
            });
        }
        var configs = (_a = this.command.provider) === null || _a === void 0 ? void 0 : _a.configs;
        if (configs === null || configs === void 0 ? void 0 : configs.charges_payment_term) {
            this.command.payment_term = configs === null || configs === void 0 ? void 0 : configs.charges_payment_term;
        }
        if (configs === null || configs === void 0 ? void 0 : configs.charges_vat_rate) {
            this.command.contents.forEach(function (content) {
                return content.vat_rate = configs === null || configs === void 0 ? void 0 : configs.charges_vat_rate;
            });
        }
    };
    CommandForm.prototype.calculLinePrices = function (i) {
        var _a, _b;
        var content = this.command.contents[i];
        content.total_ht = this.roundNumber(this.number(content.unit_price_ht) * this.number(content.quantity), 2);
        content.total_tva = this.roundNumber(content.total_ht * ((_b = (_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : 0) / 100, 2);
        content.total_ttc = this.roundNumber(content.total_ht + content.total_tva, 2);
        this.variousCostsUpdated(i);
    };
    CommandForm.prototype.calculTotals = function () {
        var _this = this;
        var rates = [];
        this.command.contents.forEach(function (content) {
            var _a, _b;
            var rate = rates.find(function (rate) { var _a; return rate.rate === ((_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate); });
            if (!rate) {
                rates.push({
                    rate: (_b = (_a = content.vat_rate) === null || _a === void 0 ? void 0 : _a.rate) !== null && _b !== void 0 ? _b : 0,
                    ht: Number(content.total_ht),
                    tva: 0,
                    ttc: 0
                });
            }
            else {
                rate.ht += Number(content.total_ht);
            }
        });
        rates = rates.map(function (rate) {
            rate.tva = _this.roundNumber(rate.ht * rate.rate / 100, 2);
            rate.ttc = _this.roundNumber(rate.ht + rate.tva, 2);
            return rate;
        });
        this.command.total_ht = sumBy_default()(rates, 'ht');
        this.command.total_tva = sumBy_default()(rates, 'tva');
        this.command.total_ttc = sumBy_default()(rates, 'ttc');
        this.command.various_costs = sumBy_default()(this.command.contents, function (content) {
            return _this.number(content.total_various_costs);
        });
    };
    CommandForm.prototype.addCatalogLine = function (element, index) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (index === void 0) { index = null; }
        var product = element.data;
        var providerReference = product.variations_length === 0 ? ((_a = product.providers_references.find(function (reference) { var _a, _b; return ((_a = reference.customer) === null || _a === void 0 ? void 0 : _a.id) === ((_b = _this.command.provider) === null || _b === void 0 ? void 0 : _b.id); })) !== null && _a !== void 0 ? _a : null) : null;
        this.addNewLine({
            product: product,
            reference: product.variations_length === 0 ? providerReference === null || providerReference === void 0 ? void 0 : providerReference.reference : null,
            designation: product.designation,
            unit_price_ht: product.variations_length === 0 ? Number((_b = providerReference === null || providerReference === void 0 ? void 0 : providerReference.buy_price_ht) !== null && _b !== void 0 ? _b : product.unit_buy_price_ht) : 0,
            quantity: 1,
            vat_rate: (_e = (_d = (_c = this.command.provider) === null || _c === void 0 ? void 0 : _c.configs) === null || _d === void 0 ? void 0 : _d.charges_vat_rate) !== null && _e !== void 0 ? _e : element.data.vat_rate,
            various_costs: product.various_costs && product.various_costs > 0 ? Number(product.various_costs) : null
        }, index);
        this.$nextTick(function () {
            if (_this.hasProductWithTracability && _this.command.status === 3) {
                _this.command.status = 1;
            }
        });
    };
    CommandForm.prototype.addEmptyLine = function (index) {
        var _a, _b, _c;
        if (index === void 0) { index = null; }
        this.addNewLine({
            designation: '',
            unit_price_ht: 0,
            quantity: 1,
            vat_rate: (_c = (_b = (_a = this.command.provider) === null || _a === void 0 ? void 0 : _a.configs) === null || _b === void 0 ? void 0 : _b.charges_vat_rate) !== null && _c !== void 0 ? _c : null
        }, index);
    };
    CommandForm.prototype.addCommentLine = function (index) {
        if (index === void 0) { index = null; }
        this.addNewLine({
            is_comments: true,
            designation: ''
        }, index);
    };
    CommandForm.prototype.addPageBreakLine = function (index) {
        if (index === void 0) { index = null; }
        this.addNewLine({
            is_pagebreak: true
        }, index);
    };
    CommandForm.prototype.addNewLine = function (content, index) {
        var _this = this;
        if (index === void 0) { index = null; }
        if (index !== null) {
            this.command.contents.splice(index, 0, content);
        }
        else {
            this.command.contents.push(content);
            index = this.command.contents.length - 1;
        }
        this.$nextTick(function () {
            _this.calculLinePrices(index);
        });
    };
    CommandForm.prototype.deleteLine = function (i) {
        lib/* Vue */.lD.delete(this.command.contents, i);
    };
    CommandForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var command;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        command = response.data;
                        this.setPageParams(command);
                        return [4 /*yield*/, this.$router.push({
                                name: 'stock-command-item',
                                params: {
                                    id: String(command.id)
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommandForm.prototype.variousCostsUpdated = function (index) {
        var _this = this;
        var content = this.command.contents[index];
        if (content.product && this.teamConfigs.provider_command_update_product_price && this.teamConfigs.provider_command_update_product_costs) {
            content.total_various_costs = this.roundNumber(this.number(content.various_costs) * this.number(content.quantity), 5);
            this.command.various_costs = sumBy_default()(this.command.contents, function (content) { return _this.number(content.total_various_costs); });
        }
    };
    CommandForm.prototype.applyGlobalCosts = function () {
        var _this = this;
        var totalCosts = this.number(this.command.various_costs);
        var totalCommand = this.number(this.command.total_ht);
        this.command.contents.forEach(function (content) {
            if (content.is_comments || content.is_pagebreak) {
                return;
            }
            var pourcentage = totalCommand > 0 ? _this.number(content.total_ht) / _this.number(_this.command.total_ht) : 0;
            var total = _this.roundNumber(totalCosts * pourcentage, 5);
            content.various_costs = _this.roundNumber(total / _this.number(content.quantity), 5);
            content.total_various_costs = _this.roundNumber(_this.number(content.various_costs) * _this.number(content.quantity), 5);
        });
    };
    CommandForm.prototype.startDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.add('dragging');
    };
    CommandForm.prototype.stopDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.remove('dragging');
    };
    CommandForm.prototype.addSubLine = function (index, event) {
        var newIndex = index;
        if (event.position === 'bottom') {
            newIndex++;
        }
        var content;
        switch (event.type) {
            case 'empty':
                this.addEmptyLine(newIndex);
                break;
            case 'comments':
                this.addCommentLine(newIndex);
                break;
            case 'pagebreak':
                this.addPageBreakLine(newIndex);
                break;
            case 'catalog':
                this.addCatalogLine(event.catalog, newIndex);
                break;
            case 'clone':
                if (this.command.contents[index]) {
                    content = JSON.parse(JSON.stringify(this.command.contents[index]));
                    delete content.id;
                    this.addNewLine(content, newIndex);
                }
                break;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommandForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], CommandForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('command.stock_location')
    ], CommandForm.prototype, "watchStockLocation", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('command.contents', { deep: true })
    ], CommandForm.prototype, "calculTotals", null);
    CommandForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, UnitSelect: interface_vue_.UnitSelect, VatRateSelect: interface_vue_.VatRateSelect, CurrencySelect: interface_vue_.CurrencySelect, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages, PaymentTermSelect: interface_vue_.PaymentTermSelect,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                CatalogSearch: CatalogSearch/* default */.A,
                ProductVariationSelect: ProductVariationSelect/* default */.A,
                StockLocationSelect: StockLocationSelect/* default */.A,
                ProductStockIndicator: ProductStockIndicator/* default */.A,
                LineMenu: LineMenu_LineMenu,
                Content: Content_Content,
                PageBreak: PageBreak_PageBreak,
                Comment: Comment_Comment,
                PdfModelSelect: sales_vue_namespaceObject.PdfModelSelect,
                draggable: (vuedraggable_umd_default()),
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormAddress: form_vue_.KFormAddress, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormTextarea: form_vue_.KFormTextarea, KFormCheckbox: form_vue_.KFormCheckbox, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BFormRow: external_bootstrap_vue_.BFormRow, BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton, BFormRadio: external_bootstrap_vue_.BFormRadio, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BButtonGroup: external_bootstrap_vue_.BButtonGroup
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['team', 'teamConfigs'])), (0,external_vuex_.mapState)('app', ['fullscreenMode'])), (0,external_vuex_.mapGetters)('sales', ['defaultPdfModel'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])), (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['setFullscreenMode', 'setDynamicAppClass', 'setPageParams'])), (0,external_vuex_.mapActions)('sales', ['loadPdfModels']))
        })
    ], CommandForm);
    return CommandForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var CommandFormvue_type_script_lang_ts_external = (CommandForm);

;// ./src/components/CommandForm/CommandForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandForm_CommandFormvue_type_script_lang_ts_external = (CommandFormvue_type_script_lang_ts_external); 
;// ./src/components/CommandForm/CommandForm.vue





/* normalize component */
;
var CommandForm_component = (0,componentNormalizer/* default */.A)(
  CommandForm_CommandFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandForm_CommandForm = (CommandForm_component.exports);

/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 8223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 8252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CatalogParams_CatalogParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CatalogParams/CatalogParams.vue?vue&type=template&id=3d330cec
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"form-catalog-params",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.params.hourlyPersonCost'),"description":_vm.$t('catalog.params.hourlyPersonCostExplain')}},[_c('k-form-number',{staticStyle:{"max-width":"200px"},attrs:{"name":"configs[average_hourly_person_cost]","append":_vm.currency.symbol},model:{value:(_vm.localConfig.average_hourly_person_cost),callback:function ($$v) {_vm.$set(_vm.localConfig, "average_hourly_person_cost", $$v)},expression:"localConfig.average_hourly_person_cost"}})],1),(_vm.hasModule('stock'))?_c('b-form-group',{attrs:{"label":_vm.$t('catalog.params.activeStockDefault')}},[_c('b-form-radio-group',{attrs:{"name":"configs[stock_new_product_state]","size":"sm"},model:{value:(_vm.localConfig.stock_new_product_state),callback:function ($$v) {_vm.$set(_vm.localConfig, "stock_new_product_state", $$v)},expression:"localConfig.stock_new_product_state"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1):_vm._e(),_c('p',{staticClass:"mt-4 mb-0"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],1)],1),_c('h3',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('catalog.params.referenceTitle')))]),_c('b-card',[_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm.$t('catalog.params.referenceExplain'))+" ")]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table w-auto table-references text-nowrap"},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th'),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.params.referenceManual')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('catalog.product.label'))+" :")]),_c('td',[_c('b-form-radio-group',{attrs:{"name":"configs[product_reference_manual]","size":"sm"},model:{value:(_vm.localConfig.product_reference_manual),callback:function ($$v) {_vm.$set(_vm.localConfig, "product_reference_manual", $$v)},expression:"localConfig.product_reference_manual"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[product_reference_prefix]","required":"","max":"10","size":"sm","disabled":_vm.localConfig.product_reference_manual},model:{value:(_vm.localConfig.product_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "product_reference_prefix", $$v)},expression:"localConfig.product_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[product_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.product_reference_manual},model:{value:(_vm.localConfig.product_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "product_reference_number", $$v)},expression:"localConfig.product_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[product_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm","disabled":_vm.localConfig.product_reference_manual},model:{value:(_vm.localConfig.product_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "product_reference_length", $$v)},expression:"localConfig.product_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.productReferenceExample))])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('catalog.service.label'))+" :")]),_c('td',[_c('b-form-radio-group',{attrs:{"name":"configs[service_reference_manual]","size":"sm"},model:{value:(_vm.localConfig.service_reference_manual),callback:function ($$v) {_vm.$set(_vm.localConfig, "service_reference_manual", $$v)},expression:"localConfig.service_reference_manual"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[service_reference_prefix]","required":"","max":"10","size":"sm","disabled":_vm.localConfig.service_reference_manual},model:{value:(_vm.localConfig.service_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "service_reference_prefix", $$v)},expression:"localConfig.service_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[service_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.service_reference_manual},model:{value:(_vm.localConfig.service_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "service_reference_number", $$v)},expression:"localConfig.service_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[service_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm","disabled":_vm.localConfig.service_reference_manual},model:{value:(_vm.localConfig.service_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "service_reference_length", $$v)},expression:"localConfig.service_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.serviceReferenceExample))])]),(_vm.hasModule('catalog-groups'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('catalog.group.label'))+" :")]),_c('td',[_c('b-form-radio-group',{attrs:{"name":"configs[group_reference_manual]","size":"sm"},model:{value:(_vm.localConfig.group_reference_manual),callback:function ($$v) {_vm.$set(_vm.localConfig, "group_reference_manual", $$v)},expression:"localConfig.group_reference_manual"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[group_reference_prefix]","required":"","max":"10","size":"sm","disabled":_vm.localConfig.group_reference_manual},model:{value:(_vm.localConfig.group_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "group_reference_prefix", $$v)},expression:"localConfig.group_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[group_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.group_reference_manual},model:{value:(_vm.localConfig.group_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "group_reference_number", $$v)},expression:"localConfig.group_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[group_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm","disabled":_vm.localConfig.group_reference_manual},model:{value:(_vm.localConfig.group_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "group_reference_length", $$v)},expression:"localConfig.group_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.groupReferenceExample))])]):_vm._e()])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)])])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CatalogParams/CatalogParams.ts?vue&type=script&lang=ts&external






var CatalogParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogParams, _super);
    function CatalogParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    CatalogParams.prototype.pad = function (number, length) {
        if (!length) {
            return;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    Object.defineProperty(CatalogParams.prototype, "productReferenceExample", {
        get: function () {
            var number = this.pad(this.localConfig.product_reference_number, this.localConfig.product_reference_length);
            return this.localConfig.product_reference_prefix + number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogParams.prototype, "serviceReferenceExample", {
        get: function () {
            var number = this.pad(this.localConfig.service_reference_number, this.localConfig.service_reference_length);
            return this.localConfig.service_reference_prefix + number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogParams.prototype, "groupReferenceExample", {
        get: function () {
            var number = this.pad(this.localConfig.group_reference_number, this.localConfig.group_reference_length);
            return this.localConfig.group_reference_prefix + number;
        },
        enumerable: false,
        configurable: true
    });
    CatalogParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormNumber: form_vue_.KFormNumber, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect,
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], CatalogParams);
    return CatalogParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CatalogParamsvue_type_script_lang_ts_external = (CatalogParams);

;// ./src/components/CatalogParams/CatalogParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CatalogParams_CatalogParamsvue_type_script_lang_ts_external = (CatalogParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CatalogParams/CatalogParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CatalogParams_CatalogParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CatalogParams_CatalogParams = (component.exports);

/***/ }),

/***/ 8282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProductVariationListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProductVariationListView.vue?vue&type=template&id=4d043942
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductVariationList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProductVariationList/ProductVariationList.vue + 3 modules
var ProductVariationList = __webpack_require__(9466);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProductVariationListView.vue?vue&type=script&lang=ts



var ProductVariationListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariationListView, _super);
    function ProductVariationListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductVariationListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProductVariationList: ProductVariationList/* default */.A
            }
        })
    ], ProductVariationListView);
    return ProductVariationListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductVariationListViewvue_type_script_lang_ts = (ProductVariationListView);

;// ./src/views/ProductVariationListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProductVariationListViewvue_type_script_lang_ts = (ProductVariationListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProductVariationListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProductVariationListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProductVariationListView = (component.exports);

/***/ }),

/***/ 8290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ManualMovementListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ManualMovementListView.vue?vue&type=template&id=46c3ca20
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ManualMovementList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ManualMovementList/ManualMovementList.vue + 3 modules
var ManualMovementList = __webpack_require__(6777);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ManualMovementListView.vue?vue&type=script&lang=ts



var ManualMovementListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ManualMovementListView, _super);
    function ManualMovementListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManualMovementListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ManualMovementList: ManualMovementList/* default */.A
            }
        })
    ], ManualMovementListView);
    return ManualMovementListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ManualMovementListViewvue_type_script_lang_ts = (ManualMovementListView);

;// ./src/views/ManualMovementListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ManualMovementListViewvue_type_script_lang_ts = (ManualMovementListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ManualMovementListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ManualMovementListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ManualMovementListView = (component.exports);

/***/ }),

/***/ 8303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 8327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CatalogParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CatalogParamsView.vue?vue&type=template&id=b39f9dde
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Params')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CatalogParams/CatalogParams.vue + 3 modules
var CatalogParams = __webpack_require__(8252);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CatalogParamsView.vue?vue&type=script&lang=ts



var CatalogParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogParamsView, _super);
    function CatalogParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Params: CatalogParams/* default */.A
            }
        })
    ], CatalogParamsView);
    return CatalogParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var CatalogParamsViewvue_type_script_lang_ts = (CatalogParamsView);

;// ./src/views/CatalogParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CatalogParamsViewvue_type_script_lang_ts = (CatalogParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CatalogParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CatalogParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CatalogParamsView = (component.exports);

/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 8655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 8674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommandDelete_CommandDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommandDelete/CommandDelete.vue?vue&type=template&id=6407dab8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'delete')),"ok-only":_vm.errorMsg !== null,"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.command.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommandDelete/CommandDelete.ts?vue&type=script&lang=ts&external



var CommandDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommandDelete, _super);
    function CommandDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    CommandDelete.prototype.mounted = function () {
        this.watchValue(this.value);
    };
    CommandDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
        this.errorMsg = null;
    };
    CommandDelete.prototype.onCancel = function () {
        this.errorMsg = null;
        return null;
    };
    CommandDelete.prototype.onOk = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.errorMsg !== null) {
                            this.onCancel();
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.$emit('deleted');
                                _this.showModal = false;
                            })
                                .catch(function (error) {
                                if (error.response.status === 422) {
                                    _this.errorMsg = error.response.data.message;
                                }
                                else {
                                    throw new Error(error);
                                }
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommandDelete.prototype, "apiUrl", {
        get: function () {
            return '/catalog/command/' + this.value;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommandDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], CommandDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CommandDelete.prototype, "onCancel", null);
    CommandDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CommandDelete);
    return CommandDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CommandDeletevue_type_script_lang_ts_external = (CommandDelete);

;// ./src/components/CommandDelete/CommandDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommandDelete_CommandDeletevue_type_script_lang_ts_external = (CommandDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommandDelete/CommandDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommandDelete_CommandDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommandDelete_CommandDelete = (component.exports);

/***/ }),

/***/ 8699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SaleCategoryListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleCategoryListView.vue?vue&type=template&id=0f72b040
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SaleCategoryList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SaleCategoryList/SaleCategoryList.vue + 3 modules
var SaleCategoryList = __webpack_require__(2812);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SaleCategoryListView.vue?vue&type=script&lang=ts



var SaleCategoryListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SaleCategoryListView, _super);
    function SaleCategoryListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaleCategoryListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SaleCategoryList: SaleCategoryList/* default */.A
            }
        })
    ], SaleCategoryListView);
    return SaleCategoryListView;
}(lib/* Vue */.lD));
/* harmony default export */ var SaleCategoryListViewvue_type_script_lang_ts = (SaleCategoryListView);

;// ./src/views/SaleCategoryListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SaleCategoryListViewvue_type_script_lang_ts = (SaleCategoryListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/SaleCategoryListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SaleCategoryListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SaleCategoryListView = (component.exports);

/***/ }),

/***/ 8746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_LotListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LotListView.vue?vue&type=template&id=2369debc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LotList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/LotList/LotList.vue + 3 modules
var LotList = __webpack_require__(7666);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LotListView.vue?vue&type=script&lang=ts



var LotListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotListView, _super);
    function LotListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LotListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LotList: LotList/* default */.A
            }
        })
    ], LotListView);
    return LotListView;
}(lib/* Vue */.lD));
/* harmony default export */ var LotListViewvue_type_script_lang_ts = (LotListView);

;// ./src/views/LotListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_LotListViewvue_type_script_lang_ts = (LotListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/LotListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_LotListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_LotListView = (component.exports);

/***/ }),

/***/ 8751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LotUsed_LotUsed; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotUsed/LotUsed.vue?vue&type=template&id=340cbba0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"table table-sm table-bordered"},[_vm._m(0),_c('tbody',_vm._l((_vm.value),function(lot,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(lot.lot.product.reference))]),_c('td',[_vm._v(_vm._s(lot.lot.product.name))]),_c('td',[_vm._v(_vm._s(lot.lot.reference))]),_c('td',[_vm._v(_vm._s(lot.quantity))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("Réf. produit")]),_c('th',[_vm._v("Nom produit")]),_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Quantité")])])])
}]


;// ./src/components/LotUsed/LotUsed.vue?vue&type=template&id=340cbba0

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotUsed/LotUsed.ts?vue&type=script&lang=ts&external



var LotUsed = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotUsed, _super);
    function LotUsed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotUsed.prototype, "value", void 0);
    LotUsed = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], LotUsed);
    return LotUsed;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var LotUsedvue_type_script_lang_ts_external = (LotUsed);

;// ./src/components/LotUsed/LotUsed.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotUsed_LotUsedvue_type_script_lang_ts_external = (LotUsedvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LotUsed/LotUsed.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LotUsed_LotUsedvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotUsed_LotUsed = (component.exports);

/***/ }),

/***/ 8839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ServiceListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ServiceListView.vue?vue&type=template&id=59d2d8e8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ServiceList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ServiceList/ServiceList.vue + 3 modules
var ServiceList = __webpack_require__(4958);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ServiceListView.vue?vue&type=script&lang=ts



var ServiceListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceListView, _super);
    function ServiceListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ServiceList: ServiceList/* default */.A
            }
        })
    ], ServiceListView);
    return ServiceListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ServiceListViewvue_type_script_lang_ts = (ServiceListView);

;// ./src/views/ServiceListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ServiceListViewvue_type_script_lang_ts = (ServiceListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ServiceListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ServiceListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ServiceListView = (component.exports);

/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661),
    setCacheAdd = __webpack_require__(1380),
    setCacheHas = __webpack_require__(1459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 8879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 8980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ StockState_StockState; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StockState/StockState.vue?vue&type=template&id=5d0c5e3a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/catalog/stock/state","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"rowActions":_vm.rowActions,"stateKey":"catalog-stock-state","bordered":"","size":"sm","exportable":"productStock"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/StockState/StockState.ts?vue&type=script&lang=ts&external





var StockState = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StockState, _super);
    function StockState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    StockState.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasModule('stock-locations')) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadStockLocations()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2:
                        interface_vue_.emitter.on('productCreated', this.productCreated);
                        interface_vue_.emitter.on('productUpdated', this.productUpdated);
                        interface_vue_.emitter.on('productDeleted', this.productDeleted);
                        interface_vue_.emitter.on('stockManuaMovementCreated', this.stockManuaMovementCreated);
                        return [2 /*return*/];
                }
            });
        });
    };
    StockState.prototype.destroyed = function () {
        interface_vue_.emitter.off('productCreated', this.productCreated);
        interface_vue_.emitter.off('productUpdated', this.productUpdated);
        interface_vue_.emitter.off('productDeleted', this.productDeleted);
        interface_vue_.emitter.off('stockManuaMovementCreated', this.stockManuaMovementCreated);
    };
    Object.defineProperty(StockState.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('catalog-products', 3)) {
                actions.push.apply(actions, [
                    {
                        variant: 'icon',
                        icon: ['fas', 'plus'],
                        click: function (row) {
                            _this.newStockMovement(1, row);
                        }
                    },
                    {
                        variant: 'icon',
                        icon: ['fas', 'minus'],
                        click: function (row) {
                            _this.newStockMovement(2, row);
                        }
                    }
                ]);
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    StockState.prototype.newStockMovement = function (type, product) {
        this.openModal({
            key: 'stock-manual-form',
            value: {
                type: type,
                date: new Date(),
                contents: [
                    {
                        product_id: product.id,
                        product: product,
                        quantity: product.stock_tracking_mode === 0 ? 1 : 0,
                        lots: []
                    }
                ]
            }
        });
    };
    Object.defineProperty(StockState.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'reference',
                    name: this.$t('catalog.list.reference')
                },
                {
                    data: 'name',
                    name: this.$t('catalog.list.name')
                },
                {
                    data: 'ean_code',
                    name: this.$t('catalog.list.ean'),
                    visible: false
                },
                {
                    data: 'unit_buy_price_ht',
                    name: this.$t('catalog.list.unitBuyPriceHt'),
                    render: 'currency'
                },
                {
                    data: 'stock_quantity',
                    name: this.$t('catalog.list.stockQuantity'),
                    render: function (val) { return (0,interface_vue_.showNumber)(val); }
                },
                {
                    data: 'total_stock_ht',
                    name: this.$t('catalog.list.stockTotal'),
                    render: 'currency'
                },
                {
                    data: 'stock_theoretical_quantity',
                    name: this.$t('catalog.list.stockTheoreticalQuantity'),
                    render: 'number',
                    visible: false
                },
                {
                    data: 'total_stock_theoretical_ht',
                    name: this.$t('catalog.list.stockTheoreticalTotal'),
                    render: 'currency',
                    visible: false
                },
                {
                    data: 'providers',
                    name: this.$t('catalog.list.providers'),
                    render: function (data, row) {
                        if (row.variations_length > 0) {
                            return data ? data.map(function (customer) { return customer.name; }).join(', ') : null;
                        }
                        else {
                            return row.providers_references ? row.providers_references.map(function (reference) { var _a; return (_a = reference.customer) === null || _a === void 0 ? void 0 : _a.name; }).join(', ') : null;
                        }
                    },
                    visible: false,
                    sortable: false
                },
                {
                    data: 'providers_references',
                    name: this.$t('catalog.list.providersReferences'),
                    render: function (data) {
                        if (!data) {
                            return null;
                        }
                        return data.map(function (ref) { return ref.reference; }).join(', ');
                    },
                    sortable: false
                },
                {
                    data: 'sale_category.label',
                    name: this.$t('catalog.list.saleCategory'),
                    visible: false
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockState.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: ['providers_references', 'sale_category']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StockState.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'text',
                    label: this.$t('catalog.filters.reference'),
                    name: 'reference'
                },
                {
                    type: 'text',
                    label: this.$t('catalog.filters.name'),
                    name: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.provider'),
                    name: 'providers',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_provider]=1',
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'text',
                    label: this.$t('catalog.filters.ean'),
                    name: 'ean'
                },
                {
                    type: 'date',
                    label: 'Stock en date du',
                    name: 'date'
                },
                {
                    type: 'select',
                    label: this.$t('catalog.filters.saleCategory'),
                    name: 'sale_category',
                    multiple: true,
                    ajax: '/catalog/sale_category?sort=label',
                    optionLabel: 'label',
                    value: 'id'
                }
            ];
            if (this.hasModule('stock-locations')) {
                filters.push({
                    type: 'select',
                    label: 'Lieu de stock',
                    name: 'stock_location',
                    options: this.stockLocations,
                    value: 'id',
                    optionLabel: 'name'
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    StockState.prototype.rowLink = function (product) {
        return {
            name: 'catalog-' + (product.is_group ? 'group' : 'product') + '-item',
            params: {
                id: String(product.id)
            }
        };
    };
    StockState.prototype.productCreated = function (product) {
        if (product.with_stock) {
            var table = this.$refs.table;
            table.addRow(product);
        }
    };
    StockState.prototype.productUpdated = function (event) {
        if (!event.new.with_stock) {
            this.productDeleted(event.new);
        }
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    StockState.prototype.productDeleted = function (product) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === product.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    StockState.prototype.stockManuaMovementCreated = function () {
        this.$refs.table.refresh();
    };
    StockState = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadStockLocations'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('catalog', ['stockLocations'])),
            components: {
                KTable: table_vue_.KTable,
                PageHeader: interface_vue_.PageHeader,
                Spinner: interface_vue_.Spinner
            }
        })
    ], StockState);
    return StockState;
}(lib/* Vue */.lD));
/* harmony default export */ var StockStatevue_type_script_lang_ts_external = (StockState);

;// ./src/components/StockState/StockState.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StockState_StockStatevue_type_script_lang_ts_external = (StockStatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/StockState/StockState.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  StockState_StockStatevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StockState_StockState = (component.exports);

/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 9302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488),
    overRest = __webpack_require__(6757),
    setToString = __webpack_require__(2865);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(294),
    toKey = __webpack_require__(7797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 9328:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'window-alt';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f40f';
var svgPathData = ['M464 32H48A48 48 0 0 0 0 80v80h512V80a48 48 0 0 0-48-48zm-240 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32z', 'M320 128a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm96 0a32 32 0 1 0-32-32 32 32 0 0 0 32 32zM0 160v272a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V160z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.jA = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductItemView_ProductItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProductItemView/ProductItemView.vue?vue&type=template&id=f22f5fae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ProductItem',{on:{"reloadProduct":_vm.reloadProduct},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProductItem/ProductItem.vue + 3 modules
var ProductItem = __webpack_require__(5663);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/fetchDatas/product.ts
var product = __webpack_require__(5719);
// EXTERNAL MODULE: ./src/mixins/LoadProductMixin.ts
var LoadProductMixin = __webpack_require__(2711);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/ProductItemView/ProductItemView.ts?vue&type=script&lang=ts&external






var ProductItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductItemView, _super);
    function ProductItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductItemView.prototype.reloadProduct = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var id;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = (_a = this.product) === null || _a === void 0 ? void 0 : _a.id;
                        return [4 /*yield*/, (0,product/* fetchProduct */.yj)(id)
                                .then(function (product) {
                                _this.product = product;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProductItem: ProductItem/* default */.A,
                Spinner: interface_vue_.Spinner
            }
        })
    ], ProductItemView);
    return ProductItemView;
}((0,lib/* Mixins */.Xe)(LoadProductMixin/* default */.A)));
/* harmony default export */ var ProductItemViewvue_type_script_lang_ts_external = (ProductItemView);

;// ./src/views/ProductItemView/ProductItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductItemView_ProductItemViewvue_type_script_lang_ts_external = (ProductItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProductItemView/ProductItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductItemView_ProductItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductItemView_ProductItemView = (component.exports);

/***/ }),

/***/ 9344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'box-open';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f49e';
var svgPathData = 'M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.LJ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ProductVariationList_ProductVariationList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductVariationList/ProductVariationList.vue?vue&type=template&id=419b8865
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('catalog.productVariations.new'),"updateTitle":_vm.$t('catalog.productVariations.edit'),"deleteMsg":_vm.$t('catalog.productVariations.deleteMsg'),"deleteAlertMessage":_vm.$t('catalog.productVariations.deleteAlertMessage'),"sort":"label","extraActions":_vm.extraActions,"actionsColWidth":"125px","withTotals":false},on:{"submitted":_vm.setVariationLevel,"deleted":_vm.deleteVariationLevel}}),_c('b-modal',{attrs:{"title":_vm.$t('catalog.productVariations.valuesModalTitle'),"ok-only":"","size":"xl","ok-title":_vm.$t('interface.close')},on:{"hidden":_vm.closeModal},model:{value:(_vm.variationValuesShow),callback:function ($$v) {_vm.variationValuesShow=$$v},expression:"variationValuesShow"}},[(_vm.variationValuesShow)?_c('VariationValues',{model:{value:(_vm.variationValuesEdit),callback:function ($$v) {_vm.variationValuesEdit=$$v},expression:"variationValuesEdit"}}):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/VariationValues/VariationValues.vue + 3 modules
var VariationValues = __webpack_require__(1227);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductVariationList/ProductVariationList.ts?vue&type=script&lang=ts&external






var ProductVariationList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductVariationList, _super);
    function ProductVariationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.variationValuesEdit = null;
        _this.variationValuesShow = false;
        return _this;
    }
    Object.defineProperty(ProductVariationList.prototype, "extraActions", {
        get: function () {
            return [{
                    label: this.$t('catalog.productVariations.manageVariations'),
                    icon: ['fas', 'list'],
                    variant: 'info',
                    action: this.manageVariationValues
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('catalog.productVariations.label'),
                    key: 'label'
                },
                {
                    label: this.$t('catalog.productVariations.nbVariations'),
                    key: 'values_count',
                    hideOnForm: true,
                    class: 'd-none d-md-table-cell'
                },
                {
                    label: this.$t('catalog.productVariations.nbProducts'),
                    key: 'products_count',
                    hideOnForm: true,
                    class: 'd-none d-md-table-cell'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariationList.prototype, "apiUrl", {
        get: function () {
            return '/catalog/variation';
        },
        enumerable: false,
        configurable: true
    });
    ProductVariationList.prototype.manageVariationValues = function (variation) {
        this.variationValuesEdit = variation;
        this.variationValuesShow = true;
    };
    ProductVariationList.prototype.closeModal = function () {
        this.variationValuesEdit = null;
        this.variationValuesShow = false;
    };
    ProductVariationList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['setVariationLevel', 'deleteVariationLevel'])),
            components: {
                DynamicList: interface_vue_.DynamicList,
                VariationValues: VariationValues/* default */.A,
                BModal: external_bootstrap_vue_.BModal
            }
        })
    ], ProductVariationList);
    return ProductVariationList;
}(lib/* Vue */.lD));
/* harmony default export */ var ProductVariationListvue_type_script_lang_ts_external = (ProductVariationList);

;// ./src/components/ProductVariationList/ProductVariationList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductVariationList_ProductVariationListvue_type_script_lang_ts_external = (ProductVariationListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ProductVariationList/ProductVariationList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ProductVariationList_ProductVariationListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductVariationList_ProductVariationList = (component.exports);

/***/ }),

/***/ 9478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ServiceDelete_ServiceDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ServiceDelete/ServiceDelete.vue?vue&type=template&id=0a44519f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"hidden":_vm.onHidden},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('catalog.service.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ServiceDelete/ServiceDelete.ts?vue&type=script&lang=ts&external




var ServiceDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceDelete, _super);
    function ServiceDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(ServiceDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/catalog/service/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    ServiceDelete.prototype.watchValue = function (value) {
        this.showModal = value !== null;
    };
    ServiceDelete.prototype.onOk = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCatalog.axios.delete(this.apiUrl)
                                .then(function () {
                                interface_vue_.emitter.emit('serviceDeleted', _this.value);
                                _this.$emit('deleted');
                                _this.onHidden();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ServiceDelete.prototype.onHidden = function () {
        //
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ServiceDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ServiceDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('hidden')
    ], ServiceDelete.prototype, "onHidden", null);
    ServiceDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], ServiceDelete);
    return ServiceDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ServiceDeletevue_type_script_lang_ts_external = (ServiceDelete);

;// ./src/components/ServiceDelete/ServiceDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ServiceDelete_ServiceDeletevue_type_script_lang_ts_external = (ServiceDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ServiceDelete/ServiceDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ServiceDelete_ServiceDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ServiceDelete_ServiceDelete = (component.exports);

/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(7334),
    defineProperty = __webpack_require__(3243),
    identity = __webpack_require__(3488);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 9585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProviderReferenceListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProviderReferenceListView.vue?vue&type=template&id=09af11af
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"mb-4"},[_vm._v(" Retrouvez ici les différentes références de vos fournisseurs. À l'inverse la liste des produits, vous retrouverez une entrée par référence fournisseur et non une entrée par produit. ")]),_c('ProviderReferenceList')],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ProviderReferenceList/ProviderReferenceList.vue + 3 modules
var ProviderReferenceList = __webpack_require__(5798);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProviderReferenceListView.vue?vue&type=script&lang=ts



var ProviderReferenceListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProviderReferenceListView, _super);
    function ProviderReferenceListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProviderReferenceListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ProviderReferenceList: ProviderReferenceList/* default */.A
            }
        })
    ], ProviderReferenceListView);
    return ProviderReferenceListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProviderReferenceListViewvue_type_script_lang_ts = (ProviderReferenceListView);

;// ./src/views/ProviderReferenceListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProviderReferenceListViewvue_type_script_lang_ts = (ProviderReferenceListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProviderReferenceListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProviderReferenceListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProviderReferenceListView = (component.exports);

/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) // removed by dead control flow
{}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) // removed by dead control flow
{}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(7828);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 9817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 9884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keysIn = __webpack_require__(7241);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 9905:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 9915:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'star';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f005';
var svgPathData = 'M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM405.8 317.9l27.8 162L288 403.5 142.5 480l27.8-162L52.5 203.1l162.7-23.6L288 32l72.8 147.5 162.7 23.6-117.7 114.8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yy = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ChargeCategoryList_ChargeCategoryList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ChargeCategoryList/ChargeCategoryList.vue?vue&type=template&id=57b99de6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"formUrl":_vm.formUrl,"columns":_vm.columns,"createTitle":_vm.$t('catalog.chargeCategory.new'),"updateTitle":_vm.$t('catalog.chargeCategory.edit'),"deleteMsg":_vm.$t('catalog.chargeCategory.deleteMsg'),"deleteAlertMessage":_vm.$t('catalog.chargeCategory.deleteAlertMsg'),"sort":"parent","sortFunction":_vm.sortElements,"replacementMessage":_vm.$t('catalog.chargeCategory.replacementComments')},on:{"submitted":_vm.submitted,"deleted":_vm.deleted}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ChargeCategoryList/ChargeCategoryList.ts?vue&type=script&lang=ts&external




var ChargeCategoryList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ChargeCategoryList, _super);
    function ChargeCategoryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('catalog.chargeCategory.label'),
                key: 'label'
            },
            {
                label: _this.$t('catalog.chargeCategory.parentLabel'),
                key: 'parent',
                keyShow: 'parent.label',
                keyValue: 'parent.id',
                type: 'select',
                optionValue: function (opt) { return opt.id; },
                required: false,
                ajax: function (el) {
                    var url = _this.formUrl + '?sort=label&filter[is_parent]=1';
                    if (el) {
                        url += '&filter[exclude]=' + el.id;
                    }
                    return url;
                },
                class: 'd-none d-md-table-cell'
            },
            {
                label: _this.$t('catalog.chargeCategory.accountLabel'),
                key: 'account_number',
                required: false,
                class: 'd-none d-md-table-cell'
            }
        ];
        return _this;
    }
    Object.defineProperty(ChargeCategoryList.prototype, "apiUrl", {
        get: function () {
            return this.formUrl + '?include=parent';
        },
        enumerable: false,
        configurable: true
    });
    ChargeCategoryList.prototype.sortElements = function (elements) {
        var _this = this;
        var parents = Array.from(elements)
            .filter(function (el) { return !el.parent; })
            .map(function (el) {
            el.childs = [];
            return el;
        })
            .sort(this.sort);
        elements.filter(function (el) { return el.parent; })
            .forEach(function (el) {
            var parent = parents.find(function (p) { return p.id === el.parent.id; });
            if (parent) { // If parent is delete, don't add children
                el.parent.label = parent.label; // We take advantage of the sort function to rename the parent in case it has been renamed
                parent.childs.push(el);
            }
        });
        parents.map(function (parent) {
            parent.childs.sort(_this.sort);
            return parent;
        });
        var final = [];
        parents.forEach(function (parent) {
            var childs = parent.childs;
            lib/* Vue */.lD.delete(parent, 'childs');
            final.push(parent);
            final.push.apply(final, childs);
        });
        return final;
    };
    ChargeCategoryList.prototype.sort = function (a, b) {
        var valA = a.label.toLowerCase();
        var valB = b.label.toLowerCase();
        return (valA < valB) ? -1 : (valA > valB) ? 1 : 0;
    };
    ChargeCategoryList.prototype.submitted = function (category) {
        if (!this.accountantMode) {
            this.setChargeCategory(category);
        }
    };
    ChargeCategoryList.prototype.deleted = function (category) {
        if (!this.accountantMode) {
            this.deleteChargeCategory(category);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ChargeCategoryList.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/catalog/charge_category' })
    ], ChargeCategoryList.prototype, "formUrl", void 0);
    ChargeCategoryList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['setChargeCategory', 'deleteChargeCategory'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], ChargeCategoryList);
    return ChargeCategoryList;
}(lib/* Vue */.lD));
/* harmony default export */ var ChargeCategoryListvue_type_script_lang_ts_external = (ChargeCategoryList);

;// ./src/components/ChargeCategoryList/ChargeCategoryList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ChargeCategoryList_ChargeCategoryListvue_type_script_lang_ts_external = (ChargeCategoryListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ChargeCategoryList/ChargeCategoryList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ChargeCategoryList_ChargeCategoryListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChargeCategoryList_ChargeCategoryList = (component.exports);

/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "catalog.common." + "catalog" + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/catalog-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			769: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_catalog_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_catalog_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CatalogElementMixin: function() { return /* reexport */ mixins_CatalogElementMixin; },
  CatalogList: function() { return /* reexport */ CatalogList/* default */.A; },
  CatalogListMixin: function() { return /* reexport */ CatalogListMixin/* default */.A; },
  CatalogParams: function() { return /* reexport */ CatalogParams/* default */.A; },
  CatalogParamsView: function() { return /* reexport */ CatalogParamsView["default"]; },
  CatalogPictures: function() { return /* reexport */ CatalogPictures/* default */.A; },
  CatalogReportView: function() { return /* reexport */ CatalogReportView["default"]; },
  CatalogSearch: function() { return /* reexport */ CatalogSearch/* default */.A; },
  CatalogStore: function() { return /* reexport */ modules_CatalogStore; },
  ChargeCategoryList: function() { return /* reexport */ ChargeCategoryList/* default */.A; },
  ChargesCategoryListView: function() { return /* reexport */ ChargesCategoryListView["default"]; },
  CommandDelete: function() { return /* reexport */ CommandDelete/* default */.A; },
  CommandForm: function() { return /* reexport */ CommandForm/* default */.A; },
  CommandFormView: function() { return /* reexport */ CommandFormView["default"]; },
  CommandItem: function() { return /* reexport */ CommandItem/* default */.A; },
  CommandItemView: function() { return /* reexport */ CommandItemView["default"]; },
  CommandList: function() { return /* reexport */ CommandList/* default */.A; },
  CommandListView: function() { return /* reexport */ CommandListView["default"]; },
  CommandReceipt: function() { return /* reexport */ CommandReceipt/* default */.A; },
  CustomPrices: function() { return /* reexport */ CustomPrices_CustomPrices; },
  CustomPricesView: function() { return /* reexport */ CustomPricesView/* default */.A; },
  CustomersSales: function() { return /* reexport */ CustomersSales/* default */.A; },
  CustomersWithoutSales: function() { return /* reexport */ CustomersWithoutSales/* default */.A; },
  ElementSalesList: function() { return /* reexport */ ElementSalesList/* default */.A; },
  GroupListView: function() { return /* reexport */ GroupListView["default"]; },
  KwixeoCatalog: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  LoadCommandMixin: function() { return /* reexport */ LoadCommandMixin/* default */.A; },
  LoadProductMixin: function() { return /* reexport */ LoadProductMixin/* default */.A; },
  LoadServiceMixin: function() { return /* reexport */ LoadServiceMixin/* default */.A; },
  LotDelete: function() { return /* reexport */ LotDelete/* default */.A; },
  LotForm: function() { return /* reexport */ LotForm_LotForm; },
  LotItem: function() { return /* reexport */ LotItem/* default */.A; },
  LotList: function() { return /* reexport */ LotList/* default */.A; },
  LotListView: function() { return /* reexport */ LotListView["default"]; },
  LotSelect: function() { return /* reexport */ LotSelect_LotSelect; },
  LotSelected: function() { return /* reexport */ LotSelected_LotSelected; },
  LotUsed: function() { return /* reexport */ LotUsed/* default */.A; },
  ManualMovementDelete: function() { return /* reexport */ ManualMovementDelete/* default */.A; },
  ManualMovementForm: function() { return /* reexport */ ManualMovementForm_ManualMovementForm; },
  ManualMovementItem: function() { return /* reexport */ ManualMovementItem/* default */.A; },
  ManualMovementList: function() { return /* reexport */ ManualMovementList/* default */.A; },
  ManualMovementListView: function() { return /* reexport */ ManualMovementListView["default"]; },
  MouvementListView: function() { return /* reexport */ MouvementListView["default"]; },
  MovementList: function() { return /* reexport */ MovementList/* default */.A; },
  PdfViewer: function() { return /* reexport */ PdfViewer/* default */.A; },
  ProductDelete: function() { return /* reexport */ ProductDelete/* default */.A; },
  ProductForm: function() { return /* reexport */ ProductForm_ProductForm; },
  ProductItem: function() { return /* reexport */ ProductItem/* default */.A; },
  ProductItemView: function() { return /* reexport */ ProductItemView["default"]; },
  ProductList: function() { return /* reexport */ ProductList/* default */.A; },
  ProductListView: function() { return /* reexport */ ProductListView["default"]; },
  ProductStockIndicator: function() { return /* reexport */ ProductStockIndicator/* default */.A; },
  ProductVariationForm: function() { return /* reexport */ ProductVariationForm/* default */.A; },
  ProductVariationList: function() { return /* reexport */ ProductVariationList/* default */.A; },
  ProductVariationListView: function() { return /* reexport */ ProductVariationListView["default"]; },
  ProductVariationSelect: function() { return /* reexport */ ProductVariationSelect/* default */.A; },
  ProductVariationView: function() { return /* reexport */ ProductVariationView/* default */.A; },
  ProductVariations: function() { return /* reexport */ ProductVariations/* default */.A; },
  ProviderReferenceList: function() { return /* reexport */ ProviderReferenceList/* default */.A; },
  ProviderReferenceListView: function() { return /* reexport */ ProviderReferenceListView["default"]; },
  SaleCategoryForm: function() { return /* reexport */ SaleCategoryForm/* default */.A; },
  SaleCategoryList: function() { return /* reexport */ SaleCategoryList/* default */.A; },
  SaleCategoryListView: function() { return /* reexport */ SaleCategoryListView["default"]; },
  ServiceDelete: function() { return /* reexport */ ServiceDelete/* default */.A; },
  ServiceForm: function() { return /* reexport */ ServiceForm_ServiceForm; },
  ServiceItem: function() { return /* reexport */ ServiceItem/* default */.A; },
  ServiceItemView: function() { return /* reexport */ ServiceItemView["default"]; },
  ServiceList: function() { return /* reexport */ ServiceList/* default */.A; },
  ServiceListView: function() { return /* reexport */ ServiceListView["default"]; },
  Statistics: function() { return /* reexport */ Statistics/* default */.A; },
  StockByLocations: function() { return /* reexport */ StockByLocations/* default */.A; },
  StockLocationForm: function() { return /* reexport */ StockLocationForm/* default */.A; },
  StockLocationList: function() { return /* reexport */ StockLocationList/* default */.A; },
  StockLocationSelect: function() { return /* reexport */ StockLocationSelect/* default */.A; },
  StockParams: function() { return /* reexport */ StockParams/* default */.A; },
  StockParamsView: function() { return /* reexport */ StockParamsView["default"]; },
  StockState: function() { return /* reexport */ StockState/* default */.A; },
  StockStateView: function() { return /* reexport */ StockStateView["default"]; },
  VariationValues: function() { return /* reexport */ VariationValues/* default */.A; },
  catalogEditorConfig: function() { return /* reexport */ editorConfig; },
  commandRelations: function() { return /* reexport */ command/* commandRelations */.l1; },
  configMenu: function() { return /* reexport */ menu_configMenu; },
  configRoutes: function() { return /* reexport */ router_config; },
  fetchCommand: function() { return /* reexport */ command/* fetchCommand */.GW; },
  fetchLot: function() { return /* reexport */ lot/* fetchLot */.wc; },
  fetchManualMovement: function() { return /* reexport */ manualMovement/* fetchManualMovement */.AD; },
  fetchProduct: function() { return /* reexport */ fetchDatas_product/* fetchProduct */.yj; },
  fetchService: function() { return /* reexport */ fetchDatas_service/* fetchService */.Ox; },
  lotRelations: function() { return /* reexport */ lot/* lotRelations */.J2; },
  manualMovementRelations: function() { return /* reexport */ manualMovement/* manualMovementRelations */.HW; },
  menu: function() { return /* reexport */ main; },
  needFetchCommand: function() { return /* reexport */ command/* needFetchCommand */.MZ; },
  needFetchLot: function() { return /* reexport */ lot/* needFetchLot */.cm; },
  needFetchManualMovement: function() { return /* reexport */ manualMovement/* needFetchManualMovement */.Y1; },
  needFetchProduct: function() { return /* reexport */ fetchDatas_product/* needFetchProduct */.U8; },
  needFetchService: function() { return /* reexport */ fetchDatas_service/* needFetchService */.cu; },
  productRelations: function() { return /* reexport */ fetchDatas_product/* productRelations */.F2; },
  routes: function() { return /* reexport */ router_routes; },
  serviceRelations: function() { return /* reexport */ fetchDatas_service/* serviceRelations */.R4; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/CatalogList/CatalogList.vue + 3 modules
var CatalogList = __webpack_require__(573);
// EXTERNAL MODULE: ./src/components/CatalogParams/CatalogParams.vue + 3 modules
var CatalogParams = __webpack_require__(8252);
// EXTERNAL MODULE: ./src/components/CatalogPictures/CatalogPictures.vue + 3 modules
var CatalogPictures = __webpack_require__(3431);
// EXTERNAL MODULE: ./src/components/CatalogSearch/CatalogSearch.vue + 57 modules
var CatalogSearch = __webpack_require__(4042);
// EXTERNAL MODULE: ./src/components/ChargeCategoryList/ChargeCategoryList.vue + 3 modules
var ChargeCategoryList = __webpack_require__(9992);
// EXTERNAL MODULE: ./src/components/CommandDelete/CommandDelete.vue + 3 modules
var CommandDelete = __webpack_require__(8674);
// EXTERNAL MODULE: ./src/components/CommandForm/CommandForm.vue + 23 modules
var CommandForm = __webpack_require__(8131);
// EXTERNAL MODULE: ./src/components/CommandItem/CommandItem.vue + 9 modules
var CommandItem = __webpack_require__(649);
// EXTERNAL MODULE: ./src/components/CommandList/CommandList.vue + 3 modules
var CommandList = __webpack_require__(4429);
// EXTERNAL MODULE: ./src/components/CommandReceipt/CommandReceipt.vue + 3 modules
var CommandReceipt = __webpack_require__(2600);
// EXTERNAL MODULE: ./src/components/CustomersSales/CustomersSales.vue + 3 modules
var CustomersSales = __webpack_require__(5999);
// EXTERNAL MODULE: ./src/components/CustomersWithoutSales/CustomersWithoutSales.vue + 3 modules
var CustomersWithoutSales = __webpack_require__(7159);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomPrices/CustomPrices.vue?vue&type=template&id=43a47fa5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.customPrices.types'),"label-cols":"auto"}},[_c('k-form-select',{attrs:{"name":"custom_price_mode","options":_vm.customPriceMode,"clearable":false,"reduce":opt => opt.id},model:{value:(_vm.localElement.custom_price_mode),callback:function ($$v) {_vm.$set(_vm.localElement, "custom_price_mode", $$v)},expression:"localElement.custom_price_mode"}})],1),(_vm.localElement.custom_price_mode === 'quantity')?_c('div',[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.customPrices.decreasingPricesCondition')}},[_c('k-form-select',{attrs:{"name":"custom_price_quantity_mode","options":_vm.customPriceQuantityModes,"clearable":false,"reduce":opt => opt.id},model:{value:(_vm.localElement.custom_price_quantity_mode),callback:function ($$v) {_vm.$set(_vm.localElement, "custom_price_quantity_mode", $$v)},expression:"localElement.custom_price_quantity_mode"}})],1)],1),(_vm.localElement.custom_price_quantity_mode === 4)?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.customPrices.decreasingPricesNbMonth')}},[_c('k-form-spinner',{attrs:{"name":"custom_price_quantity_month_length","required":"","min":1,"noDefaultValue":""},model:{value:(_vm.localElement.custom_price_quantity_month_length),callback:function ($$v) {_vm.$set(_vm.localElement, "custom_price_quantity_month_length", $$v)},expression:"localElement.custom_price_quantity_month_length"}})],1)],1):_vm._e()],1),_c('p',{staticClass:"font-weight-bold mt-2 mb-1"},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.decreasingPricesList')))]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm mb-1 w-auto text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.qtyMin')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.qtyMax')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),_c('tbody',[(_vm.localElement.custom_quantity_prices.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addQuantityPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")])],1)]):_vm._e(),_vm._l((_vm.localElement.custom_quantity_prices),function(price,i){return _c('tr',{key:i},[_c('td',[_c('k-form-spinner',{attrs:{"name":'custom_quantity_prices[' + i + '][minimum]',"size":"sm","required":"","min":_vm.localElement.custom_quantity_prices[i-1] ? (_vm.localElement.custom_quantity_prices[i-1].maximum + 1) : null,"noDefaultValue":""},model:{value:(price.minimum),callback:function ($$v) {_vm.$set(price, "minimum", $$v)},expression:"price.minimum"}})],1),_c('td',[_c('k-form-spinner',{attrs:{"name":'custom_quantity_prices[' + i + '][maximum]',"size":"sm","required":"","min":price.minimum + 1,"noDefaultValue":""},model:{value:(price.maximum),callback:function ($$v) {_vm.$set(price, "maximum", $$v)},expression:"price.maximum"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'custom_quantity_prices[' + i + '][price]',"size":"sm","required":"","noDefaultValue":""},model:{value:(price.price),callback:function ($$v) {_vm.$set(price, "price", $$v)},expression:"price.price"}})],1)],1),_c('td',{staticClass:"text-center px-0 align-middle"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){return _vm.deleteQuantityPrice(i)}}},[_vm._v(" X ")])],1)])})],2)])]),(_vm.localElement.custom_quantity_prices.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addQuantityPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")]):_vm._e()],1):(_vm.localElement.custom_price_mode === 'type')?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCustomerTypeExplain'))+" ")]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm mb-1 text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.customer')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))])])]),_c('tbody',_vm._l((_vm.localElement.custom_price_customer_type_prices),function(type,i){return _c('tr',{key:i},[_c('td',[_vm._v(" "+_vm._s(type.label)+" "),_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + i + '][id]'},domProps:{"value":type.id}}),_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + i + '][type]'},domProps:{"value":'customerType'}})]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + i + '][price]'},domProps:{"value":type.price}}),_c('k-form-number',{attrs:{"validationName":'custom_type_prices[' + i + '][price]',"size":"sm","noDefaultValue":""},model:{value:(type.price),callback:function ($$v) {_vm.$set(type, "price", $$v)},expression:"type.price"}})],1)],1)])}),0)])])]):(_vm.localElement.custom_price_mode === 'customer')?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCustomerExplain'))+" ")]),_c('div',{staticClass:"table-responsive mb-2"},[_c('table',{staticClass:"table table-bordered table-sm mb-1 text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.customer')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),_c('tbody',[(_vm.localElement.custom_price_customer_prices.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewCustomerPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")])],1)]):_vm._e(),_vm._l((_vm.localElement.custom_price_customer_prices),function(price,i){return _c('tr',{key:i},[_c('td',[_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][id]'},domProps:{"value":price.element ? price.element.id : null}}),_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][type]',"value":"customer"}}),_c('k-form-select',{attrs:{"ajax":_vm.customerApiUrl,"ajax-cache":_vm.customersCache,"label":"name","size":"sm","required":"","clearable":false},on:{"cacheUpdated":val => _vm.customersCache = val},model:{value:(price.element),callback:function ($$v) {_vm.$set(price, "element", $$v)},expression:"price.element"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][price]',"size":"sm","required":"","noDefaultValue":""},model:{value:(price.price),callback:function ($$v) {_vm.$set(price, "price", $$v)},expression:"price.price"}})],1)],1),_c('td',{staticClass:"text-center px-0 align-middle"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){return _vm.deleteCustomerPrice(i)}}},[_vm._v(" X ")])],1)])})],2)])]),(_vm.localElement.custom_price_customer_prices.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewCustomerPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")]):_vm._e()],1):(_vm.localElement.custom_price_mode === 'country')?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.byCustomerExplain'))+" ")]),_c('div',{staticClass:"table-responsive mb-2"},[_c('table',{staticClass:"table table-bordered table-sm mb-1 text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.country')))]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v(_vm._s(_vm.$t('catalog.customPrices.unitPriceHt')))]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),_c('tbody',[(_vm.localElement.custom_price_country_prices.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',[_vm._v(_vm._s(_vm.$t('catalog.customPrices.noCustomPrice')))]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewCountryPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")])],1)]):_vm._e(),_vm._l((_vm.localElement.custom_price_country_prices),function(price,i){return _c('tr',{key:i},[_c('td',[_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][id]'},domProps:{"value":price.element ? price.element.id : null}}),_c('input',{attrs:{"type":"hidden","name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][type]',"value":"country"}}),_c('k-form-select',{attrs:{"ajax":_vm.countryApiUrl,"label":"name","size":"sm","required":"","clearable":false},model:{value:(price.element),callback:function ($$v) {_vm.$set(price, "element", $$v)},expression:"price.element"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'custom_type_prices[' + (i + _vm.customerTypes.length) + '][price]',"size":"sm","required":"","noDefaultValue":""},model:{value:(price.price),callback:function ($$v) {_vm.$set(price, "price", $$v)},expression:"price.price"}})],1)],1),_c('td',{staticClass:"text-center px-0 align-middle"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){return _vm.deleteCountryPrice(i)}}},[_vm._v(" X ")])],1)])})],2)])]),(_vm.localElement.custom_price_country_prices.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewCountryPrice()}}},[_vm._v(" "+_vm._s(_vm.$t('catalog.customPrices.addCustomPrice'))+" ")]):_vm._e()],1):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomPrices/CustomPrices.ts?vue&type=script&lang=ts&external






var CustomPrices = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomPrices, _super);
    function CustomPrices() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localElement = {
            custom_price_mode: 'quantity',
            custom_price_customer_type_prices: [],
            custom_price_customer_prices: [],
            custom_price_country_prices: [],
            custom_quantity_prices: [],
            custom_price_quantity_mode: 5
        };
        _this.customPriceMode = [
            { id: 'quantity', label: _this.$t('catalog.customPrices.decreasingPrices') },
            { id: 'type', label: _this.$t('catalog.customPrices.byCustomerType') },
            { id: 'customer', label: _this.$t('catalog.customPrices.byCustomer') },
            { id: 'country', label: _this.$t('catalog.customPrices.byCountry') }
        ];
        _this.customPriceQuantityModes = [
            { id: 1, label: _this.$t('catalog.customPrices.qtyOnDocument') },
            { id: 2, label: _this.$t('catalog.customPrices.qtyCurrentYear') },
            { id: 3, label: _this.$t('catalog.customPrices.qtyPreviousYear') },
            { id: 4, label: _this.$t('catalog.customPrices.qtyLastMonths') },
            { id: 5, label: _this.$t('catalog.customPrices.qtyTotal') }
        ];
        _this.customersCache = {};
        _this.loading = true;
        return _this;
    }
    CustomPrices.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomerTypes()];
                    case 1:
                        _a.sent();
                        this.watchValue();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomPrices.prototype.watchValue = function () {
        if (this.value) {
            this.setLocalElement(this.value);
        }
        else {
            this.localElement.custom_price_customer_type_prices = this.customerTypes;
        }
    };
    Object.defineProperty(CustomPrices.prototype, "customerApiUrl", {
        get: function () {
            return '/customer?sort=name&filter[is_prospect_or_customer]=1';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomPrices.prototype, "countryApiUrl", {
        get: function () {
            return '/country?sort=name';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomPrices.prototype, "getCustomerTypes", {
        get: function () {
            var customPrice = this.value && this.value.custom_type_prices ? this.value.custom_type_prices.filter(function (price) { return price.type === 'customerType'; }) : [];
            return this.customerTypes.map(function (type) {
                var custom = customPrice.find(function (price) { return price.type === 'customerType' && price.id === type.id; });
                return Object.assign({
                    price: custom === null || custom === void 0 ? void 0 : custom.price
                }, type);
            });
        },
        enumerable: false,
        configurable: true
    });
    CustomPrices.prototype.setLocalElement = function (element) {
        var _a, _b;
        var customPrice = element.custom_type_prices ? element.custom_type_prices.filter(function (price) { return price.type === 'customerType'; }) : [];
        var types = this.customerTypes.map(function (type) {
            var custom = customPrice.find(function (price) { return price.type === 'customerType' && price.id === type.id; });
            return Object.assign({
                price: custom === null || custom === void 0 ? void 0 : custom.price
            }, type);
        });
        this.localElement = {
            custom_price_mode: element.custom_price_mode,
            custom_price_customer_type_prices: JSON.parse(JSON.stringify(types)),
            custom_price_customer_prices: element.custom_type_prices ? element.custom_type_prices.filter(function (price) { return price.type === 'customer'; }) : [],
            custom_price_country_prices: element.custom_type_prices ? element.custom_type_prices.filter(function (price) { return price.type === 'country'; }) : [],
            custom_quantity_prices: (_a = element.custom_quantity_prices) !== null && _a !== void 0 ? _a : [],
            custom_price_quantity_mode: (_b = element.custom_price_quantity_mode) !== null && _b !== void 0 ? _b : 5,
            custom_price_quantity_month_length: element.custom_price_quantity_month_length
        };
    };
    CustomPrices.prototype.addNewCustomerPrice = function () {
        this.localElement.custom_price_customer_prices.push({});
    };
    CustomPrices.prototype.deleteCustomerPrice = function (index) {
        this.localElement.custom_price_customer_prices.splice(index, 1);
    };
    CustomPrices.prototype.addNewCountryPrice = function () {
        this.localElement.custom_price_country_prices.push({});
    };
    CustomPrices.prototype.deleteCountryPrice = function (index) {
        this.localElement.custom_price_country_prices.splice(index, 1);
    };
    CustomPrices.prototype.addQuantityPrice = function () {
        this.localElement.custom_quantity_prices.push({});
    };
    CustomPrices.prototype.deleteQuantityPrice = function (index) {
        this.localElement.custom_quantity_prices.splice(index, 1);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomPrices.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], CustomPrices.prototype, "watchValue", null);
    CustomPrices = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])), (0,external_vuex_.mapState)('customers', ['customerTypes'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['loadCustomerTypes'])),
            components: {
                Spinner: interface_vue_.Spinner,
                KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner, KFormNumber: form_vue_.KFormNumber,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup
            }
        })
    ], CustomPrices);
    return CustomPrices;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomPricesvue_type_script_lang_ts_external = (CustomPrices);

;// ./src/components/CustomPrices/CustomPrices.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomPrices_CustomPricesvue_type_script_lang_ts_external = (CustomPricesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomPrices/CustomPrices.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomPrices_CustomPricesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomPrices_CustomPrices = (component.exports);
// EXTERNAL MODULE: ./src/components/CustomPricesView/CustomPricesView.vue + 3 modules
var CustomPricesView = __webpack_require__(3613);
// EXTERNAL MODULE: ./src/components/ElementSalesList/ElementSalesList.vue + 3 modules
var ElementSalesList = __webpack_require__(7596);
// EXTERNAL MODULE: ./src/components/LotDelete/LotDelete.vue + 3 modules
var LotDelete = __webpack_require__(607);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotForm/LotForm.vue?vue&type=template&id=48616e79
var LotFormvue_type_template_id_48616e79_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.productReference')}},[_vm._v(" "+_vm._s(_vm.lot.product.reference)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.productName')}},[_vm._v(" "+_vm._s(_vm.lot.product.name)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.reference' + _vm.lot.product.stock_tracking_mode)}},[_c('k-form-input',{attrs:{"name":"reference","required":""},model:{value:(_vm.lot.reference),callback:function ($$v) {_vm.$set(_vm.lot, "reference", $$v)},expression:"lot.reference"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.expire' + _vm.lot.product.stock_tracking_mode)}},[_c('k-form-datepicker',{attrs:{"name":"expire_at","required":_vm.lot.product.stock_tracking_mode === 1,"positionFixed":""},model:{value:(_vm.lot.expire_at),callback:function ($$v) {_vm.$set(_vm.lot, "expire_at", $$v)},expression:"lot.expire_at"}})],1),(_vm.lot.product.stock_tracking_mode === 1)?[_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.quantity')}},[_c('k-form-spinner',{attrs:{"name":"quantity","min":0,"maxDecimal":5},model:{value:(_vm.lot.quantity),callback:function ($$v) {_vm.$set(_vm.lot, "quantity", $$v)},expression:"lot.quantity"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('catalog.productLot.form.stockQuantity')}},[_c('k-form-spinner',{attrs:{"name":"stock_quantity","min":0,"max":_vm.lot.quantity,"maxDecimal":5},model:{value:(_vm.lot.stock_quantity),callback:function ($$v) {_vm.$set(_vm.lot, "stock_quantity", $$v)},expression:"lot.stock_quantity"}})],1)]:[_c('b-form-group',[_c('input',{attrs:{"type":"hidden","name":"stock_quantity"},domProps:{"value":_vm.inStock ? 1 : 0}}),_c('k-form-checkbox',{model:{value:(_vm.inStock),callback:function ($$v) {_vm.inStock=$$v},expression:"inStock"}},[_vm._v(" En stock ")])],1)],(_vm.hasModule('stock-locations'))?_c('b-form-group',{attrs:{"label":"Lieu de stock"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.lot.stock_location?.id}}),_c('StockLocationSelect',{attrs:{"validationName":"stock_location"},model:{value:(_vm.lot.stock_location),callback:function ($$v) {_vm.$set(_vm.lot, "stock_location", $$v)},expression:"lot.stock_location"}})],1):_vm._e()],2)],1)
}
var LotFormvue_type_template_id_48616e79_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/StockLocationSelect/StockLocationSelect.vue + 3 modules
var StockLocationSelect = __webpack_require__(6225);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotForm/LotForm.ts?vue&type=script&lang=ts&external







var LotForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotForm, _super);
    function LotForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.lot = {};
        _this.inStock = false;
        return _this;
    }
    Object.defineProperty(LotForm.prototype, "formAction", {
        get: function () {
            return '/catalog/stock/lot/' + this.lot.id;
        },
        enumerable: false,
        configurable: true
    });
    LotForm.prototype.mounted = function () {
        this.setLocalValue(this.value);
        this.loading = false;
    };
    LotForm.prototype.setLocalValue = function (value) {
        var _a;
        this.lot = JSON.parse(JSON.stringify(value));
        if (((_a = this.lot.product) === null || _a === void 0 ? void 0 : _a.stock_tracking_mode) === 2) {
            this.inStock = this.lot.stock_quantity === 1;
        }
    };
    LotForm.prototype.watchQuantity = function (quantity, oldQuantity) {
        if (oldQuantity === undefined) {
            return;
        }
        if (this.lot.stock_quantity === undefined) {
            this.lot.stock_quantity = 0;
        }
        this.lot.stock_quantity += quantity - oldQuantity;
    };
    LotForm.prototype.submitComplete = function (response) {
        interface_vue_.emitter.emit('productLotUpdated', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], LotForm.prototype, "setLocalValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('lot.quantity')
    ], LotForm.prototype, "watchQuantity", null);
    LotForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox,
                Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                StockLocationSelect: StockLocationSelect/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], LotForm);
    return LotForm;
}(lib/* Vue */.lD));
/* harmony default export */ var LotFormvue_type_script_lang_ts_external = (LotForm);

;// ./src/components/LotForm/LotForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotForm_LotFormvue_type_script_lang_ts_external = (LotFormvue_type_script_lang_ts_external); 
;// ./src/components/LotForm/LotForm.vue





/* normalize component */
;
var LotForm_component = (0,componentNormalizer/* default */.A)(
  LotForm_LotFormvue_type_script_lang_ts_external,
  LotFormvue_type_template_id_48616e79_render,
  LotFormvue_type_template_id_48616e79_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotForm_LotForm = (LotForm_component.exports);
// EXTERNAL MODULE: ./src/components/LotItem/LotItem.vue + 3 modules
var LotItem = __webpack_require__(1798);
// EXTERNAL MODULE: ./src/components/LotList/LotList.vue + 3 modules
var LotList = __webpack_require__(7666);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotSelect/LotSelect.vue?vue&type=template&id=0ebcaa99
var LotSelectvue_type_template_id_0ebcaa99_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"title":"Sélection de lots","ok-title":"Valider la sélection","cancel-title":_vm.$t('interface.cancel'),"size":"xl","ok-disabled":_vm.tooMuchQuantity},on:{"ok":_vm.validSelection},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[(_vm.selected.length === 0)?_c('p',{staticClass:"text-center font-weight-bold"},[_vm._v(" Quantité à selectionner : "+_vm._s(_vm.showNumber(_vm.quantity))+" ")]):_c('div',{staticClass:"p-3 mb-4",staticStyle:{"background-color":"#f9f9f9","border":"1px solid #d7d7d7"}},[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v("Lots sélectionnés")]),_c('table',{staticClass:"table table-sm table-bordered align-middle"},[_c('thead',[_c('tr',[(_vm.product.stock_tracking_mode === 1)?[_c('th',[_vm._v("Numéro de lot")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"170px"}},[_vm._v("Date de péremption")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("En stock")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"150px"}},[_vm._v("Quantité à utiliser")])]:[_c('th',[_vm._v("Numéro de série")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"170px"}},[_vm._v("Date d'entrée")])],_c('th',{staticStyle:{"width":"30px"}})],2)]),_c('tbody',_vm._l((_vm.selected),function(lot,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(lot.lot.reference))]),(_vm.product.stock_tracking_mode === 1)?[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.lot.expire_at)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(_vm.stockQuantityAvailable(lot))))]),_c('td',{staticClass:"text-center"},[_c('k-form-spinner',{attrs:{"min":0,"max":_vm.stockQuantityAvailable(lot),"maxDecimal":5,"size":"sm"},model:{value:(_vm.selected[i].quantity),callback:function ($$v) {_vm.$set(_vm.selected[i], "quantity", $$v)},expression:"selected[i].quantity"}})],1)]:[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.lot.created_at)))])],_c('td',{staticClass:"px-0"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger",attrs:{"variant":"icon","title":"Supprimer le lot de la sélection"},on:{"click":function($event){$event.preventDefault();return _vm.deleteSelection(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1)],2)}),0),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":_vm.product.stock_tracking_mode === 1 ? 3 : 1}},[_vm._v("Total :")]),_c('th',{class:{
                  'text-center': true,
                  'text-danger': _vm.tooMuchQuantity
                }},[_vm._v(" "+_vm._s(_vm.showNumber(_vm.totalSelectedQuantity))+" / "+_vm._s(_vm.showNumber(_vm.quantity))+" ")]),_c('th')])])]),_c('p',{class:{
          'text-center': true,
          'mb-0': true,
          'alert-warning': _vm.cantSelectLot && !_vm.tooMuchQuantity,
          'p-2': _vm.cantSelectLot && !_vm.tooMuchQuantity,
        }},[_c('b-alert',{attrs:{"variant":"warning","show":_vm.tooMuchQuantity}},[_vm._v(" Vous ne pouvez pas sélectionner plus de quantité que nécessaire ")]),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.selected = []}}},[_vm._v(" Effacer la sélection ")]),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.tooMuchQuantity ? 'Vous avez sélectionné plus de quantité que nécessaire' : null }),expression:"{ title: tooMuchQuantity ? 'Vous avez sélectionné plus de quantité que nécessaire' : null }"}]},[_c('b-button',{attrs:{"variant":"primary","size":"sm","disabled":_vm.tooMuchQuantity},on:{"click":function($event){$event.preventDefault();return _vm.validSelection.apply(null, arguments)}}},[_vm._v(" Valider la sélection ")])],1)],1)]),(_vm.lots.length > 0)?_c('div',{staticClass:"text-center"},[_c('p',{class:{
            'text-center': true,
            'd-inline-block': true,
            'p-3': _vm.product.stock_tracking_mode === 1
          },style:(_vm.product.stock_tracking_mode === 1 ? { border: '1px solid #e3e3e3' } : null)},[(_vm.product.stock_tracking_mode === 1)?_c('b-form-radio-group',{staticClass:"d-inline-block",attrs:{"options":[
              { text: 'Privilégier la date d\'expiration', value: 1 },
              { text: 'Privilégier un seul lot', value: 2 }
            ]},model:{value:(_vm.autoSelectionMode),callback:function ($$v) {_vm.autoSelectionMode=$$v},expression:"autoSelectionMode"}}):_vm._e(),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.autoSelection.apply(null, arguments)}}},[_vm._v(" Selection automatique ")])],1)]):_vm._e(),_c('table',{staticClass:"table table-sm w-100 table-bordered align-middle"},[_c('thead',[_c('tr',[(_vm.product.stock_tracking_mode === 1)?[_c('th',[_vm._v("Numéro de lot")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"170px"}},[_vm._v("Date de péremption")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"170px"}},[_vm._v("Quantité disponible")])]:[_c('th',[_vm._v("Numéro de série")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"170px"}},[_vm._v("Date d'entrée")])],_c('th',{staticStyle:{"width":"110px"}})],2)]),_c('tbody',[(_vm.unselectedLots.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p3",attrs:{"colspan":_vm.product.stock_tracking_mode === 1 ? 4 : 3}},[_vm._v(" Aucun lot de disponible ")])]):_vm._e(),_vm._l((_vm.unselectedLots),function(lot,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(lot.reference))]),(_vm.product.stock_tracking_mode === 1)?[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.expire_at)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(_vm.availableStockQuantityAvailable(lot))))])]:[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.created_at)))])],_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: (_vm.cantSelectLot ? 'Vous ne pouvez pas sélectionner plus de lot que la quantité nécessaire' : null) }),expression:"{ title: (cantSelectLot ? 'Vous ne pouvez pas sélectionner plus de lot que la quantité nécessaire' : null) }"}]},[_c('b-button',{attrs:{"size":"sm","variant":"primary","disabled":_vm.cantSelectLot},on:{"click":function($event){$event.preventDefault();return _vm.selectLot(lot)}}},[_vm._v(" Sélectionner ")])],1)],2)})],2)])]],2)],1)
}
var LotSelectvue_type_template_id_0ebcaa99_staticRenderFns = []


;// external "lodash"
var external_lodash_namespaceObject = require("lodash");
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotSelect/LotSelect.ts?vue&type=script&lang=ts&external








var LotSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotSelect, _super);
    function LotSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.loaded = false;
        _this.modalState = false;
        _this.selected = [];
        _this.autoSelectionMode = 1;
        _this.lots = [];
        return _this;
    }
    LotSelect.prototype.watchQuantity = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.autoSelect === 0) {
                            return [2 /*return*/];
                        }
                        if (!!this.loaded) return [3 /*break*/, 2];
                        this.watchSelected(this.value);
                        return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.autoSelect === 2 && this.allLots.length > 1) {
                            return [2 /*return*/];
                        }
                        this.autoSelection();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LotSelect.prototype, "filteredUsedLots", {
        get: function () {
            var _a;
            return ((_a = this.usedLots) !== null && _a !== void 0 ? _a : []).filter(this.lotsFilter);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : 'Sélectionner un lot';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "allLots", {
        // Return available lots
        get: function () {
            var _this = this;
            var lots = JSON.parse(JSON.stringify(this.lots));
            this.filteredUsedLots.forEach(function (lot) {
                var used = _this.selected.find(function (use) { return use.lot.id === lot.lot.id; });
                if (!used) {
                    var unusedLot_1 = JSON.parse(JSON.stringify(lot.lot));
                    unusedLot_1.stock_quantity = _this.number(unusedLot_1.stock_quantity) + _this.number(lot.quantity);
                    var existIndex = lots.findIndex(function (val) { return val.id === unusedLot_1.id; });
                    if (existIndex >= 0) {
                        lots.splice(existIndex, 1);
                    }
                    lots.push(unusedLot_1);
                }
            });
            return lots;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "unselectedLots", {
        get: function () {
            var _this = this;
            return this.allLots.filter(function (lot) { return !_this.selected.find(function (select) { return select.lot.id === lot.id; }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "totalSelectedQuantity", {
        get: function () {
            var _this = this;
            return this.roundNumber((0,external_lodash_namespaceObject.sumBy)(this.selected, function (value) { return _this.number(value.quantity); }), 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "cantSelectLot", {
        get: function () {
            return this.totalSelectedQuantity >= this.quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "tooMuchQuantity", {
        get: function () {
            return this.totalSelectedQuantity > this.quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "stockQuantityAvailable", {
        get: function () {
            var _this = this;
            return function (lot) {
                var usedLot = _this.value.find(function (used) { var _a; return ((_a = used.lot) === null || _a === void 0 ? void 0 : _a.id) === lot.lot.id; });
                return _this.number(lot.lot.stock_quantity) + (usedLot ? _this.number(usedLot.quantity) : 0);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelect.prototype, "availableStockQuantityAvailable", {
        get: function () {
            var _this = this;
            return function (lot) {
                var usedLot = _this.value.find(function (used) { var _a; return ((_a = used.lot) === null || _a === void 0 ? void 0 : _a.id) === lot.id; });
                return _this.number(lot.stock_quantity) + (usedLot ? _this.number(usedLot.quantity) : 0);
            };
        },
        enumerable: false,
        configurable: true
    });
    LotSelect.prototype.watchSelected = function (value) {
        this.selected = JSON.parse(JSON.stringify(value.filter(this.lotsFilter)));
    };
    LotSelect.prototype.watchModalState = function (state) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!state) return [3 /*break*/, 2];
                        this.watchSelected(this.value);
                        return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // Fetch lots from api
    LotSelect.prototype.getDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        filter = {
                            where_product: this.product.id,
                            only_in_stock: true
                        };
                        if (this.hasModule('stock-locations') && this.location) {
                            filter.stock_location = this.location.id;
                        }
                        return [4 /*yield*/, this.$kwCatalog.axios.get('/catalog/stock/lot', {
                                params: {
                                    per_page: 500,
                                    sort: 'expire_at',
                                    filter: filter
                                }
                            })
                                .then(function (response) {
                                _this.lots = response.data.data;
                                _this.loading = false;
                                _this.loaded = true;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // Select automaticaly the lots
    LotSelect.prototype.autoSelection = function () {
        var _this = this;
        var lots = Array.from(this.allLots);
        var selected = [];
        var quantity = this.number(this.quantity);
        this.filteredUsedLots.every(function (lot) {
            var lotQty = _this.number(lot.quantity);
            if (lotQty > quantity) {
                lotQty = quantity;
            }
            if (lotQty > 0) {
                selected.push({
                    lot: lot.lot,
                    quantity: lotQty
                });
            }
            quantity -= lotQty;
            return quantity > 0;
        });
        if (quantity > 0) {
            if (this.product.stock_tracking_mode === 1) {
                lots = lots.sort(function (a, b) { return new Date(a.expire_at).getTime() - new Date(b.expire_at).getTime(); });
                if (this.autoSelectionMode === 2) {
                    var lotsMin = lots.filter(function (lot) { return _this.number(lot.stock_quantity) < quantity; });
                    lots = lots.filter(function (lot) { return _this.number(lot.stock_quantity) >= quantity; });
                    lots.push.apply(lots, lotsMin);
                }
            }
            lots.every(function (lot) {
                var lotQty = _this.number(lot.stock_quantity);
                if (lotQty > quantity) {
                    lotQty = quantity;
                }
                if (lotQty > 0) {
                    selected.push({
                        lot: lot,
                        quantity: lotQty
                    });
                }
                quantity -= lotQty;
                return quantity > 0;
            });
        }
        this.selected = selected;
        this.validSelection();
    };
    LotSelect.prototype.selectLot = function (lot) {
        var stayQty = this.roundNumber(this.quantity - this.totalSelectedQuantity, 5);
        if (stayQty > lot.stock_quantity) {
            stayQty = this.number(lot.stock_quantity);
        }
        var index = this.selected.findIndex(function (val) { return val.lot.id === lot.id; });
        if (index >= 0) {
            this.selected[index].quantity += stayQty;
        }
        else {
            this.selected.push({
                lot: lot,
                quantity: stayQty
            });
        }
    };
    LotSelect.prototype.validSelection = function () {
        this.modalState = false;
        return JSON.parse(JSON.stringify(this.selected));
    };
    // Remove a selected lot
    LotSelect.prototype.deleteSelection = function (index) {
        this.selected.splice(index, 1);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], LotSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotSelect.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], LotSelect.prototype, "usedLots", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotSelect.prototype, "quantity", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'primary' })
    ], LotSelect.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LotSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotSelect.prototype, "location", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 0 })
    ], LotSelect.prototype, "autoSelect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return true; } })
    ], LotSelect.prototype, "lotsFilter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('quantity', { immediate: true })
    ], LotSelect.prototype, "watchQuantity", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LotSelect.prototype, "watchSelected", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], LotSelect.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], LotSelect.prototype, "validSelection", null);
    LotSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BAlert: external_bootstrap_vue_.BAlert,
                Spinner: interface_vue_.Spinner,
                KFormSpinner: form_vue_.KFormSpinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule']))
        })
    ], LotSelect);
    return LotSelect;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var LotSelectvue_type_script_lang_ts_external = (LotSelect);

;// ./src/components/LotSelect/LotSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotSelect_LotSelectvue_type_script_lang_ts_external = (LotSelectvue_type_script_lang_ts_external); 
;// ./src/components/LotSelect/LotSelect.vue





/* normalize component */
;
var LotSelect_component = (0,componentNormalizer/* default */.A)(
  LotSelect_LotSelectvue_type_script_lang_ts_external,
  LotSelectvue_type_template_id_0ebcaa99_render,
  LotSelectvue_type_template_id_0ebcaa99_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotSelect_LotSelect = (LotSelect_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LotSelected/LotSelected.vue?vue&type=template&id=578b1787
var LotSelectedvue_type_template_id_578b1787_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.filteredUsedLots.length > 0)?_c('LotSelect',{staticClass:"mb-2",attrs:{"product":_vm.product,"quantity":_vm.computedQuantity,"usedLots":_vm.usedLots,"location":_vm.location,"autoSelect":_vm.autoSelect,"lotsFilter":_vm.lotsFilter,"size":"sm","label":"Gérer les lots"},model:{value:(_vm.value.used_lots),callback:function ($$v) {_vm.$set(_vm.value, "used_lots", $$v)},expression:"value.used_lots"}}):_vm._e(),_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',[_vm._v("Référence")]),(_vm.product.stock_tracking_mode === 1)?[_c('th',{staticClass:"text-center",staticStyle:{"width":"150px"}},[_vm._v("Date d'expiration")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Quantité")])]:[_c('th',{staticClass:"text-center",staticStyle:{"width":"150px"}},[_vm._v("Date d'entrée")])]],2)]),_c('tbody',[(_vm.filteredUsedLots.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-3",attrs:{"colspan":"3"}},[_c('p',[_vm._v(" Aucun lot sélectionné ")]),_c('LotSelect',{attrs:{"product":_vm.product,"quantity":_vm.computedQuantity,"usedLots":_vm.usedLots,"location":_vm.location,"autoSelect":_vm.autoSelect,"lotsFilter":_vm.lotsFilter,"size":"sm"},model:{value:(_vm.value.used_lots),callback:function ($$v) {_vm.$set(_vm.value, "used_lots", $$v)},expression:"value.used_lots"}})],1)]):_vm._e(),_vm._l((_vm.filteredUsedLots),function(lot,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(lot.lot.reference))]),(_vm.product.stock_tracking_mode === 1)?[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.lot.expire_at)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(lot.quantity)))])]:[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.lot.created_at)))])]],2)})],2)])],1)
}
var LotSelectedvue_type_template_id_578b1787_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LotSelected/LotSelected.ts?vue&type=script&lang=ts&external




var LotSelected = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LotSelected, _super);
    function LotSelected() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LotSelected.prototype, "computedQuantity", {
        get: function () {
            var _a;
            var quantity = (_a = this.quantity) !== null && _a !== void 0 ? _a : this.value.quantity;
            if (quantity < 0) {
                quantity = 0;
            }
            return quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotSelected.prototype, "filteredUsedLots", {
        get: function () {
            var _a;
            return ((_a = this.value.used_lots) !== null && _a !== void 0 ? _a : []).filter(this.lotsFilter);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotSelected.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LotSelected.prototype, "product", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], LotSelected.prototype, "usedLots", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotSelected.prototype, "quantity", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LotSelected.prototype, "location", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 0 })
    ], LotSelected.prototype, "autoSelect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return (function () { return true; }); } })
    ], LotSelected.prototype, "lotsFilter", void 0);
    LotSelected = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LotSelect: LotSelect_LotSelect
            }
        })
    ], LotSelected);
    return LotSelected;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var LotSelectedvue_type_script_lang_ts_external = (LotSelected);

;// ./src/components/LotSelected/LotSelected.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LotSelected_LotSelectedvue_type_script_lang_ts_external = (LotSelectedvue_type_script_lang_ts_external); 
;// ./src/components/LotSelected/LotSelected.vue





/* normalize component */
;
var LotSelected_component = (0,componentNormalizer/* default */.A)(
  LotSelected_LotSelectedvue_type_script_lang_ts_external,
  LotSelectedvue_type_template_id_578b1787_render,
  LotSelectedvue_type_template_id_578b1787_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LotSelected_LotSelected = (LotSelected_component.exports);
// EXTERNAL MODULE: ./src/components/LotUsed/LotUsed.vue + 4 modules
var LotUsed = __webpack_require__(8751);
// EXTERNAL MODULE: ./src/components/ManualMovementDelete/ManualMovementDelete.vue + 3 modules
var ManualMovementDelete = __webpack_require__(5365);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ManualMovementForm/ManualMovementForm.vue?vue&type=template&id=a52c0922
var ManualMovementFormvue_type_template_id_a52c0922_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"12","md":_vm.hasModule('stock-locations') ? 4 : 6}},[_c('b-form-group',{attrs:{"label":"Type de mouvement :"}},[(!_vm.movement.id)?_c('b-form-radio-group',{staticClass:"pt-2",attrs:{"name":"type"},model:{value:(_vm.movement.type),callback:function ($$v) {_vm.$set(_vm.movement, "type", $$v)},expression:"movement.type"}},[_c('b-form-radio',{attrs:{"value":1}},[_vm._v("Entrée")]),_c('b-form-radio',{attrs:{"value":2}},[_vm._v("Sortie")]),(_vm.hasModule('stock-locations'))?_c('b-form-radio',{attrs:{"value":3}},[_vm._v(" Transfert ")]):_vm._e()],1):[(_vm.movement.type === 1)?_c('span',[_vm._v("Entrée")]):_c('span',[_vm._v("Sortie")])]],2)],1),_c('b-col',{attrs:{"cols":"12","md":_vm.hasModule('stock-locations') ? 4 : 6}},[_c('b-form-group',{staticStyle:{"max-width":"150px"},attrs:{"label":"Date :"}},[_c('k-form-datepicker',{attrs:{"name":"date","required":""},model:{value:(_vm.movement.date),callback:function ($$v) {_vm.$set(_vm.movement, "date", $$v)},expression:"movement.date"}})],1)],1),(_vm.hasModule('stock-locations') && _vm.movement.type !== 3)?_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Lieu de stockage :"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.movement.stock_location?.id}}),_c('StockLocationSelect',{attrs:{"validationName":"stock_location","selectDefault":""},on:{"input":_vm.resetUsedLots},model:{value:(_vm.movement.stock_location),callback:function ($$v) {_vm.$set(_vm.movement, "stock_location", $$v)},expression:"movement.stock_location"}})],1)],1):_vm._e()],1),(_vm.hasModule('stock-locations') && _vm.movement.type === 3)?_c('b-form-row',[_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Stock de départ"}},[_c('input',{attrs:{"type":"hidden","name":"from_stock_location"},domProps:{"value":_vm.movement.from_stock_location?.id}}),_c('StockLocationSelect',{attrs:{"validationName":"from_stock_location","required":""},on:{"input":_vm.selectStartLocation},model:{value:(_vm.movement.from_stock_location),callback:function ($$v) {_vm.$set(_vm.movement, "from_stock_location", $$v)},expression:"movement.from_stock_location"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Stock de destination"}},[_c('input',{attrs:{"type":"hidden","name":"stock_location"},domProps:{"value":_vm.movement.stock_location?.id}}),_c('StockLocationSelect',{attrs:{"validationName":"stock_location","required":""},on:{"input":_vm.selectEndLocation},model:{value:(_vm.movement.stock_location),callback:function ($$v) {_vm.$set(_vm.movement, "stock_location", $$v)},expression:"movement.stock_location"}})],1)],1)],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Description"}},[_c('k-form-editor',{attrs:{"name":"comments","mode":"simple","size":"sm"},model:{value:(_vm.movement.comments),callback:function ($$v) {_vm.$set(_vm.movement, "comments", $$v)},expression:"movement.comments"}})],1),_c('h3',{staticClass:"form-title"},[_vm._v("Contenu")]),_c('CatalogSearch',{attrs:{"size":"sm","placeholder":"Rechercher un produit","only":['product', 'group'],"filters":_vm.catalogSearchFilters,"include":{ product: ['variation_levels', 'stockLocations'] }},on:{"selected":_vm.addProduct}}),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm mt-2 table-bordered text-nowrap"},[_c('thead',{staticClass:"thead-dark small"},[_c('tr',[_c('th',[_vm._v("Produit")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"120px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"21px"}})])]),_c('tbody',[(_vm.movement.contents.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"3"}},[_vm._v(" Aucun produit "),_c('input',{attrs:{"type":"hidden","name":"contents"},domProps:{"value":[]}})])]):_vm._e(),_vm._l((_vm.movement.contents),function(content,i){return [_c('tr',{key:i},[_c('td',{class:{
                'border-bottom-0': content.product && content.product.stock_tracking_mode !== 0 && (content.lots?.length > 0 || content.createdLots?.length > 0),
                 'align-middle': true,
                 'pt-3': true,
                 'pb-3': !(content.product.stock_tracking_mode !== 0 && (content.quantity > 0 || (content.createdLots && content.createdLots.length > 0)))
              }},[_vm._v(" "+_vm._s(content.product.name)+" "),_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i, 'variation')},domProps:{"value":_vm.movement.contents[i].variation ? _vm.movement.contents[i].variation.id : null}}),(content.product && content.product.variations_length > 0)?_c('ProductVariationSelect',{staticClass:"mt-3",attrs:{"product":content.product,"validationName":_vm.getInputName(i, 'variation')},model:{value:(_vm.movement.contents[i].variation),callback:function ($$v) {_vm.$set(_vm.movement.contents[i], "variation", $$v)},expression:"movement.contents[i].variation"}}):_vm._e()],1),_c('td',{class:{
                 'pt-3': true,
                 'pb-3': !(content.product.stock_tracking_mode !== 0 && (content.quantity > 0 || (content.createdLots && content.createdLots.length > 0)))
              }},[_c('k-form-spinner',{attrs:{"name":_vm.getInputName(i, 'quantity'),"size":"sm","min":_vm.minQuantity(content),"maxDecimal":5},on:{"input":function($event){return _vm.updateQuantity(i)}},model:{value:(_vm.movement.contents[i].quantity),callback:function ($$v) {_vm.$set(_vm.movement.contents[i], "quantity", $$v)},expression:"movement.contents[i].quantity"}}),_c('ProductStockIndicator',{staticClass:"mt-1 text-center",attrs:{"product":content.product,"variation":content.variation,"location":_vm.movement.stock_location,"location2":_vm.movement.from_stock_location}})],1),_c('td',{class:{
                  'align-middle': true,
                   'pt-3': true,
                   'pb-3': !(content.product.stock_tracking_mode !== 0 && (content.quantity > 0 || (content.createdLots && content.createdLots.length > 0)))
                }},[_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i, 'product')},domProps:{"value":content.product_id}}),(content.variation)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i,'variation')},domProps:{"value":content.variation.id}}):_vm._e(),(content.id)?_c('input',{attrs:{"type":"hidden","name":_vm.getInputName(i, 'id')},domProps:{"value":content.id}}):_vm._e(),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.hasModule('stock-tracabilities') && content.createdLots?.length > 0 ? 'Vous devez supprimer les lots avant de supprimer la ligne' : null }),expression:"{ title: hasModule('stock-tracabilities') && content.createdLots?.length > 0 ? 'Vous devez supprimer les lots avant de supprimer la ligne' : null }"}]},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Supprimer la ligne' }),expression:"{ title: 'Supprimer la ligne' }"}],staticClass:"p-0",attrs:{"variant":"icon","size":"sm","disabled":content.createdLots?.length > 0},on:{"click":function($event){return _vm.deleteLine(i)}}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']}})],1)],1)])]),(_vm.hasModule('stock-tracabilities') && content.product.stock_tracking_mode !== 0 && (content.quantity > 0 || (content.createdLots && content.createdLots.length > 0)))?_c('tr',{key:i + '-lot'},[_c('td',{staticClass:"border-top-0 pb-3",attrs:{"colspan":"3"}},[(_vm.movement.type === 1)?[_c('b-alert',{staticClass:"text-wrap",attrs:{"variant":"danger","show":content.createdLots && content.createdLots.length > content.quantity}},[_vm._v(" "+_vm._s(_vm.$t('catalog.manualMovement.lotExplain'))+" ")]),(content.product.stock_tracking_mode === 1)?_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v("N° de lot")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"180px"}},[_vm._v("Date d'expiration")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"180px"}},[_vm._v("Quantité dans le lot")])])]),_c('tbody',[_vm._l((content.createdLots),function(lot,index){return _c('tr',{key:'old-' + index},[_c('td',[_vm._v(_vm._s(lot.reference))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.date(lot.expire_at)))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.showNumber(lot.quantity)))])])}),_vm._l((content.lots),function(lot,index){return _c('tr',{key:'new-' + index},[_c('td',[_c('k-form-input',{attrs:{"name":_vm.getInputName(i, 'reference', index),"required":"","size":"sm"},model:{value:(_vm.movement.contents[i].lots[index].reference),callback:function ($$v) {_vm.$set(_vm.movement.contents[i].lots[index], "reference", $$v)},expression:"movement.contents[i].lots[index].reference"}})],1),_c('td',[_c('k-form-datepicker',{attrs:{"name":_vm.getInputName(i, 'expire_at', index),"required":"","size":"sm","positionFixed":""},model:{value:(_vm.movement.contents[i].lots[index].expire_at),callback:function ($$v) {_vm.$set(_vm.movement.contents[i].lots[index], "expire_at", $$v)},expression:"movement.contents[i].lots[index].expire_at"}})],1),_c('td',[_c('k-form-spinner',{attrs:{"name":_vm.getInputName(i, 'quantity', index),"min":0,"required":"","size":"sm","maxDecimal":5},on:{"input":function($event){return _vm.updateLotQuantity(content, index)}},model:{value:(_vm.movement.contents[i].lots[index].quantity),callback:function ($$v) {_vm.$set(_vm.movement.contents[i].lots[index], "quantity", $$v)},expression:"movement.contents[i].lots[index].quantity"}})],1)])})],2)]):(content.product.stock_tracking_mode === 2)?_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(" N° de série "),(content.lots.length > 1 && _vm.canGenerateSerial(content))?_c('k-form-checkbox',{staticClass:"d-inline-block ml-5",attrs:{"size":"sm"},on:{"input":state => state && content.lots.length > 2 ? _vm.generateSerial(content) : null},model:{value:(_vm.movement.contents[i].generate_serial),callback:function ($$v) {_vm.$set(_vm.movement.contents[i], "generate_serial", $$v)},expression:"movement.contents[i].generate_serial"}},[_vm._v(" Générer des numéros de série chronologique ")]):_vm._e()],1)])]),_c('tbody',[_vm._l((content.createdLots),function(lot,index){return _c('tr',{key:'old-' + index},[_c('td',[_vm._v(" "+_vm._s(lot.reference)+" ")])])}),_vm._l((content.lots),function(lot,index){return _c('tr',{key:'new-' + index},[_c('td',[_c('k-form-input',{attrs:{"name":_vm.getInputName(i, 'reference', index),"required":"","size":"sm","readonly":content.generate_serial && index > 0 && _vm.canGenerateSerial(content)},on:{"change":function($event){content.generate_serial && index === 0 && _vm.canGenerateSerial(content) ? _vm.generateSerial(content) : null}},model:{value:(_vm.movement.contents[i].lots[index].reference),callback:function ($$v) {_vm.$set(_vm.movement.contents[i].lots[index], "reference", $$v)},expression:"movement.contents[i].lots[index].reference"}})],1)])})],2)]):_vm._e()]:[_c('LotSelected',{attrs:{"product":content.product,"usedLots":_vm.movement.used_lots ?? [],"location":_vm.stockLocationLots},model:{value:(_vm.movement.contents[i]),callback:function ($$v) {_vm.$set(_vm.movement.contents, i, $$v)},expression:"movement.contents[i]"}}),_vm._l((_vm.movement.contents[i].used_lots),function(lot,index){return [_c('input',{key:'id-' + index,attrs:{"type":"hidden","name":'contents[' + i + '][use_lots][' + index + '][lot]'},domProps:{"value":lot.lot.id}}),_c('input',{key:'quantity-' + index,attrs:{"type":"hidden","name":'contents[' + i + '][use_lots][' + index + '][quantity]'},domProps:{"value":lot.quantity}})]})]],2)]):_vm._e()]})],2)])]),_c('b-alert',{attrs:{"variant":"danger","show":_vm.productWithLotDeleted}},[_vm._v(" "+_vm._s(_vm.$t('catalog.manualMovement.lotExplain2'))+" ")])],1)],1)
}
var ManualMovementFormvue_type_template_id_a52c0922_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./src/fetchDatas/manualMovement.ts
var manualMovement = __webpack_require__(4853);
// EXTERNAL MODULE: ./src/components/ProductVariationSelect/ProductVariationSelect.vue + 3 modules
var ProductVariationSelect = __webpack_require__(7081);
// EXTERNAL MODULE: ./src/components/ProductStockIndicator/ProductStockIndicator.vue + 3 modules
var ProductStockIndicator = __webpack_require__(4373);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ManualMovementForm/ManualMovementForm.ts?vue&type=script&lang=ts&external














var ManualMovementForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ManualMovementForm, _super);
    function ManualMovementForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.productWithLotDeleted = false;
        _this.movement = {
            contents: []
        };
        return _this;
    }
    Object.defineProperty(ManualMovementForm.prototype, "formUrl", {
        get: function () {
            return '/catalog/stock/manual' + (this.movement.id ? '/' + this.movement.id : '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementForm.prototype, "formMethod", {
        get: function () {
            return this.movement.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementForm.prototype, "canGenerateSerial", {
        get: function () {
            return function (content) {
                var lots = content.lots && content.lots.filter(function (lot) { return lot.id === undefined; });
                var serial = lots && lots.length > 0 ? lots[0].reference : null;
                if (!serial) {
                    return true;
                }
                var regex = /[0-9]+$/;
                var test = regex.exec(serial);
                return test !== null;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementForm.prototype, "minQuantity", {
        get: function () {
            return function (content) { var _a; return (_a = sumBy_default()(content.createdLots, 'quantity')) !== null && _a !== void 0 ? _a : 0; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementForm.prototype, "stockLocationLots", {
        get: function () {
            return this.movement.type === 3 ? this.movement.from_stock_location : this.movement.stock_location;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManualMovementForm.prototype, "catalogSearchFilters", {
        get: function () {
            var filters = {
                with_stock: true
            };
            if (this.movement.type === 3) {
                filters.with_stock_tracking_mode = 0;
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    ManualMovementForm.prototype.selectStartLocation = function () {
        var _a, _b;
        if (((_a = this.movement.stock_location) === null || _a === void 0 ? void 0 : _a.id) === ((_b = this.movement.from_stock_location) === null || _b === void 0 ? void 0 : _b.id)) {
            this.movement.stock_location = null;
        }
    };
    ManualMovementForm.prototype.selectEndLocation = function () {
        var _a, _b;
        if (((_a = this.movement.from_stock_location) === null || _a === void 0 ? void 0 : _a.id) === ((_b = this.movement.stock_location) === null || _b === void 0 ? void 0 : _b.id)) {
            this.movement.from_stock_location = null;
        }
    };
    ManualMovementForm.prototype.resetUsedLots = function () {
        var _this = this;
        this.movement.contents.forEach(function (content, i) {
            lib/* Vue */.lD.set(_this.movement.contents[i], 'used_lots', []);
        });
    };
    ManualMovementForm.prototype.watchMovementType = function () {
        if (this.movement.type !== 3) {
            return;
        }
        this.movement.contents = this.movement.contents.filter(function (content) {
            return content.product.stock_tracking_mode === 0;
        });
    };
    ManualMovementForm.prototype.watchValue = function (value) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var movement;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) return [3 /*break*/, 3];
                        if (!(value.id && (0,manualMovement/* needFetchManualMovement */.Y1)(value))) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0,manualMovement/* fetchManualMovement */.AD)(value.id)];
                    case 1:
                        value = _a.sent();
                        _a.label = 2;
                    case 2:
                        movement = JSON.parse(JSON.stringify(value));
                        movement.contents.map(function (content) {
                            if (content.lots && content.lots.length > 0) {
                                content.createdLots = content.lots;
                                content.lots = [];
                                if (!content.used_lots) {
                                    content.used_lots = [];
                                }
                            }
                            return content;
                        });
                        this.movement = movement;
                        return [3 /*break*/, 4];
                    case 3:
                        this.movement = {
                            type: 1,
                            date: new Date(),
                            contents: []
                        };
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ManualMovementForm.prototype.addProduct = function (data) {
        var product = data.data;
        if (this.movement.type === 3 && product.stock_tracking_mode !== 0) {
            return;
        }
        var searchFunc = function (content) { return content.product_id === product.id && content.product.variations_length === 0; };
        var line = this.movement.contents.find(searchFunc);
        if (line) {
            line.quantity++;
            var product_1 = line.product;
            if (product_1.with_stock && product_1.stock_tracking_mode && product_1.stock_tracking_mode > 0) {
                var index_1 = this.movement.contents.findIndex(searchFunc);
                this.updateQuantity(index_1);
            }
            return;
        }
        var index = this.movement.contents.push({
            product: product,
            product_id: product.id,
            variation: null,
            quantity: 1,
            lots: [],
            generate_serial: true
        });
        this.updateQuantity(index - 1);
    };
    ManualMovementForm.prototype.deleteLine = function (i) {
        var content = this.movement.contents[i];
        if (content.createdLots && content.createdLots.length > 0) {
            this.productWithLotDeleted = true;
        }
        lib/* Vue */.lD.delete(this.movement.contents, i);
    };
    ManualMovementForm.prototype.getInputName = function (index, name, lot) {
        if (lot === void 0) { lot = null; }
        if (name.indexOf('.')) {
            name = name.replaceAll('.', '][');
        }
        var input = 'contents[' + index + ']';
        if (lot !== null) {
            input += '[lots][' + lot + ']';
        }
        input += '[' + name + ']';
        return input;
    };
    ManualMovementForm.prototype.updateQuantity = function (index) {
        var _a, _b;
        var content = this.movement.contents[index];
        var stockMode = Number((_a = content.product) === null || _a === void 0 ? void 0 : _a.stock_tracking_mode);
        if (stockMode === 0) {
            return;
        }
        var lots = content.lots;
        var qty = this.roundNumber(content.quantity - this.roundNumber((_b = sumBy_default()(content.createdLots, 'quantity')) !== null && _b !== void 0 ? _b : 0, 5), 5);
        if (stockMode === 2) {
            // If stock with serial
            if (qty > lots.length) {
                for (var i = lots.length; i < qty; i++) {
                    lots.push({
                        reference: null
                    });
                }
            }
            else if (lots.length > qty) {
                for (var i = lots.length; i > qty; i--) {
                    lots.splice(-1, 1);
                }
            }
        }
        else if (stockMode === 1) {
            // If stock with lot
            if (lots.length === 0) {
                // If have not some lots
                if (qty > 0) {
                    lots.push({
                        reference: null,
                        expire_at: null,
                        quantity: qty
                    });
                }
            }
            else {
                // If have already some lots
                var actualQty = sumBy_default()(lots, 'quantity');
                if (actualQty < qty) {
                    // If need to add quantity, add to the last lot
                    var lastLot = lots[lots.length - 1];
                    lastLot.quantity = Number(lastLot.quantity) + (qty - actualQty);
                }
                else if (actualQty > qty) {
                    // If have too many quantity
                    var lastLot = lots[lots.length - 1];
                    var newQty = Number(lastLot.quantity) - (actualQty - qty);
                    if (newQty > 0) {
                        lastLot.quantity = newQty;
                    }
                    else {
                        lots.splice(-1, 1);
                        if (newQty !== 0) {
                            this.updateQuantity(index);
                        }
                    }
                }
            }
        }
    };
    ManualMovementForm.prototype.updateLotQuantity = function (content, index) {
        var _a;
        var lots = content.lots;
        var createdQty = ((_a = sumBy_default()(content.createdLots, 'quantity')) !== null && _a !== void 0 ? _a : 0);
        var qty = content.quantity - createdQty;
        var actualQty = sumBy_default()(lots, 'quantity');
        if (qty > actualQty) {
            if (index === (lots.length - 1)) {
                // If remove quantity from the last lot, add a new
                lots.push({
                    reference: null,
                    expire_at: null,
                    quantity: qty - actualQty
                });
            }
            else {
                // Add quantity to the last
                var lastLot = lots[lots.length - 1];
                lastLot.quantity = Number(lastLot.quantity) + (qty - actualQty);
            }
        }
        else if (actualQty > qty) {
            if (index === (lots.length - 1)) {
                content.quantity = actualQty + createdQty;
            }
            else {
                var lastLot = lots[lots.length - 1];
                var newQty = Number(lastLot.quantity) - (actualQty - qty);
                if (newQty > 0) {
                    lastLot.quantity = newQty;
                }
                else {
                    lots.splice(-1, 1);
                    if (newQty !== 0) {
                        this.updateLotQuantity(content, lots.length - 1);
                    }
                }
            }
        }
    };
    ManualMovementForm.prototype.generateSerial = function (content) {
        var _a;
        var lots = (_a = content.lots) === null || _a === void 0 ? void 0 : _a.filter(function (lot) { return lot.id === undefined; });
        if (lots && lots.length > 0 && lots[0].reference) {
            var prefix_1 = '';
            var number_1 = 0;
            lots.forEach(function (lot, i) {
                if (i === 0) {
                    // Take first serial and store datas
                    var reference = String(lot.reference);
                    var regex = /[0-9]+$/;
                    var test = regex.exec(reference);
                    if (test) {
                        prefix_1 = reference.substr(0, test.index);
                        number_1 = Number(test[0]);
                    }
                }
                else {
                    number_1++; // Increment serial
                    lot.reference = prefix_1 + number_1;
                }
            });
        }
    };
    ManualMovementForm.prototype.submitComplete = function (response) {
        var movement = response.data;
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('stockManuaMovementUpdated', { old: this.value, new: movement });
        }
        else {
            interface_vue_.emitter.emit('stockManuaMovementCreated', movement);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ManualMovementForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('movement.type')
    ], ManualMovementForm.prototype, "watchMovementType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ManualMovementForm.prototype, "watchValue", null);
    ManualMovementForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                ProductVariationSelect: ProductVariationSelect/* default */.A, LotSelected: LotSelected_LotSelected, CatalogSearch: CatalogSearch/* default */.A, StockLocationSelect: StockLocationSelect/* default */.A, ProductStockIndicator: ProductStockIndicator/* default */.A,
                KForm: form_vue_.KForm, KFormDatepicker: form_vue_.KFormDatepicker, KFormEditor: form_vue_.KFormEditor, KFormSpinner: form_vue_.KFormSpinner, KFormInput: form_vue_.KFormInput, KFormDatetime: form_vue_.KFormDatetime, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ManualMovementForm);
    return ManualMovementForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var ManualMovementFormvue_type_script_lang_ts_external = (ManualMovementForm);

;// ./src/components/ManualMovementForm/ManualMovementForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ManualMovementForm_ManualMovementFormvue_type_script_lang_ts_external = (ManualMovementFormvue_type_script_lang_ts_external); 
;// ./src/components/ManualMovementForm/ManualMovementForm.vue





/* normalize component */
;
var ManualMovementForm_component = (0,componentNormalizer/* default */.A)(
  ManualMovementForm_ManualMovementFormvue_type_script_lang_ts_external,
  ManualMovementFormvue_type_template_id_a52c0922_render,
  ManualMovementFormvue_type_template_id_a52c0922_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ManualMovementForm_ManualMovementForm = (ManualMovementForm_component.exports);
// EXTERNAL MODULE: ./src/components/ManualMovementItem/ManualMovementItem.vue + 3 modules
var ManualMovementItem = __webpack_require__(2685);
// EXTERNAL MODULE: ./src/components/ManualMovementList/ManualMovementList.vue + 3 modules
var ManualMovementList = __webpack_require__(6777);
// EXTERNAL MODULE: ./src/components/MovementList/MovementList.vue + 3 modules
var MovementList = __webpack_require__(5593);
// EXTERNAL MODULE: ./src/components/PdfViewer/PdfViewer.vue + 3 modules
var PdfViewer = __webpack_require__(7611);
// EXTERNAL MODULE: ./src/components/ProductDelete/ProductDelete.vue + 3 modules
var ProductDelete = __webpack_require__(160);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProductForm/ProductForm.vue?vue&type=template&id=32e3db76
var ProductFormvue_type_template_id_32e3db76_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{staticClass:"py-0 px-2",attrs:{"action":_vm.formAction,"method":_vm.localElement.id ? 'PUT' : 'POST',"validateDatas":_vm.validateFormDatas},on:{"submitComplete":_vm.submitComplete}},[(_vm.isGroup)?_c('input',{attrs:{"type":"hidden","name":"is_group"},domProps:{"value":true}}):_vm._e(),(_vm.hasVariations)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" Ce produit comporte des variations ")]):_vm._e(),_c('b-form-row',[(_vm.teamConfigs.product_reference_manual)?_c('b-col',{attrs:{"cols":"6","md":"2","order":"1","order-md":"1"}},[_c('b-form-group',{attrs:{"label":"Référence"}},[_c('k-form-input',{attrs:{"name":"reference","required":""},on:{"change":_vm.referenceUpdated},model:{value:(_vm.localElement.reference),callback:function ($$v) {_vm.$set(_vm.localElement, "reference", $$v)},expression:"localElement.reference"}})],1)],1):_vm._e(),_c('b-col',{attrs:{"cols":"12","md":"7","order":"3","order-md":"2"}},[_c('b-form-group',{attrs:{"label":"Nom"}},[_c('k-form-input',{attrs:{"name":"name","required":""},on:{"change":_vm.onNameChanged},model:{value:(_vm.localElement.name),callback:function ($$v) {_vm.$set(_vm.localElement, "name", $$v)},expression:"localElement.name"}})],1)],1),_c('b-col',{attrs:{"cols":"6","md":"3","order":"2","order-md":"3"}},[_c('b-form-group',{attrs:{"label":"Statut"}},[_c('k-form-select',{attrs:{"options":_vm.status,"reduce":val => val.id,"clearable":false},model:{value:(_vm.localElement.formStatus),callback:function ($$v) {_vm.$set(_vm.localElement, "formStatus", $$v)},expression:"localElement.formStatus"}}),_c('input',{attrs:{"type":"hidden","name":"status"},domProps:{"value":_vm.localElement.formStatus !== 1}}),_c('input',{attrs:{"type":"hidden","name":"not_for_sale"},domProps:{"value":_vm.localElement.formStatus === 3}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Désignation"}},[_c('k-form-editor',{attrs:{"name":"designation","mode":"simple","size":"sm","config":_vm.computedEditorConfig},model:{value:(_vm.localElement.designation),callback:function ($$v) {_vm.$set(_vm.localElement, "designation", $$v)},expression:"localElement.designation"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":"Catégorie de vente"}},[_c('k-form-select',{attrs:{"name":"sale_category","options":_vm.saleCategories,"reduce":val => val.label,"taggable":""},model:{value:(_vm.localElement.sale_category),callback:function ($$v) {_vm.$set(_vm.localElement, "sale_category", $$v)},expression:"localElement.sale_category"}})],1),(!_vm.isGroup)?_c('b-form-group',{attrs:{"label":"Catégorie de charge"}},[_c('k-form-select',{attrs:{"name":"charge_category","reduce":val => val.label,"options":_vm.chargeCategories,"taggable":""},model:{value:(_vm.localElement.charge_category),callback:function ($$v) {_vm.$set(_vm.localElement, "charge_category", $$v)},expression:"localElement.charge_category"}})],1):_vm._e()],1),_c('b-col',[_c('b-row',[_c('b-col',[(!_vm.hasVariations)?_c('b-form-group',{attrs:{"label":"Code EAN"}},[_c('k-form-input',{attrs:{"name":"ean_code"},model:{value:(_vm.localElement.ean_code),callback:function ($$v) {_vm.$set(_vm.localElement, "ean_code", $$v)},expression:"localElement.ean_code"}})],1):_vm._e()],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Poids"}},[_c('b-input-group',{attrs:{"append":"kg"}},[_c('k-form-number',{attrs:{"name":"unit_weight"},model:{value:(_vm.localElement.unit_weight),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_weight", $$v)},expression:"localElement.unit_weight"}})],1)],1)],1)],1),(!_vm.isGroup)?_c('b-form-group',{attrs:{"label":"Dimensions (L x l x h)"}},[_c('div',{staticClass:"d-flex"},[_c('div',[_c('b-input-group',{staticClass:"pr-1",attrs:{"append":"m"}},[_c('k-form-number',{attrs:{"name":"size_length","placeholder":"Longueur","noDefaultValue":""},model:{value:(_vm.localElement.size_length),callback:function ($$v) {_vm.$set(_vm.localElement, "size_length", $$v)},expression:"localElement.size_length"}})],1)],1),_c('div',[_c('b-input-group',{staticClass:"px-1",attrs:{"append":"m"}},[_c('k-form-number',{attrs:{"name":"size_width","placeholder":"Largeur","noDefaultValue":""},model:{value:(_vm.localElement.size_width),callback:function ($$v) {_vm.$set(_vm.localElement, "size_width", $$v)},expression:"localElement.size_width"}})],1)],1),_c('div',[_c('b-input-group',{attrs:{"append":"m"}},[_c('k-form-number',{staticClass:"pl-1",attrs:{"name":"size_height","placeholder":"Hauteur","noDefaultValue":""},model:{value:(_vm.localElement.size_height),callback:function ($$v) {_vm.$set(_vm.localElement, "size_height", $$v)},expression:"localElement.size_height"}})],1)],1)])]):_vm._e()],1)],1),(_vm.hasVariations)?_c('b-form-group',{staticStyle:{"max-width":"200px"},attrs:{"label":"Taux de TVA"}},[_c('input',{attrs:{"type":"hidden","name":"vat_rate"},domProps:{"value":_vm.localElement.vat_rate ? _vm.localElement.vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"selectDefault":""},on:{"input":_vm.calculUnitPriceHT},model:{value:(_vm.localElement.vat_rate),callback:function ($$v) {_vm.$set(_vm.localElement, "vat_rate", $$v)},expression:"localElement.vat_rate"}})],1):_vm._e(),_c('CustomFieldsForm',{attrs:{"title-class":"form-title-alt mt-2","type":"product"},model:{value:(_vm.localElement.custom_fields),callback:function ($$v) {_vm.$set(_vm.localElement, "custom_fields", $$v)},expression:"localElement.custom_fields"}}),_c('b-tabs',{staticClass:"mt-5",attrs:{"content-class":"mt-3"}},[(!_vm.hasVariations && _vm.localElement.formStatus !== 3)?_c('b-tab',{attrs:{"title":"Prix de vente"}},[_c('b-form-row',[_c('b-col',{staticClass:"sell-price-left-part",attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":"Prix vente HT","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ht","maxDecimal":5},on:{"change":_vm.calculUnitPriceHT},model:{value:(_vm.localElement.unit_price_ht),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_ht", $$v)},expression:"localElement.unit_price_ht"}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de TVA","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"vat_rate"},domProps:{"value":_vm.localElement.vat_rate ? _vm.localElement.vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"selectDefault":""},on:{"input":_vm.calculUnitPriceHT},model:{value:(_vm.localElement.vat_rate),callback:function ($$v) {_vm.$set(_vm.localElement, "vat_rate", $$v)},expression:"localElement.vat_rate"}})],1),_c('b-form-group',{attrs:{"label":"Montant TVA","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_tva","readonly":"","maxDecimal":5},model:{value:(_vm.localElement.unit_price_tva),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_tva", $$v)},expression:"localElement.unit_price_tva"}})],1)],1),_c('b-form-group',{attrs:{"label":"Prix vente TTC","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ttc"},on:{"change":_vm.calculUnitPriceTTC},model:{value:(_vm.localElement.unit_price_ttc),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_ttc", $$v)},expression:"localElement.unit_price_ttc"}})],1)],1),_c('b-form-group',{staticClass:"mt-lg-5",attrs:{"label":"Qté par défaut","label-cols-sm":"3"}},[_c('b-input-group',[_c('k-form-spinner',{attrs:{"name":"default_quantity","min":0,"maxDecimal":5},model:{value:(_vm.localElement.default_quantity),callback:function ($$v) {_vm.$set(_vm.localElement, "default_quantity", $$v)},expression:"localElement.default_quantity"}})],1)],1),_c('b-form-group',{attrs:{"label":"Unité","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"unit"},domProps:{"value":_vm.localElement.unit ? _vm.localElement.unit.label : null}}),_c('UnitSelect',{attrs:{"selectDefault":!_vm.localElement.id},model:{value:(_vm.localElement.unit),callback:function ($$v) {_vm.$set(_vm.localElement, "unit", $$v)},expression:"localElement.unit"}})],1),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":"Éco participation (inclus dans le prix de vente) :"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Montant HT"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","name":"eco_tax_ht"},on:{"change":_vm.calculEcoTaxHT},model:{value:(_vm.localElement.eco_tax_ht),callback:function ($$v) {_vm.$set(_vm.localElement, "eco_tax_ht", $$v)},expression:"localElement.eco_tax_ht"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Montant TVA"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","readonly":""},model:{value:(_vm.localElement.eco_tax_tva),callback:function ($$v) {_vm.$set(_vm.localElement, "eco_tax_tva", $$v)},expression:"localElement.eco_tax_tva"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Montant TTC"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"size":"sm","name":"eco_tax_ttc"},on:{"change":_vm.calculEcoTaxTTC},model:{value:(_vm.localElement.eco_tax_ttc),callback:function ($$v) {_vm.$set(_vm.localElement, "eco_tax_ttc", $$v)},expression:"localElement.eco_tax_ttc"}})],1)],1)],1)],1)],1)],1),_c('b-col',{attrs:{"cols":"12","lg":"5","offset":"0","offset-lg":"1"}},[_c('b-form-group',{attrs:{"label":"Prix d'achat U. HT","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[(_vm.localElement.is_group || (_vm.localElement.providers_references && _vm.localElement.providers_references.length > 1))?_c('k-form-number',{attrs:{"name":"unit_buy_price_ht","value":_vm.averageProviderUnitPrice,"maxDecimal":5,"readonly":""}}):_c('k-form-number',{attrs:{"name":"unit_buy_price_ht","maxDecimal":5},on:{"change":_vm.changeUnitPrice},model:{value:(_vm.localElement.unit_buy_price_ht),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_buy_price_ht", $$v)},expression:"localElement.unit_buy_price_ht"}})],1)],1),_c('b-form-group',{attrs:{"label":"Coûts divers","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"various_costs","maxDecimal":5},model:{value:(_vm.localElement.various_costs),callback:function ($$v) {_vm.$set(_vm.localElement, "various_costs", $$v)},expression:"localElement.various_costs"}})],1)],1),_c('b-form-group',{attrs:{"label":"Coûts total","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.totalCosts,"maxDecimal":5,"readonly":""}})],1)],1),_c('b-form-group',{staticClass:"mt-lg-5",attrs:{"label":"Marge par produit","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.grossMarginAmount},on:{"change":_vm.updateMarginAmount}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de marge","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"value":_vm.grossMarginRate},on:{"change":_vm.updateMarginRate}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de marque","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"value":_vm.markupRate},on:{"change":_vm.updateMarkupRate}})],1)],1),_c('input',{attrs:{"type":"hidden","name":"cant_change_price"},domProps:{"value":_vm.localElement.cant_change_price}}),_c('b-form-checkbox',{staticClass:"mt-5 pr-5",model:{value:(_vm.localElement.cant_change_price),callback:function ($$v) {_vm.$set(_vm.localElement, "cant_change_price", $$v)},expression:"localElement.cant_change_price"}},[_vm._v(" Bloquer la modification du prix de vente lors l'édition des documents de vente ")])],1)],1)],1):_vm._e(),(_vm.isGroup)?_c('b-tab',{attrs:{"title":"Contenu"}},[(_vm.hasModule('stock'))?[_c('input',{attrs:{"type":"hidden","name":"group_stock_management"},domProps:{"value":_vm.localElement.group_stock_management ? true : false}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localElement.group_stock_management),callback:function ($$v) {_vm.$set(_vm.localElement, "group_stock_management", $$v)},expression:"localElement.group_stock_management"}},[_c('span',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Déduire automatiquement les produits du stock ")])])]:_vm._e(),_c('CatalogSearch',{attrs:{"size":"sm","only":['product', 'service'],"filters":{ with_stock_tracking_mode: 0, has_variations: 0 }},on:{"selected":_vm.addGroupContent}}),_c('div',{staticClass:"table-responsive mb-0"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 align-middle mb-0 text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Type")]),_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom")]),_c('th',{staticStyle:{"width":"140px"}},[_vm._v("Coûts U.")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Coûts total")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),(_vm.localElement.group_contents?.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"7"}},[_c('p',{staticClass:"mb-0"},[_vm._v("Aucun produit")])])]):_vm._e(),_vm._l((_vm.localElement.group_contents),function(content,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.$t('catalog.' + content.catalog.type + '.label')))]),_c('td',[_vm._v(_vm._s(content.catalog.element.reference))]),_c('td',[_vm._v(_vm._s(content.catalog.element.name))]),_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(content.catalog.element.total_costs))+" ")]),_c('td',[_c('k-form-spinner',{attrs:{"name":'group_contents[' + i + '][quantity]',"size":"sm","maxDecimal":2},model:{value:(content.quantity),callback:function ($$v) {_vm.$set(content, "quantity", $$v)},expression:"content.quantity"}})],1),_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.groupContentTotalCost(i)))+" ")]),_c('td',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",modifiers:{"left":true}}],staticClass:"p-0 text-danger",attrs:{"variant":"icon","title":"Supprimer le produit"},on:{"click":function($event){$event.preventDefault();return _vm.deleteGroupContent(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1),_c('input',{attrs:{"type":"hidden","name":'group_contents[' + i + '][catalog][type]'},domProps:{"value":content.catalog.type}}),_c('input',{attrs:{"type":"hidden","name":'group_contents[' + i + '][catalog][id]'},domProps:{"value":content.catalog.id}})],1)])})],2)])],2):_vm._e(),(_vm.hasVariations)?_c('b-tab',{attrs:{"title":"Fournisseurs"}},[_c('b-form-group',{attrs:{"label":"Fournisseur(s) proposant ce produit"}},[_vm._l((_vm.localElement.providers),function(provider){return _c('input',{key:provider.id,attrs:{"type":"hidden","name":"providers[]"},domProps:{"value":provider.id}})}),_c('b-input-group',[_c('k-form-select',{attrs:{"ajax":_vm.providerApiUrl,"ajax-cache":_vm.providersCache,"label":"name","multiple":""},on:{"cacheUpdated":val => _vm.providersCache = val},model:{value:(_vm.localElement.providers),callback:function ($$v) {_vm.$set(_vm.localElement, "providers", $$v)},expression:"localElement.providers"}}),_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right.hover",modifiers:{"right":true,"hover":true}}],staticClass:"px-2",attrs:{"title":_vm.$t('customers.provider.addLabel'),"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.newProvider(_vm.localElement.providers)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}})],1)],1)],1)],2)],1):_vm._e(),(!_vm.hasVariations && !_vm.isGroup)?_c('b-tab',{attrs:{"title":"Références fournisseurs"}},[_c('div',{staticClass:"table-responsive mb-2"},[_c('table',{staticClass:"table table-bordered table-sm mb-1 text-nowrap product-providers-reference-form"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Fournisseur")]),_c('th',[_vm._v("Référence")]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Prix U. HT")]),_c('th',{staticStyle:{"width":"205px"}},[_vm._v("Coûts divers")]),_c('th',[_vm._v("Coûts total")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),_c('tbody',[(!_vm.localElement.providers_references || _vm.localElement.providers_references.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',[_vm._v("Aucune référence fournisseur")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewProviderReference()}}},[_vm._v(" Ajouter une référence ")])],1)]):_vm._e(),_vm._l((_vm.localElement.providers_references),function(reference,i){return _c('tr',{key:i},[_c('td',[_c('input',{attrs:{"type":"hidden","name":'providers_references[' + i + '][customer]'},domProps:{"value":reference.customer ? reference.customer.id : null}}),_c('b-input-group',[_c('k-form-select',{attrs:{"label":"name","ajax":_vm.providerApiUrl,"ajax-cache":_vm.providersCache,"size":"sm","required":""},on:{"cacheUpdated":val => _vm.providersCache = val},model:{value:(reference.customer),callback:function ($$v) {_vm.$set(reference, "customer", $$v)},expression:"reference.customer"}}),_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.right.hover",modifiers:{"right":true,"hover":true}}],staticClass:"px-2",attrs:{"title":_vm.$t('customers.provider.addLabel'),"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.newProvider(_vm.localElement.providers)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}})],1)],1)],1)],1),_c('td',[_c('k-form-input',{attrs:{"name":'providers_references[' + i + '][reference]',"size":"sm","required":""},model:{value:(reference.reference),callback:function ($$v) {_vm.$set(reference, "reference", $$v)},expression:"reference.reference"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'providers_references[' + i + '][buy_price_ht]',"maxDecimal":5,"size":"sm","required":""},model:{value:(reference.buy_price_ht),callback:function ($$v) {_vm.$set(reference, "buy_price_ht", $$v)},expression:"reference.buy_price_ht"}})],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"name":'providers_references[' + i + '][various_costs]',"maxDecimal":5,"size":"sm","required":""},model:{value:(reference.various_costs),callback:function ($$v) {_vm.$set(reference, "various_costs", $$v)},expression:"reference.various_costs"}})],1)],1),_c('td',{staticClass:"text-right align-middle"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.calculProviderReferenceTotalLine(reference)))+" ")]),_c('td',{staticClass:"text-center px-0 align-middle"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){return _vm.deleteProviderReference(i)}}},[_vm._v(" X ")])],1)])})],2)])]),(_vm.localElement.providers_references && _vm.localElement.providers_references.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return _vm.addNewProviderReference()}}},[_vm._v(" Ajouter une référence fournisseur ")]):_vm._e()],1):_vm._e(),(_vm.hasModule('stock'))?_c('b-tab',{attrs:{"title":"Gestion du stock"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"auto"}},[_c('b-form-group',{attrs:{"label":"Gestion du stock :","label-class":"pb-2"}},[_c('b-form-radio-group',{attrs:{"name":"with_stock"},model:{value:(_vm.localElement.with_stock),callback:function ($$v) {_vm.$set(_vm.localElement, "with_stock", $$v)},expression:"localElement.with_stock"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v("Oui")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v("Non")])],1)],1)],1),_c('b-col',[(_vm.localElement.with_stock && !_vm.hasVariations)?_c('b-form-group',{attrs:{"label":"Traçabilité des produits :"}},[_c('k-form-select',{attrs:{"name":"stock_tracking_mode","options":_vm.traceabilities,"reduce":val => val.id,"clearable":false},model:{value:(_vm.localElement.stock_tracking_mode),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_tracking_mode", $$v)},expression:"localElement.stock_tracking_mode"}})],1):_vm._e()],1),(!_vm.hasVariations && _vm.localElement.with_stock && _vm.localElement.stock_tracking_mode === 2)?_c('b-col',{attrs:{"cols":"12","lg":"2"}},[_c('b-form-group',{attrs:{"label":"Durée de la garantie"}},[_c('b-input-group',[_c('k-form-spinner',{attrs:{"name":"warranty_duration","noDefaultValue":"","required":"","min":0},model:{value:(_vm.localElement.warranty_duration),callback:function ($$v) {_vm.$set(_vm.localElement, "warranty_duration", $$v)},expression:"localElement.warranty_duration"}}),_c('b-input-group-append',[_c('b-input-group-text',[_vm._v(" mois ")])],1)],1)],1)],1):_vm._e()],1),(_vm.localElement.with_stock)?_c('div',[(!_vm.hasVariations && !_vm.hasModule('stock-locations'))?_c('b-row',[_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock réel"}},[_c('k-form-spinner',{attrs:{"name":"stock_quantity","disabled":_vm.localElement.stock_tracking_mode > 0,"maxDecimal":5},model:{value:(_vm.localElement.stock_quantity),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_quantity", $$v)},expression:"localElement.stock_quantity"}})],1)],1),_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock théorique"}},[_c('k-form-spinner',{attrs:{"name":"stock_theoretical_quantity"},model:{value:(_vm.localElement.stock_theoretical_quantity),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_theoretical_quantity", $$v)},expression:"localElement.stock_theoretical_quantity"}})],1)],1)],1):_vm._e(),(_vm.localElement.stock_tracking_mode > 0)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" Il n'est pas possible de modifier manuellement le niveau de stock lorsque la traçabilité est activée. Il est possible de passer par les entrées et sorties de stock pour ajouter ou retirer des lots. ")]):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock mini"}},[_c('k-form-spinner',{attrs:{"name":"stock_minimum","min":0,"maxDecimal":5,"noDefaultValue":""},model:{value:(_vm.localElement.stock_minimum),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_minimum", $$v)},expression:"localElement.stock_minimum"}})],1)],1),_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Stock maxi"}},[_c('k-form-spinner',{attrs:{"name":"stock_maximum","min":0,"maxDecimal":5,"noDefaultValue":""},model:{value:(_vm.localElement.stock_maximum),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_maximum", $$v)},expression:"localElement.stock_maximum"}})],1)],1),_c('b-col',{attrs:{"cols":"6","md":"3"}},[_c('b-form-group',{attrs:{"label":"Seuil d'alerte"}},[_c('k-form-spinner',{attrs:{"name":"stock_alert","min":0,"maxDecimal":5,"noDefaultValue":""},model:{value:(_vm.localElement.stock_alert),callback:function ($$v) {_vm.$set(_vm.localElement, "stock_alert", $$v)},expression:"localElement.stock_alert"}})],1)],1)],1)],1):_vm._e()],1):_vm._e(),(_vm.hasModule('catalog-variations') && _vm.localElement.formStatus !== 3 && !_vm.isGroup)?_c('b-tab',{attrs:{"title":"Variations"}},[_c('p',[_vm._v(" Indiquer ici les différents niveaux de variation qui compose votre produit (Ex: Couleur, Taille)."),_c('br')]),(_vm.localElement.variations_length > 0)?_c('div',{staticClass:"alert alert-info"},[(_vm.localElement.id)?[_vm._v(" Les différentes variations peuvent être saisies depuis la fiche produit. ")]:[_vm._v(" Les différentes variations pourront être saisies par la suite depuis la fiche produit. ")]],2):_vm._e(),(_vm.localElement.id && _vm.localElement.variations_length > 0)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" Attention, si vous modifier les niveaux de variation et que des variations existent déjà sur ce produit, celles-ci seront supprimées. Pour simplement renommer une variation existante, vous devez passer par la configuration. ")]):_vm._e(),_c('b-form-group',{attrs:{"label":"Nombre de niveaux de variation","label-cols-sm":"3"}},[_c('k-form-select',{attrs:{"name":"variations_length","options":_vm.variationLevelsLength,"reduce":val => val.value,"clearable":false},model:{value:(_vm.localElement.variations_length),callback:function ($$v) {_vm.$set(_vm.localElement, "variations_length", $$v)},expression:"localElement.variations_length"}})],1),(_vm.localElement.variations_length > 0)?_c('b-form-group',{attrs:{"label":"Nom du niveau 1","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"variation_level1"},domProps:{"value":_vm.variationLevelValue(_vm.localElement.variation_level1)}}),_c('k-form-select',{attrs:{"validationName":"variation_level1","options":_vm.variationLevels,"label":"label","required":"","taggable":"","clearable":false},model:{value:(_vm.localElement.variation_level1),callback:function ($$v) {_vm.$set(_vm.localElement, "variation_level1", $$v)},expression:"localElement.variation_level1"}})],1):_vm._e(),(_vm.localElement.variations_length > 1)?_c('b-form-group',{attrs:{"label":"Nom du niveau 2","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"variation_level2"},domProps:{"value":_vm.variationLevelValue(_vm.localElement.variation_level2)}}),_c('k-form-select',{attrs:{"validationName":"variation_level2","options":_vm.variationLevels,"label":"label","required":"","taggable":"","clearable":false},model:{value:(_vm.localElement.variation_level2),callback:function ($$v) {_vm.$set(_vm.localElement, "variation_level2", $$v)},expression:"localElement.variation_level2"}})],1):_vm._e(),(_vm.localElement.variations_length > 2)?_c('b-form-group',{attrs:{"label":"Nom du niveau 3","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"variation_level3"},domProps:{"value":_vm.variationLevelValue(_vm.localElement.variation_level3)}}),_c('k-form-select',{attrs:{"validationName":"variation_level3","options":_vm.variationLevels,"label":"label","required":"","taggable":"","clearable":false},model:{value:(_vm.localElement.variation_level3),callback:function ($$v) {_vm.$set(_vm.localElement, "variation_level3", $$v)},expression:"localElement.variation_level3"}})],1):_vm._e(),(_vm.localElement.variations_length > 0)?_c('div',{staticClass:"font-weight-bold text-danger mt-5"},[_vm._v(" Vous pouvez ajouter des variables dynamiques dans la désignation du produit, celles-ci seront automatiquement remplacées par la valeur de la variation. Pour ajouter une variable, vous devez cliquer sur le bouton rouge situé dans le menu de l'éditeur de texte (gras, italique...). ")]):_vm._e()],1):_vm._e(),(!_vm.hasVariations && _vm.hasModule('catalog-custom-prices') && _vm.localElement.formStatus !== 3)?_c('b-tab',{attrs:{"title":"Prix personnalisé"}},[_c('custom-prices',{model:{value:(_vm.localElement),callback:function ($$v) {_vm.localElement=$$v},expression:"localElement"}})],1):_vm._e()],1)],1)],1)
}
var ProductFormvue_type_template_id_32e3db76_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(2193);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: external "froala-editor"
var external_froala_editor_ = __webpack_require__(189);
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_);
;// ./src/mixins/editorConfig.ts

var buttons = [
    'bold',
    'italic',
    'underline',
    '|',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    '|',
    'textColor',
    'backgroundColor',
    '|',
    'formatUL',
    'formatOL',
    '|',
    'insertDynamicVariables'
];
var moreMisc = {
    buttons: ['undo', 'redo', 'html'],
    align: 'right',
    buttonsVisible: 0
};
var config = {
    enter: (external_froala_editor_default()).ENTER_BR,
    fontSize: ['6', '7', '8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtonsXS: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 0,
        }
    },
    toolbarButtonsSM: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 4,
        }
    },
    toolbarButtonsMD: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 5,
        }
    },
    toolbarButtons: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 12
        },
        moreMisc: moreMisc
    },
    htmlAllowedStyleProps: ['font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color'],
    pastePlain: false,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    pasteDeniedAttrs: ['class', 'id'],
    htmlAllowComments: false,
    imageUpload: false,
    events: {
        'paste.afterCleanup': function (content) {
            return content.replaceAll(/<br([^>])+?>/gi, '<br>')
                .replaceAll(/font-size: ?([\d.]+)px/gi, 'font-size: $1pt');
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./src/mixins/CatalogElementMixin.ts







var CatalogElementMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogElementMixin, _super);
    function CatalogElementMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(CatalogElementMixin.prototype, "totalCosts", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogElementMixin.prototype, "status", {
        get: function () {
            return [
                { id: false, label: this.$t('catalog.form.status.disable') },
                { id: true, label: this.$t('catalog.form.status.enable') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CatalogElementMixin.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSaleCategories()];
                    case 1:
                        _a.sent();
                        if (this.value) {
                            if (this.value.id) {
                                this.checkElementDatas(this.value)
                                    .then(this.setLocalElement);
                            }
                            else {
                                this.localElement = JSON.parse(JSON.stringify(merge_default()(this.localElement, this.value)));
                            }
                        }
                        if ((this.value && !this.id) || !this.id) {
                            this.loading = false;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CatalogElementMixin.prototype, "grossMarginAmount", {
        get: function () {
            return +this.number(this.localElement.unit_price_ht) - +this.totalCosts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogElementMixin.prototype, "grossMarginRate", {
        get: function () {
            var costs = this.totalCosts;
            if (costs === 0) {
                return 0;
            }
            return (this.grossMarginAmount / costs) * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogElementMixin.prototype, "markupRate", {
        get: function () {
            var price = this.number(this.localElement.unit_price_ht);
            if (price === 0) {
                return 0;
            }
            var rate = (this.grossMarginAmount / price) * 100;
            return rate >= 100 ? 99.99 : rate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogElementMixin.prototype, "vatRate", {
        get: function () {
            return this.localElement.vat_rate ? this.number(this.localElement.vat_rate.rate) : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogElementMixin.prototype, "computedEditorConfig", {
        get: function () {
            var customFields = {
                dynamicVariables: {
                    variations: {
                        label: 'Variations de produit',
                        variables: [
                            { value: 'VARIATION-LEVEL1', label: 'Valeur de la variation pour le niveau 1' },
                            { value: 'VARIATION-LEVEL2', label: 'Valeur de la variation pour le niveau 2' },
                            { value: 'VARIATION-LEVEL3', label: 'Valeur de la variation pour le niveau 3' }
                        ]
                    },
                    contracts: {
                        label: 'Contrats',
                        variables: [
                            { value: 'CONTRACT-NUM', label: 'Référence du contrat' },
                            { value: 'CONTRACT-TITLE', label: 'Titre du contrat' },
                            { value: 'CONTRACT-BEGIN', label: 'Date de début de l\'échéance' },
                            { value: 'CONTRACT-END', label: 'Date de fin de l\'échéance' }
                        ]
                    }
                }
            };
            var fields = this.customFields.filter(function (field) { return field.usage.includes('contract'); });
            if (fields.length > 0) {
                var variables_1 = [];
                fields.forEach(function (field) {
                    variables_1.push({
                        value: 'CUSTOM-FIELD-' + field.id,
                        label: field.label
                    });
                });
                customFields.dynamicVariables['customFields'] = {
                    label: 'Contrats - Champs personnalisés',
                    variables: variables_1
                };
            }
            return merge_default()(editorConfig, customFields);
        },
        enumerable: false,
        configurable: true
    });
    // Check if the element has all relationship loaded, override in component
    CatalogElementMixin.prototype.checkElementDatas = function (element) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                return [2 /*return*/, element];
            });
        });
    };
    CatalogElementMixin.prototype.onNameChanged = function () {
        if (!this.localElement.designation || this.localElement.designation === '') {
            this.localElement.designation = this.localElement.name;
        }
    };
    // Apply element property
    CatalogElementMixin.prototype.setLocalElement = function (element) {
        var formElement = JSON.parse(JSON.stringify(element));
        formElement.formStatus = element.status.active;
        this.localElement = formElement;
    };
    // update sale price from margin amount
    CatalogElementMixin.prototype.updateMarginAmount = function (amount) {
        this.localElement.unit_price_ht = this.number(this.totalCosts) + this.number(amount);
        this.calculUnitPriceHT();
    };
    // update sale price from margin rate
    CatalogElementMixin.prototype.updateMarginRate = function (rate) {
        this.localElement.unit_price_ht = this.number(this.totalCosts) * (1 + (this.number(rate) / 100));
        this.calculUnitPriceHT();
    };
    // update sale price from markup rate
    CatalogElementMixin.prototype.updateMarkupRate = function (rate) {
        this.localElement.unit_price_ht = this.number(this.totalCosts) / (100 - this.number(rate)) * 100;
        this.calculUnitPriceHT();
    };
    // Calculate unit prices from ht
    CatalogElementMixin.prototype.calculUnitPriceHT = function () {
        var val = this.number(this.localElement.unit_price_ht);
        var tva = this.roundNumber(val * this.vatRate / 100, 2);
        var ttc = this.roundNumber(tva + val, 2);
        this.localElement.unit_price_tva = tva;
        this.localElement.unit_price_ttc = ttc;
    };
    // Calculate unit prices from ttc
    CatalogElementMixin.prototype.calculUnitPriceTTC = function (val) {
        var ht = val / ((this.vatRate / 100) + 1);
        this.localElement.unit_price_tva = this.roundNumber(val - ht, 2);
        this.localElement.unit_price_ht = ht;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogElementMixin.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CatalogElementMixin.prototype, "id", void 0);
    CatalogElementMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'currency'])), (0,external_vuex_.mapState)('catalog', ['saleCategories'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('customFields', ['customFields'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadSaleCategories'])),
            components: {
                CustomPrices: CustomPrices_CustomPrices,
                Spinner: interface_vue_.Spinner,
                UnitSelect: interface_vue_.UnitSelect,
                VatRateSelect: interface_vue_.VatRateSelect
            }
        })
    ], CatalogElementMixin);
    return CatalogElementMixin;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var mixins_CatalogElementMixin = (CatalogElementMixin);

// EXTERNAL MODULE: ./src/fetchDatas/product.ts
var fetchDatas_product = __webpack_require__(5719);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ProductForm/ProductForm.ts?vue&type=script&lang=ts&external













var ProductForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProductForm, _super);
    function ProductForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localElement = {
            designation: null,
            status: { active: true },
            not_for_sale: false,
            variations_length: 0,
            providers_references: [],
            customers_price: [],
            unit_buy_price_ht: 0,
            unit_price_ht: 0,
            unit_price_tva: 0,
            unit_price_ttc: 0,
            default_quantity: 1,
            formStatus: 2,
            with_stock: false,
            stock_tracking_mode: 0,
            cant_change_price: false,
            custom_price_mode: 'quantity',
            custom_fields: [],
            group_contents: []
        };
        _this.traceabilities = [
            { id: 0, label: _this.$t('catalog.form.traceabilities.no') },
            { id: 1, label: _this.$t('catalog.form.traceabilities.lot') },
            { id: 2, label: _this.$t('catalog.form.traceabilities.serial') }
        ];
        _this.variationLevelsLength = [
            { value: 0, label: _this.$t('catalog.form.variationLevels.no') },
            { value: 1, label: _this.$tc('catalog.form.variationLevels.level', 1) },
            { value: 2, label: _this.$tc('catalog.form.variationLevels.level', 2) },
            { value: 3, label: _this.$tc('catalog.form.variationLevels.level', 3) }
        ];
        _this.providersCache = {};
        return _this;
    }
    Object.defineProperty(ProductForm.prototype, "status", {
        get: function () {
            var status = [
                { id: 1, label: this.$t('catalog.form.status.disable') },
                { id: 2, label: this.$t('catalog.form.status.enable') }
            ];
            if (!this.isGroup) {
                status.push({ id: 3, label: this.$t('catalog.form.status.notForSale') });
            }
            return status;
        },
        enumerable: false,
        configurable: true
    });
    ProductForm.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var product;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0,fetchDatas_product/* fetchProduct */.yj)(this.id)];
                    case 1:
                        product = _a.sent();
                        this.setLocalElement(product);
                        this.loading = false;
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.teamConfigs.stock_new_product_state) {
                            this.localElement.with_stock = true;
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProductForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadChargeCategories()];
                    case 1:
                        _a.sent();
                        if (!this.hasModule('catalog-variations')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadVariationLevels()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProductForm.prototype, "formAction", {
        // Return form url
        get: function () {
            var url = '/catalog/product';
            if (this.localElement.id) {
                url += '/' + this.localElement.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductForm.prototype, "providerApiUrl", {
        get: function () {
            return '/customer?sort=name&filter[is_provider]=1';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductForm.prototype, "averageProviderUnitPrice", {
        // Return the average costs of providers reference
        get: function () {
            var _this = this;
            var _a;
            if (this.localElement.is_group) {
                return sumBy_default()(this.localElement.group_contents, function (content) { var _a, _b; return _this.roundNumber(_this.number(content.quantity) * _this.number((_b = (_a = content === null || content === void 0 ? void 0 : content.catalog) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.total_costs), 2); });
            }
            var references = (_a = this.localElement.providers_references) !== null && _a !== void 0 ? _a : [];
            var total = references.map(function (ref) { return _this.calculProviderReferenceTotalLine(ref) * 100; })
                .reduce(function (a, b) { return a + (b || 0); });
            return Math.round(total / references.length) / 100;
        },
        enumerable: false,
        configurable: true
    });
    ProductForm.prototype.watchProvidersReferences = function () {
        if (this.localElement.providers_references.length === 1) {
            this.localElement.unit_buy_price_ht = this.averageProviderUnitPrice;
        }
    };
    ProductForm.prototype.changeUnitPrice = function () {
        var _a;
        if (this.localElement.providers_references.length === 1) {
            this.localElement.providers_references[0].buy_price_ht = this.localElement.unit_buy_price_ht - ((_a = this.localElement.providers_references[0].various_costs) !== null && _a !== void 0 ? _a : 0);
        }
    };
    Object.defineProperty(ProductForm.prototype, "totalCosts", {
        // Return the amount of all costs
        get: function () {
            var price = !this.localElement.providers_references || this.localElement.providers_references.length === 0 ?
                this.number(this.localElement.unit_buy_price_ht) :
                this.averageProviderUnitPrice;
            return +price + +this.number(this.localElement.various_costs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductForm.prototype, "vatRate", {
        // Return the vat rate to use
        get: function () {
            return this.localElement.vat_rate ? this.number(this.localElement.vat_rate.rate) : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductForm.prototype, "variationLevelValue", {
        get: function () {
            return function (level) {
                if (level === undefined || level === null) {
                    return null;
                }
                else if (typeof level === 'string') {
                    return level;
                }
                else {
                    return level.label;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductForm.prototype, "hasVariations", {
        get: function () {
            return this.number(this.localElement.variations_length) > 0 && this.hasModule('catalog-variations');
        },
        enumerable: false,
        configurable: true
    });
    ProductForm.prototype.checkElementDatas = function (element) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                if (element.id && (0,fetchDatas_product/* needFetchProduct */.U8)(element)) {
                    return [2 /*return*/, (0,fetchDatas_product/* fetchProduct */.yj)(element.id)];
                }
                return [2 /*return*/, element];
            });
        });
    };
    // Set the local product
    ProductForm.prototype.setLocalElement = function (product) {
        var localElement = JSON.parse(JSON.stringify(product));
        // Set the local status
        localElement.formStatus = product.not_for_sale ? 3 : product.status && product.status.active ? 2 : 1;
        if (!localElement.providers) {
            localElement.providers = [];
        }
        if (!localElement.providers_references) {
            localElement.providers_references = [];
        }
        if (!localElement.custom_fields) {
            localElement.custom_fields = [];
        }
        if (!localElement.group_contents) {
            localElement.group_contents = [];
        }
        this.localElement = localElement;
    };
    // Add a provider reference
    ProductForm.prototype.addNewProviderReference = function () {
        this.localElement.providers_references.push({});
    };
    // Remove a provider reference
    ProductForm.prototype.deleteProviderReference = function (index) {
        this.localElement.providers_references.splice(index, 1);
    };
    // Caculate total costs for a product for a provider line
    ProductForm.prototype.calculProviderReferenceTotalLine = function (reference) {
        var unit_price = this.number(reference.buy_price_ht);
        var various_costs = this.number(reference.various_costs);
        return unit_price + various_costs;
    };
    // Calculate eco tax amounts from ht
    ProductForm.prototype.calculEcoTaxHT = function (val) {
        var tva = val * this.vatRate / 100;
        var ttc = tva + val;
        this.localElement.eco_tax_tva = tva;
        this.localElement.eco_tax_ttc = ttc;
    };
    // Calculate eco tax amounts from ttc
    ProductForm.prototype.calculEcoTaxTTC = function (val) {
        var ht = val / ((this.vatRate / 100) + 1);
        this.localElement.eco_tax_tva = val - ht;
        this.localElement.eco_tax_ht = ht;
    };
    // Validate datas before submit form
    ProductForm.prototype.validateFormDatas = function () {
        var _this = this;
        var errors = {};
        // Check providers references
        if (!this.hasVariations && this.localElement.providers_references.length > 0) {
            var providers_1 = Array.from(this.localElement.providers_references);
            var duplicates_1 = [];
            providers_1.forEach(function (ref, idx) {
                var duplicate = providers_1.find(function (v, i) {
                    return v.customer && ref.customer && v.customer.id === ref.customer.id && v.reference === ref.reference && i !== idx;
                });
                if (duplicate !== undefined) {
                    duplicates_1.push(idx);
                }
            });
            duplicates_1.forEach(function (i) {
                errors['providers_references.' + i + '.reference'] = [_this.$t('catalog.form.duplicateProviderReferenceError')];
            });
        }
        // Check variations
        if (this.localElement.variations_length > 1) {
            var variations_1 = [this.variationLevelValue(this.localElement.variation_level1), this.variationLevelValue(this.localElement.variation_level2)];
            if (this.localElement.variations_length === 3) {
                variations_1.push(this.variationLevelValue(this.localElement.variation_level3));
            }
            var duplicates_2 = [];
            variations_1.forEach(function (variation, idx) {
                var duplicate = variations_1.find(function (v, i) {
                    return v && variation && v === variation && i !== idx;
                });
                if (duplicate !== undefined) {
                    duplicates_2.push(idx);
                }
            });
            duplicates_2.forEach(function (i) {
                errors['variation_level' + (i + 1)] = [_this.$t('catalog.form.duplicateVariationLevelError')];
            });
        }
        if (isEmpty_default()(errors)) {
            return true;
        }
        return errors;
    };
    // Create a new provider
    ProductForm.prototype.newProvider = function (target) {
        var _this = this;
        this.openModal({
            key: 'provider-form',
            attributes: {
                withRedirection: false
            },
            submitted: function (response) {
                var _a;
                var provider = response.data;
                (_a = _this.providersCache.options) === null || _a === void 0 ? void 0 : _a.push(provider);
                if (Array.isArray(target)) {
                    target.push(provider);
                }
                else {
                    target = provider;
                }
            }
        });
    };
    ProductForm.prototype.submitComplete = function (response) {
        var product = response.data;
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('productUpdated', { old: this.value, new: product });
        }
        else {
            interface_vue_.emitter.emit('productCreated', product);
        }
    };
    ProductForm.prototype.referenceUpdated = function (reference) {
        if (!reference) {
            return;
        }
        this.localElement.providers_references.forEach(function (provider) {
            if (!provider.reference) {
                provider.reference = reference;
            }
        });
    };
    ProductForm.prototype.addGroupContent = function (content) {
        var element = content.data;
        var contents = this.localElement.group_contents;
        if (!contents) {
            return;
        }
        var index = contents.findIndex(function (val) { return val.catalog.type === content.type && val.catalog.id === element.id; });
        if (index >= 0) {
            contents[index].quantity = Number(contents[index].quantity) + 1;
        }
        else {
            contents.push({
                catalog: {
                    id: element.id,
                    type: content.type,
                    element: element,
                },
                unit_costs: element.total_costs,
                quantity: 1,
                total_costs: element.total_costs,
            });
        }
    };
    ProductForm.prototype.deleteGroupContent = function (index) {
        var _a;
        (_a = this.localElement.group_contents) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
    };
    Object.defineProperty(ProductForm.prototype, "groupContentTotalCost", {
        get: function () {
            var _this = this;
            return function (index) {
                var content = _this.localElement.group_contents[index];
                return _this.roundNumber(Number(content.catalog.element.total_costs) * Number(content.quantity), 2);
            };
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ProductForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ProductForm.prototype, "isGroup", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localElement.providers_references', { deep: true })
    ], ProductForm.prototype, "watchProvidersReferences", null);
    ProductForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('catalog', ['loadChargeCategories', 'loadVariationLevels'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('catalog', ['chargeCategories', 'variationLevels'])),
            components: {
                KFormCheckbox: form_vue_.KFormCheckbox,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BInputGroup: external_bootstrap_vue_.BInputGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BFormCheckbox: external_bootstrap_vue_.BFormCheckbox, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                BFormRadio: external_bootstrap_vue_.BFormRadio, BButton: external_bootstrap_vue_.BButton, BInputGroupText: external_bootstrap_vue_.BInputGroupText, BAlert: external_bootstrap_vue_.BAlert,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                CatalogSearch: CatalogSearch/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ProductForm);
    return ProductForm;
}((0,lib/* Mixins */.Xe)(mixins_CatalogElementMixin)));
/* harmony default export */ var ProductFormvue_type_script_lang_ts_external = (ProductForm);

;// ./src/components/ProductForm/ProductForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ProductForm_ProductFormvue_type_script_lang_ts_external = (ProductFormvue_type_script_lang_ts_external); 
;// ./src/components/ProductForm/ProductForm.vue





/* normalize component */
;
var ProductForm_component = (0,componentNormalizer/* default */.A)(
  ProductForm_ProductFormvue_type_script_lang_ts_external,
  ProductFormvue_type_template_id_32e3db76_render,
  ProductFormvue_type_template_id_32e3db76_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductForm_ProductForm = (ProductForm_component.exports);
// EXTERNAL MODULE: ./src/components/ProductItem/ProductItem.vue + 3 modules
var ProductItem = __webpack_require__(5663);
// EXTERNAL MODULE: ./src/components/ProductList/ProductList.vue + 3 modules
var ProductList = __webpack_require__(7439);
// EXTERNAL MODULE: ./src/components/ProductVariationForm/ProductVariationForm.vue + 3 modules
var ProductVariationForm = __webpack_require__(1411);
// EXTERNAL MODULE: ./src/components/ProductVariationList/ProductVariationList.vue + 3 modules
var ProductVariationList = __webpack_require__(9466);
// EXTERNAL MODULE: ./src/components/ProductVariations/ProductVariations.vue + 3 modules
var ProductVariations = __webpack_require__(7007);
// EXTERNAL MODULE: ./src/components/ProductVariationView/ProductVariationView.vue + 3 modules
var ProductVariationView = __webpack_require__(4456);
// EXTERNAL MODULE: ./src/components/ProviderReferenceList/ProviderReferenceList.vue + 3 modules
var ProviderReferenceList = __webpack_require__(5798);
// EXTERNAL MODULE: ./src/components/SaleCategoryForm/SaleCategoryForm.vue + 3 modules
var SaleCategoryForm = __webpack_require__(747);
// EXTERNAL MODULE: ./src/components/SaleCategoryList/SaleCategoryList.vue + 3 modules
var SaleCategoryList = __webpack_require__(2812);
// EXTERNAL MODULE: ./src/components/ServiceDelete/ServiceDelete.vue + 3 modules
var ServiceDelete = __webpack_require__(9478);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ServiceForm/ServiceForm.vue?vue&type=template&id=1b276dc4
var ServiceFormvue_type_template_id_1b276dc4_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{staticClass:"py-0 px-2",attrs:{"action":_vm.formAction,"method":_vm.localElement.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-row',[(_vm.teamConfigs.service_reference_manual)?_c('b-col',{attrs:{"cols":"6","md":"2","order":"1","order-md":"1"}},[_c('b-form-group',{attrs:{"label":"Référence"}},[_c('k-form-input',{attrs:{"name":"reference","required":""},model:{value:(_vm.localElement.reference),callback:function ($$v) {_vm.$set(_vm.localElement, "reference", $$v)},expression:"localElement.reference"}})],1)],1):_vm._e(),_c('b-col',{attrs:{"cols":"12","md":"7","order":"3","order-md":"2"}},[_c('b-form-group',{attrs:{"label":"Nom"}},[_c('k-form-input',{attrs:{"name":"name","required":""},on:{"change":function($event){!_vm.localElement.designation ? _vm.localElement.designation = _vm.localElement.name : {}}},model:{value:(_vm.localElement.name),callback:function ($$v) {_vm.$set(_vm.localElement, "name", $$v)},expression:"localElement.name"}})],1)],1),_c('b-col',{attrs:{"cols":"6","md":"3","order":"2","order-md":"3"}},[_c('b-form-group',{attrs:{"label":"Statut"}},[_c('k-form-select',{attrs:{"name":"status","options":_vm.status,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.localElement.formStatus),callback:function ($$v) {_vm.$set(_vm.localElement, "formStatus", $$v)},expression:"localElement.formStatus"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Désignation"}},[_c('k-form-editor',{attrs:{"name":"designation","mode":"simple","size":"sm","config":_vm.computedEditorConfig},model:{value:(_vm.localElement.designation),callback:function ($$v) {_vm.$set(_vm.localElement, "designation", $$v)},expression:"localElement.designation"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":"Catégorie de vente"}},[_c('k-form-select',{attrs:{"name":"sale_category","options":_vm.saleCategories,"reduce":val => val.label,"taggable":""},model:{value:(_vm.localElement.sale_category),callback:function ($$v) {_vm.$set(_vm.localElement, "sale_category", $$v)},expression:"localElement.sale_category"}})],1)],1),_c('b-col')],1),_c('CustomFieldsForm',{attrs:{"title-class":"form-title-alt mt-2","type":"service"},model:{value:(_vm.localElement.custom_fields),callback:function ($$v) {_vm.$set(_vm.localElement, "custom_fields", $$v)},expression:"localElement.custom_fields"}}),_c('b-tabs',{staticClass:"mt-5",attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Prix de vente"}},[_c('b-form-row',[_c('b-col',{staticClass:"sell-price-left-part",attrs:{"cols":"12","lg":"6"}},[_c('b-form-group',{attrs:{"label":"Prix vente HT","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ht","maxDecimal":5},on:{"change":_vm.calculUnitPriceHT},model:{value:(_vm.localElement.unit_price_ht),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_ht", $$v)},expression:"localElement.unit_price_ht"}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de TVA","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"vat_rate"},domProps:{"value":_vm.localElement.vat_rate ? _vm.localElement.vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"selectDefault":""},on:{"input":_vm.calculUnitPriceHT},model:{value:(_vm.localElement.vat_rate),callback:function ($$v) {_vm.$set(_vm.localElement, "vat_rate", $$v)},expression:"localElement.vat_rate"}})],1),_c('b-form-group',{attrs:{"label":"Montant TVA","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_tva","readonly":"","maxDecimal":5},model:{value:(_vm.localElement.unit_price_tva),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_tva", $$v)},expression:"localElement.unit_price_tva"}})],1)],1),_c('b-form-group',{attrs:{"label":"Prix vente TTC","label-cols-sm":"3"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"unit_price_ttc","maxDecimal":5},on:{"change":_vm.calculUnitPriceTTC},model:{value:(_vm.localElement.unit_price_ttc),callback:function ($$v) {_vm.$set(_vm.localElement, "unit_price_ttc", $$v)},expression:"localElement.unit_price_ttc"}})],1)],1),_c('b-form-group',{staticClass:"mt-lg-5",attrs:{"label":"Qté par défaut","label-cols-sm":"3"}},[_c('b-input-group',[_c('k-form-spinner',{attrs:{"name":"default_quantity","min":0,"maxDecimal":5},model:{value:(_vm.localElement.default_quantity),callback:function ($$v) {_vm.$set(_vm.localElement, "default_quantity", $$v)},expression:"localElement.default_quantity"}})],1)],1),_c('b-form-group',{attrs:{"label":"Unité","label-cols-sm":"3"}},[_c('input',{attrs:{"type":"hidden","name":"unit"},domProps:{"value":_vm.localElement.unit ? _vm.localElement.unit.label : null}}),_c('UnitSelect',{attrs:{"selectDefault":!_vm.localElement.id},model:{value:(_vm.localElement.unit),callback:function ($$v) {_vm.$set(_vm.localElement, "unit", $$v)},expression:"localElement.unit"}})],1),_c('input',{attrs:{"type":"hidden","name":"cant_change_price"},domProps:{"value":_vm.localElement.cant_change_price}}),_c('b-form-checkbox',{staticClass:"mt-4 pr-5",model:{value:(_vm.localElement.cant_change_price),callback:function ($$v) {_vm.$set(_vm.localElement, "cant_change_price", $$v)},expression:"localElement.cant_change_price"}},[_vm._v(" Bloquer la modification du prix de vente lors l'édition des documents de vente ")])],1),_c('b-col',{attrs:{"cols":"12","lg":"5","offset":"0","offset-lg":"1"}},[_c('b-form-group',{attrs:{"label":"Coûts des produits","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.totalProductsCosts,"maxDecimal":5,"readonly":""}})],1)],1),_c('b-form-group',{attrs:{"label":"Main d'oeuvre","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.totalWorkforceCosts,"readonly":""}})],1)],1),_c('b-form-group',{attrs:{"label":"Coûts divers","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"various_costs"},model:{value:(_vm.localElement.various_costs),callback:function ($$v) {_vm.$set(_vm.localElement, "various_costs", $$v)},expression:"localElement.various_costs"}})],1)],1),_c('b-form-group',{attrs:{"label":"Coûts total","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.totalCosts,"readonly":""}})],1)],1),_c('b-form-group',{staticClass:"mt-lg-5",attrs:{"label":"Marge par produit","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.grossMarginAmount},on:{"change":_vm.updateMarginAmount}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de marge","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"value":_vm.grossMarginRate},on:{"change":_vm.updateMarginRate}})],1)],1),_c('b-form-group',{attrs:{"label":"Taux de marque","label-cols-sm":"4"}},[_c('b-input-group',{staticClass:"flex-nowrap",attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"value":_vm.markupRate},on:{"change":_vm.updateMarkupRate}})],1)],1)],1)],1)],1),_c('b-tab',{attrs:{"title":"Produits"}},[_c('p',[_vm._v(" Liste des produits nécessaire à la réalisation de la prestation ")]),(_vm.hasModule('stock'))?[_c('input',{attrs:{"type":"hidden","name":"products_stock_management"},domProps:{"value":_vm.localElement.products_stock_management}}),_c('k-form-checkbox',{model:{value:(_vm.localElement.products_stock_management),callback:function ($$v) {_vm.$set(_vm.localElement, "products_stock_management", $$v)},expression:"localElement.products_stock_management"}},[_c('span',{staticClass:"text-danger font-weight-bold"},[_vm._v(" Déduire automatiquement les produits du stock ")])])]:_vm._e(),_c('k-form-select',{staticClass:"mt-4",attrs:{"ajax":_vm.productApiUrl,"getOptionLabel":opt => opt.reference + ' - ' + opt.name,"placeholder":"Sélectionner un produit à ajouter"},on:{"input":_vm.addProduct},model:{value:(_vm.productToAdd),callback:function ($$v) {_vm.productToAdd=$$v},expression:"productToAdd"}}),_c('div',{staticClass:"table-responsive mb-0"},[_c('table',{staticClass:"table table-sm table-bordered mt-1 align-middle mb-0 text-nowrap"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom du produit")]),_c('th',{staticStyle:{"width":"140px"}},[_vm._v("Prix achat U. HT")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Total HT")]),_c('th',{staticClass:"p-0",staticStyle:{"width":"25px"}})])]),(_vm.localElement.products.length === 0)?_c('tr',[_c('td',{staticClass:"text-center py-3",attrs:{"colspan":"6"}},[_c('p',{staticClass:"mb-0"},[_vm._v("Aucun produit")])])]):_vm._e(),_vm._l((_vm.localElement.products),function(product,i){return _c('tr',{key:i},[_c('td',[_c('input',{attrs:{"type":"hidden","name":'products[' + i + '][product]'},domProps:{"value":product.product.id}}),_vm._v(" "+_vm._s(product.product.reference)+" ")]),_c('td',[_vm._v(_vm._s(product.product.name))]),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"readonly":"","size":"sm"},model:{value:(product.unit_price_ht),callback:function ($$v) {_vm.$set(product, "unit_price_ht", $$v)},expression:"product.unit_price_ht"}})],1)],1),_c('td',[_c('k-form-spinner',{attrs:{"size":"sm","name":'products[' + i + '][quantity]'},on:{"change":_vm.calculUnitPriceHT},model:{value:(product.quantity),callback:function ($$v) {_vm.$set(product, "quantity", $$v)},expression:"product.quantity"}})],1),_c('td',[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"value":product.unit_price_ht * product.quantity,"readonly":"","size":"sm"},on:{"change":_vm.calculUnitPriceHT}})],1)],1),_c('td',{staticClass:"text-center px-0 align-middle"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){return _vm.removeProduct(i)}}},[_vm._v(" X ")])],1)])})],2)]),(_vm.localElement.products.length > 0)?_c('table',{staticClass:"table table-sm table-bordered align-middle float-right w-auto border-top-0",staticStyle:{"margin-right":"25px"}},[_c('tr',[_c('td',{staticClass:"border-top-0",staticStyle:{"width":"100px"}},[_vm._v("Total :")]),_c('td',{staticClass:"border-top-0",staticStyle:{"width":"120px"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol,"size":"sm"}},[_c('k-form-number',{attrs:{"value":_vm.totalProductsCosts,"readonly":"","size":"sm"}})],1)],1)])]):_vm._e(),_c('div',{staticClass:"clearfix",staticStyle:{"height":"40px"}})],2),_c('b-tab',{attrs:{"title":"Main d'oeuvre"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('b-form-group',{attrs:{"label":"Nombre de personne nécessaire :"}},[_c('k-form-spinner',{attrs:{"name":"number_people_needed","min":0},model:{value:(_vm.localElement.number_people_needed),callback:function ($$v) {_vm.$set(_vm.localElement, "number_people_needed", $$v)},expression:"localElement.number_people_needed"}})],1),_c('b-form-group',{attrs:{"label":"Durée de la prestation :"}},[_c('b-input-group',[_c('k-form-spinner',{attrs:{"name":"duration","min":0,"maxDecimal":2},model:{value:(_vm.localElement.duration),callback:function ($$v) {_vm.$set(_vm.localElement, "duration", $$v)},expression:"localElement.duration"}}),_c('b-input-group-append',[_c('k-form-select',{attrs:{"name":"duration_type","options":_vm.durationTypes,"clearable":false,"reduce":opt => opt.id},model:{value:(_vm.localElement.duration_type),callback:function ($$v) {_vm.$set(_vm.localElement, "duration_type", $$v)},expression:"localElement.duration_type"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Coûts horaire d'une personne :","description":'Laisser vide pour utiliser la valeur par défaut renseignée dans la configuration : ' + this.defaultWorkforceCosts + ' ' + this.currency.symbol}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"hourly_person_cost","min":0,"noDefaultValue":""},model:{value:(_vm.localElement.hourly_person_cost),callback:function ($$v) {_vm.$set(_vm.localElement, "hourly_person_cost", $$v)},expression:"localElement.hourly_person_cost"}})],1)],1),_c('b-form-group',{attrs:{"label":"Coûts total :"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"value":_vm.totalWorkforceCosts,"readonly":""}})],1)],1)],1),_c('b-col',{staticClass:"pl-lg-5",attrs:{"cols":"12","md":"8"}},[_c('b-form-group',{attrs:{"label":"Techniciens pouvant réaliser cette prestation :"}},[_c('b-form-radio-group',{staticClass:"mt-2",attrs:{"name":"allowed_all_technicians"},model:{value:(_vm.localElement.allowed_all_technicians),callback:function ($$v) {_vm.$set(_vm.localElement, "allowed_all_technicians", $$v)},expression:"localElement.allowed_all_technicians"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" Tous les techniciens ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" Uniquement les techniciens suivants : ")])],1),(_vm.localElement.technicians.length > 0)?_vm._l((_vm.localElement.technicians),function(technician,i){return _c('input',{key:i,attrs:{"name":"technicians[]","type":"hidden"},domProps:{"value":technician.id}})}):_c('input',{attrs:{"name":"technicians","type":"hidden","value":""}}),(!_vm.localElement.allowed_all_technicians)?_c('k-form-select',{staticClass:"mt-2",attrs:{"options":_vm.teamUsersRole('technical'),"label":"fullname","multiple":""},model:{value:(_vm.localElement.technicians),callback:function ($$v) {_vm.$set(_vm.localElement, "technicians", $$v)},expression:"localElement.technicians"}}):_vm._e()],2),_c('b-form-group',{attrs:{"label":"Description destinée aux personnes qui réaliseront la prestation :"}},[_c('k-form-editor',{attrs:{"mode":"simple","name":"work_description","size":"sm"},model:{value:(_vm.localElement.work_description),callback:function ($$v) {_vm.$set(_vm.localElement, "work_description", $$v)},expression:"localElement.work_description"}})],1)],1)],1)],1),(_vm.hasModule('catalog-custom-prices'))?_c('b-tab',{attrs:{"title":"Prix personnalisé"}},[_c('custom-prices',{model:{value:(_vm.localElement),callback:function ($$v) {_vm.localElement=$$v},expression:"localElement"}})],1):_vm._e()],1)],1)],1)
}
var ServiceFormvue_type_template_id_1b276dc4_staticRenderFns = []


// EXTERNAL MODULE: ./src/fetchDatas/service.ts
var fetchDatas_service = __webpack_require__(459);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ServiceForm/ServiceForm.ts?vue&type=script&lang=ts&external









var ServiceForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ServiceForm, _super);
    function ServiceForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localElement = {
            custom_price_mode: 'quantity',
            designation: null,
            formStatus: true,
            unit_price_ht: 0,
            unit_price_tva: 0,
            unit_price_ttc: 0,
            default_quantity: 1,
            cant_change_price: false,
            allowed_all_technicians: true,
            products_stock_management: true,
            duration_type: 'hour',
            products: [],
            technicians: [],
            custom_fields: []
        };
        _this.durationTypes = [
            { id: 'hour', label: 'Heure' },
            { id: 'minute', label: 'Minute' }
        ];
        _this.productToAdd = null;
        return _this;
    }
    ServiceForm.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var service;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0,fetchDatas_service/* fetchService */.Ox)(this.id)];
                    case 1:
                        service = _a.sent();
                        this.setLocalElement(service);
                        this.loading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ServiceForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ServiceForm.prototype, "formAction", {
        // Return url for form
        get: function () {
            var url = '/catalog/service';
            if (this.localElement.id) {
                url += '/' + this.localElement.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "productApiUrl", {
        // Return url for products list
        get: function () {
            return '/catalog/product?sort=name';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "technicalApiUrl", {
        // Return url for technical list
        get: function () {
            return '/team/user?sort=fullname&filter[roles]=technical';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "totalWorkforceCosts", {
        // Calcultate the total workforce costs
        get: function () {
            var _a;
            var quantity = this.number(this.localElement.number_people_needed);
            var unitCosts = this.number((_a = this.localElement.hourly_person_cost) !== null && _a !== void 0 ? _a : this.defaultWorkforceCosts);
            var duration = this.number(this.localElement.duration);
            var hourDuration = this.number(this.localElement.duration_type === 'hour' ? duration : (duration / 60));
            return this.number(quantity * unitCosts * hourDuration);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "defaultWorkforceCosts", {
        // Return the default workforce costs
        get: function () {
            return this.number(this.teamConfigs.average_hourly_person_cost);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "totalProductsCosts", {
        // Calculate the products total costs
        get: function () {
            var _this = this;
            var _a;
            var products = (_a = this.localElement.products) !== null && _a !== void 0 ? _a : [];
            if (products.length === 0) {
                return 0;
            }
            return products
                .map(function (product) { return _this.number(product.product.total_costs) * _this.number(product.quantity); })
                .reduce(function (a, b) { return _this.number(a + b); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ServiceForm.prototype, "totalCosts", {
        // Calculate the total costs
        get: function () {
            return this.number(this.totalWorkforceCosts + this.totalProductsCosts + this.number(this.localElement.various_costs));
        },
        enumerable: false,
        configurable: true
    });
    ServiceForm.prototype.checkElementDatas = function (element) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                if (element.id && (0,fetchDatas_service/* needFetchService */.cu)(element)) {
                    return [2 /*return*/, (0,fetchDatas_service/* fetchService */.Ox)(element.id)];
                }
                return [2 /*return*/, element];
            });
        });
    };
    // Add a new product reference
    ServiceForm.prototype.addProduct = function (product) {
        var _this = this;
        if (!product) {
            return;
        }
        var exist = this.localElement.products.find(function (p) { var _a; return ((_a = p.product) === null || _a === void 0 ? void 0 : _a.id) === product.id; });
        if (exist) {
            exist.quantity++;
        }
        else {
            this.localElement.products.push({
                product: product,
                unit_price_ht: Number(product.total_costs),
                quantity: 1
            });
        }
        this.$nextTick(function () { return _this.productToAdd = null; });
    };
    ServiceForm.prototype.removeProduct = function (index) {
        this.localElement.products.splice(index, 1);
    };
    ServiceForm.prototype.submitComplete = function (response) {
        var service = response.data;
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('serviceUpdated', { old: this.value, new: service });
        }
        else {
            interface_vue_.emitter.emit('serviceCreated', service);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ServiceForm.prototype, "value", void 0);
    ServiceForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BInputGroup: external_bootstrap_vue_.BInputGroup, BFormCheckbox: external_bootstrap_vue_.BFormCheckbox, BButton: external_bootstrap_vue_.BButton, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole']))
        })
    ], ServiceForm);
    return ServiceForm;
}((0,lib/* Mixins */.Xe)(mixins_CatalogElementMixin)));
/* harmony default export */ var ServiceFormvue_type_script_lang_ts_external = (ServiceForm);

;// ./src/components/ServiceForm/ServiceForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ServiceForm_ServiceFormvue_type_script_lang_ts_external = (ServiceFormvue_type_script_lang_ts_external); 
;// ./src/components/ServiceForm/ServiceForm.vue





/* normalize component */
;
var ServiceForm_component = (0,componentNormalizer/* default */.A)(
  ServiceForm_ServiceFormvue_type_script_lang_ts_external,
  ServiceFormvue_type_template_id_1b276dc4_render,
  ServiceFormvue_type_template_id_1b276dc4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ServiceForm_ServiceForm = (ServiceForm_component.exports);
// EXTERNAL MODULE: ./src/components/ServiceItem/ServiceItem.vue + 3 modules
var ServiceItem = __webpack_require__(4204);
// EXTERNAL MODULE: ./src/components/ServiceList/ServiceList.vue + 3 modules
var ServiceList = __webpack_require__(4958);
// EXTERNAL MODULE: ./src/components/Statistics/Statistics.vue + 3 modules
var Statistics = __webpack_require__(7220);
// EXTERNAL MODULE: ./src/components/StockByLocations/StockByLocations.vue + 3 modules
var StockByLocations = __webpack_require__(4254);
// EXTERNAL MODULE: ./src/components/StockLocationForm/StockLocationForm.vue + 3 modules
var StockLocationForm = __webpack_require__(7284);
// EXTERNAL MODULE: ./src/components/StockLocationList/StockLocationList.vue + 3 modules
var StockLocationList = __webpack_require__(2724);
// EXTERNAL MODULE: ./src/components/StockParams/StockParams.vue + 3 modules
var StockParams = __webpack_require__(3921);
// EXTERNAL MODULE: ./src/components/StockState/StockState.vue + 3 modules
var StockState = __webpack_require__(8980);
// EXTERNAL MODULE: ./src/components/VariationValues/VariationValues.vue + 3 modules
var VariationValues = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/views/CommandFormView/CommandFormView.vue + 3 modules
var CommandFormView = __webpack_require__(991);
// EXTERNAL MODULE: ./src/views/CommandItemView/CommandItemView.vue + 3 modules
var CommandItemView = __webpack_require__(5321);
// EXTERNAL MODULE: ./src/views/ProductItemView/ProductItemView.vue + 3 modules
var ProductItemView = __webpack_require__(9341);
// EXTERNAL MODULE: ./src/views/ServiceItemView/ServiceItemView.vue + 3 modules
var ServiceItemView = __webpack_require__(4683);
// EXTERNAL MODULE: ./src/views/CatalogParamsView.vue + 3 modules
var CatalogParamsView = __webpack_require__(8327);
// EXTERNAL MODULE: ./src/views/CatalogReportView.vue + 7 modules
var CatalogReportView = __webpack_require__(2480);
// EXTERNAL MODULE: ./src/views/ChargesCategoryListView.vue + 3 modules
var ChargesCategoryListView = __webpack_require__(7269);
// EXTERNAL MODULE: ./src/views/CommandListView.vue + 3 modules
var CommandListView = __webpack_require__(1565);
// EXTERNAL MODULE: ./src/views/GroupListView.vue + 3 modules
var GroupListView = __webpack_require__(4660);
// EXTERNAL MODULE: ./src/views/LotListView.vue + 3 modules
var LotListView = __webpack_require__(8746);
// EXTERNAL MODULE: ./src/views/ManualMovementListView.vue + 3 modules
var ManualMovementListView = __webpack_require__(8290);
// EXTERNAL MODULE: ./src/views/MouvementListView.vue + 3 modules
var MouvementListView = __webpack_require__(1738);
// EXTERNAL MODULE: ./src/views/ProductListView.vue + 3 modules
var ProductListView = __webpack_require__(3249);
// EXTERNAL MODULE: ./src/views/ProductVariationListView.vue + 3 modules
var ProductVariationListView = __webpack_require__(8282);
// EXTERNAL MODULE: ./src/views/ProviderReferenceListView.vue + 3 modules
var ProviderReferenceListView = __webpack_require__(9585);
// EXTERNAL MODULE: ./src/views/SaleCategoryListView.vue + 3 modules
var SaleCategoryListView = __webpack_require__(8699);
// EXTERNAL MODULE: ./src/views/ServiceListView.vue + 3 modules
var ServiceListView = __webpack_require__(8839);
// EXTERNAL MODULE: ./src/views/StockStateView.vue + 3 modules
var StockStateView = __webpack_require__(6834);
// EXTERNAL MODULE: ./src/views/StockParamsView.vue + 3 modules
var StockParamsView = __webpack_require__(2713);
;// ./src/lang/en.ts
var catalogLang = {};
/* harmony default export */ var en = ({
    catalog: catalogLang
});

;// ./src/lang/fr.ts
var fr_catalogLang = {
    menuTitle: 'Catalogue',
    product: {
        label: 'Produit',
        menu: 'Produits',
        listTitle: 'Liste des produits',
        addTitle: 'Nouveau produit',
        editTitle: 'Modification d\'un produit',
        addLabel: 'Créer un produit',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
        itemTitle: 'Fiche produit',
        clone: 'Cloner le produit'
    },
    providerReferences: {
        menu: 'Références fournisseurs',
        listTitle: 'Liste des références fournisseurs'
    },
    service: {
        label: 'Prestation',
        menu: 'Prestations',
        listTitle: 'Liste des prestations',
        addTitle: 'Nouvelle prestation',
        editTitle: 'Modification d\'une prestation',
        addLabel: 'Créer une prestation',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette prestation ?',
        itemTitle: 'Fiche prestation',
        clone: 'Cloner la prestation'
    },
    group: {
        label: 'Groupe',
        menu: 'Groupes',
        listTitle: 'Liste des groupes',
        addTitle: 'Nouveau groupe',
        editTitle: 'Modification d\'un groupe',
        addLabel: 'Créer un groupe',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
        itemTitle: 'Fiche groupe',
        clone: 'Cloner le groupe'
    },
    stock: {
        menuTitle: 'Stock',
        commandsListTitle: 'Liste des commandes fournisseurs',
        addLabel: 'Créer une commande',
        mvtListPagetitle: 'Liste des mouvements de stock',
        manualMvtListPagetitle: 'Liste des entrées et sorties manuelles de stock',
        manualAddTitle: 'Création d\'un mouvement de stock',
        manualEditTitle: 'Modification d\'un mouvement de stock',
        StockStatePagetitle: 'État du stock',
        addManual: 'Nouveau mouvement de stock',
        params: {
            referenceNormal: 'Normal',
            referenceMonth: 'Remise à 0 tous les mois',
            referenceYear: 'Remise à 0 tous les ans',
            inStock1: 'Lorsque les produits sont marqués comme livré sur une commande fournisseur',
            inStock2: 'À la création d\'une commande fournisseur (peu importe le statut)',
            outStock1: 'Lorsque le bon de livraison est marqué comme envoyé',
            outStock2: 'Lorsque le bon de livraison est marqué comme "À envoyer"',
            outStock3: 'À la création d\'un bon de livraison (Brouillon)',
            outStock4: 'À la validation d\'un devis',
            outStock5: 'À la validation d\'un bon de commande',
            outStock6: 'À la validation d\'un devis ou d\'un bon de commande',
            outStock7: 'À la création d\'une facture',
            paramsTitle: 'Paramètres',
            theoricaltitle: 'Mouvements de stock théorique',
            theorical: 'théorique',
            addToStock: 'Ajouter les produits au stock :',
            removeFromStock: 'Sortir les produits au stock :',
            realTitle: 'Mouvements de stock réel',
            stockValueTitle: 'Calcul de la valeur de stock',
            stockValueOptions1: 'Calculer la valeur du stock en fonction du prix d\'achat',
            stockValueOptions2: 'Calculer la valeur du stock en fonction du prix unitaire moyen pondéré',
            stockValueExplain1: 'Le prix unitaire moyen pondéré sera calculé en fonction des commandes fournisseurs.',
            stockValueExplain2: 'Si aucune commande fournisseur n\'est présente ou que la quantité en stock est négative, le prix d\'achat sera alors utilisé.',
            providerCommandStock: 'Remplir automatiquement les quantités en se basant sur',
            providerCommandStockOption1: 'Le stock réel',
            providerCommandStockOption2: 'Le stock théorique',
            providerCommandStockDraft: 'Par défaut, ajouter les produits aux commandes fournisseur existantes',
            real: 'réel',
            realExplain1: 'Lorsque la gestion des stocks avec traçabilité est activée sur un produit, il est obligatoire :',
            realExplain2: 'D\'effectuer un bon de livraison pour sortir le(s) produit(s) concerné(s) du stock',
            realExplain3: 'De passer par la réception de la commande fournisseur ou une entrée de stock manuelle pour les entrées de stock',
            notificationTitle: 'Notifications',
            receiveNotification: 'Recevoir un email quand :',
            productThreshold: 'un produit atteint le seuil d\'alerte {mode}',
            productMin: 'un produit atteint le seuil minimum {mode}',
            productEmpty: 'un produit n\'a plus de stock {mode}',
            productMax: 'un produit atteint le seuil maximum {mode}',
            notificationRecipients: 'Destinataire(s) des notifications :',
            providerCommand: 'Commandes fournisseurs',
            defaultParams: 'Paramètres par défaut des commandes',
            pdfOptions: 'Options du bon de commande PDF',
            showContact: 'Afficher le contact',
            showReference: 'Afficher la colonne référence',
            showUnit: 'Afficher les unités',
            notshowPrices: 'Ne pas afficher les prix',
            formOptions: 'Options de saisie',
            canSelectAllProduct: 'Permettre de sélectionner des produits non reliés au fournisseur',
            updateProductPrice: 'Mettre à jour les prix d\'achat des produits en fonction des prix de la commande',
            calculateProductCosts: 'Permettre de modifier les coûts divers des différents produits lors de la saisie de la commande',
            defaultDeliveryAddress: 'Adresse de livraison par défaut',
            emptyDeliveryAddress: 'Laisser vide pour utiliser l\'adresse de votre entreprise',
            defaultStatus: 'Statut par défaut lors la création des commandes :',
            statusExplain: 'Si la commande est créée au statut livrée, alors les produits sont automatiquement ajoutés au stock.',
            referenceTitle: 'Référence des commandes fournisseurs',
            manualMovement: 'Mouvements de stock manuels',
            manualMovementReferenceTitle: 'Référence des mouvements de stock manuels',
        },
        types: {
            stockManualContentEntry: 'Entrée de stock n°{reference}',
            stockManualContentOuput: 'Sortie de stock n°{reference}',
            stockManualContentDelete: 'Mouvement de stock supprimé',
            providerCommand: 'Commande fournisseur n°{reference}',
            providerCommandDelete: 'Commande fournisseur supprimée',
            product: 'Produit',
            group: 'Groupe',
            productVariation: 'Variation du produit',
            productLot: 'Lot',
            quotation: 'Devis n°{reference}',
            quotationDelete: 'Devis supprimé',
            command: 'Bon de commande n°{reference}',
            commandDelete: 'Bon de commande supprimé',
            proforma: 'Facture proforma n°{reference}',
            proformaDelete: 'Facture proforma supprimée',
            delivery: 'Bon de livraison n°{reference}',
            deliveryDelete: 'Bon de livraison supprimé',
            invoice: 'Facture n°{reference}',
            invoiceDelete: 'Facture supprimée',
            credit: 'Avoir n°{reference}',
            creditDelete: 'Avoir supprimé'
        }
    },
    manualMovement: {
        type: {
            1: 'Entrée',
            2: 'Sortie',
            3: 'Transfert'
        },
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mouvement de stock ?',
        lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité inférieure à la quantité renseignée au préalable ne supprimera pas le(s) lot(s) déjà rentré(s) dans le stock, vous devez supprimer le(s) lot(s) manuellement.',
        lotExplain2: 'Dans le cas des gestions de stock avec lot, supprimer un produit ne supprimera pas le(s) lot(s) déjà rentré(s) dans le stock, vous devez supprimer le(s) lot(s) manuellement.'
    },
    form: {
        status: {
            disable: 'Désactivé',
            enable: 'Actif',
            notForSale: 'Non destiné à la vente'
        },
        traceabilities: {
            no: 'Non',
            lot: 'Tracabilité avec gestion des lots et des dates de péremption',
            serial: 'Tracabilité avec gestion des numéros de série et de la garantie'
        },
        variationLevels: {
            no: 'Ce produit ne comporte aucune variation',
            level: '1 niveau | {count} niveaux'
        },
        duplicateProviderReferenceError: 'Vous ne pouvez pas utiliser deux fois la même référence pour le même fournisseur',
        duplicateVariationLevelError: 'Vous ne pouvez pas utiliser deux fois la même variation'
    },
    list: {
        reference: 'Référence',
        providerReference: 'Référence fournisseur',
        name: 'Nom',
        providerName: 'Fournisseur',
        designation: 'Description',
        cantChangePrice: 'Prix modifiable',
        unitPriceHt: 'Prix U. HT',
        unitPriceTva: 'Prix U. TVA',
        unitPriceTtc: 'Prix U. TTC',
        defaultQuantity: 'Quantité par défaut',
        totalHt: 'Total HT',
        totalTva: 'Total TVA',
        totalTtc: 'Total TTC',
        unitBuyPriceHt: 'Prix d\'achat U. HT',
        variousCosts: 'Coûts divers',
        totalCosts: 'Coûts totaux',
        grossMarginAmount: 'Marge brute HT',
        grossMarginRate: 'Taux de marge',
        markupRate: 'Taux de marque',
        vatRate: 'Taux de TVA',
        unit: 'Unité',
        notForSale: 'Non destiné à la vente',
        saleCategory: 'Catégorie de vente',
        chargeCategory: 'Catégorie de charge',
        ean: 'Code EAN',
        unitWeight: 'Poids unitaire',
        sizeLength: 'Longueur',
        sizeWidth: 'Largeur',
        sizeHeight: 'Hauteur',
        ecoTaxHt: 'Éco-participation HT',
        ecoTaxTva: 'Éco-participation TVA',
        ecoTaxTtc: 'Éco-participation TTC',
        withStock: 'Gestion de stock',
        averageBuyPrice: 'Coût unitaire pondéré',
        stockQuantity: 'Quantité réelle en stock',
        stockTotal: 'Total stock HT',
        stockTheoreticalQuantity: 'Quantité théorique en stock',
        stockTheoreticalTotal: 'Total stock théorique HT',
        stockMinimum: 'Stock minimum',
        stockMaximum: 'Stock maximum',
        stockAlert: 'Stock : Niveau d\'alerte',
        stockTrackingMode: 'Stock : Traçabilité',
        variationsLength: 'Avec variations',
        variationsLevel1: 'Niveau de variation 1',
        variationsLevel2: 'Niveau de variation 2',
        variationsLevel3: 'Niveau de variation 3',
        providers: 'Fournisseur(s)',
        providersReferences: 'Référence(s) Fournisseur(s)',
        providersVariousCosts: 'Coûts divers fournisseur(s)',
        providersBuyPrice: 'Prix d\'achat HT fournisseur(s)',
        providersTotalCosts: 'Coûts total fournisseur(s)',
        hourlyPersonCost: 'Coûts horaire',
        productsCosts: 'Coûts du contenu',
        workforceCosts: 'Coûts de la main d\'oeuvre',
        durationMn: 'Durée en mn',
        durationHour: 'Durée en heure',
        numberPeopleNeeded: 'Nombre de technicien requis',
    },
    filters: {
        reference: 'Référence :',
        name: 'Nom :',
        saleCategory: 'Catégorie(s) de vente :',
        chargeCategory: 'Catégorie(s) de charge :',
        status: 'Statut :',
        notForSale: 'Non-destiné à la vente :',
        withStock: 'Avec gestion de stock :',
        withVariations: 'Comporte des variations :',
        provider: 'Fournisseur(s) :',
        product: 'Produit(s) :',
        ean: 'Code EAN :'
    },
    params: {
        menu: 'Catalogue',
        pageTitle: 'Configuration du catalogue',
        referenceManual: 'Renseigner manuellement',
        referenceTitle: 'Références des éléments du catalogue',
        referenceExplain: 'La référence est obligatoire pour chaque élément (produit, prestation ou groupe). Celle-ci doit être unique pour un type d\'élément et ne peut donc pas être utilisée deux fois sur deux produits différents (par exemple). Si vous ne souhaitez pas gérer l\'attribution des références vous-même, vous pouvez activer l\'attribution automatique ci-dessous.',
        referencePrefix: 'Préfixe',
        referenceNextNumber: 'Prochain numéro',
        referenceLength: 'Longueur des chiffres',
        hourlyPersonCost: 'Coûts horaire moyen d\'un technicien :',
        hourlyPersonCostExplain: 'Cette valeur est utilisée pour calculer le coût des prestations. Elle pourra être modifiée directement lors de la création / modification d\'une prestation.',
        activeStockDefault: 'Activer le stock par défaut pour les nouveaux produits'
    },
    productVariations: {
        menu: 'Variations des produits',
        pageTitle: 'Gestion des variations des produits',
        label: 'Nom de la variation',
        nbVariations: 'Nombre de valeurs',
        nbProducts: 'Nombre de produits utlisant la variation',
        new: 'Création d\'une variation de produit',
        edit: 'Modification d\'une variation de produit',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette variation de produit ?',
        deleteAlertMessage: 'Attention : Toutes les variations de produit utilisant cette variation seront supprimées.',
        manageVariations: 'Gérer les valeurs pour cette variation',
        valuesModalTitle: 'Gestion des valeurs d\'une variation',
        newValue: 'Création d\'une valeur pour la variation',
        editValue: 'Modification d\'une valeur pour la variation',
        deleteValueMsg: 'Êtes-vous sûr de vouloir supprimer cette valeur de variation ?',
        deleteValueAlertMessage: 'Attention : Toutes les variations de produit utilisant cette valeur de variation seront supprimées.',
        labelValue: 'Nom de la valeur',
        nbVariationsValue: 'Nombre de variations de produit utilisant cette valeur'
    },
    config: {
        menu: 'Stock',
        menuTitle: 'Ventes',
        pageTitle: 'Configuration du stock'
    },
    catalogSearch: {
        placeholder: 'Rechercher un produit, une prestation...',
        goToCatalog: 'Accéder au catalogue',
        noResults: 'Aucun résultat',
        askAddElement: 'Souhaitez-vous ajouter l\'élément au document ?'
    },
    pictures: {
        addLabel: 'Ajouter des photos',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette photo ?',
        markDefault: 'Marquer comme photo par défaut'
    },
    command: {
        addTitle: 'Création d\'une commande fournisseur',
        editTitle: 'Modification d\'une commande fournisseur',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
        form: {
            title: 'Titre',
            date: 'Date',
            provider: 'Fournisseur',
            deliveryAddress: 'Adresse de livraison',
            road: 'Rue',
            currency: 'Devise',
            pdfModel: 'Modèle PDF',
            comments: 'Commentaires',
            pdfOptions: 'Options du PDF :',
            pdfShowContact: 'Afficher le contact',
            pdfShowReference: 'Afficher la colonne référence',
            pdfShowUnit: 'Afficher les unités',
            pdfDontShowPrices: 'Ne pas afficher les prix',
            needManualReceipt: 'Lors de l\'utilisation de produit avec gestion de stock avec traçabilité, il n\'est pas possible de passer la commande en livrée directement',
            content: 'Contenu de la commande',
            productSearch: 'Rechercher un produit...',
            needSelectProvider: 'Vous devez sélectionner un fournisseur avant de pouvoir sélectionner un produit',
            emptyLine: 'Ligne vide',
            reference: 'Référence',
            designation: 'Désignation',
            unitPriceHt: 'Prix U. HT',
            vatRate: 'Taux TVA',
            quantity: 'Quantité',
            totalHt: 'Total HT',
            emptyCommand: 'Le contenu de la commande est vide',
            cantDeleteLine: 'Il n\'est pas possible de supprimer cette ligne car des lots y sont liés. Supprimer les lots avant de supprimer la ligne.',
            sidebar: {
                sidebarPosition: 'Modifier la position de la barre',
                fullscreen: 'Plein écran',
                totalHt: 'Total HT',
                totalTva: 'Total TVA',
                totalTtc: 'Total TTC'
            },
            lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité inférieure à la quantité déjà livrée ne supprimera pas le lot et n\'influera donc pas sur le stock. Vous devez supprimer manuellement le lot avant de modifier la commande.'
        },
        list: {
            reference: 'Référence',
            date: 'Date',
            title: 'Titre',
            provider: 'Fournisseur',
            contact: 'Contact',
            road1: 'Adresse de livraison - Rue 1',
            road2: 'Adresse de livraison - Rue 2',
            road3: 'Adresse de livraison - Rue 3',
            postalCode: 'Adresse de livraison - Code postal',
            town: 'Adresse de livraison - Ville',
            country: 'Adresse de livraison - Pays',
            comments: 'Commentaires',
            totalHt: 'Total HT',
            totalTva: 'Total TVA',
            totalTtc: 'Total TTC',
            status: 'Statut'
        },
        filter: {
            reference: 'Référence',
            period: 'Date',
            provider: 'Fournisseur',
            status: 'Statut'
        },
        status: {
            draft: 'Brouillon',
            waitDelivery: 'En attente de livraison',
            partiallyDelivered: 'Livrée partiellement',
            delivered: 'Livrée',
        },
        receipt: {
            allDelivered: 'Tout marquer comme livré',
            reference: 'Réf.',
            designation: 'Désignation',
            commandQty: 'Qté cmd',
            deliveredQty: 'Déjà livrée',
            toDeliverQty: 'Qté restante',
            qty: 'Qté',
            lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité négative modifie les quantités livrées mais ne supprime pas le lot et n\'influe donc pas sur le stock. Par contre, supprimer le(s) lot(s) mettra automatiquement à jour le stock et les quantitées livrées sur la commande.',
            lotNumber: 'N° de lot',
            expirationDate: 'Date d\'expiration',
            lotQty: 'Quantité dans le lot',
            serial: 'N° de série',
            automaticGeneration: 'Générer des numéros de série chronologique'
        }
    },
    customPrices: {
        types: 'Type de prix personnalisés :',
        qtyOnDocument: 'Quantité présente sur le document',
        qtyCurrentYear: 'Quantité commandée entre le 01 janvier et le 31 décembre de l\'année en cours',
        qtyPreviousYear: 'Quantité commandée entre le 01 janvier et le 31 décembre de l\'année précédente',
        qtyLastMonths: 'Quantité commandée sur les X derniers mois',
        qtyLastNbMonths: 'Quantité commandée sur le dernier mois | Quantité commandée sur les {count) derniers mois',
        qtyTotal: 'Quantité totale commandée',
        decreasingPrices: 'Prix dégressif selon la quantité',
        decreasingPricesCondition: 'Appliquer les prix dégressifs selon :',
        decreasingPricesNbMonth: 'Nombre de mois à prendre en compte :',
        decreasingPricesList: 'Liste des prix dégressifs :',
        qtyMin: 'Quantité minimum',
        qtyMax: 'Quantité maximum',
        unitPriceHt: 'Prix U. HT',
        noCustomPrice: 'Aucun prix personnalisé',
        addCustomPrice: 'Ajouter un prix personnalisé',
        customer: 'Client',
        byCustomerType: 'Prix par type de client',
        byCustomerTypeExplain: 'Personnalisez le prix selon le type de client. Laisser le prix vide pour ne pas appliquer de prix personnalisé.',
        byCustomer: 'Prix selon un client en particulier',
        byCustomerExplain: 'Personnalisez le prix selon un client en particulier',
        byCountry: 'Prix selon le pays du client',
        byCountryExplain: 'Personnalisez le prix selon le pays du client',
        country: 'Pays'
    },
    saleCategory: {
        menu: 'Catégories de vente',
        pageTitle: 'Gestion des catégories de vente',
        label: 'Nom de la catégorie',
        parentLabel: 'Catégorie parente',
        accountLabel: 'Compte comptable',
        new: 'Création d\'une catégorie de vente',
        edit: 'Modification d\'une catégorie de vente',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de vente ?',
        accountByVatRate: 'Comptes ',
        form: {
            name: 'Nom de la catégorie :',
            parent: 'Catégorie parente :',
            accountNumberLabel: 'N° de compte (plan comptable) :',
            accountByVatRate: 'Utiliser un compte par taux de TVA',
            vatRate: 'Taux de TVA',
            accountNumber: 'N° de compte'
        }
    },
    chargeCategory: {
        menu: 'Catégories de charge',
        pageTitle: 'Gestion des catégories de charge',
        label: 'Nom de la catégorie de charge',
        parentLabel: 'Catégorie parente',
        accountLabel: 'Numéro de compte comptable',
        new: 'Création de la catégorie de charge',
        edit: 'Modification de la catégorie de charge',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de charge ?',
        deleteAlertMsg: 'Attention, la suppression d\'une catégorie parente entraînera la suppression de toutes les catégories enfants.',
        replacementComments: 'Cette catégorie est utilisée, elle doit donc être fusionnée avec une autre catégorie afin que le logiciel fonctionne normalement.'
    },
    references: {
        referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
        referenceYear4: 'l\'année sur 4 chiffres',
        referenceYear2: 'l\'année sur 2 chiffres',
        referenceMonth: 'le mois',
        referenceDay: 'le jour',
        referenceTitle: 'Numérotation des documents',
        referencePrefix: 'Préfixe',
        referenceNextNumber: 'Prochain numéro',
        referenceTypeNumber: 'Type de numérotation',
        referenceLength: 'Nombre de chiffre'
    },
    productLot: {
        pageTitle: 'Liste des lots de produits',
        editTitle: 'Modification d\'un lot',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce lot de produit ?',
        deleteMsgAlertCommand: 'La suppression du lot entraînera la mise à jour des quantités livrées sur la commande fournisseur liée.',
        deleteMsgAlertMovement: 'La suppression du lot entraînera la mise à jour des quantités livrées sur l\'entrée/sortie de stock manuelle.',
        list: {
            productReference: 'Référence du produit',
            productName: 'Nom du produit',
            reference: 'N° de lot/série',
            expire: 'Date de péremption/fin de garantie',
            quantity: 'Quantité',
            stockQuantity: 'Quantité en stock'
        },
        filter: {
            productReference: 'Référence produit',
            reference: 'N° de lot/série',
            expire: 'Date de péremption/fin de garantie',
            inStock: 'En stock'
        },
        form: {
            productReference: 'Réf. Produit',
            productName: 'Nom produit',
            reference1: 'Numéro du lot',
            reference2: 'Numéro de série',
            expire1: 'Date de péremption',
            expire2: 'Date de fin de garantie',
            quantity: 'Quantité',
            stockQuantity: 'Quantité en stock'
        }
    },
    sales: {
        list: {
            documentReference: 'N° document',
            date: 'Date',
            customer: 'Client',
            contact: 'Contact',
            unitPriceHt: 'Prix U. HT',
            unitPriceTva: 'Prix U. TVA',
            unitPriceTtc: 'Prix U. TTC',
            catalogCostU: 'Prix d\'achat U.',
            variousCostU: 'Coûts divers U.',
            totalCostU: 'Coûts total U.',
            hourlyPersonCost: 'Coûts horaire',
            numberPeopleNeeded: 'Nb technicien',
            duration: 'Durée U.',
            workforceCostsU: 'Main d\'oeuvre U.',
            totalChargeU: 'Total charge U.',
            grossMarginAmountU: 'Marge brute HT U.',
            quantity: 'Quantité',
            secondaryQuantity: 'Quantité 2',
            totalQuantity: 'Quantité totale',
            vatRate: 'Taux TVA',
            totalHt: 'Total HT',
            totalTva: 'Total TVA',
            totalTtc: 'Total TTC',
            totalCatalogCosts: 'Total coûts achats',
            totalVariousCosts: 'Total coûts divers',
            totalCosts: 'Coûts total',
            totalDurationHour: 'Durée totale (H)',
            totalWorkforce: 'Total main d\'oeuvre',
            totalCharge: 'Charge totale',
            grossMarginAmount: 'Marge brute',
            grossMarginRate: 'Taux de marge',
            markupRate: 'Taux de marque'
        },
        filter: {
            period: 'Date du document',
            customer: 'Client(s)'
        }
    },
    statistics: {
        since: 'Début',
        until: 'Fin',
        ca: 'Chiffre d\'affaires :',
        salesQuantities: 'Quantités vendues :',
        totalCosts: 'Total coûts :',
        totalGrossMargin: 'Total marge HT :',
        averageUnitPrice: 'Prix de vente moyen :',
        averageQuantities: 'Quantités moyennes vendues :',
        averageCosts: 'Coûts moyens :',
        averageGrossMargin: 'Marge moyenne :',
        other: 'Autres statistiques :',
        salesPerCustomers: 'Ventes par clients',
        customersWithoutSales: 'Clients sans achat',
        tables: {
            reference: 'Référence',
            name: 'Nom',
            period: 'Filtrer par date',
            customer: 'Client',
            quantity: 'Quantité',
            totalHt: 'Total HT',
            totalTva: 'Total TVA',
            totalTtc: 'Total TTC',
            buyPrice: 'Prix d\'achat',
            variousCosts: 'Coûts divers',
            totalCosts: 'Coûts total',
            duration: 'Durée (H)',
            workforce: 'Coûts main d\'oeuvre',
            charge: 'Total charges',
            grossMargin: 'Marge brute HT'
        }
    }
};
/* harmony default export */ var fr = ({
    catalog: fr_catalogLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/router/routes.ts

var routes_ProductListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 3249)); };
var routes_ProductItemView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 9341)); };
var routes_ProviderReferenceListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 9585)); };
var routes_ServiceListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8839)); };
var routes_ServiceItemView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 4683)); };
var routes_GroupListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 4660)); };
var routes_CommandListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 1565)); };
var routes_CommandFormView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 991)); };
var routes_CommandItemView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 5321)); };
var routes_ManualMovementListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8290)); };
var routes_MouvementListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 1738)); };
var routes_LotListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8746)); };
var routes_StockStateView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 6834)); };
var routes_CatalogReportView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 2480)); };
var routes = function (i18n) { return ([
    {
        path: '/catalog/products',
        name: 'catalog-products-list',
        component: routes_ProductListView,
        meta: {
            title: i18n.t('catalog.product.listTitle'),
            userPermission: ['catalog-products', 1],
            buttons: [
                {
                    label: i18n.t('catalog.product.addLabel'),
                    modal: {
                        key: 'catalog-product-form',
                        submitted: function (response) {
                            external_vue_default().prototype.$kwCatalog.router.push({
                                name: 'catalog-product-item',
                                params: {
                                    id: String(response.data.id)
                                }
                            });
                        }
                    },
                    userPermission: ['catalog-products', 2],
                    attributes: {
                        class: 'rounded'
                    }
                },
                {
                    label: i18n.t('catalog.providerReferences.menu'),
                    to: '/catalog/providers-references',
                    variant: 'secondary',
                    attributes: {
                        class: 'rounded ml-2'
                    }
                }
            ]
        }
    },
    {
        path: '/catalog/products/:id',
        name: 'catalog-product-item',
        component: routes_ProductItemView,
        meta: {
            title: i18n.t('catalog.product.itemTitle'),
            userPermission: ['catalog-products', 1],
            pageHeader: false
        }
    },
    {
        path: '/catalog/providers-references',
        name: 'catalog-providers-references-list',
        component: routes_ProviderReferenceListView,
        meta: {
            title: i18n.t('catalog.providerReferences.listTitle'),
            userPermission: ['catalog-products', 1],
            buttons: [
                {
                    label: i18n.t('catalog.product.listTitle'),
                    to: '/catalog/products'
                }
            ]
        }
    },
    {
        path: '/catalog/services',
        name: 'catalog-services-list',
        component: routes_ServiceListView,
        meta: {
            title: i18n.t('catalog.service.listTitle'),
            userPermission: ['catalog-services', 1],
            buttons: [
                {
                    label: i18n.t('catalog.service.addLabel'),
                    userPermission: ['catalog-services', 2],
                    modal: {
                        key: 'catalog-service-form',
                        submitted: function (response) {
                            external_vue_default().prototype.$kwCatalog.router.push({
                                name: 'catalog-service-item',
                                params: {
                                    id: String(response.data.id)
                                }
                            });
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/catalog/services/:id',
        name: 'catalog-service-item',
        component: routes_ServiceItemView,
        meta: {
            title: i18n.t('catalog.service.itemTitle'),
            userPermission: ['catalog-services', 1],
            pageHeader: false
        }
    },
    {
        path: '/catalog/groups',
        name: 'catalog-groups-list',
        component: routes_GroupListView,
        meta: {
            title: i18n.t('catalog.group.listTitle'),
            appModule: 'catalog-groups',
            userPermission: ['catalog-groups', 1],
            buttons: [
                {
                    label: i18n.t('catalog.group.addLabel'),
                    modal: 'catalog-group-form',
                    userPermission: ['catalog-groups', 2]
                }
            ]
        }
    },
    {
        path: '/catalog/groups/:id',
        name: 'catalog-group-item',
        component: routes_ProductItemView,
        meta: {
            title: i18n.t('catalog.group.itemTitle'),
            appModule: 'catalog-groups',
            userPermission: ['catalog-groups', 1],
            pageHeader: false
        }
    },
    {
        path: '/catalog/report',
        name: 'catalog-report',
        component: routes_CatalogReportView,
        meta: {
            title: 'Statistiques',
            userPermission: ['sales-invoice', 1]
        }
    },
    {
        path: '/stock/commands',
        name: 'stock-commands',
        component: routes_CommandListView,
        meta: {
            title: i18n.t('catalog.stock.commandsListTitle'),
            appModule: 'stock',
            userPermission: ['manage-stock', 1],
            buttons: [
                {
                    label: i18n.t('catalog.stock.addLabel'),
                    to: '/stock/commands/form/'
                }
            ]
        }
    },
    {
        path: '/stock/commands/form/:id?',
        name: 'stock-command-form',
        component: routes_CommandFormView,
        meta: {
            appModule: 'stock',
            userPermission: ['manage-stock', 1],
            sidebarMode: 2,
            allowFullscreen: true,
            pageHeader: false
        }
    },
    {
        path: '/stock/commands/:id',
        name: 'stock-command-item',
        component: routes_CommandItemView,
        meta: {
            appModule: 'stock',
            userPermission: ['manage-stock', 1],
            pageHeader: false,
            appClass: { 'stock-command-item': true }
        }
    },
    {
        path: '/stock/state',
        name: 'stock-state',
        component: routes_StockStateView,
        meta: {
            appModule: 'stock',
            userPermission: ['manage-stock', 1],
            title: i18n.t('catalog.stock.StockStatePagetitle'),
            buttons: [
                {
                    label: i18n.t('catalog.stock.addManual'),
                    modal: 'stock-manual-form'
                },
                {
                    label: i18n.t('catalog.stock.addLabel'),
                    to: '/stock/commands/form/'
                }
            ]
        }
    },
    {
        path: '/stock/manual-mouvements',
        name: 'stock-manual-mouvements',
        component: routes_ManualMovementListView,
        meta: {
            title: i18n.t('catalog.stock.manualMvtListPagetitle'),
            appModule: 'stock',
            userPermission: ['manage-stock', 1],
            buttons: [
                {
                    label: i18n.t('catalog.stock.addManual'),
                    modal: 'stock-manual-form'
                }
            ]
        }
    },
    {
        path: '/stock/mouvements',
        name: 'stock-mouvements',
        component: routes_MouvementListView,
        meta: {
            title: i18n.t('catalog.stock.mvtListPagetitle'),
            appModule: 'stock',
            userPermission: ['see-stock', 1]
        }
    },
    {
        path: '/stock/lots',
        name: 'stock-lots',
        component: routes_LotListView,
        meta: {
            title: i18n.t('catalog.productLot.pageTitle'),
            appModule: 'stock',
            userPermission: ['see-stock', 1]
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

;// ./src/router/config.ts
var config_CatalogParamsView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8327)); };
var config_SaleCategoryListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8699)); };
var config_ChargesCategoryListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 7269)); };
var config_ProductVariationListView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 8282)); };
var config_StockParamsView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 2713)); };
var CustomPricesSalesCategoriesView = function () { return __webpack_require__.e(/* import() | catalog */ 624).then(__webpack_require__.bind(__webpack_require__, 2578)); };
var config_routes = function (i18n) { return ([
    {
        name: 'sales-sales-categories',
        path: 'sales/sales-categories',
        component: config_SaleCategoryListView,
        meta: {
            title: i18n.t('catalog.saleCategory.pageTitle')
        }
    },
    {
        name: 'sales-catalog',
        path: 'sales/catalog',
        component: config_CatalogParamsView,
        meta: {
            title: i18n.t('catalog.params.pageTitle')
        }
    },
    {
        name: 'sales-product-variations',
        path: 'sales/product-variations',
        component: config_ProductVariationListView,
        meta: {
            title: i18n.t('catalog.productVariations.pageTitle'),
            appModule: 'catalog-variations'
        }
    },
    {
        name: 'sales-custom-prices',
        path: 'sales/custom-prices',
        component: CustomPricesSalesCategoriesView,
        meta: {
            title: 'Prix personnalisés',
            appModule: 'catalog-custom-prices'
        }
    },
    {
        name: 'charges-charge-categories',
        path: 'charges/charge-categories',
        component: config_ChargesCategoryListView,
        meta: {
            title: i18n.t('catalog.chargeCategory.pageTitle')
        }
    },
    {
        name: 'stock-params',
        path: 'stock-params',
        component: config_StockParamsView,
        meta: {
            title: i18n.t('catalog.config.pageTitle'),
            appModule: 'stock'
        }
    }
]); };
/* harmony default export */ var router_config = (config_routes);

;// ./src/dynamicModals.ts




var modals = [
    {
        key: 'catalog-product-form',
        title: function (product) { return product && product.id ? 'catalog.product.editTitle' : 'catalog.product.addTitle'; },
        component: ProductForm_ProductForm,
        size: 'xl',
        scrollable: false
    },
    {
        key: 'catalog-service-form',
        title: function (service) { return service && service.id ? 'catalog.service.editTitle' : 'catalog.service.addTitle'; },
        component: ServiceForm_ServiceForm,
        size: 'xl'
    },
    {
        key: 'catalog-group-form',
        title: function (group) { return group && group.id ? 'catalog.group.editTitle' : 'catalog.group.addTitle'; },
        component: ProductForm_ProductForm,
        attributes: {
            isGroup: true
        },
        size: 'xl'
    },
    {
        key: 'stock-manual-form',
        title: function (event) { return event && event.id ? 'catalog.stock.manualEditTitle' : 'catalog.stock.manualAddTitle'; },
        component: ManualMovementForm_ManualMovementForm,
        size: 'xl',
        scrollable: false
    },
    {
        key: 'catalog-product-lot',
        title: 'catalog.productLot.editTitle',
        component: LotForm_LotForm,
        size: 'md'
    },
];
/* harmony default export */ var dynamicModals = (modals);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/CatalogStore.ts



var CatalogStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CatalogStore, _super);
    function CatalogStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saleCategoriesLoaded = false;
        _this.saleCategories = [];
        _this.chargeCategoriesLoaded = false;
        _this.chargeCategories = [];
        _this.variationLevelsLoaded = false;
        _this.variationLevels = [];
        _this.stockLocationsLoaded = false;
        _this.stockLocations = [];
        return _this;
    }
    // CLEAR STORE STATE
    CatalogStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['SaleCategories', 'ChargeCategories', 'VariationLevels', 'StockLocations'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // Sort a list alphabetically
    CatalogStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    // Change the loaded state
    CatalogStore.prototype.setSaleCategoriesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.saleCategoriesLoaded = state;
    };
    // Set the sale categories
    CatalogStore.prototype.setSaleCategories = function (saleCategories) {
        this.saleCategories = saleCategories;
    };
    // Add or update a sale category
    CatalogStore.prototype.updateSaleCategory = function (saleCategory) {
        if (!this.saleCategoriesLoaded) {
            return;
        }
        var index = this.saleCategories.findIndex(function (type) { return type.id === saleCategory.id; });
        if (index >= 0) {
            external_vue_default().set(this.saleCategories, index, saleCategory);
        }
        else {
            this.saleCategories.push(saleCategory);
        }
    };
    // Remove a sale category
    CatalogStore.prototype.removeSaleCategory = function (saleCategory) {
        if (!this.saleCategoriesLoaded) {
            return;
        }
        var index = this.saleCategories.findIndex(function (type) { return type.id === saleCategory.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.saleCategories, index);
        }
    };
    // Load the customer types for server
    CatalogStore.prototype.loadSaleCategories = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.saleCategoriesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCatalog.axios.get('/catalog/sale_category?per_page=500&sort=label&include=customPrices')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setSaleCategories', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setSaleCategoriesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer type
    CatalogStore.prototype.setSaleCategory = function (saleCategory) {
        this.context.commit('updateSaleCategory', saleCategory);
        if (this.saleCategoriesLoaded) {
            this.context.commit('orderList', { list: this.saleCategories, key: 'label' });
        }
    };
    // Delete a customer type
    CatalogStore.prototype.deleteSaleCategory = function (saleCategory) {
        this.context.commit('removeSaleCategory', saleCategory);
    };
    // Change the loaded state
    CatalogStore.prototype.setChargeCategoriesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.chargeCategoriesLoaded = state;
    };
    // Set the charge categories
    CatalogStore.prototype.setChargeCategories = function (chargeCategories) {
        this.chargeCategories = chargeCategories;
    };
    // Add or update a charge category
    CatalogStore.prototype.updateChargeCategory = function (chargeCategory) {
        if (!this.chargeCategoriesLoaded) {
            return;
        }
        var index = this.chargeCategories.findIndex(function (type) { return type.id === chargeCategory.id; });
        if (index >= 0) {
            external_vue_default().set(this.chargeCategories, index, chargeCategory);
        }
        else {
            this.chargeCategories.push(chargeCategory);
        }
    };
    // Remove a charge category
    CatalogStore.prototype.removeChargeCategory = function (chargeCategory) {
        if (!this.chargeCategoriesLoaded) {
            return;
        }
        var index = this.chargeCategories.findIndex(function (type) { return type.id === chargeCategory.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.chargeCategories, index);
        }
    };
    // Load the customer types for server
    CatalogStore.prototype.loadChargeCategories = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.chargeCategoriesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCatalog.axios.get('/catalog/charge_category?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setChargeCategories', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setChargeCategoriesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer type
    CatalogStore.prototype.setChargeCategory = function (chargeCategory) {
        this.context.commit('updateChargeCategory', chargeCategory);
        if (this.chargeCategoriesLoaded) {
            this.context.commit('orderList', { list: this.chargeCategories, key: 'label' });
        }
    };
    // Delete a customer type
    CatalogStore.prototype.deleteChargeCategory = function (chargeCategory) {
        this.context.commit('removeChargeCategory', chargeCategory);
    };
    // Change the loaded state
    CatalogStore.prototype.setVariationLevelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.variationLevelsLoaded = state;
    };
    // Set the charge categories
    CatalogStore.prototype.setVariationLevels = function (variationLevels) {
        this.variationLevels = variationLevels;
    };
    // Add or update a charge category
    CatalogStore.prototype.updateVariationLevel = function (variationLevel) {
        if (!this.variationLevelsLoaded) {
            return;
        }
        var index = this.variationLevels.findIndex(function (type) { return type.id === variationLevel.id; });
        if (index >= 0) {
            external_vue_default().set(this.variationLevels, index, variationLevel);
        }
        else {
            this.variationLevels.push(variationLevel);
        }
    };
    // Remove a charge category
    CatalogStore.prototype.removeVariationLevel = function (variationLevel) {
        if (!this.variationLevelsLoaded) {
            return;
        }
        var index = this.variationLevels.findIndex(function (type) { return type.id === variationLevel.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.variationLevels, index);
        }
    };
    // Load the customer types for server
    CatalogStore.prototype.loadVariationLevels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.variationLevelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCatalog.axios.get('/catalog/variation?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setVariationLevels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setVariationLevelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer type
    CatalogStore.prototype.setVariationLevel = function (variationLevel) {
        this.context.commit('updateVariationLevel', variationLevel);
        if (this.variationLevelsLoaded) {
            this.context.commit('orderList', { list: this.variationLevels, key: 'label' });
        }
    };
    // Delete a customer type
    CatalogStore.prototype.deleteVariationLevel = function (variationLevel) {
        this.context.commit('removeVariationLevel', variationLevel);
    };
    // Change the loaded state
    CatalogStore.prototype.setStockLocationsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.stockLocationsLoaded = state;
    };
    // Set the charge categories
    CatalogStore.prototype.setStockLocations = function (stockLocations) {
        this.stockLocations = stockLocations;
    };
    // Add or update a charge category
    CatalogStore.prototype.updateStockLocation = function (stockLocation) {
        if (!this.stockLocationsLoaded) {
            return;
        }
        var index = this.stockLocations.findIndex(function (type) { return type.id === stockLocation.id; });
        if (index >= 0) {
            external_vue_default().set(this.stockLocations, index, stockLocation);
        }
        else {
            this.stockLocations.push(stockLocation);
        }
    };
    // Remove a charge category
    CatalogStore.prototype.removeStockLocation = function (stockLocation) {
        if (!this.stockLocationsLoaded) {
            return;
        }
        var index = this.stockLocations.findIndex(function (type) { return type.id === stockLocation.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.stockLocations, index);
        }
    };
    // Load the customer types for server
    CatalogStore.prototype.loadStockLocations = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.stockLocationsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCatalog.axios.get('/catalog/stock/location?per_page=500&sort=name&include=country')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setStockLocations', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setStockLocationsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer type
    CatalogStore.prototype.setStockLocation = function (stockLocation) {
        this.context.commit('updateStockLocation', stockLocation);
        if (this.stockLocationsLoaded) {
            this.context.commit('orderList', { list: this.stockLocations, key: 'name' });
        }
    };
    // Delete a customer type
    CatalogStore.prototype.deleteStockLocation = function (stockLocation) {
        this.context.commit('removeStockLocation', stockLocation);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setSaleCategoriesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setSaleCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "updateSaleCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "removeSaleCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "loadSaleCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "setSaleCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "deleteSaleCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setChargeCategoriesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setChargeCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "updateChargeCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "removeChargeCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "loadChargeCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "setChargeCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "deleteChargeCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setVariationLevelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setVariationLevels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "updateVariationLevel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "removeVariationLevel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "loadVariationLevels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "setVariationLevel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "deleteVariationLevel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setStockLocationsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "setStockLocations", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "updateStockLocation", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CatalogStore.prototype, "removeStockLocation", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "loadStockLocations", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "setStockLocation", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CatalogStore.prototype, "deleteStockLocation", null);
    CatalogStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], CatalogStore);
    return CatalogStore;
}(VuexModule));
/* harmony default export */ var modules_CatalogStore = (CatalogStore);

;// ./src/broadcasts/team.ts
/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.SaleCategoryCreated',
        callback: function (category) {
            store.dispatch('catalog/setSaleCategory', category);
        }
    },
    {
        name: '.SaleCategoryUpdated',
        callback: function (category) {
            store.dispatch('catalog/setSaleCategory', category);
        }
    },
    {
        name: '.SaleCategoryDeleted',
        callback: function (category) {
            store.dispatch('catalog/deleteSaleCategory', category);
        }
    },
    {
        name: '.ChargeCategoryCreated',
        callback: function (category) {
            store.dispatch('catalog/setChargeCategory', category);
        }
    },
    {
        name: '.ChargeCategoryUpdated',
        callback: function (category) {
            store.dispatch('catalog/setChargeCategory', category);
        }
    },
    {
        name: '.ChargeCategoryDeleted',
        callback: function (category) {
            store.dispatch('catalog/deleteChargeCategory', category);
        }
    },
    {
        name: '.VariationCreated',
        callback: function (variationLevel) {
            store.dispatch('catalog/setVariationLevel', variationLevel);
        }
    },
    {
        name: '.VariationUpdated',
        callback: function (variationLevel) {
            store.dispatch('catalog/setVariationLevel', variationLevel);
        }
    },
    {
        name: '.VariationDeleted',
        callback: function (variationLevel) {
            store.dispatch('catalog/deleteVariationLevel', variationLevel);
        }
    }
]); });

;// ./src/install.ts







var KwixeoCatalog = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwCatalog = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(1848);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            catalog: modules_CatalogStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
        // Register dynamicModals
        dynamicModals.forEach(function (modal) { return store.dispatch('dynamicModals/registerModal', modal); });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        router_config(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoCatalog);

// EXTERNAL MODULE: ./src/fetchDatas/command.ts
var command = __webpack_require__(6589);
// EXTERNAL MODULE: ./src/fetchDatas/lot.ts
var lot = __webpack_require__(2443);
// EXTERNAL MODULE: ./src/mixins/CatalogListMixin.ts
var CatalogListMixin = __webpack_require__(3859);
// EXTERNAL MODULE: ./src/mixins/LoadCommandMixin.ts
var LoadCommandMixin = __webpack_require__(4873);
// EXTERNAL MODULE: ./src/mixins/LoadProductMixin.ts
var LoadProductMixin = __webpack_require__(2711);
// EXTERNAL MODULE: ./src/mixins/LoadServiceMixin.ts
var LoadServiceMixin = __webpack_require__(1055);
;// ./src/menu/configMenu.ts
var configMenu = function (i18n) { return ([
    {
        label: i18n.t('catalog.config.menuTitle'),
        icon: ['fas', 'shopping-cart'],
        open: false,
        active: '/configuration/sales',
        items: [
            {
                label: i18n.t('catalog.params.menu'),
                path: '/configuration/sales/catalog'
            },
            {
                label: i18n.t('catalog.productVariations.menu'),
                path: '/configuration/sales/product-variations',
                appModule: 'catalog-variations'
            },
            {
                label: i18n.t('catalog.saleCategory.menu'),
                path: '/configuration/sales/sales-categories'
            },
            {
                label: 'Prix personnalisés',
                path: '/configuration/sales/custom-prices',
                appModule: 'catalog-custom-prices'
            },
        ]
    },
    {
        label: i18n.t('catalog.config.menu'),
        path: '/configuration/stock-params',
        icon: ['fas', 'box-open'],
        appModule: 'stock'
    },
    {
        label: 'Charges',
        icon: ['fas', 'truck-container'],
        open: false,
        active: '/configuration/charges',
        items: [
            {
                label: i18n.t('catalog.chargeCategory.menu'),
                path: '/configuration/charges/charge-categories'
            }
        ]
    },
    {
        label: i18n.t('interface.menuLabel.users'),
        path: '/configuration/users',
        icon: ['fas', 'users']
    }
]); };
/* harmony default export */ var menu_configMenu = (configMenu);

;// ./src/menu/main.ts
var addIcon = ['fas', 'plus-circle'];
var menu = function (i18n) { return ([
    {
        label: 'Tbord',
        path: '/'
    },
    {
        label: 'Ventes',
        icon: ['fas', 'file-alt'],
        open: false,
        active: '/sales',
        items: [
            {
                label: 'Devis',
                path: '/sales/quotations',
                addIcon: addIcon,
                addRoute: '/sales/quotations/form'
            },
            {
                label: 'Bons de commande',
                path: '/sales/commands',
                addIcon: addIcon,
                addRoute: '/sales/commands/form',
                appModule: 'sales-commands'
            },
            {
                label: 'Bons de livraison',
                path: '/sales/deliveries',
                addIcon: addIcon,
                addRoute: '/sales/deliveries/form',
                appModule: 'sales-deliveries'
            },
            {
                label: 'Factures proforma',
                path: '/sales/proformas',
                addIcon: addIcon,
                addRoute: '/sales/proformas/form',
                appModule: 'sales-proformas'
            }
        ]
    },
    {
        label: i18n.t('catalog.menuTitle'),
        icon: ['fas', 'books'],
        open: false,
        active: '/catalog',
        items: [
            {
                label: i18n.t('catalog.product.menu'),
                path: '/catalog/products',
                userPermission: ['catalog-products', 1],
                addIcon: addIcon,
                addModal: 'catalog-product-form',
                addUserPermission: ['catalog-products', 2]
            },
            {
                label: i18n.t('catalog.service.menu'),
                path: '/catalog/services',
                userPermission: ['catalog-services', 1],
                addIcon: addIcon,
                addModal: 'catalog-service-form',
                addUserPermission: ['catalog-services', 2]
            },
            {
                label: i18n.t('catalog.group.menu'),
                path: '/catalog/groups',
                appModule: 'catalog-groups',
                userPermission: ['catalog-groups', 1],
                addIcon: addIcon,
                addModal: 'catalog-group-form',
                addUserPermission: ['catalog-groups', 2]
            },
            {
                label: 'Statistiques',
                path: '/catalog/report',
                userPermission: ['sales-invoice', 1]
            }
        ]
    },
    {
        label: i18n.t('catalog.stock.menuTitle'),
        icon: ['fas', 'box-open'],
        open: false,
        active: '/stock',
        appModule: 'stock',
        items: [
            {
                label: 'État',
                path: '/stock/state',
                userPermission: ['see-stock', 1]
            },
            {
                label: 'Mouvements',
                path: '/stock/mouvements',
                userPermission: ['see-stock', 1]
            },
            {
                label: 'Lots de produits',
                path: '/stock/lots',
                appModule: 'stock-tracabilities',
                userPermission: ['see-stock', 1]
            },
            {
                label: 'Commandes',
                path: '/stock/commands',
                addIcon: addIcon,
                addRoute: '/stock/commands/form',
                userPermission: ['manage-stock', 1]
            },
            {
                label: 'Entrées & Sorties',
                path: '/stock/manual-mouvements',
                addIcon: addIcon,
                addModal: 'stock-manual-form',
                userPermission: ['manage-stock', 1]
            }
        ]
    }
]); };
/* harmony default export */ var main = (menu);

;// ./src/index.ts
















































































// Vue X Modules


















;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=catalog.common.js.map